webpackJsonp([1],{

/***/ "+9af":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdatePartOrderDialog_vue__ = __webpack_require__("N+sg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dee990c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdatePartOrderDialog_vue__ = __webpack_require__("6lmq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdatePartOrderDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dee990c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdatePartOrderDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+XIM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+bCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.$t('serviceTickets.selectCategory') + ' ' + _vm.ticketId + ' ' + _vm.$t('serviceTickets.details'),"visible":_vm.showDialog,"width":"650px","append-to-body":"","close-on-click-modal":false,"disable":_vm.loading},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadTicket,"close":_vm.closeDialog}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":9}},[_c('dl',[(_vm.details.confirmation)?_c('dt',[_vm._v(_vm._s(_vm.details.confirmationText))]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v("Opened by")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.openedBy))]),_vm._v(" "),_c('dt',[_vm._v("Opened on")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("date")(_vm.details.raisedOn)))]),_vm._v(" "),_c('dt',[_vm._v("Dispatched to")]),_vm._v(" "),_c('dd',{domProps:{"innerHTML":_vm._s(_vm.details.dispatchedTo)}}),_vm._v(" "),_c('dt',[_vm._v("Urgency")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.urgency))]),_vm._v(" "),_c('dt',[_vm._v("Overtime")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.overtimeApproved ? _vm.$t('common.yes') : _vm.$t('common.no')))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":9}},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.customerName')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.customerName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.address')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.customerAddress))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.phone')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.callBy')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.callBy))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.callerPhone')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.callerPhoneNumber == null ? '' : _vm.details.callerPhoneNumber))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.status')))]),_vm._v(" "),_c('dd',[_c('span',[_vm._v(_vm._s(_vm.details.statusText))])])])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.model')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.model))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.serial')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.serialNumber))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.coverage')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.coverage))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.gasType')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.gasType))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.warrEnd')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("date")(_vm.details.warrantyEnd)))])])])],1),_vm._v(" "),(_vm.details.note)?_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.communicationRequirements')))]),_vm._v("\n        "+_vm._s(_vm.details.note)+"\n    ")]):_vm._e(),_vm._v(" "),_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.symptoms')))]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('table',{staticStyle:{"width":"100%"}},_vm._l((_vm.details.complaints),function(complaint){return _c('tbody',{key:complaint.code},[_c('tr',[_c('td',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.symptomCodes')))])]),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.description')))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(complaint.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(complaint.description))])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.ShowMandatoryParts(complaint))?_c('h4',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.mandatoryParts')))]):_vm._e()]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[(_vm.ShowMandatoryParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowMandatoryParts(complaint)))]):_vm._e(),_vm._v(" "),(_vm.ShowMandatoryParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowDescriptionForMandatoryParts(complaint)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[(_vm.ShowRecommendedParts(complaint))?_c('h4',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.recommendedParts')))]):_vm._e()]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[(_vm.ShowRecommendedParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowRecommendedParts(complaint)))]):_vm._e(),_vm._v(" "),(_vm.ShowRecommendedParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowDescriptionForRecommendedParts(complaint)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[_c('hr')])])])}))])],1),_vm._v(" "),_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.comments')))]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.details.comments),function(comment){return _c('li',{key:comment.id},[_c('p',[_vm._v("\n                        "+_vm._s(comment.message)+"\n\n                    ")]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm.showCommentFullTime(comment))+" by "+_vm._s(comment.author))])])}))])],1),_vm._v(" "),_c('el-row',[_c('h4',[_vm._v("What was done?")]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.details.escalationCommentWhatWasDone),function(whatWasDone){return _c('li',{key:whatWasDone.id},[_c('p',[_vm._v("\n                        "+_vm._s(whatWasDone.message)+"\n\n                    ")]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm.showCommentFullTime(whatWasDone))+" by "+_vm._s(whatWasDone.author))])])}))])],1),_vm._v(" "),_c('el-row',[_c('h4',[_vm._v("Escalation Next Step")]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.details.escalationCommentNextStep),function(escalationCommentNextStep){return _c('li',{key:escalationCommentNextStep.id},[_c('p',[_vm._v("\n                        "+_vm._s(escalationCommentNextStep.message)+"\n\n                    ")]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm.showCommentFullTime(escalationCommentNextStep))+" by "+_vm._s(escalationCommentNextStep.author))])])}))])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":function($event){_vm.showSubscriptionDialog = true}}},[_vm._v("Subscription List")]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('serviceTickets.close')))])],1)]),_vm._v(" "),_c('el-dialog',{staticStyle:{"margin-left":"-15px"},attrs:{"visible":_vm.showSubscriptionDialog,"width":"650px","append-to-body":""},on:{"update:visible":function($event){_vm.showSubscriptionDialog=$event}}},[_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('h4',[_vm._v("Subscription List")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.subscriberForm,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"name","width":"90","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","width":"90","label":"Email"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sms","width":"90","label":"Phone Number"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"IsSubscribedByEmail","label":"Email Subscription","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100%"}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"disabled":true},model:{value:(scope.row.isSubscribedByEmail),callback:function ($$v) {_vm.$set(scope.row, "isSubscribedByEmail", $$v)},expression:"scope.row.isSubscribedByEmail"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"IsSubscribedBySms","label":"SMS Subscription","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100%"}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"disabled":true},model:{value:(scope.row.isSubscribedBySms),callback:function ($$v) {_vm.$set(scope.row, "isSubscribedBySms", $$v)},expression:"scope.row.isSubscribedBySms"}})],1)]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+kGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductSelector__ = __webpack_require__("At//");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductSelector__["a"]; });


/***/ }),

/***/ "/3FV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/4Dx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("xaXQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-complaint-code-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        codeId: {
            required: false
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        PartSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["j" /* PartSelector */]
    },
    data: function data() {
        return {
            form: {
                productId: null,
                code: '',
                description: '',
                category: '',
                mandatoryParts: [],
                recommendedParts: []
            },
            rules: {
                productId: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectProduct'),
                    trigger: 'change'
                }],
                code: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCode'),
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: this.$t('common.pleaseEntercodeDescription'),
                    trigger: 'blur'
                }],
                category: [{
                    type: 'string',
                    required: true,
                    message: this.$t('common.pleaseEnterCategory'),
                    trigger: 'blur'
                }]
            },
            loading: false,
            showDialog: this.visible,
            disableForm: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadCode: function loadCode() {
            var _this = this;

            if (this.codeId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCode(this.codeId).then(function (response) {
                    _this.loading = false;
                    _this.form = Object.assign({}, response.data);
                });
            }
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
            this.form.mandatoryParts = [];
            this.form.recommendedParts = [];
            this.$refs['form'].resetFields();
        },
        save: function save() {
            var _this2 = this;

            this.$refs['form'].validate(function (valid) {
                if (_this2.form.description.length > 500) {
                    _this2.$notify({
                        title: "Error",
                        message: _this2.$t('masters.descriptionlengtherror'),
                        type: "error"
                    });
                } else {
                    _this2.$refs['form'].validate(function (valid) {
                        if (valid) {
                            _this2.loading = true;
                            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCode(_this2.codeId, _this2.form).then(function (response) {
                                _this2.$emit('save', {
                                    new: _this2.codeId === undefined,
                                    id: _this2.codeId,
                                    data: _this2.form
                                });
                                _this2.closeDialog();
                            });
                        } else {
                            return false;
                        }
                    });
                }
            });
        },
        mandatoryPartSelected: function mandatoryPartSelected(addedPart) {
            console.log(addedPart);
            var part = this.form.mandatoryParts.find(function (p) {
                return p.id === addedPart.id;
            });
            if (part === undefined) {
                this.form.mandatoryParts.push(addedPart);
            }
        },
        recommendedPartSelected: function recommendedPartSelected(addedPart) {
            console.log(addedPart);
            var part = this.form.recommendedParts.find(function (p) {
                return p.id === addedPart.id;
            });
            if (part === undefined) {
                this.form.recommendedParts.push(addedPart);
            }
        },
        removeMandatoryPart: function removeMandatoryPart(id) {
            var part = this.form.mandatoryParts.find(function (p) {
                return p.id === id;
            });
            if (part !== undefined) {
                var index = this.form.mandatoryParts.indexOf(part);
                if (index !== -1) this.form.mandatoryParts.splice(index, 1);
                //this.form.mandatoryParts.remove(part);
            }
        },
        removeRecommendedPart: function removeRecommendedPart(id) {
            var part = this.form.recommendedParts.find(function (p) {
                return p.id === id;
            });
            if (part !== undefined) {
                var index = this.form.recommendedParts.indexOf(part);
                if (index !== -1) this.form.recommendedParts.splice(index, 1);
                //this.form.recommendedParts.remove(part);
            }
        }
    }
});

/***/ }),

/***/ "/57N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColoredBox_vue__ = __webpack_require__("FJcX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a880daa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColoredBox_vue__ = __webpack_require__("dSIX");
function injectStyle (ssrContext) {
  __webpack_require__("Ory7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a880daa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColoredBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a880daa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColoredBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/PYK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResolutionCategorySelector__ = __webpack_require__("Jhwe");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ResolutionCategorySelector__["a"]; });


/***/ }),

/***/ "/U6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceTicketPartSelector__ = __webpack_require__("c5wQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("H50Z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "add-part-dialog",
    components: {
        ServiceTicketPartSelector: __WEBPACK_IMPORTED_MODULE_1__ServiceTicketPartSelector__["a" /* default */]
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        serviceCompanyId: {
            type: Number,
            required: false
        },
        productId: {
            required: true
        },
        isNotWarrantyClaim: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            form: {
                part: undefined,
                quantity: 1,

                name: "",
                price: undefined,
                extendedPrice: undefined
            },
            rules: {
                part: [{
                    required: true,
                    message: "Please select part",
                    trigger: "change"
                }],
                name: [{
                    required: true,
                    message: "Please enter name",
                    trigger: "blur"
                }],
                price: [{
                    type: "number",
                    required: true,
                    message: "Please enter price",
                    trigger: "blur"
                }],
                extendedPrice: [{
                    type: "number",
                    required: true,
                    message: "Please enter extended price",
                    trigger: "blur"
                }],
                quantity: [{
                    type: "number",
                    required: true,
                    message: "Please enter quantity",
                    trigger: "blur"
                }]
            },
            selectedPart: undefined,
            showDialog: this.visible
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.selectedPart = undefined;
            this.$refs["form"].resetFields();
            if (this.$refs["part-selector"]) {
                this.$refs["part-selector"].reset();
            }
            this.showDialog = false;
            this.$emit("dialogClosed");
        },
        partSelected: function partSelected(part) {
            if (part) {
                this.form.part = part;
                var self = this;
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPartById(part.id, this.serviceCompanyId, this.isNotWarrantyClaim).then(function (response) {
                    self.form.part = response.data;
                    self.selectedPart = response.data;
                });
            } else {
                this.form.part = undefined;
                this.form.quantity = 1;
                this.selectedPart = undefined;
            }
        },
        addPart: function addPart() {
            var _this = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    var part = _this.form.part;
                    if (_this.misc) {
                        part = {
                            name: _this.form.name,
                            price: _this.form.price,
                            extendedPrice: _this.form.extendedPrice
                        };
                    }
                    _this.$emit("part-added", {
                        part: part,
                        quantity: _this.form.quantity
                    });
                    _this.closeDialog();
                } else {
                    return false;
                }
            });
        }
    },
    computed: {
        currentCompanyId: function currentCompanyId() {
            return this.$isAdmin ? this.serviceCompanyId : window.currentCompany.id;
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    }
});

/***/ }),

/***/ "/a9S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('product-selector',{model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"data":_vm.codes,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('common.code'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"product","label":_vm.$t('common.product')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editCode(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteCode(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-complaint-code-dialog',{attrs:{"codeId":_vm.codeToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendCode}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/cZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_event_bus_js__ = __webpack_require__("fEXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("065F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-country-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            form: {
                name: null,
                ISOCode: null
            },
            rules: {
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCounryName'),
                    trigger: "blur"
                }],
                ISOCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCounryISOCode'),
                    trigger: "blur",
                    max: 2
                }]
            },
            showDialog: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.$refs["form"].resetFields();
            this.$emit("dialogClosed");
        },
        save: function save() {
            var _this = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCountry(_this.form).then(function (response) {
                        if (response != null && response.data != null) {
                            __WEBPACK_IMPORTED_MODULE_0__app_event_bus_js__["a" /* EventBus */].$emit("countryCreated");
                            _this.$message({
                                type: "success",
                                message: _this.$t('common.countryCreated')
                            });
                        }
                        _this.closeDialog();
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ "/e34":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getClaims: function getClaims(page, filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/claims/accounting', {
            params: {
                page: page,
                q: filter.q,
                status: filter.type,
                dateFrom: filter.dateFrom,
                dateTo: filter.dateTo
            }
        });
    },
    payClaim: function payClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/claims/' + id + '/pay');
    },
    printClaim: function printClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/claims/' + id + '/print');
    },
    processClaim: function processClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/claims/' + id + '/process');
    },
    payAndPrint: function payAndPrint(listId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/claims/payAndPrint', listId);
    },

    // TODO Dunno why we repeat values in each subfolder 
    deleteClaim: function deleteClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/claims/' + id);
    }
});

/***/ }),

/***/ "/mdh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/r6A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeList_vue__ = __webpack_require__("9mdt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71060c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeList_vue__ = __webpack_require__("Jq0s");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71060c44_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/x2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategorySelector_vue__ = __webpack_require__("cnXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150afb63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategorySelector_vue__ = __webpack_require__("i7TQ");
function injectStyle (ssrContext) {
  __webpack_require__("vtEV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-150afb63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategorySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_150afb63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategorySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "03aQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escalationdashboard__ = __webpack_require__("tCss");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }



/* unused harmony default export */ var _unused_webpack_default_export = ([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__escalationdashboard__["a" /* routes */])));

/***/ }),

/***/ "065F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter, sort) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/customers/export', {
            countryId: filter.countryId,
            chainId: filter.chainId,
            name: filter.text,
            sortBy: sort ? sort.prop : undefined,
            sortOrder: sort ? sort.order : undefined
        });
    },
    getCustomers: function getCustomers(page, countryId, chainId, text, city, zip, state, sort, notification) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/table', {
            params: {
                page: page,
                countryId: countryId,
                chainId: chainId,
                name: text,
                city: city,
                zip: zip,
                state: state,
                customerNotification: notification,
                sortBy: sort ? sort.prop : undefined,
                sortOrder: sort ? sort.order : undefined
            }
        });
    },
    getCustomer: function getCustomer(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + id + '/customerwithequipment').then(function (response) {
            var result = Object.assign({}, response.data.customer);
            result.classification = result.classification.toString();
            result.selectedCountryState = [result.address.countryId.toString(), result.address.stateId.toString()];
            result.chainId = [result.chainId.toString(), result.chainRule];
            result.city = result.address.city;
            result.region = result.address.region;
            result.regional = result.address.regional;
            result.zip = result.address.zip;
            result.address = result.address.street;
            result.registeredEquipment.forEach(function (x) {
                x.model = x.product.name;
                x.warrantyStartString = new Date(x.warrantyStart).toLocaleDateString("en-US");
                x.warrantyEndString = new Date(x.warrantyEnd).toLocaleDateString("en-US");
            });
            result.info = response.data.info.toString();
            result.qrCodeImg = response.data.qrCodeImg ? response.data.qrCodeImg.toString() : null;

            return result;
        });
    },
    getEquipment: function getEquipment(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + id + '/equipment');
    },
    getNotifications: function getNotifications(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + id + '/notifications');
    },
    saveCustomer: function saveCustomer(id, customer) {
        var request = Object.assign({}, customer);
        request.countryId = customer.selectedCountryState[0];
        request.stateId = customer.selectedCountryState[1];

        var chainAndRule = customer.chainId;
        request.chainId = chainAndRule[0];
        request.chainRule = chainAndRule[1];

        delete request.selectedCountryState;
        if (typeof request.email == 'undefined' || request.email == '') {
            request.email = null;
        }
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/customers/' + id, request);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/customers', request);
    },
    deleteCustomer: function deleteCustomer(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/customers/' + id);
    },
    saveNotification: function saveNotification(id, notification) {
        if (notification.id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/customers/' + id + '/notifications', notification);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/customers/' + id + '/notifications', notification);
    },
    deleteNotification: function deleteNotification(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/customers/' + id + '/notifications');
    },
    deleteEquipment: function deleteEquipment(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/equipment/' + id);
    },
    saveCountry: function saveCountry(country) {
        var request = Object.assign({}, country);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/countries', request);
    },
    getCookingParams: function getCookingParams(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + id + '/cooking_params');
    },
    deleteCookingParam: function deleteCookingParam(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/customers/' + id + '/cooking_params');
    },
    saveCookingParam: function saveCookingParam(id, cookingParam) {
        if (cookingParam.id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/customers/' + id + '/cooking_params', cookingParam);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/customers/' + id + '/cooking_params', cookingParam);
    }
});

/***/ }),

/***/ "07F/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentSelector_vue__ = __webpack_require__("TDmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d189b992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentSelector_vue__ = __webpack_require__("j5tU");
function injectStyle (ssrContext) {
  __webpack_require__("1qrV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d189b992"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d189b992_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "07Nn":
/***/ (function(module, exports) {

module.exports = {"createServiceTicket":"Create Service Ticket","ticketNum":"Ticket #","customer":"Customer","product":"Product","warrantyEnd":"Warranty End","callerTitle":"Caller Title","deliManager":"Deli Manager","deliSupervisor":"Deli Supervisor","meatManager":"Meat Manager","regionalManager":"Regional Manager","hardtManager":"Hardt Manager","hardtProductManager":"Hardt Product Manager","warehouseManager":"Warehouse Manager","warehouseManagerAssistant":"Warehouse Manager Assistant","operator":"Operator","customerCorporateRequest":"Customer Corporate Request","maintance":"Maintenance","freshManager":"Fresh Manager","freshManagerAssistant":"Fresh Manager Assistant","other":"Other","callerName":"Caller Name","callerPhone":"Caller Phone","secondContact":"Second Contact","urgency":"Urgency","escalation":"Escalation","priorityDown":"Priority 1 - Down","priorityOperational":"Priority 2 - Operational","installation":"Installation","postInstallation":"Post Installation","installPostInstallCombo":"Install/Post Install Combo","hold":"Hold","status":"Status","serviceCoverage":"Service Coverage","warranty":"Warranty - INVOICE HARDT","costcoNonWarranty":"Costco Non-Warranty - INVOICE HARDT","costcoPreventativeMaintenance":"Costco Preventative Maintenance, Invoice Hardt","wallMartNonWarranty":"Wal-Mart Non-Warranty - INVOICE HARDT","pendingWarranty":"Pending Warranty - INVOICE HARDT PENDING DECISION","warrantyException":"Warranty Exception - INVOICE HARDT","installationPostInstallation":"Installation / Post Install","nonWarranty":"Non-Warranty / INVOICE Hardt","overtimeApproved":"Overtime Approved","communicationRequirements":"Communication Requirements","productNote":"Note for equipment (Product)","responseTime":"Response time","symptoms":"Symptoms","selectCategory":"Select category","pleaseSelectCategory":"Please select category","selectSubcategory":"Select subcategory","pleaseSelectSubcategory":"Please select subcategory","addSymptom":"Add symptom","previousCalls":"Previous Calls","date":"Date","serialNumber":"Serial Number","description":"Description","view":"View","ticketFiles":"Ticket Files","dropFile":"Drop file here or","clicktoUpload":"click to upload","copyAndSave":"Copy & save","save":"Save","close":"Close","cancel":"Cancel","customerRs":"Customer 'RS'","rsMessage1":"This is a RS Customer, please apply the appropriate procedures.","rsMessage2":"Click 'OK' to proceed or View RS procedures.","ok":"OK","viewRsProcedures":"View RS procedures","sendAsEmail":"Send as Email","serviceCompany":"Service Company","phone":"Phone","email":"Email","callerEmail":"Caller Email","useCustom":"Use Custom","send":"Send","yesSaveSend":"Yes, Save & Send as Email","noSaveClose":"No, Save and Close","ticket":"Ticket","details":"Details","callBy":"Call By","address":"Address","customerName":"CustomerName","select":"Select","model":"Model","serial":"Serial","coverage":"Coverage","gasType":"Gas Type","warrEnd":"Warr. End","symptomCodes":"Symptom codes","mandatoryParts":"Mandatory Parts","recommendedParts":"Recommended Parts","comments":"Comments","newTicketComment":"New ticket comment","saveComment":"Save Comment","generateAuth":"Generate Auth#","seeAuth":"See Auth#","currentAuth":"Current Auth #:","resend":"Resend","resolveTicket":"Resolve ticket","reopen":"Reopen","print":"Print","accept":"Accept","reject":"Reject","update":"Update","rejectServiceDispatch":"Please confirm why you are REJECTING this service dispatch?","partNumber":"Part Number","techName":"Tech Name","generate":"Generate","export":"Export","customerNumber":"Customer Number","ticketNumber":"Ticket Number","city":"City","state":"State","lookUpServiceCompany":"***Look-Up***Service Company contains, e.g. DCS-","fromRaisedOnDate":"***From Raised on Date***","toRaisedOnDate":"***To Raised on Date***","confirmation":"Confirmation","openedBy":"Opened By","raisedOn":"Raised On","codeDescription":"Code-Description","serviceCompanyPhone":"Service Company Phone","ticketSent":"Ticket was sent (# of hours)","operations":"Operations","mondayToFriday":"Monday-Friday","mondayToFridayHours":" 8:00am - 5:30pm","afterHours":"After Hours","afterHoursHours":" 5:30pm - 10:00pm","afterHoursWeekends":"After Hours Weekends","afterHoursWeekendsHours":" 7:30am - 6:00pm","hardtEqTechnResources":"Hardt Equipment Technical Resources","hardtEqTechnResourcesText1":"Need drawings, schematics, or technical documents?","hardtEqTechnResourcesText2":"Instant access is available at our online library:","liveSupportAvailability":"Live Support Availability (EST)","statusHistory":"Status History","changedAt":"Changed At","oldStatus":"Old Status","newStatus":"New Status","changedBy":"Changed By","source":"Source"}

/***/ }),

/***/ "0BtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("KL0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdatePartOrderDialog__ = __webpack_require__("+9af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TrackingInfo__ = __webpack_require__("MFWS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShippingInfo__ = __webpack_require__("GW79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DeliveryInfo__ = __webpack_require__("5Ju1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_event_bus_js__ = __webpack_require__("fEXR");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: "part-order-list",
    components: {
        CreateUpdatePartOrderDialog: __WEBPACK_IMPORTED_MODULE_1__CreateUpdatePartOrderDialog__["a" /* default */],
        TrackingInfo: __WEBPACK_IMPORTED_MODULE_2__TrackingInfo__["a" /* default */],
        ShippingInfo: __WEBPACK_IMPORTED_MODULE_3__ShippingInfo__["a" /* default */],
        DeliveryInfo: __WEBPACK_IMPORTED_MODULE_4__DeliveryInfo__["a" /* default */]
    },
    computed: {
        getTime: function getTime() {
            return function (placedAt, status) {
                if (status == "New") {
                    return new Date(placedAt).toLocaleTimeString();
                } else {
                    return "";
                }
            };
        },
        getDate: function getDate() {
            return function (placedAt) {
                return new Date(placedAt).toLocaleDateString();
            };
        }
    },
    data: function data() {
        return {
            orders: [],
            dialogVisible: false,
            orderToView: null,
            filter: {
                status: this.$route.params.status || null,
                partOrderNumber: "",
                serviceCompanyName: "",
                purchaseOrderNumber: ""
            },
            sorting: {},
            categories: [],
            loading: true,
            // updateLoading: false,
            currentPage: 1,
            total: 0
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                if (this.filter.status === null && this.$route.params.status != null) {
                    window.location.href = "/#/part-orders";
                }
                this.loadOrders();
                this.loadCategories();
            }
        }
    },
    created: function created() {
        this.loadOrders();
        this.loadCategories();
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        __WEBPACK_IMPORTED_MODULE_5__app_event_bus_js__["a" /* EventBus */].$on("order-placed", function (order) {
            // self.orders.push(order);
            _this.loadOrders();
            _this.loadCategories();
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_5__app_event_bus_js__["a" /* EventBus */].$off("order-placed");
    },

    methods: {
        parseDate: function parseDate(str) {
            return str.slice(0, 10).split("-");
        },
        parseTime: function parseTime(str) {
            return str.slice(str.indexOf("T") + 1, str.indexOf("T") + 9).split(":");
        },
        loadOrders: function loadOrders() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getOrders(this.currentPage, this.filter, this.sorting).then(function (response) {
                _this2.orders = response.data.items;
                _this2.orders = response.data.items.map(function (obj) {
                    var statusFrench = _this2.mapSatusFr(obj.status);
                    return _extends({}, obj, { statusFr: statusFrench
                    });
                });
                console.log(_this2.orders);
                _this2.total = response.data.total;
                _this2.loading = false;
            });
        },
        mapSatusFr: function mapSatusFr(status) {
            switch (status) {
                case "Open":
                    return "Ouvrir";
                case "New":
                    return "Nouveau";
                case "Processed":
                    return "Traité";
                case "Deleted":
                    return "Supprimé";
                default:
                    return "";
            }
        },
        sortPartOrders: function sortPartOrders(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadOrders();
            } else {
                this.currentPage = 1;
            }
        },

        // updateTracking(id, data) {
        //   this.updateLoading = true;
        //   api.updateTrackingInfo(id, data).then(response => {
        //     var order = this.orders.find(o => o.orderNumber === id);
        //     Object.assign(order, data);
        //     this.updateLoading = false;
        //   });
        // },
        // updateShipping(id, data) {
        //   this.updateLoading = true;
        //   api.updateShippingInfo(id, data).then(response => {
        //     var order = this.orders.find(o => o.orderNumber === id);
        //     Object.assign(order, data);
        //     this.updateLoading = false;
        //   });
        // },
        // updateDelivery(id, data) {
        //   this.updateLoading = true;
        //   api.updateDeliveryInfo(id, data).then(response => {
        //     var order = this.orders.find(o => o.orderNumber === id);
        //     Object.assign(order, data);
        //     this.updateLoading = false;
        //     this.loadOrders();
        //   });
        // },
        viewOrder: function viewOrder(id) {
            this.orderToView = id;
            this.dialogVisible = true;
            document.title = "PARTS ORDER";
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadOrders();
        },
        loadCategories: function loadCategories() {
            var _this3 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCategories().then(function (response) {
                _this3.loading = false;
                _this3.categories = response.data;
            });
        },
        dialogClosed: function dialogClosed() {
            this.loadOrders();
            this.loadCategories();
            this.dialogVisible = false;
            document.title = "Service Claim Processing";
        },
        deletePartOrder: function deletePartOrder(id) {
            var _this4 = this;

            this.$confirm(this.$t('common.areYouSureYouWantToDeleteThePartOrder'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteOrder(id).then(function () {
                    _this4.loadOrders();
                    _this4.loadCategories();
                    _this4.$message({
                        type: "success",
                        message: _this4.$t('common.thePartOrderIsSuccessfullyDeleted')
                    });
                }).catch(function (err) {
                    console.log(err);
                });
            }).catch(function (_) {});
        }
    }
});

/***/ }),

/***/ "0HqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'shipping-method-selector',
    props: ['value', 'disabled'],
    data: function data(vm) {
        return {
            loading: false,
            roles: [{
                id: '0',
                name: vm.$t('common.express')
            }, {
                id: '1',
                name: vm.$t('common.expressSat')
            }, {
                id: '4',
                name: vm.$t('common.standard')
            }, {
                id: '5',
                name: vm.$t('common.other')
            }]
        };
    }
});

/***/ }),

/***/ "0KeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("7fbR");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/equipment',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* EquipmentList */],
  name: 'equipmentList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "0RgM":
/***/ (function(module, exports) {

module.exports = {"createServiceTicket":"Créer un ticket de service","ticketNum":"Ticket #","customer":"Client","product":"Produit","warrantyEnd":"Fin de garantie","callerTitle":"Titre de l'appelant","deliManager":"Gérant de Deli","deliSupervisor":"Superviseur de Deli","meatManager":"Gérant de la viande","regionalManager":"Directeur régional","hardtManager":"Directeur Hardt","hardtProductManager":"Directeur des produits Hardt","warehouseManager":"Directeur d'entrepôt","warehouseManagerAssistant":"Assistant du gérant d'entrepôt","operator":"Opérateur","customerCorporateRequest":"Demande d'entreprise du client","maintance":"Entretien","freshManager":"Gérant frais","freshManagerAssistant":"Assistant gérant frais","other":"Autre","callerName":"Nom de l'appelant","callerPhone":"Téléphone de l'appelant","secondContact":"Deuxième Contact","urgency":"Urgence","escalation":"Escalade","priorityDown":"Priorité 1 - En panne","priorityOperational":"Priorité 2 - Opérationnelle","installation":"Installation","postInstallation":"Post-installation","installPostInstallCombo":"Combo Installation/Post-installation","hold":"Attente","status":"Statut","serviceCoverage":"Couverture de service","warranty":"Garantie - FACTURE HARDT","costcoNonWarranty":"Hors garantie Costco - FACTURE HARDT","costcoPreventativeMaintenance":"Maintenance Préventive Costco, Facture Hardt","wallMartNonWarranty":"Hors garantie Wal-Mart - FACTURE HARDT","pendingWarranty":"Garantie en attente - FACTURE HARDT DÉCISION EN ATTENTE","warrantyException":"Exception de garantie - FACTURE HARDT","installationPostInstallation":"Installation / Post-installation","nonWarranty":"Hors garantie / FACTURE Hardt","overtimeApproved":"Heures supplémentaires approuvées","communicationRequirements":"Exigences de communication","productNote":"Note pour l'équipement (Produit)","responseTime":"Temps de réponse","symptoms":"Symptômes","selectCategory":"Choisir une catégorie","pleaseSelectCategory":"Veuillez sélectionnez la catégorie","selectSubcategory":"Sélectionnez la sous-catégorie","pleaseSelectSubcategory":"Veuillez sélectionnez la sous-catégorie","addSymptom":"Ajouter un symptôme","previousCalls":"Appels précédents","date":"Date","serialNumber":"Numéro de série","description":"Description","view":"Vue","ticketFiles":"Fichiers de ticket","dropFile":"Déposez le fichier ici ou","clicktoUpload":"cliquez pour télécharger","copyAndSave":"Copier et enregistrer","save":"Enregistrer","close":"Fermer","cancel":"Annuler","customerRs":"Client 'RS'","rsMessage1":"Vous êtes un client de RS, veuillez appliquer les procédures appropriées.","rsMessage2":"Cliquez sur 'OK' pour continuer ou Afficher les procédures RS.","ok":"OK","viewRsProcedures":"Afficher les procédures RS","sendAsEmail":"Envoyer par e-mail","serviceCompany":"Société de services","phone":"Téléphone","email":"Email","callerEmail":"Email de l'appelant","useCustom":"Utiliser personnalisé","send":"Envoyer","yesSaveSend":"Oui, enregistrer et envoyer par e-mail","noSaveClose":"Non, enregistrer et fermer","ticket":"Ticket","details":"Détails","callBy":"Appeler par","address":"Adresse","customerName":"Nom du client","select":"Sélectionner","model":"Modèle","serial":"Série","coverage":"Couverture","gasType":"Type de gaz","warrEnd":"Fin de garantie","symptomCodes":"Codes de symptômes","mandatoryParts":"Pièces obligatoires","recommendedParts":"Pièces recommandées","comments":"Commentaires","newTicketComment":"Nouveau commentaire de ticket","saveComment":"Enregistrer le commentaire","generateAuth":"Générer l'authentification#","seeAuth":"Voir Authentification#","currentAuth":"Authentification actuelle# :","resend":"Renvoyer","resolveTicket":"Résoudre le ticket","reopen":"Rouvrir","print":"Imprimer","accept":"Accepter","reject":"Rejeter","update":"Mise à jour","rejectServiceDispatch":"Veuillez confirmer pourquoi vous REJETEZ cette intervention de service?","partNumber":"Numéro d'article","techName":"Nom du technicien","generate":"Générer","export":"Exporter","customerNumber":"Numéro de client","ticketNumber":"Numéro de ticket","city":"Ville","state":"État","lookUpServiceCompany":"***Look-Up***Service Company contient, par ex. DCS-","fromRaisedOnDate":"***À partir de la date de levée***","toRaisedOnDate":"*** À lever le ***","confirmation":"Confirmation","openedBy":"Ouvert par","raisedOn":"Date de soumission","codeDescription":"Code-Description","serviceCompanyPhone":"Téléphone de l'entreprise de services","ticketSent":"Le ticket a été envoyé (nombre d'heures)","operations":"Opérations","mondayToFriday":"lundi au vendredi","mondayToFridayHours":" 8 h à 17 h 30","afterHours":"après heures ouvrables","afterHoursHours":" 17 h 30 à 22 h","afterHoursWeekends":"après heures ouvrables / fins de semaine","afterHoursWeekendsHours":" 7 h 30 à 18 h","hardtEqTechnResources":"Ressources techniques pour les équipements Hardt","hardtEqTechnResourcesText1":"Besoin de dessins, de schémas ou de documents techniques ?","hardtEqTechnResourcesText2":"Accédez-y instantanément avec notre bibliothèque en ligne:","liveSupportAvailability":"Assistance en direct (HNE)","statusHistory":"Historique du statut","changedAt":"Modifié le","oldStatus":"Ancien statut","newStatus":"Nouveau statut","changedBy":"Modifié par","source":"Source"}

/***/ }),

/***/ "0cFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceCompanyList__ = __webpack_require__("mAoe");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceCompanyList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateServiceCompanyDialog__ = __webpack_require__("qd8r");
/* unused harmony reexport CreateUpdateServiceCompanyDialog */



/***/ }),

/***/ "0dYb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectCategory'),"loading":_vm.loading},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.categories),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0wAw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"Duplicate Ticket Warning","visible":_vm.dialogVisible,"width":"30%","append-to-body":""},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('span',[_vm._v("\n        Ticket "+_vm._s(_vm.existingTicketId)+" was generated on "+_vm._s(_vm.existingTicketDate)+",\n        please review to ensure a duplicate ticket is not being created.\n    ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.handleCancel}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleContinue}},[_vm._v("Continue Anyway")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0wdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateResolutionCodeCategoryDialog_vue__ = __webpack_require__("fBw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a911f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateResolutionCodeCategoryDialog_vue__ = __webpack_require__("gG23");
function injectStyle (ssrContext) {
  __webpack_require__("l3fA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateResolutionCodeCategoryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a911f4a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateResolutionCodeCategoryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "12Wx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "15dZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getDocumentation: function getDocumentation() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/technicaldocumentation');
    },
    getFolders: function getFolders() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/technicaldocumentation/folders');
    },
    createFolder: function createFolder(form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/technicaldocumentation/folders', form);
    },
    deleteFolder: function deleteFolder(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/technicaldocumentation/folders/' + id, id);
    },
    deleteDocument: function deleteDocument(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/technicaldocumentation/' + id, id);
    },
    uploadDocuments: function uploadDocuments(form) {
        var fd = new FormData();
        for (var prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'documents') {
                    for (var i = 0; i < form.documents.length; i++) {
                        if (form.documents[i] instanceof File) {
                            fd.append('documents', form.documents[i]);
                        }
                    }
                } else {
                    fd.append(prop, form[prop]);
                }
            }
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/technicaldocumentation', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
});

/***/ }),

/***/ "1AEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanadianTaxList_vue__ = __webpack_require__("FuKB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165df7af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanadianTaxList_vue__ = __webpack_require__("sRA6");
function injectStyle (ssrContext) {
  __webpack_require__("2ZHm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-165df7af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanadianTaxList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_165df7af_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanadianTaxList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1l2M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RepairCodeSelector__ = __webpack_require__("z60R");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "add-repair-code-dialog",
    components: {
        RepairCodeSelector: __WEBPACK_IMPORTED_MODULE_1__RepairCodeSelector__["a" /* default */]
    },
    props: {
        productId: {
            required: true
        },
        codeToEdit: {
            default: undefined
        },
        visible: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        var _this = this;

        return {
            form: {
                regularTime: 0,
                overTime: 0,
                supplementaryRegularTime: 0,
                supplementaryOverTime: 0,
                supplementaryComment: ""
            },
            rules: {
                regularTime: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseRegularTime'),
                    trigger: "blur"
                }],
                overTime: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseOvertime'),
                    trigger: "blur"
                }],
                supplementaryComment: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.commentEnabled && _this.form.supplementaryComment.trim() === "") {
                            callback(new Error(_this.$t('common.supplementaryCommentRequired')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }]
            },
            selectedCode: undefined,
            selectedCodes: [],
            showDialog: this.visible
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.selectedCode = undefined;
            this.selectedCodes = [];
            this.$refs["form"].resetFields();
            this.$refs["code-selector"].reset();
            this.showDialog = false;
            this.$emit("dialogClosed");
        },
        codeSelected: function codeSelected(code) {
            this.selectedCodes = [];
            if (code) {
                this.selectedCode = code;
            } else {
                this.selectedCode = undefined;
            }
        },
        codesSelected: function codesSelected(code) {
            if (this.codeToEdit) {
                return;
            }
            this.selectedCode = undefined;
            var index = this.selectedCodes.indexOf(code);
            if (code) {
                if (index === -1) {
                    this.selectedCodes.push(code);
                }
            }
        },
        addCode: function addCode() {
            var _this2 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    var codesToAdd = [];
                    if (_this2.multiple) {
                        var regularPerCode = Math.round(_this2.form.regularTime / _this2.selectedCodes.length * 100) / 100;
                        var overtimePerCode = Math.round(_this2.form.overTime / _this2.selectedCodes.length * 100) / 100;
                        for (var i = 0; i < _this2.selectedCodes.length; i++) {
                            var code = _this2.selectedCodes[i];
                            var codeToAdd = {
                                code: code
                            };
                            if (regularPerCode > code.maxTime) {
                                codeToAdd.regularTime = code.maxTime;
                                codeToAdd.supplementaryRegularTime = Math.round((regularPerCode - code.maxTime) * 100) / 100;
                                codeToAdd.supplementaryComment = _this2.form.supplementaryComment;
                            } else {
                                codeToAdd.regularTime = regularPerCode;
                                codeToAdd.supplementaryRegularTime = 0;
                            }

                            if (overtimePerCode > code.maxTime) {
                                codeToAdd.overTime = code.maxTime;
                                codeToAdd.supplementaryOverTime = Math.round((overtimePerCode - code.maxTime) * 100) / 100;
                                codeToAdd.supplementaryComment = _this2.form.supplementaryComment;
                            } else {
                                codeToAdd.overTime = overtimePerCode;
                                codeToAdd.supplementaryOverTime = 0;
                            }

                            codesToAdd.push(codeToAdd);
                        }
                    } else {
                        codesToAdd.push(_extends({
                            code: _this2.selectedCode
                        }, _this2.form));
                    }
                    var codeToEdit = _this2.codeToEdit;
                    _this2.$emit("codes-selected", { codesToAdd: codesToAdd, codeToEdit: codeToEdit });
                    _this2.closeDialog();
                }
            });
        },
        regularChange: function regularChange(evt) {
            var _this3 = this;

            if (this.multiple) {
                return;
            }
            var val = +evt.currentTarget.value;
            if (val > this.selectedCode.maxTime) {
                var timeOverMaximum = val - this.selectedCode.maxTime;
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                    _this3.form.regularTime = _this3.selectedCode.maxTime;
                });
                this.form.supplementaryRegularTime = timeOverMaximum;
                this.form.supplementaryOverTime = this.form.overTime + this.form.supplementaryOverTime;
                this.form.overTime = 0;
            } else {
                this.form.supplementaryRegularTime = 0;
                this.form.supplementaryComment = "";

                if (this.form.overTime !== 0) {
                    this.form.overTime = this.selectedCode.maxTime - val;
                    this.overTimeChange(this.form.overTime);
                }
            }
            this.$forceUpdate();
        },
        overTimeChange: function overTimeChange(evt) {
            var _this4 = this;

            if (this.multiple) {
                return;
            }
            var val = parseFloat(evt.target.value);
            if (val + this.form.regularTime > this.selectedCode.maxTime) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
                    _this4.form.overTime = _this4.selectedCode.maxTime - _this4.form.regularTime;
                });
                var timeOverMaximum = val + this.form.regularTime - this.selectedCode.maxTime;
                this.form.supplementaryOverTime = timeOverMaximum;
            } else {
                this.form.supplementaryOverTime = 0;
            }
        },
        deleteCode: function deleteCode(id) {
            this.selectedCodes = this.selectedCodes.filter(function (item) {
                return item.id !== id;
            });
        }
    },
    computed: {
        commentEnabled: function commentEnabled() {
            return !this.multiple && this.selectedCode !== undefined && (this.form.supplementaryRegularTime > 0 || this.form.supplementaryOverTime > 0);
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        codeToEdit: function codeToEdit(val) {
            if (!val) return;
            this.selectedCode = val.code;
            this.form.regularTime = val.regularTime;
            this.form.overTime = val.overTime;
            this.form.supplementaryRegularTime = val.supplementaryRegularTime;
            this.form.supplementaryOverTime = val.supplementaryOverTime;
            this.form.supplementaryComment = val.supplementaryComment;
        }
    }
});

/***/ }),

/***/ "1lX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompanySelector__ = __webpack_require__("v9zC");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CompanySelector__["a"]; });


/***/ }),

/***/ "1qrV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1w+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("kFxS");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* Dashboard */],
  name: 'dashboard'
}]);

/***/ }),

/***/ "1zRy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'rma-status-selector',
    props: ['value', 'disabled'],
    data: function data() {
        return {
            loading: false,
            statuses: [{ id: 0, name: "Closed" }, { id: 1, name: "Opened" }],
            reOpenStatuses: [{ id: 0, name: "Closed" }, { id: 2, name: "Reopen" }]
        };
    }
});

/***/ }),

/***/ "2XZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerChainList__ = __webpack_require__("wGf4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerChainList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateCustomerChainDialog__ = __webpack_require__("ozTw");
/* unused harmony reexport CreateUpdateCustomerChainDialog */



/***/ }),

/***/ "2ZHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2as5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.showDialog,"width":"750px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadServiceCompany,"close":_vm.closeDialog}},[_c('el-tabs',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],model:{value:(_vm.activeStep),callback:function ($$v) {_vm.activeStep=$$v},expression:"activeStep"}},[_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":(_vm.serviceCompanyId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('common.serviceCompany'),"name":"serviceCompany"}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"200px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.code'),"prop":"code"}},[_c('el-input',{attrs:{"disabled":_vm.serviceCompanyId !== null},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-form-item',{attrs:{"label":_vm.$t('masters.epicorSupplierCode'),"prop":"epicorSupplierCode"}},[_c('el-input',{model:{value:(_vm.form.epicorSupplierCode),callback:function ($$v) {_vm.$set(_vm.form, "epicorSupplierCode", $$v)},expression:"form.epicorSupplierCode"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.contactPerson'),"prop":"contactPersonName"}},[_c('el-input',{model:{value:(_vm.form.contactPersonName),callback:function ($$v) {_vm.$set(_vm.form, "contactPersonName", $$v)},expression:"form.contactPersonName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.companyType'),"prop":"companyType"}},[_c('el-radio-group',{model:{value:(_vm.form.companyType),callback:function ($$v) {_vm.$set(_vm.form, "companyType", $$v)},expression:"form.companyType"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('masters.regular')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('masters.parent')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"}},[_vm._v(_vm._s(_vm.$t('masters.subAgent')))])],1)],1),_vm._v(" "),(_vm.form.companyType == 3)?_c('el-form-item',{attrs:{"label":_vm.$t('masters.parentAccount'),"prop":"parentAccount"}},[_c('el-select',{model:{value:(_vm.form.parentCompanyId),callback:function ($$v) {_vm.$set(_vm.form, "parentCompanyId", $$v)},expression:"form.parentCompanyId"}},_vm._l((_vm.parentCompanies),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.rating'),"prop":"rating"}},[_c('el-radio-group',{model:{value:(_vm.form.rating),callback:function ($$v) {_vm.$set(_vm.form, "rating", $$v)},expression:"form.rating"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v("A")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("B")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"}},[_vm._v("C")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.isLimited')}},[_c('el-switch',{model:{value:(_vm.form.isLimited),callback:function ($$v) {_vm.$set(_vm.form, "isLimited", $$v)},expression:"form.isLimited"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.isAuthorized')}},[_c('el-switch',{model:{value:(_vm.form.isAuthorized),callback:function ($$v) {_vm.$set(_vm.form, "isAuthorized", $$v)},expression:"form.isAuthorized"}})],1),_vm._v(" "),_c('address-selector',{model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_vm._v(" "),(_vm.isCanadian)?_c('el-form-item',{attrs:{"label":"GST","prop":"gst"}},[_c('el-input',{model:{value:(_vm.form.gst),callback:function ($$v) {_vm.$set(_vm.form, "gst", $$v)},expression:"form.gst"}})],1):_vm._e(),_vm._v(" "),(_vm.isCanadian)?_c('el-form-item',{attrs:{"label":"PST","prop":"qst"}},[_c('el-input',{model:{value:(_vm.form.qst),callback:function ($$v) {_vm.$set(_vm.form, "qst", $$v)},expression:"form.qst"}})],1):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('masters.contactInfo')))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.bilingAccountEmail'),"prop":"email"}},[_c('el-input',{model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.serviceEmail'),"prop":"serviceEmail"}},[_c('el-input',{model:{value:(_vm.form.serviceEmail),callback:function ($$v) {_vm.$set(_vm.form, "serviceEmail", $$v)},expression:"form.serviceEmail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.serviceEmail2'),"prop":"serviceEmail2"}},[_c('el-input',{model:{value:(_vm.form.serviceEmail2),callback:function ($$v) {_vm.$set(_vm.form, "serviceEmail2", $$v)},expression:"form.serviceEmail2"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.partsEmail'),"prop":"partsEmail"}},[_c('el-input',{model:{value:(_vm.form.partsEmail),callback:function ($$v) {_vm.$set(_vm.form, "partsEmail", $$v)},expression:"form.partsEmail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.phone'),"prop":"phone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('masters.warrantyRates')))]),_vm._v(" "),(_vm.serviceCompanyId !== null)?_c('p',[_vm._v(_vm._s(_vm.$t('masters.lastUpdate'))+" "+_vm._s(_vm._f("date")(_vm.form.lastRatesUpdate)))]):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"rate-input-set"},[_vm._v(_vm._s(_vm.$t('masters.regularTimeRates')))]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyRegularLaborRate","label-width":"0","label":_vm.$t('common.labor')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.laborRate')},model:{value:(_vm.form.warrantyRegularLaborRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyRegularLaborRate", _vm._n($$v))},expression:"form.warrantyRegularLaborRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyRegularTravelRate","label-width":"0","label":_vm.$t('masters.travel')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.travelRate')},model:{value:(_vm.form.warrantyRegularTravelRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyRegularTravelRate", _vm._n($$v))},expression:"form.warrantyRegularTravelRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyRegularMileageRate","label-width":"0","label":_vm.$t('common.mileage')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.mileageRate')},model:{value:(_vm.form.warrantyRegularMileageRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyRegularMileageRate", _vm._n($$v))},expression:"form.warrantyRegularMileageRate"}})],1)],1)],1),_vm._v(" "),_c('h4',{staticClass:"rate-input-set"},[_vm._v(_vm._s(_vm.$t('masters.overtimeRates')))]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyOvertimeLaborRate","label-width":"0","label":_vm.$t('common.labor')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.laborRate')},model:{value:(_vm.form.warrantyOvertimeLaborRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyOvertimeLaborRate", _vm._n($$v))},expression:"form.warrantyOvertimeLaborRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyOvertimeTravelRate","label-width":"0","label":_vm.$t('masters.travel')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.travelRate')},model:{value:(_vm.form.warrantyOvertimeTravelRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyOvertimeTravelRate", _vm._n($$v))},expression:"form.warrantyOvertimeTravelRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"warrantyOvertimeMileageRate","label-width":"0","label":_vm.$t('common.mileage')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.mileageRate')},model:{value:(_vm.form.warrantyOvertimeMileageRate),callback:function ($$v) {_vm.$set(_vm.form, "warrantyOvertimeMileageRate", _vm._n($$v))},expression:"form.warrantyOvertimeMileageRate"}})],1)],1)],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('masters.nonWarrantyRates')))]),_vm._v(" "),_c('h4',{staticClass:"rate-input-set"},[_vm._v(_vm._s(_vm.$t('masters.regularTimeRates')))]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyRegularLaborRate","label-width":"0","label":_vm.$t('common.labor')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.laborRate')},model:{value:(_vm.form.nonWarrantyRegularLaborRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyRegularLaborRate", _vm._n($$v))},expression:"form.nonWarrantyRegularLaborRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyRegularTravelRate","label-width":"0","label":_vm.$t('masters.travel')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.travelRate')},model:{value:(_vm.form.nonWarrantyRegularTravelRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyRegularTravelRate", _vm._n($$v))},expression:"form.nonWarrantyRegularTravelRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyRegularMileageRate","label-width":"0","label":_vm.$t('common.mileage')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.mileageRate')},model:{value:(_vm.form.nonWarrantyRegularMileageRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyRegularMileageRate", _vm._n($$v))},expression:"form.nonWarrantyRegularMileageRate"}})],1)],1)],1),_vm._v(" "),_c('h4',{staticClass:"rate-input-set"},[_vm._v(_vm._s(_vm.$t('masters.overtimeRates')))]),_vm._v(" "),_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyOvertimeLaborRate","label-width":"0","label":_vm.$t('common.labor')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.laborRate')},model:{value:(_vm.form.nonWarrantyOvertimeLaborRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyOvertimeLaborRate", _vm._n($$v))},expression:"form.nonWarrantyOvertimeLaborRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyOvertimeTravelRate","label-width":"0","label":_vm.$t('masters.travel')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.travelRate')},model:{value:(_vm.form.nonWarrantyOvertimeTravelRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyOvertimeTravelRate", _vm._n($$v))},expression:"form.nonWarrantyOvertimeTravelRate"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"prop":"nonWarrantyOvertimeMileageRate","label-width":"0","label":_vm.$t('common.mileage')}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.mileageRate')},model:{value:(_vm.form.nonWarrantyOvertimeMileageRate),callback:function ($$v) {_vm.$set(_vm.form, "nonWarrantyOvertimeMileageRate", _vm._n($$v))},expression:"form.nonWarrantyOvertimeMileageRate"}})],1)],1)],1)],1)],1),_vm._v(" "),(_vm.serviceCompanyId !== null)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('common.subContractor'),"name":"subContractor"}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"formSubContractor",attrs:{"model":_vm.formSubContractor,"rules":_vm.rulesSubContractor,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.formSubContractor.name),callback:function ($$v) {_vm.$set(_vm.formSubContractor, "name", $$v)},expression:"formSubContractor.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.contactPerson'),"prop":"contactName"}},[_c('el-input',{model:{value:(_vm.formSubContractor.contactName),callback:function ($$v) {_vm.$set(_vm.formSubContractor, "contactName", $$v)},expression:"formSubContractor.contactName"}})],1),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('masters.contactInfo')))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.phone'),"prop":"phone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.formSubContractor.phone),callback:function ($$v) {_vm.$set(_vm.formSubContractor, "phone", $$v)},expression:"formSubContractor.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.email'),"prop":"email"}},[_c('el-input',{model:{value:(_vm.formSubContractor.email),callback:function ($$v) {_vm.$set(_vm.formSubContractor, "email", $$v)},expression:"formSubContractor.email"}})],1)],1),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.addSubcontractor}},[_vm._v(_vm._s(_vm.formSubContractor.id ? _vm.$t('common.update') : _vm.$t('common.add')))]),_vm._v(" "),_c('div',{staticClass:"subcontractors"},[(_vm.subcontractors.length > 0)?_c('el-row',{staticClass:"subcontractors-header"},[_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(_vm.$t('common.name'))+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(_vm.$t('common.contact'))+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(_vm.$t('common.phone'))+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_vm._v(" "+_vm._s(_vm.$t('common.email'))+" ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.subcontractors),function(subcontractor){return _c('el-row',{key:subcontractor.id},[_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(subcontractor.name)+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(subcontractor.contactName)+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_vm._v(" "+_vm._s(subcontractor.phone)+" ")]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_vm._v(" "+_vm._s(subcontractor.email)+" ")]),_vm._v(" "),_c('i',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editSubcontractor(subcontractor)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),_c('i',{attrs:{"size":"mini"},on:{"click":function($event){_vm.deleteSubcontractor(subcontractor)}}},[_c('i',{staticClass:"el-icon-delete"})])],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.form.companyType == 2)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('masters.branchContractor'),"name":"branchContractor"}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},_vm._l((_vm.form.childCompaniesList),function(item){return _c('span',{staticStyle:{"display":"flex","justify-content":"space-around"}},[_c('span',[_c('el-label',[_vm._v(_vm._s(_vm.$t('common.code')))]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true},model:{value:(item.code),callback:function ($$v) {_vm.$set(item, "code", $$v)},expression:"item.code"}})],1),_vm._v(" "),_c('span',[_c('el-label',[_vm._v(_vm._s(_vm.$t('common.name')))]),_vm._v(" "),_c('el-input',{attrs:{"disabled":true},model:{value:(item.name),callback:function ($$v) {_vm.$set(item, "name", $$v)},expression:"item.name"}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"auto"}},[_c('el-button',{staticStyle:{"max-height":"40px"},on:{"click":function($event){_vm.navigateToBranchContractor(item.id)}}},[_vm._v("\n                            "+_vm._s(_vm.$t('common.link'))+"\n                        ")])],1)])}))],1):_vm._e()],1),_vm._v(" "),(_vm.activeStep == 'serviceCompany')?_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin&&_vm.serviceCompanyId)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary","title":_vm.$t('common.weWillSendEmailToResetPassword')},on:{"click":_vm.resetPassword}},[_vm._v(_vm._s(_vm.$t('common.resetPassword')))]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.serviceCompanyId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2iVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketSelector_vue__ = __webpack_require__("twtB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe244f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketSelector_vue__ = __webpack_require__("hTs4");
function injectStyle (ssrContext) {
  __webpack_require__("YFZB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55fe244f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fe244f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2urG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2zae":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NodeTree__ = __webpack_require__("UZ+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("15dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "documentation-list",
    components: {
        NodeTree: __WEBPACK_IMPORTED_MODULE_0__NodeTree__["a" /* default */]
    },
    data: function data(vm) {
        return {
            totalFiles: 0,
            uploadFilesLength: 0,
            totalFilesLength: 0,
            loading: false,
            uploading: false,
            folderList: [],
            folders: [],
            uploadPercentage: 0,
            form: {
                name: "",
                parent: undefined
            },
            rules: {
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterName'),
                    trigger: "blur"
                }]
            },
            uploadForm: {
                folderId: undefined,
                documents: []
            },
            uploadRules: {
                folder: [{
                    required: true,
                    message: vm.$t('common.pleaseSelectFolder'),
                    trigger: "change"
                }],
                documents: [{
                    type: "array",
                    message: vm.$t('common.pleaseSelectDocumentsToUpload'),
                    required: true,
                    trigger: "change"
                }]
            }
        };
    },
    created: function created() {
        this.loadDocumentation();
        this.loadFolders();
    },

    methods: {
        getTotal: function getTotal(fileList) {
            for (var i = 0; i < fileList.length; i++) {
                this.uploadFilesLength += fileList[i].size;
            }
            this.uploadFilesLength = Math.floor(this.uploadFilesLength / 1024);
        },
        deleteAttachment: function deleteAttachment(file, fileList) {
            this.getTotal(fileList);
        },
        documentPlaced: function documentPlaced(file, fileList) {
            this.getTotal(fileList);
            this.uploadForm.documents = fileList.map(function (f) {
                return f.raw;
            });
        },
        countTotalSize: function countTotalSize(value, folders) {
            for (var i = 0; i < folders.length; i++) {
                var folder = folders[i];
                value += folder.folderSize;
                if (folder.children.length) {
                    for (var j = 0; j < folder.children.length; j++) {
                        value += this.countTotalSize(value, [folder.children[j]]);
                    }
                }
            }
            return value;
        },
        loadDocumentation: function loadDocumentation() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getDocumentation().then(function (response) {
                _this.folders = response.data;
                _this.loading = false;
                var size = _this.countTotalSize(0, _this.folders);
                _this.totalFilesLength = Math.floor(size / 1024 / 1024);
            });
        },
        loadFolders: function loadFolders() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getFolders().then(function (response) {
                _this2.folderList = response.data;
            });
        },
        addFolder: function addFolder() {
            var _this3 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].createFolder(_this3.form).then(function (response) {
                        _this3.$notify({
                            title: _this3.$t('common.success'),
                            message: _this3.$t('common.folderSuccesfullyCreated'),
                            type: "success"
                        });
                        _this3.$refs["form"].resetFields();
                        _this3.loadFolders();
                        _this3.loadDocumentation();
                    });
                }
            });
        },
        uploadDocuments: function uploadDocuments() {
            var _this4 = this;

            this.$refs["uploadForm"].validate(function (valid) {
                if (valid) {
                    _this4.uploading = true;
                    var form = _this4.uploadForm;
                    var fd = new FormData();
                    for (var prop in form) {
                        if (form.hasOwnProperty(prop)) {
                            if (prop === "documents") {
                                for (var i = 0; i < form.documents.length; i++) {
                                    if (form.documents[i] instanceof File) {
                                        fd.append("documents", form.documents[i]);
                                    }
                                }
                            } else {
                                fd.append(prop, form[prop]);
                            }
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("/api/technicaldocumentation", fd, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        onUploadProgress: function (progressEvent) {
                            this.uploadPercentage = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                        }.bind(_this4)
                    }).then(function (response) {
                        _this4.$notify({
                            title: _this4.$t('common.success'),
                            message: _this4.$t('common.documentsSuccesfullySubmitted'),
                            type: "success"
                        });
                        _this4.$refs["uploader"].clearFiles();
                        _this4.$refs["uploadForm"].resetFields();
                        _this4.uploadPercentage = 0;
                        _this4.uploadForm.folderId = null;
                        _this4.loadDocumentation();
                        _this4.uploading = false;
                    }).catch(function (response) {
                        _this4.uploading = false;
                    });
                }
            });
        },
        folderDeleted: function folderDeleted() {
            this.$notify({
                title: this.$t('common.success'),
                message: this.$t('common.folderSuccesfullyDeleted'),
                type: "success"
            });
            loadFolders();
            loadDocumentation();
        }
    }
});

/***/ }),

/***/ "32fV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentRegistrationDialog_vue__ = __webpack_require__("VTOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c028c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentRegistrationDialog_vue__ = __webpack_require__("ruon");
function injectStyle (ssrContext) {
  __webpack_require__("12Wx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c028c2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentRegistrationDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c028c2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentRegistrationDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3HQz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RMA_vue__ = __webpack_require__("qTlW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99f837e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RMA_vue__ = __webpack_require__("rcIU");
function injectStyle (ssrContext) {
  __webpack_require__("C+VW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-99f837e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RMA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99f837e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RMA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3HyX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page)?_c('div',{staticClass:"pdf-document"},[_c('PDFPage',_vm._b({},'PDFPage',{page: _vm.page, scale: _vm.scale},false))],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3MN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3hN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.isHistory?'Costco Request Form':'Create Costco Request',"visible":_vm.showDialog,"width":"60%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[(_vm.form.isDeleted)?_c('el-alert',{attrs:{"closable":false,"type":"error"}},[(_vm.form.isDeleted)?_c('h3',[_vm._v("IS DELETED")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.isHistory)?_c('el-alert',{attrs:{"closable":false,"title":"Hardt Tech processing","type":"warning"}},[_vm._v("\n        Processed by : "+_vm._s(_vm.form.processedBy)+" "),_c('br'),_vm._v("\n        Processed Date : "+_vm._s(_vm._f("datetime")(_vm.form.processingDate))+"\n    ")]):_vm._e(),_vm._v(" "),_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"disabled":_vm.isSavingInProgress || _vm.isHistory,"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Ticket #"}},[_c('el-input',{attrs:{"disabled":"","type":"number"},model:{value:(_vm.form.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.form, "serviceTicketNumber", $$v)},expression:"form.serviceTicketNumber"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"Customer",attrs:{"label":"Customer","prop":"customerId","disabled":_vm.isHistory}},[(!_vm.copyticket)?_c('customer-selector',{attrs:{"customerName":_vm.form.customerName,"disabled":!!_vm.isHistory},model:{value:(_vm.form.customerId),callback:function ($$v) {_vm.$set(_vm.form, "customerId", $$v)},expression:"form.customerId"}}):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('el-form-item',{attrs:{"label":"Product","prop":"equipmentId"}},[_c('equipment-selector',{attrs:{"customerId":_vm.form.customerId},on:{"equipmentSelected":_vm.equipmentSelected},model:{value:(_vm.form.equipmentId),callback:function ($$v) {_vm.$set(_vm.form, "equipmentId", $$v)},expression:"form.equipmentId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{staticStyle:{"float":"right"},attrs:{"label":"Warranty End"}},[_c('el-input',{attrs:{"disabled":"","type":"text"},model:{value:(_vm.equipmentWrtEnd),callback:function ($$v) {_vm.equipmentWrtEnd=$$v},expression:"equipmentWrtEnd"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Caller Title","prop":"callerTitle","disabled":_vm.isHistory}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.callerTitle),callback:function ($$v) {_vm.$set(_vm.form, "callerTitle", $$v)},expression:"form.callerTitle"}},[_c('el-option',{attrs:{"value":15,"label":"Food Court Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":"Deli Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":14,"label":"Deli Supervisor"}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"Meat Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":"Regional Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"Hardt Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":"Hardt Product Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"Warehouse Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":"Warehouse Manager Assistant"}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":"Operator"}}),_vm._v(" "),_c('el-option',{attrs:{"value":9,"label":"Customer Corporate Request"}}),_vm._v(" "),_c('el-option',{attrs:{"value":10,"label":"Maintenance"}}),_vm._v(" "),_c('el-option',{attrs:{"value":11,"label":"Fresh Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":12,"label":"Fresh Manager Assistant"}}),_vm._v(" "),_c('el-option',{attrs:{"value":13,"label":"Other"}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Caller Name","prop":"requestorName"}},[_c('el-input',{model:{value:(_vm.form.requestorName),callback:function ($$v) {_vm.$set(_vm.form, "requestorName", $$v)},expression:"form.requestorName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Caller Email","prop":"email"}},[_c('el-input',{model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Urgency","prop":"urgency"}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.urgency),callback:function ($$v) {_vm.$set(_vm.form, "urgency", $$v)},expression:"form.urgency"}},[_c('el-option',{attrs:{"value":1,"label":"Priority 1 - Down"}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"Priority 2 - Operational"}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":"Installation"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"Post Installation"}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":"Install/Post Install Combo"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"Hold"}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Status","prop":"status"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"value":1,"label":" "}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":"Flagged"}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":"Escalation"}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":"Standard"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Service Coverage","prop":"serviceCoverage"}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.form, "serviceCoverage", $$v)},expression:"form.serviceCoverage"}},[_c('el-option',{attrs:{"value":1,"label":"Warranty - INVOICE HARDT"}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"Costco Non-Warranty - INVOICE HARDT"}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":"Costco Preventative Maintenance, Invoice Hardt"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"Wal-Mart Non-Warranty - INVOICE HARDT"}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":"Pending Warranty - INVOICE HARDT PENDING DECISION"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"Warranty Exception - INVOICE HARDT"}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":"Installation / Post Install"}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":"Non-Warranty / INVOICE Hardt"}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Overtime Approved","prop":"overtimeApproved"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.overtimeApproved),callback:function ($$v) {_vm.$set(_vm.form, "overtimeApproved", $$v)},expression:"form.overtimeApproved"}},[_c('el-option',{attrs:{"value":true,"label":"Yes"}}),_vm._v(" "),_c('el-option',{attrs:{"value":false,"label":"No"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Communication Requirements","prop":"notes"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.notes),callback:function ($$v) {_vm.$set(_vm.form, "notes", $$v)},expression:"form.notes"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Response time","prop":"responseTime"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.responseTime),callback:function ($$v) {_vm.$set(_vm.form, "responseTime", $$v)},expression:"form.responseTime"}},[_c('el-option',{attrs:{"value":-1,"label":" "}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"2 hrs"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"4 hrs"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"6 hrs"}})],1)],1),_vm._v(" "),_c('h4',[_vm._v("Symptoms")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","justify-content":"space-around"}},[_c('el-form-item',{attrs:{"label":"Select category","prop":"categoryName"}},[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","placeholder":"Please select category"},model:{value:(_vm.form.categoryName),callback:function ($$v) {_vm.$set(_vm.form, "categoryName", $$v)},expression:"form.categoryName"}},_vm._l((_vm.form.categories),function(item){return _c('el-option',{attrs:{"label":"item.category","value":item.category}})}))],1),_vm._v(" "),(_vm.form.subCategories && _vm.form.subCategories.length >  0 && _vm.form.equipmentName && _vm.form.equipmentName.includes('I4500'))?_c('el-form-item',{staticStyle:{"margin-left":"30px"},attrs:{"label":"Select subcategory","prop":"subCategoryName"}},[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","placeholder":"Please select subcategory"},model:{value:(_vm.form.subCategoryName),callback:function ($$v) {_vm.$set(_vm.form, "subCategoryName", $$v)},expression:"form.subCategoryName"}},_vm._l((_vm.form.subCategories),function(item){return (_vm.form.categoryName)?_c('el-option',{attrs:{"label":"item","value":item}}):_vm._e()}))],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Add symptom"}},[_c('complaint-code-selector',{attrs:{"equipmentId":_vm.form.equipmentId,"categoryName":_vm.form.categoryName,"subCategoryName":_vm.form.subCategoryName},on:{"code-selected":_vm.appendCode}})],1),_vm._v(" "),_vm._l((_vm.form.complaintCodes),function(complaint){return _c('el-alert',{key:complaint.id,staticStyle:{"margin-bottom":"5px"},attrs:{"title":complaint.name,"type":"info"},on:{"close":function($event){_vm.removeCode(complaint.id)}}})}),_vm._v(" "),(_vm.previousTickets.length > 0)?_c('el-form-item',{attrs:{"label":"Previous Calls"}},[_c('el-table',{staticClass:"tablewithshading",attrs:{"disabled":_vm.isSavingInProgress,"data":_vm.previousTickets}},[_c('el-table-column',{attrs:{"prop":"raisedOn","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"Ticket #","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":"Serial Number"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"note","label":"Description","min-width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Status","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"View","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editTicket(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})])]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"10px"}},[(!_vm.previousTicketsButtonDisabled)?_c('el-button',{staticStyle:{"width":"300px"},on:{"click":function($event){_vm.getMorePreviousTickets()}}},[_vm._v("\n                    Load More\n                ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Ticket Files","prop":"attachments"}},[_c('el-upload',{attrs:{"name":"attachments","drag":"","multiple":"","file-list":_vm.form.attachments,"auto-upload":false,"limit":10,"action":"","on-change":_vm.attachmentChanged,"on-preview":_vm.handlePreview}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                    Drop file here or\n                    "),_c('em',[_vm._v("click to upload")])])])],1)],2),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(!_vm.isHistory)?_c('el-button',{attrs:{"type":"danger","disabled":_vm.isSavingInProgress},on:{"click":_vm.deleteServiceRequest}},[_vm._v("Delete")]):_vm._e(),_vm._v(" "),(!_vm.isHistory)?_c('el-button',{attrs:{"type":"primary","loading":_vm.isSavingInProgress && !_vm.isCopy,"disabled":_vm.isSavingInProgress && _vm.isCopy},on:{"click":_vm.showEmailDialog}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.isSavingInProgress},on:{"click":_vm.closeDialog}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showImagePreview,"width":"60%","append-to-body":""},on:{"update:visible":function($event){_vm.showImagePreview=$event}}},[(_vm.fileExtension!=='pdf')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.fileUrlPreview,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.fileExtension==='pdf')?_c('embed',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.fileUrlPreview,"type":"application/pdf"}}):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showImagePreview = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('send-email-dialog',{attrs:{"visible":_vm.showSaveDialog,"loadingChangeEmail":_vm.loadingChangeEmail,"formChangeEmail":_vm.formChangeEmail},on:{"save":_vm.save}}),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showRsMessage,"width":"30%","append-to-body":"","title":"Customer 'RS'"},on:{"update:visible":function($event){_vm.showRsMessage=$event}}},[_c('p',[_vm._v("\n            This is a RS Customer, please apply the appropriate procedures."),_c('br'),_vm._v("\n            Click 'OK' to proceed or View RS procedures.\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showRsMessage = false}}},[_vm._v("OK")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.viewrsprocedures}},[_vm._v("View RS procedures")])],1),_vm._v(" "),_c('service-ticket-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4/9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentList_vue__ = __webpack_require__("hbpE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214e022c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentList_vue__ = __webpack_require__("Vxr6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EquipmentList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_214e022c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EquipmentList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4LC1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4M/W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairCodeSelector_vue__ = __webpack_require__("UrNm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54bf8cff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairCodeSelector_vue__ = __webpack_require__("ej2T");
function injectStyle (ssrContext) {
  __webpack_require__("Hlr1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54bf8cff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairCodeSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54bf8cff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairCodeSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4RiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components_ChangePasswordDialog__ = __webpack_require__("QG3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_costcoservicerequests_store_js__ = __webpack_require__("Ayk/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "navigation",
    components: {
        ChangePasswordDialog: __WEBPACK_IMPORTED_MODULE_0__app_shared_components_ChangePasswordDialog__["a" /* default */]
    },
    data: function data() {
        return {
            passwordChangeVisible: false,
            language: "en",
            costcoServiceRequestsCount: 0,
            isGmailActive: false,
            store: __WEBPACK_IMPORTED_MODULE_1__app_costcoservicerequests_store_js__["a" /* default */]
        };
    },

    computed: {
        isDashboard: function isDashboard() {
            return this.$route.path === '/';
        },
        isClaims: function isClaims() {
            return this.$route.path.includes('claims');
        },
        isServiceTickets: function isServiceTickets() {
            return this.$route.path.includes('service-tickets');
        },
        isEscalationTickets: function isEscalationTickets() {
            return this.$route.path.includes('escalation-tickets');
        },
        isCostcoServiceRequests: function isCostcoServiceRequests() {
            return this.$route.path.includes('costco-service-requests');
        },
        isPartOrders: function isPartOrders() {
            return this.$route.path.includes('part-orders');
        },
        isClaimsFAQ: function isClaimsFAQ() {
            return this.$route.path.includes('FAQ');
        },
        isRma: function isRma() {
            return this.$route.path == '/rma';
        },
        isRmaReport: function isRmaReport() {
            return this.$route.path == '/reports/rma';
        }
    },
    methods: {
        openInNewTab: function openInNewTab(url) {
            window.open(url, '_blank');
        },
        signout: function signout() {
            window.localStorage.clear();
            window.document.cookie = "browserClosed=" + new Date().getTime();
            window.localStorage.setItem("browserClosed", new Date().getTime());
            window.signInManager.signoutRedirect();
        },
        changePassword: function changePassword() {
            this.passwordChangeVisible = true;
        },
        returnToAdminAccount: function returnToAdminAccount() {
            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/account/returnToAccount').then(function (response) {
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = response.data.token;
                localStorage.removeItem("isImpersonateUser");
                window.signInManager.signinRedirect();
            });
        },
        updateGmailConfiguration: function updateGmailConfiguration() {
            var _this = this;

            var data = {};
            data.isActive = this.isGmailActive;
            data.name = 'Gmail';

            var message = data.isActive ? this.$t('common.turnGmailOn') : this.$t('common.turnGmailOff');

            this.$confirm(message, 'Warning', {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            }).then(function (res) {
                __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/gmail-configuration', data).then(function (response) {
                    _this.isGmailActive = response.data.isActive;
                });
            }).catch(function (_) {
                _this.isGmailActive = !_this.isGmailActive;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/service-requests/count').then(function (response) {
            if (response.data.count) {
                _this2.store.setCount(response.data.count);
            }
        });

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/gmail-configuration').then(function (response) {
            _this2.isGmailActive = response.data.isActive;
        });
    },
    updated: function updated() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('api/service-requests/count').then(function (response) {
            if (response.data.count) {
                _this3.store.setCount(response.data.count);
            }
        });
    }
});

/***/ }),

/***/ "4a7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Costco_vue__ = __webpack_require__("x0TM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276485d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Costco_vue__ = __webpack_require__("A7XZ");
function injectStyle (ssrContext) {
  __webpack_require__("gkJ4")
  __webpack_require__("R847")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-276485d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Costco_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_276485d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Costco_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4aim":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailsList_vue__ = __webpack_require__("Z2aN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a87c45e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailsList_vue__ = __webpack_require__("Btwz");
function injectStyle (ssrContext) {
  __webpack_require__("XUke")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a87c45e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a87c45e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ap1":
/***/ (function(module, exports) {

module.exports = {"subCategory":"Sub Category","mandatoryParts":"Mandatory Parts","recommendedParts":"recommendedParts","toAddAnotherPartPleaseStartTypingNameOrPartNumber":"To add another part please start typing name or part number","storeNumberRequired":"Store Number Required","addRule":"Add Rule","validationRules":"Validation Rules","pleaseSelectChain":"Please select chain","customerDetails":"Customer Details","createCountry":"Create Country","classification":"Classification","notifications":"Notifications","newNotificationColon":"New notification:","cookingParameters":"Cooking parameters","qrCode":"QR Code","newCookingParameterColon":"New cooking parameter:","customerHasNoEquipment":"Customer has no equipment","searchNotifications":"Search notifications","messages":"Messages","customerHasNoNotifications":"Customer has no notifications","numberOfNotifications":"# of Notifications","pleaseEnterTheNotification":"Please enter the notification","needsReturn":"Needs Return","extDiscountRate":"Ext. Discount Rate","usListPrice":"US List Price","cdnListPrice":"CDN List Price","unavailableForPartsOrders":"Unavailable for parts orders","unavailableForClaimsDeactivated":"Unavailable for claims (Deactivated)","authorizationNumRequired":"Authorization # Required","pleaseLeaveCommentBeforeDeactivatePart":"Please leave comment before deactivate part","extendedPriceRate":"Extended Price Rate","usExtendedPrice":"US Extended Price","cdnExtendedPrice":"CDN Extended Price","shipVia":"Ship Via","authReq":"Auth Req.","errorsWhileImporting":"Errors while importing","AreYouSureThatYouWantToImportParts":"Are you sure that you want to import parts?","partsWillBeUpdated":"parts will be updated","partsWillBeDeleted":"parts will be deleted","partsWillBeAdded":"parts will be added","serialPrefix":"Serial Prefix","laborGLCode":"Labor GL Code","partGLCode":"Part GL Code","handlingGLCode":"Handling GL Code","freightGLCode":"Freight GL Code","miscGLCode":"Misc GL Code","note":"Service Ticket Note","type":"Type","resolutionCode":"Resolution Code","epicorSupplierCode":"Epicor Supplier Code","companyType":"Company Type","regular":"Regular","parent":"Parent","subAgent":"Sub-Agent","parentAccount":"Parent Account","rating":"Rating","isLimited":"Is Limited","isAuthorized":"Is Authorized","contactInfo":"Contact Info","bilingAccountEmail":"Billing Account E-Mail","serviceEmail":"Service E-Mail","serviceEmail2":"Service Email 2","partsEmail":"Parts E-Mail","warrantyRates":"Warranty Rates","lastUpdate":"Last Update","regularTimeRates":"Regular Time Rates","laborRate":"Labor Rate","travel":"Travel","travelRate":"Travel Rate","mileageRate":"Mileage Rate","overtimeRates":"Overtime Rates","nonWarrantyRates":"Non-Warranty Rates","branchContractor":"Branch Contractor","weWillSendEmailToResetPassword":"We will send email to reset password","searchByNameOrCode":"Search by name or code","suspendServiceCompany":"Suspend service company","activateServiceCompany":"Activate service company","impersonate":"Impersonate","userName":"UserName","isReadOnly":"Is Read Only","isSuperAdmin":"Is Super Admin","symptomCode":"Symptom Code","customerChain":"Customer Chain","part":"Part","product":"Product","descriptionlengtherror":"Description cannot exceed 500 characters.","thisWillDeleteCategoryContinue":"This will delete category, continue?","categoryCreated":"Category created","categoryUpdated":"Category updated"}

/***/ }),

/***/ "4ffL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/web/viewer.html?file=%2Fhttps://sims2hardt.blob.core.windows.net/documentation/d733755dd6c446ae9d1c09dae080ae9b-Blaze.pdf"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "587g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("YN2j");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "5ERq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[(_vm.$isFullAdmin)?_c('el-col',{attrs:{"span":8}},[_vm._v("\n             \n            "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('product-selector',{model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('resolution-category-selector',{attrs:{"productId":_vm.filter.productId},model:{value:(_vm.filter.categoryId),callback:function ($$v) {_vm.$set(_vm.filter, "categoryId", $$v)},expression:"filter.categoryId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.codes}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('common.code'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"product","label":_vm.$t('common.product'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"category","label":_vm.$t('common.category'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"labor","label":_vm.$t('common.labor'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"maxTime","label":_vm.$t('common.maxTime'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 160 : 116 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editCode(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isFullAdmin && _vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteCode(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-resolution-code-dialog',{attrs:{"codeId":_vm.codeToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendCode}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Ju1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryInfo_vue__ = __webpack_require__("ndkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4483522a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryInfo_vue__ = __webpack_require__("Ks6o");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeliveryInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4483522a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeliveryInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5KcP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("o8U/");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "5V4q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("TmYv");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/technical-documentation',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* DocumentationList */],
    name: 'documentationList'
}]);

/***/ }),

/***/ "5W/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComplaintCodeList__ = __webpack_require__("M0Cj");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ComplaintCodeList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateComplaintCodeDialog__ = __webpack_require__("xMBn");
/* unused harmony reexport CreateUpdateComplaintCodeDialog */



/***/ }),

/***/ "5avN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceCoverageSelector_vue__ = __webpack_require__("nw/e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5db50e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceCoverageSelector_vue__ = __webpack_require__("h84l");
function injectStyle (ssrContext) {
  __webpack_require__("+XIM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fa5db50e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceCoverageSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa5db50e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceCoverageSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5h5b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("9aBF");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-update-service-company-dialog",
    components: {
        AddressSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["a" /* AddressSelector */],
        ChainSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["d" /* ChainSelector */]
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        serviceCompanyId: {
            required: false
        }
    },
    data: function data() {
        var _this = this,
            _rules;

        return {
            form: {
                code: undefined,
                name: undefined,
                epicorSupplierCode: undefined,
                contactPersonName: undefined,
                rating: undefined,
                isLimited: undefined,
                isAuthorized: undefined,
                selectedCountryState: undefined,
                city: undefined,
                address: undefined,
                regional: undefined,
                region: undefined,
                zip: undefined,
                qst: undefined,
                gst: undefined,
                phone: undefined,
                email: undefined,
                serviceEmail: undefined,
                serviceEmail2: undefined,
                partsEmail: undefined,
                shipToName: undefined
            },
            rules: (_rules = {
                code: [{
                    required: true,
                    message: this.$t('common.pleaseEnterServiceCompanyCode'),
                    trigger: "blur"
                }],
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterServiceCompanyName'),
                    trigger: "blur"
                }],
                contactPersonName: [{
                    required: true,
                    message: this.$t('common.pleaseEnterContactPersonName'),
                    trigger: "blur"
                }],
                rating: [{
                    required: true,
                    message: this.$t('common.pleaseEnterRating'),
                    trigger: "change"
                }],
                selectedCountryState: [{
                    type: "array",
                    required: true,
                    message: this.$t('common.pleaseEnterProvinceAndCountry'),
                    trigger: "change"
                }],
                gst: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.isCanadian && (!value || value === "")) {
                            callback(new Error(_this.$t('common.gstNumberIsRequired')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],
                qst: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.isCanadian && (!value || value === "")) {
                            callback(new Error(_this.$t('common.pstNumberIsRequired')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],

                city: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCity'),
                    trigger: "blur"
                }],
                shipToName: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shipToName) {
                            if (!_this.form.shipToName.trim()) {
                                return callback(new Error(_this.$confirm(_this.$t('common.pleaseEnterCompanyName'))));
                            } else return callback();
                        } else return callback(new Error(_this.$confirm(_this.$t('common.pleaseEnterCompanyName'))));
                    },
                    required: true,
                    trigger: "blur"
                }],
                address: [{
                    required: true,
                    message: this.$t('common.pleaseEnterAddress'),
                    trigger: "blur"
                }]
            }, _defineProperty(_rules, "shipToName", [{
                validator: function validator(rule, value, callback) {
                    if (_this.form.shipToName) {
                        if (!_this.form.shipToName.trim()) {
                            return callback(new Error(_this.$confirm(_this.$t('common.pleaseEnterCompanyName'))));
                        } else return callback();
                    } else return callback(new Error(_this.$confirm(_this.$t('common.pleaseEnterCompanyName'))));
                },
                required: true,
                trigger: "blur"
            }]), _defineProperty(_rules, "zip", [{
                required: true,
                message: this.$t('common.pleaseEnterZip'),
                trigger: "blur"
            }]), _defineProperty(_rules, "email", [{
                required: true,
                message: this.$t('common.pleaseEnterEmail'),
                trigger: "blur"
            }]), _defineProperty(_rules, "serviceEmail", [{
                required: true,
                message: this.$t('common.pleaseEnterServiceEmail'),
                trigger: "blur"
            }]), _defineProperty(_rules, "partsEmail", [{
                required: true,
                message: this.$t('common.pleaseEnterPartsEmail'),
                trigger: "blur"
            }]), _defineProperty(_rules, "phone", [{
                required: true,
                message: this.$t('common.pleaseEnterPhone'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyRegularLaborRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyRegularTravelRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyRegularMileageRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyOvertimeLaborRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyOvertimeTravelRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "warrantyOvertimeMileageRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyRegularLaborRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyRegularTravelRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyRegularMileageRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyOvertimeLaborRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyOvertimeTravelRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _defineProperty(_rules, "nonWarrantyOvertimeMileageRate", [{
                type: "number",
                required: true,
                message: this.$t('common.pleaseEnterRate'),
                trigger: "blur"
            }]), _rules),
            loading: false,
            showDialog: this.visible,
            activeStep: "serviceCompany",
            formSubContractor: {
                id: undefined,
                name: undefined,
                contactName: undefined,
                phone: undefined,
                email: undefined
            },
            rulesSubContractor: {
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterSubContractorName'),
                    trigger: "blur"
                }],
                contactName: [{
                    required: true,
                    message: this.$t('common.pleaseEnterContactName'),
                    trigger: "blur"
                }],
                email: [{
                    required: true,
                    message: this.$t('common.pleaseEnterEmail'),
                    trigger: "blur"
                }],
                phone: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPhone'),
                    trigger: "blur"
                }]
            },
            subcontractors: {}
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    computed: {
        isCanadian: function isCanadian() {
            return this.form.selectedCountryState && this.form.selectedCountryState[0] === "2";
        },
        isQuebec: function isQuebec() {
            return this.isCanadian && this.form.selectedCountryState[1] === "49";
        }
    },
    methods: {
        loadServiceCompany: function loadServiceCompany() {
            var _this2 = this;

            this.loading = true;
            if (this.serviceCompanyId) {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getServiceCompany(this.serviceCompanyId).then(function (serviceCompany) {
                    _this2.loading = false;
                    _this2.form = Object.assign({}, serviceCompany);
                    _this2.subcontractors = serviceCompany.subcontractors;
                });
            }
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getParentServiceCompanies().then(function (result) {
                _this2.loading = false;
                _this2.parentCompanies = result.data;
            });
        },
        navigateToBranchContractor: function navigateToBranchContractor(id) {
            var _this3 = this;

            this.closeDialog();
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getServiceCompany(id).then(function (serviceCompany) {
                _this3.loading = false;
                _this3.form = Object.assign({}, serviceCompany);
                _this3.subcontractors = serviceCompany.subcontractors;
                _this3.showDialog = true;
            });
        },
        closeDialog: function closeDialog() {
            this.activeStep = "serviceCompany";
            this.$refs["form"].resetFields();
            this.resetSubcontractorForm();
            this.subcontractors = {};
            this.parentCompanies = {};
            this.showDialog = false;
            this.loading = false;
            this.$emit("dialogClosed");
        },
        save: function save() {
            var _this4 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this4.loading = true;
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveServiceCompany(_this4.serviceCompanyId, _this4.form).then(function (response) {
                        _this4.$emit("save", {
                            new: _this4.serviceCompanyId === undefined,
                            id: _this4.serviceCompanyId,
                            data: _this4.form
                        });
                        _this4.closeDialog();
                    }, function (err) {
                        _this4.loading = false;
                        var message = "";
                        try {
                            message = Object.values(err.response.data).join(" ");
                        } catch (e) {
                            message = _this4.$t('common.cantCreateNewCompany');
                        }

                        _this4.$message.error(message);
                    });
                } else {
                    return false;
                }
            });
        },
        resetPassword: function resetPassword() {
            var _this5 = this;

            this.$confirm(this.$t('common.weWillSendEmailToResetPasswordContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].resetPassword(_this5.serviceCompanyId).then(function () {
                    _this5.$notify({
                        title: _this5.$t('common.success'),
                        message: _this5.$t('common.emailWasSent'),
                        type: "success"
                    });
                });
            }).catch(function (_) {});
        },
        addSubcontractor: function addSubcontractor() {
            var _this6 = this;

            this.$refs["formSubContractor"].validate(function (valid) {
                if (valid) {
                    _this6.loading = true;
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].addSubcontractor(_this6.serviceCompanyId, _this6.formSubContractor).then(function (response) {
                        _this6.loading = false;
                        _this6.resetSubcontractorForm();
                        if (response.data) {
                            var edited = _this6.subcontractors.filter(function (item) {
                                return item.id === response.data.id;
                            });
                            if (edited.length) {
                                edited[0].name = response.data.name;
                                edited[0].contactName = response.data.contactName;
                                edited[0].phone = response.data.phone;
                                edited[0].email = response.data.email;
                                _this6.resetSubcontractorForm();
                            } else {
                                _this6.subcontractors.push(response.data);
                            }
                        }
                    });
                }
            });
        },
        editSubcontractor: function editSubcontractor(subcontractor) {
            this.formSubContractor.id = subcontractor.id;
            this.formSubContractor.name = subcontractor.name;
            this.formSubContractor.contactName = subcontractor.contactName;
            this.formSubContractor.phone = subcontractor.phone;
            this.formSubContractor.email = subcontractor.email;
        },
        deleteSubcontractor: function deleteSubcontractor(subcontractor) {
            var _this7 = this;

            this.$confirm(this.$t('common.areYouSureToDeleteTheSubcontractor'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteSubcontractor(_this7.serviceCompanyId, subcontractor).then(function (response) {
                    _this7.loading = false;
                    _this7.resetSubcontractorForm();
                    if (response.data.id) {
                        _this7.subcontractors = _this7.subcontractors.filter(function (item) {
                            return item.id !== response.data.id;
                        });
                    }
                    _this7.$message({
                        type: "success",
                        message: _this7.$t('common.deleteCompleted')
                    });
                });
            }).catch(function () {
                _this7.loading = false;
            });
        },
        resetSubcontractorForm: function resetSubcontractorForm() {
            if (this.$refs["formSubContractor"]) {
                this.$refs["formSubContractor"].resetFields();
                this.formSubContractor.id = undefined;
            }
        }
    }
});

/***/ }),

/***/ "60SY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainSelector_vue__ = __webpack_require__("Fpq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e96d09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainSelector_vue__ = __webpack_require__("nlNp");
function injectStyle (ssrContext) {
  __webpack_require__("4LC1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64e96d09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e96d09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "65DM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "66FX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.customerChainId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('shared.customerChain'),"visible":_vm.showDialog,"width":"500px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadCustomerChain,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"160px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.storeNumberRequired'),"prop":"storeNumberRequired"}},[_c('el-switch',{model:{value:(_vm.form.storeNumberRequired),callback:function ($$v) {_vm.$set(_vm.form, "storeNumberRequired", $$v)},expression:"form.storeNumberRequired"}})],1),_vm._v(" "),_vm._l((_vm.form.validationRules),function(rule,index){return _c('el-form-item',{key:index,attrs:{"label":'Rule ' + (index+1),"prop":'validationRules.' + index + '.value',"rules":{
  required: true, message: 'Rule can not be null', trigger: 'blur'
}}},[_c('el-input',{model:{value:(rule.value),callback:function ($$v) {_vm.$set(rule, "value", $$v)},expression:"rule.value"}},[(index > 0)?_c('el-button',{attrs:{"slot":"append"},on:{"click":function($event){$event.preventDefault();_vm.removeRule(rule)}},slot:"append"},[_vm._v(_vm._s(_vm.$t('common.delete')))]):_vm._e()],1)],1)}),_vm._v(" "),_c('el-form-item',[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.addRule}},[_vm._v(_vm._s(_vm.$t('masters.addRule')))]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.customerChainId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6dq+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ChainSelector__ = __webpack_require__("60SY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ChainSelector__["a"]; });


/***/ }),

/***/ "6lmq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.showDialog,"width":"60%","autoComplete":"false","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadOrder,"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"220px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('orders.purchaseOrder'),"prop":"purchaseOrderNumber"}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.purchaseOrderNumber),callback:function ($$v) {_vm.$set(_vm.form, "purchaseOrderNumber", $$v)},expression:"form.purchaseOrderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.orderNotes'),"prop":"notes"}},[_c('el-input',{attrs:{"type":"textarea","disabled":_vm.disableForm},model:{value:(_vm.form.notes),callback:function ($$v) {_vm.$set(_vm.form, "notes", $$v)},expression:"form.notes"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.orderDate')}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.placedAt),callback:function ($$v) {_vm.$set(_vm.form, "placedAt", $$v)},expression:"form.placedAt"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label-width":"0"}},[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('orders.billingAddress')))]),_vm._v(" "),_c('ul',{staticStyle:{"margin":"0","padding":"0","list-style":"none","line-height":"20px"}},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceCompanyName')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.name)+"\n                    ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.address')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.address)+"\n                    ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.phone')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.phone)+"\n                    ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.code')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.code)+"\n                    ")])])]),_vm._v(" "),_c('el-form-item',{staticClass:"shipping-method-toggle",attrs:{"label":_vm.$t('orders.shippingAddressSameAsBillTo')}},[_c('el-switch',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.shippingAddressAsBillTo),callback:function ($$v) {_vm.$set(_vm.form, "shippingAddressAsBillTo", $$v)},expression:"form.shippingAddressAsBillTo"}})],1),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('address-selector',{attrs:{"show-regional":false,"disable":_vm.disableForm},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},[(!_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label":_vm.$t('common.companyName')}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.shipToName),callback:function ($$v) {_vm.$set(_vm.form, "shipToName", $$v)},expression:"form.shipToName"}})],1):_vm._e(),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label":_vm.$t('common.phone')}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.shipToPhone),callback:function ($$v) {_vm.$set(_vm.form, "shipToPhone", $$v)},expression:"form.shipToPhone"}})],1):_vm._e(),_vm._v(" "),_c('h4',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('orders.shippingAddress')))])],1):_vm._e(),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label":_vm.$t('common.phone')}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.shipToPhone),callback:function ($$v) {_vm.$set(_vm.form, "shipToPhone", $$v)},expression:"form.shipToPhone"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.shippingMethod'),"prop":"shippingMethod"}},[_c('shipping-method-selector',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.shippingMethod),callback:function ($$v) {_vm.$set(_vm.form, "shippingMethod", $$v)},expression:"form.shippingMethod"}})],1),_vm._v(" "),(_vm.form.shippingMethod === '5')?_c('el-form-item',{attrs:{"label":_vm.$t('common.otherCompany'),"prop":"otherCompany"}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.otherCompany),callback:function ($$v) {_vm.$set(_vm.form, "otherCompany", $$v)},expression:"form.otherCompany"}})],1):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('common.parts')))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.addPart')}},[_c('part-selector',{attrs:{"disabled":_vm.disableForm,"serviceCompanyId":_vm.serviceCompany.id,"title":_vm.$t('masters.toAddAnotherPartPleaseStartTypingNameOrPartNumber')},on:{"part-selected":_vm.partSelected}})],1),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.form.parts,"size":"mini","summary-method":_vm.partsTotals,"show-summary":""}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.partDescription')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('small',[_vm._v(_vm._s(_vm.$i18n.locale == 'en' ? scope.row.name : scope.row.nameFr))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('common.price'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.price))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"extendedPrice","label":_vm.$t('common.extPrice'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.$isUser)?_c('el-input-number',{staticStyle:{"width":"90px"},attrs:{"size":"mini","min":0,"max":100,"disabled":_vm.orderId != null},on:{"change":function($event){_vm.quantityChanged($event, scope.row.id)}},model:{value:(scope.row.quantity),callback:function ($$v) {_vm.$set(scope.row, "quantity", $$v)},expression:"scope.row.quantity"}}):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('span',[_vm._v(_vm._s(scope.row.quantity))]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.orderStatus == 1 || _vm.orderStatus == 2)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('h4',[_vm._v("Tracking Information")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.trackingNumber'),"prop":"trackingNumber"}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.trackingNumber),callback:function ($$v) {_vm.$set(_vm.form, "trackingNumber", $$v)},expression:"form.trackingNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.serviceOrderNumber'),"prop":"serviceOrderNumber"}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.serviceOrderNumber),callback:function ($$v) {_vm.$set(_vm.form, "serviceOrderNumber", $$v)},expression:"form.serviceOrderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.shippingCost'),"prop":"shippingCharges"}},[_c('el-input',{attrs:{"type":"number","disabled":_vm.disableForm},model:{value:(_vm.form.shippingCharges),callback:function ($$v) {_vm.$set(_vm.form, "shippingCharges", _vm._n($$v))},expression:"form.shippingCharges"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedBy'),"prop":"deliverySignedBy"}},[_c('el-input',{attrs:{"disabled":_vm.disableForm},model:{value:(_vm.form.deliverySignedBy),callback:function ($$v) {_vm.$set(_vm.form, "deliverySignedBy", $$v)},expression:"form.deliverySignedBy"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedOn'),"prop":"deliveryDate"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.$t('common.selectDate'),"disabled":_vm.disableForm},model:{value:(_vm.form.deliveryDate),callback:function ($$v) {_vm.$set(_vm.form, "deliveryDate", $$v)},expression:"form.deliveryDate"}})],1),_vm._v(" "),_c('img',{staticStyle:{"cursor":"pointer","margin-left":"auto","margin-right":"auto","display":"block"},attrs:{"src":"static/ups_tracking.jpg"},on:{"click":_vm.openTrackingWindow}})],1):_vm._e()],1),_vm._v(" "),(_vm.orderStatus == 0 && _vm.$isFullAdmin)?_c('div',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.exportParts}},[_vm._v(_vm._s(_vm.$t('common.export')))])],1):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.orderId != null && _vm.$isFullAdmin && _vm.orderStatus === 0)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.printAndProcessOrder}},[_vm._v(_vm._s(_vm.$t('orders.printAndProcess')))]):_vm._e(),_vm._v(" "),(((_vm.orderId == null) || _vm.$isAdmin))?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.showSummary}},[_vm._v(_vm._s(_vm.orderId == null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.previewSummaryVisible,"width":"50%","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.previewSummaryVisible=$event},"close":_vm.closePreviewDialog}},[_c('el-form',{attrs:{"size":"small","label-width":"220px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('orders.purchaseOrder')}},[_c('span',[_vm._v(_vm._s(_vm.form.purchaseOrderNumber))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.orderNotes')}},[_c('span',[_vm._v(_vm._s(_vm.form.notes))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.orderDate')}},[_c('span',[_vm._v(_vm._s(_vm.form.placedAt))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label-width":"0"}},[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('orders.billingAddress')))]),_vm._v(" "),_c('ul',{staticStyle:{"margin":"0","padding":"0","list-style":"none","line-height":"20px"}},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceCompanyName')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.name)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.address')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.address)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.phone')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.phone)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.code')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.code)+"\n                        ")])])]),_vm._v(" "),_c('el-form-item',{staticClass:"shipping-method-toggle",attrs:{"label":_vm.$t('orders.shippingAddressSameAsBillTo')}},[_c('span',[_vm._v(_vm._s(_vm.form.shippingAddressAsBillTo ? _vm.$t('common.yes') : _vm.$t('common.no')))])]),_vm._v(" "),(_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label-width":"0"}},[_c('h4',{staticStyle:{"margin":"0"}},[_vm._v(_vm._s(_vm.$t('orders.shippingAddress')))]),_vm._v(" "),_c('ul',{staticStyle:{"margin":"0","padding":"0","list-style":"none","line-height":"20px"}},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.companyName')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.name)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.address')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.address)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.phone')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.phone)+"\n                        ")]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.code')))]),_vm._v(" "+_vm._s(_vm.serviceCompany.code)+"\n                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('address-selector',{attrs:{"show-regional":false,"showAsPreview":true},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}},[_c('h4',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('orders.shippingAddress')))])]):_vm._e(),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label":_vm.$t('common.companyName')}},[_c('span',[_vm._v(_vm._s(_vm.form.shipToName))])]):_vm._e(),_vm._v(" "),(!_vm.form.shippingAddressAsBillTo)?_c('el-form-item',{attrs:{"label":_vm.$t('common.phone')}},[_c('span',[_vm._v(_vm._s(_vm.form.shipToPhone))])]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.shippingMethod')}},[_vm._v("\n                    "+_vm._s(_vm.form.shippingMethod === '5' ? _vm.$t('common.otherCompany') :
          _vm.form.shippingMethod === '0' ? _vm.$t('common.express') :
          _vm.form.shippingMethod === '1' ? _vm.$t('common.expressSAT') :
          _vm.form.shippingMethod === '4' ? _vm.$t('common.standard') : _vm.$t('common.notSelected'))+"\n                ")]),_vm._v(" "),(_vm.form.shippingMethod === '5')?_c('el-form-item',{attrs:{"label":_vm.$t('common.otherCompany')}},[_c('span',[_vm._v(_vm._s(_vm.form.otherCompany))])]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('common.parts')))]),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.form.parts,"size":"mini","summary-method":_vm.partsTotals,"show-summary":""}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.partDescription')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('small',[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("money")(scope.row.price))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"extendedPrice","label":_vm.$t('common.extPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.quantity))])]}}])})],1),_vm._v(" "),(_vm.orderStatus == 1)?_c('div',{staticStyle:{"margin-top":"15px"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.trackingNumber'),"prop":"trackingNumber"}},[_c('span',[_vm._v(_vm._s(_vm.form.trackingNumber))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.serviceOrderNumber'),"prop":"serviceOrderNumber"}},[_c('span',[_vm._v(_vm._s(_vm.form.serviceOrderNumber))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.shippingCost'),"prop":"shippingCharges"}},[_c('span',[_vm._v(_vm._s(_vm.form.shippingCharges))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedBy'),"prop":"deliverySignedBy"}},[_c('span',[_vm._v(_vm._s(_vm.form.deliverySignedBy))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedOn'),"prop":"deliveryDate"}},[_c('span',[_vm._v(_vm._s(_vm._f("datetime")(_vm.form.deliveryDate)))])])],1):_vm._e()],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('common.submit')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closePreviewDialog}},[_vm._v(_vm._s(_vm.$t('common.back')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7ANf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApReport_vue__ = __webpack_require__("ntHU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8fcc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApReport_vue__ = __webpack_require__("SlQP");
function injectStyle (ssrContext) {
  __webpack_require__("m4RV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f8fcc14"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8fcc14_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ApReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7GoO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7M95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('h3',[_vm._v("Escalation Dashboard")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card",staticStyle:{"margin-bottom":"20px"}},[_c('el-row',{staticStyle:{"display":"flex","justify-content":"flex-end","margin-right":"35px"}},[_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toggleGrouping}},[_vm._v(_vm._s(_vm.isGrouped ? 'Ungroup' : 'Group'))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.toggleAllNextStepComments}},[_vm._v(_vm._s(_vm.allCommentNextStepVisible  ? 'Hide All Next Step Comments' : 'Show All Next Step Comments'))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}}),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"placeholder":"Customer Number","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.customer),callback:function ($$v) {_vm.$set(_vm.filter, "customer", $$v)},expression:"filter.customer"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"placeholder":"Ticket Number","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.ticket),callback:function ($$v) {_vm.$set(_vm.filter, "ticket", $$v)},expression:"filter.ticket"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"placeholder":"Serial Number","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.serialNumber),callback:function ($$v) {_vm.$set(_vm.filter, "serialNumber", $$v)},expression:"filter.serialNumber"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"From Raised On Date"},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"To Raised On Date"},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('strong',[_vm._v("Creation Date")]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px","justify-content":"flex-end","margin-right":"35px"}},[_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-left":"10px","margin-bottom":"5px"}},[_c('span',{staticClass:"filterClass"},[_vm._v("6+ Days")])]),_vm._v(" "),_c('colored-box',{attrs:{"number":_vm.escalationCriticalCount,"boxColor":"#f2999a"},on:{"click":function($event){_vm.handleBoxClick('critical')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-left":"10px","margin-bottom":"5px"}},[_c('span',{staticClass:"filterClass"},[_vm._v("4-6 Days")])]),_vm._v(" "),_c('colored-box',{attrs:{"number":_vm.escalationWarningCount,"boxColor":"#fdff65"},on:{"click":function($event){_vm.handleBoxClick('warning')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-left":"10px","margin-bottom":"5px"}},[_c('span',{staticClass:"filterClass"},[_vm._v("1-4 Days")])]),_vm._v(" "),_c('colored-box',{attrs:{"number":_vm.escalationNewCount,"boxColor":"#f0f9eb"},on:{"click":function($event){_vm.handleBoxClick('new')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-left":"10px","margin-bottom":"5px"}},[_c('span',{staticClass:"filterClass"},[_vm._v("Sales Follow Up")])]),_vm._v(" "),_c('colored-box',{attrs:{"number":_vm.escalationSalesFollowUpCount,"boxColor":"#efe4b6"},on:{"click":function($event){_vm.handleBoxClick('salesFollowUp')}}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-row',{staticStyle:{"margin-left":"10px","margin-bottom":"5px"}},[_c('span',{staticClass:"filterClass"},[_vm._v("All")])]),_vm._v(" "),_c('colored-box',{attrs:{"number":_vm.escalationTotalCount,"boxColor":"#a6a5a4"},on:{"click":function($event){_vm.handleBoxClick('total')}}})],1)],1)],1),_vm._v(" "),(_vm.isGrouped)?_vm._l((_vm.groupedTickets),function(tickets,customer){return _c('el-row',{key:customer},[_c('el-col',[_c('h4',[_vm._v(_vm._s(customer))]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tickets-table",attrs:{"size":"mini","data":tickets,"row-class-name":_vm.tableRowEscalationTime,"row-key":_vm.rowKey,"expand-row-keys":_vm.allCommentsNextStepVisible ? tickets.map(function (ticket) { return ticket.id; }) : []},on:{"sort-change":_vm.sortServiceTickets,"row-click":_vm.handleRowClick}},[_c('el-table-column',{attrs:{"type":"expand","width":"20"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('p',[_c('strong',[_vm._v("Next Step:")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(scope.row.escalationCommentNextStep))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"Ticket #","sortable":"custom","width":"75"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"Customer #","sortable":"custom","width":"115"}}),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Raised On","sortable":"custom","width":"85"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("datetime")(scope.row.raisedOn))+"\n                        ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"daysSinceRaised","label":"Days","sortable":"custom","formatter":_vm.daysSinceRaisedFormatter,"width":"55"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"daysSinceEscalation","label":"Days Escalation","sortable":"custom","formatter":_vm.daysSinceRaisedFormatter,"width":"200"}}),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastComment","label":"Last Comment","sortable":"custom","min-width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('div',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n                            "+_vm._s(scope.row.lastComment)+"\n                        ")])}}])}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastUpdatedTime","label":"Last Update","sortable":"custom","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("datetime")(scope.row.lastUpdatedTime))+"\n                        ")]}}])}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastUpdatedBy","label":"Last Update by","sortable":"custom","width":"110"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Part Required","width":"85"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Tracking #","width":"75"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Serial #","width":"75","prop":"serialNumber"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"serviceCompany","label":"Service Company","sortable":"custom","width":"140"}}):_vm._e()],1)],1)],1)}):[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tickets-table",attrs:{"size":"mini","data":_vm.tickets,"row-class-name":_vm.tableRowEscalationTime,"row-key":_vm.rowKey,"expand-row-keys":_vm.allCommentsNextStepVisible ? _vm.tickets.map(function (ticket) { return ticket.id; }) : []},on:{"sort-change":_vm.sortServiceTickets,"row-click":_vm.handleRowClick}},[_c('el-table-column',{attrs:{"type":"expand","width":"20"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('p',[_c('strong',[_vm._v("Last Comment:")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(scope.row.lastComment))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":"Ticket #","sortable":"custom","width":"75"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"Customer #","sortable":"custom","width":"115"}}),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Raised On","sortable":"custom","width":"85"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("datetime")(scope.row.raisedOn))+"\n                ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"daysSinceRaised","label":"Days","sortable":"custom","formatter":_vm.daysSinceRaisedFormatter,"width":"55"}}),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastComment","label":"Last Comment","sortable":"custom","min-width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _c('div',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n                    "+_vm._s(scope.row.lastComment)+"\n                ")])}}])}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastUpdatedTime","label":"Last Update","sortable":"custom","width":"90"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("datetime")(scope.row.lastUpdatedTime))+"\n                ")]}}])}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"lastUpdatedBy","label":"Last Update by","sortable":"custom","width":"110"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Part Required","width":"85"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Tracking #","width":"75"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"label":"Serial #","width":"75","prop":"serialNumber"}}):_vm._e(),_vm._v(" "),(_vm.width > 768)?_c('el-table-column',{attrs:{"prop":"serviceCompany","label":"Service Company","sortable":"custom","width":"140"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Status","sortable":"custom","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(scope.row.status)+"\n                ")]}}])})],1)],_vm._v(" "),_c('escalation-list-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Mi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxInput_vue__ = __webpack_require__("vBEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4372db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxInput_vue__ = __webpack_require__("Aqa7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a4372db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7UCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFPage_vue__ = __webpack_require__("f19G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_080c5918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFPage_vue__ = __webpack_require__("4ffL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_080c5918_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7eYv":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./accounting/en.json": "IkBD",
	"./accounting/fr.json": "QBFw",
	"./claims/en.json": "hdl+",
	"./claims/fr.json": "ROTR",
	"./common/en.json": "DxmK",
	"./common/fr.json": "aG6Z",
	"./dashboard/en.json": "Vv/e",
	"./dashboard/fr.json": "bDAA",
	"./en.json": "JxAT",
	"./equipments/en.json": "jDhz",
	"./equipments/fr.json": "8zVP",
	"./masters/en.json": "4ap1",
	"./masters/fr.json": "irhS",
	"./orders/en.json": "UGjV",
	"./orders/fr.json": "F0e/",
	"./reports/en.json": "ZpMc",
	"./reports/fr.json": "kKqp",
	"./rma/en.json": "NAUj",
	"./rma/fr.json": "OkWW",
	"./servicetickets/en.json": "07Nn",
	"./servicetickets/fr.json": "0RgM",
	"./shared/en.json": "mIN7",
	"./shared/fr.json": "qx1m",
	"./technicaldocumentation/en.json": "GzPh",
	"./technicaldocumentation/fr.json": "gqzI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7eYv";

/***/ }),

/***/ "7ece":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("QC7l");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "7fbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EquipmentList__ = __webpack_require__("4/9e");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EquipmentList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EquipmentRegistrationDialog__ = __webpack_require__("32fV");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__EquipmentRegistrationDialog__["a"]; });



/***/ }),

/***/ "7u+r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerSelector__ = __webpack_require__("KlKx");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerSelector__["a"]; });


/***/ }),

/***/ "84W6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketDetailsDialog_vue__ = __webpack_require__("o64V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d283bcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketDetailsDialog_vue__ = __webpack_require__("pn1f");
function injectStyle (ssrContext) {
  __webpack_require__("VVmc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d283bcc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketDetailsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d283bcc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketDetailsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Vec":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('shared.allowedDistance')}},[_c('el-input',{attrs:{"type":"number"},model:{value:(_vm.allowedDistance),callback:function ($$v) {_vm.allowedDistance=$$v},expression:"allowedDistance"}})],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.getServiceCompanies();}}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCompany'),"prop":"primaryServiceCompanyId"}},[_c('el-select',{staticClass:"select",attrs:{"name":"serviceCompanySelector","value":_vm.value,"clearable":"","placeholder":_vm.$t('shared.pleaseSelectServiceCompany'),"loading":_vm.loading,"no-data-text":_vm.$t('shared.noCompaniesInCurrentProvince')},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.companies),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8rwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"part-dialog",attrs:{"title":"Add Part","visible":_vm.showDialog,"width":"500px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"100px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Part","prop":"part"}},[_c('service-ticket-part-selector',{ref:"part-selector",attrs:{"serviceCompanyId":_vm.currentCompanyId,"productId":_vm.productId,"isNotWarrantyClaim":_vm.isNotWarrantyClaim},on:{"part-selected":_vm.partSelected}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Quantity","prop":"quantity"}},[_c('el-input-number',{attrs:{"min":1,"max":1000},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addPart}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v("Cancel")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8zVP":
/***/ (function(module, exports) {

module.exports = {"customerAddressColon":"Adresse du client:","customerPhoneColon":"Téléphone client :","gasTypeColon":"Type de gaz :","serviceCompanyColon":"Société de services :","serviceCompanyEmailColon":"E-mail de la société de services :","serviceCompanyServiceEmailColon":"E-mail de service de la société de services :","serviceCompanyPartsEmailColon":"E-mail de pièces de la société de service :","serviceCompanyPhoneColon":"Téléphone de la société de services :","serial":"En série","shippingDate":"Date d'expédition","equipmentRegistration":"Enregistrement de l'équipement","createCustomer":"Créer un client","gasType":"Type de gaz","notApplicable":"N'est pas applicable","natural":"Naturel","propane":"Propane","pickDate":"Choisir la date","installationDate":"Date d'installation","copyAndCreate":"Copie"}

/***/ }),

/***/ "9Fxv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"app"}},[_c('el-container',[_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9U2S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.nodes),function(node){return _c('div',{key:node.id,staticClass:"node-tree"},[_c('h4',[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.deleteFolder(node.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(node.name))]),_vm._v(" "),_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.openFolder(node)}}},[_vm._v("["+_vm._s(node.open ? '-' : '+')+"]")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(node.open),expression:"node.open"}]},[_vm._l((node.documents),function(document){return _c('el-row',{key:document.id},[_c('el-col',{attrs:{"span":6}},[_c('p',{staticStyle:{"margin":"10px 0 0 20px"}},[_c('a',{attrs:{"href":document.url,"target":"_blank"}},[_c('i',{staticClass:"el-icon-download"})]),_vm._v(" "),_c('a',[_vm._v(_vm._s(document.name))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.deleteDocument(document.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()],1)],1)}),_vm._v(" "),(node.children && node.children.length)?_c('ul',[_c('node',{attrs:{"nodes":node.children}})],1):_vm._e()],2)])}),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isPreviewPdf,"width":"60%"},on:{"update:visible":function($event){_vm.isPreviewPdf=$event},"close":_vm.ClosePreviewWindow}},[_c('PDFDocument',_vm._b({},'PDFDocument',{url: _vm.previewUrl, scale: _vm.scale},false)),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.ClosePreviewWindow}},[_vm._v(_vm._s(_vm.$t('common.close')))])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9aBF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  download: function download(filter) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/servicecompanies/export', {
      countryId: filter.countryId,
      isActive: filter.isActive,
      code: filter.text,
      name: filter.text
    });
  },
  getServiceCompanies: function getServiceCompanies(page, isActive, countryId, text, state) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicecompanies/table', {
      params: {
        page: page,
        countryId: countryId,
        isActive: isActive,
        code: text,
        name: text,
        state: state
      }
    });
  },
  getParentServiceCompanies: function getParentServiceCompanies() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicecompanies/parentCompanies');
  },
  getServiceCompany: function getServiceCompany(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicecompanies/' + id).then(function (response) {
      var result = Object.assign({}, response.data);

      result.rating = result.rating.toString();
      result.companyType = result.companyType.toString();
      result.selectedCountryState = [result.address.countryId.toString(), result.address.stateId.toString()];
      result.city = result.address.city;
      result.region = result.address.region;
      result.regional = result.address.regional;
      result.zip = result.address.zip;
      result.address = result.address.street;

      result.warrantyRegularLaborRate = result.warrantyRegular.laborRate;
      result.warrantyRegularTravelRate = result.warrantyRegular.travelRate;
      result.warrantyRegularMileageRate = result.warrantyRegular.mileageRate;
      delete result.warrantyRegular;

      result.warrantyOvertimeLaborRate = result.warrantyOvertime.laborRate;
      result.warrantyOvertimeTravelRate = result.warrantyOvertime.travelRate;
      result.warrantyOvertimeMileageRate = result.warrantyOvertime.mileageRate;
      delete result.warrantyOvertime;

      result.nonWarrantyRegularLaborRate = result.nonWarrantyRegular.laborRate;
      result.nonWarrantyRegularTravelRate = result.nonWarrantyRegular.travelRate;
      result.nonWarrantyRegularMileageRate = result.nonWarrantyRegular.mileageRate;
      delete result.nonWarrantyRegular;

      result.nonWarrantyOvertimeLaborRate = result.nonWarrantyOvertime.laborRate;
      result.nonWarrantyOvertimeTravelRate = result.nonWarrantyOvertime.travelRate;
      result.nonWarrantyOvertimeMileageRate = result.nonWarrantyOvertime.mileageRate;
      delete result.nonWarrantyOvertime;

      result.subContractorPhone = result.subContractor ? result.subContractor.phone : undefined;
      result.subContractorEmail = result.subContractor ? result.subContractor.email : undefined;
      result.subContractorContactName = result.subContractor ? result.subContractor.contactName : undefined;
      delete result.subContractor;

      return result;
    });
  },
  saveServiceCompany: function saveServiceCompany(id, serviceCompany) {
    var request = Object.assign({}, serviceCompany);
    request.countryId = serviceCompany.selectedCountryState[0];
    request.stateId = serviceCompany.selectedCountryState[1];
    delete request.selectedCountryState;

    if (id) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/servicecompanies/' + id, request);
    }
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicecompanies', request);
  },
  deleteServiceCompany: function deleteServiceCompany(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/servicecompanies/' + id);
  },
  deleteUser: function deleteUser(name) {
    console.log('/api/users/deletebyname/' + name);
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/users/deletebyname/' + name);
  },
  changeActivationStatus: function changeActivationStatus(id, status) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/servicecompanies/' + id, {
      status: status
    });
  },
  resetPassword: function resetPassword(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/servicecompanies/' + id + '/resetpassword');
  },
  impersonate: function impersonate(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/account/loginas/' + id);
  },
  addSubcontractor: function addSubcontractor(id, subcontractor) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicecompanies/' + id + '/subcontractors', subcontractor);
  },
  deleteSubcontractor: function deleteSubcontractor(id, subcontractor) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicecompanies/' + id + '/deletesubcontractors', subcontractor);
  }
});

/***/ }),

/***/ "9mdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("esN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "price-list-report",
  components: {
    ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
    ResolutionCategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["m" /* ResolutionCategorySelector */]
  },
  data: function data() {
    return {
      loading: false,
      codes: [],
      filter: {
        productId: undefined,
        categoryId: undefined,
        description: undefined
      },
      currentPage: 1,
      total: 0
    };
  },
  created: function created() {
    this.loadCodes();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        this.currentPage = 1;
        this.loadCodes();
      }
    },
    "filter.productId": function filterProductId() {
      this.filter.categoryId = undefined;
    }
  },
  methods: {
    loadCodes: function loadCodes() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCodes(this.currentPage, this.filter).then(function (response) {
        _this.loading = false;
        _this.codes = response.data.items;
        _this.total = response.data.total;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadCodes();
    },
    download: function download() {
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].download(this.filter);
    }
  }
});

/***/ }),

/***/ "9otv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("/e34");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__claims_components__ = __webpack_require__("w9Cu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "claims-list",
    components: {
        PreviewClaimDialog: __WEBPACK_IMPORTED_MODULE_1__claims_components__["c" /* PreviewClaimDialog */]
    },
    data: function data() {
        return {
            loading: false,
            claims: [],
            filter: {
                type: 2,
                q: "",
                dateFrom: null,
                dateTo: null
            },
            currentPage: 1,
            total: 0,
            claimToView: undefined,
            claimToEdit: undefined,
            previewClaimVisible: false,

            claimId: undefined,
            processClaimConfirmationVisible: false,
            payClaimConfirmationVisible: false,

            selectedClaims: [],
            payAndPrintConfirmationVisible: false
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler() {
                this.loadClaims();
            }
        }
    },
    created: function created() {
        this.loadClaims();
    },

    computed: {
        IsShownPayAndPrint: function IsShownPayAndPrint() {
            return this.selectedClaims.length > 0;
        }
    },
    methods: {
        payClaim: function payClaim(id) {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].payClaim(id).then(function () {
                _this.loading = false;
                _this.loadClaims();
                _this.payClaimConfirmationVisible = false;
                _this.claimToView = id;
                _this.previewClaimVisible = true;
            });
        },
        payClaimConfirm: function payClaimConfirm(id) {
            this.claimId = id;
            this.payClaimConfirmationVisible = true;
        },
        printClaim: function printClaim(id) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].printClaim(id).then(function (response) {
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);

                dstDoc.close();
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    }, 500);
                }
            });
        },
        processClaim: function processClaim(id) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].processClaim(id).then(function () {
                _this2.loadClaims();
                _this2.processClaimConfirmationVisible = false;
            });
        },
        processClaimConfirm: function processClaimConfirm(id) {
            this.claimId = id;
            this.processClaimConfirmationVisible = true;
        },
        loadClaims: function loadClaims() {
            var _this3 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getClaims(this.currentPage, this.filter).then(function (response) {
                _this3.loading = false;
                _this3.claims = response.data.items;
                _this3.total = response.data.total;
            });
        },
        deleteClaim: function deleteClaim(id) {
            var _this4 = this;

            this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function (res) {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteClaim(id).then(function () {
                    _this4.loadClaims();
                    _this4.$message({
                        type: "success",
                        message: _this4.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {
                console.warn(_);
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadClaims();
        },
        viewClaim: function viewClaim(id) {
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        showClaimPreview: function showClaimPreview(id) {
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        previewClaimFinished: function previewClaimFinished() {
            this.claimToView = undefined;
            this.previewClaimVisible = false;
        },
        claimPublished: function claimPublished() {
            this.$notify({
                title: this.$t('common.success'),
                message: this.$t('common.claimSuccesfullySubmitted'),
                type: "success"
            });
            this.loadClaims();
        },
        payAndPrintConfirm: function payAndPrintConfirm() {
            this.payAndPrintConfirmationVisible = true;
        },
        payAndPrint: function payAndPrint() {
            var _this5 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].payAndPrint(this.selectedClaims).then(function (response) {

                _this5.payClaimConfirmationVisible = false;
                _this5.claimToView = _this5.selectedClaims[0];
                _this5.previewClaimVisible = true;
                _this5.loading = false;

                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);

                dstDoc.close();
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        setTimeout(function () {}, 300);
                        document.body.removeChild(oHiddFrame);
                    }, 3000);
                }

                _this5.payAndPrintConfirmationVisible = false;
                _this5.loadClaims();
            });
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.selectedClaims = val.map(function (item) {
                return item.id;
            });
        }
    }
});

/***/ }),

/***/ "A7XZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{attrs:{"size":"mini"}},[_c('el-form-item',[_c('el-select',{staticClass:"select",staticStyle:{"width":"270px"},attrs:{"clearable":"","placeholder":_vm.$t('reports.pleaseSelectType'),"loading":_vm.loading,"size":"large"},on:{"change":_vm.change},model:{value:(_vm.reportType),callback:function ($$v) {_vm.reportType=$$v},expression:"reportType"}},[_c('el-option',{attrs:{"label":"CDN Costco Non Warranty / Hardt","value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":"CDN Costco Non Warranty / Costco","value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":"USA Costco Non Warranty / Hardt","value":2}}),_vm._v(" "),_c('el-option',{attrs:{"label":"USA Costco Non Warranty / Costco","value":3}})],1)],1),_vm._v(" "),_c('el-collapse',[_c('el-collapse-item',[_c('template',{slot:"title"},[_c('p',{staticClass:"custome-collapse-color"},[_vm._v("\n                "+_vm._s(_vm.$t('reports.parameters'))+" "),_c('i',{staticClass:"header-icon el-icon-info"})])]),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.dateFromAcceptedDate'),"prop":"dateFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateFrom),callback:function ($$v) {_vm.$set(_vm.form, "dateFrom", $$v)},expression:"form.dateFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCompany'),"prop":"serviceCompany"}},[_c('el-input',{model:{value:(_vm.form.serviceCompany),callback:function ($$v) {_vm.$set(_vm.form, "serviceCompany", $$v)},expression:"form.serviceCompany"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customer'),"prop":"customerId"}},[_c('customer-selector',{model:{value:(_vm.form.customerId),callback:function ($$v) {_vm.$set(_vm.form, "customerId", $$v)},expression:"form.customerId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.claimNumber'),"prop":"claimNumber"}},[_c('el-input',{model:{value:(_vm.form.claimNumber),callback:function ($$v) {_vm.$set(_vm.form, "claimNumber", $$v)},expression:"form.claimNumber"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.dateToAcceptedDate'),"prop":"dateTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateTo),callback:function ($$v) {_vm.$set(_vm.form, "dateTo", $$v)},expression:"form.dateTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.status'),"prop":"status"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.sortBy'),"prop":"sortBy"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.sortBy),callback:function ($$v) {_vm.$set(_vm.form, "sortBy", $$v)},expression:"form.sortBy"}},[_c('el-option',{attrs:{"label":_vm.$t('reports.customerNumber'),"value":"0"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.customerName'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptedDate'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.address'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.city'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('reports.province'),"value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.region'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.regional'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('reports.company'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.claimNumber'),"value":"9"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.invoiceNumber'),"value":"10"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.workOrder'),"value":"11"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('reports.dateOfCompletion'),"value":"12"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.model'),"value":"13"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.labor'),"value":"16"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.parts'),"value":"18"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.freight'),"value":"19"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.total'),"value":"20"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.sortDescending'),"prop":"sortDesc"}},[_c('el-switch',{model:{value:(_vm.form.sortDesc),callback:function ($$v) {_vm.$set(_vm.form, "sortDesc", $$v)},expression:"form.sortDesc"}})],1)],1)],1)],2)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.generateReport}},[_vm._v(_vm._s(_vm.$t('common.generate')))]),_vm._v(" "),(_vm.claims.length > 0)?_c('el-button',{attrs:{"loading":_vm.loading},on:{"click":_vm.exportExcel}},[_vm._v(_vm._s(_vm.$t('reports.exportToExcel')))]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.claims.length > 0)?_c('el-scrollbar',[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('reports.claimCreationDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.dateOfCompletition')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.acceptedDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.daysToInvoice')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.customerNo')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.customerName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.address')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.city')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.province')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.region')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.regional')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.company')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.claimNumber')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.invoiceNumber')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.workOrder')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.serialNumber')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.model')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.repairCode')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.repairDescription')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.laborHours')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.labor')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.travelTruckMileage')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.parts')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.freight')))]),_vm._v(" "),(_vm.form.isCanadian)?_c('th',[_vm._v("HST 13%")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('reports.total')))]),_vm._v(" "),(_vm.form.isForCostco)?_c('th',[_vm._v(_vm._s(_vm.$t('reports.laborRegularHours')))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('th',[_vm._v(_vm._s(_vm.$t('reports.laborRegularTotal')))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('th',[_vm._v(_vm._s(_vm.$t('reports.laborOvertimeHours')))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('th',[_vm._v(_vm._s(_vm.$t('reports.laborOvertimeTotal')))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('th',[_vm._v(_vm._s(_vm.$t('common.misc')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.claims),function(claim){return [_c('tr',{key:claim.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.chooseAction(claim.id, claim.status)}}},[_c('td',[_vm._v(_vm._s(_vm._f("date")(claim.claimCreationDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("date")(claim.dateWorkCompleted)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("date")(claim.acceptedDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.daysToInvoice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.storeNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.customerName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.street))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.region))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.regional))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.companyName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.claimNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.invoiceNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.serviceWorkOrder))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.serialNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.model))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.firstRepair ? claim.firstRepair.code : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.firstRepair ? claim.firstRepair.description : ''))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(claim.laborHours))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.laborTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.travelTruckMileage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.partsTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.freight)))]),_vm._v(" "),(_vm.form.isCanadian)?_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.gst)))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.total)))]),_vm._v(" "),(_vm.form.isForCostco)?_c('td',[_vm._v(_vm._s(claim.laborRegularHours))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.laborRegularTotal)))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('td',[_vm._v(_vm._s(claim.laborOvertimeHours))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.laborOvertimeTotal)))]):_vm._e(),_vm._v(" "),(_vm.form.isForCostco)?_c('td',[_vm._v(_vm._s(_vm._f("money")(claim.tax)))]):_vm._e()]),_vm._v(" "),_vm._l((claim.restRepairs),function(code){return _c('tr',{key:code.id},[_c('td',{attrs:{"colspan":"15"}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(code.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(code.description))])])})]})],2)])]):_vm._e(),_vm._v(" "),(_vm.showNoDataMessage)?_c('el-alert',{attrs:{"title":_vm.$t('reports.noDataFound'),"type":"error"}}):_vm._e(),_vm._v(" "),(_vm.showButton)?_c('el-button',{attrs:{"loading":_vm.loading},on:{"click":_vm.generateFullReport}},[_vm._v(_vm._s(_vm.$t('reports.viewMore')))]):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('common.pleaseChoose'),"visible":_vm.chooseActionVisible,"width":"30%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.chooseActionVisible=$event}}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.whatYouWantToDo')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.chooseActionVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.nothing')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.viewClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.view')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.canBeEdited},on:{"click":function($event){_vm.editClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('reports.edit')))])],1)]),_vm._v(" "),_c('create-update-claim-dialog',{attrs:{"claimId":_vm.claimToEdit,"visible":_vm.updateClaimVisible},on:{"dialogClosed":_vm.updateClaimFinished,"showClaimPreview":_vm.showClaimPreview}}),_vm._v(" "),_c('preview-claim-dialog',{attrs:{"claimId":_vm.claimToView,"visible":_vm.previewClaimVisible},on:{"dialogClosed":_vm.previewClaimFinished,"editClaim":_vm.editClaim,"claimPublished":_vm.claimPublished}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ABK5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getCountries: function getCountries() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/countries/lookup').then(function (response) {
            return response.data.map(function (c) {
                return { id: c.value, name: c.label };
            });
        });
    }
});

/***/ }),

/***/ "AKRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerList__ = __webpack_require__("lkUS");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChainSelector__ = __webpack_require__("T4VY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ChainSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateUpdateCustomerDialog__ = __webpack_require__("XQmu");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__CreateUpdateCustomerDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateCountryDialog__ = __webpack_require__("gXVo");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__CreateCountryDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CustomerNotificationList__ = __webpack_require__("OKu3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__CustomerNotificationList__["a"]; });






/***/ }),

/***/ "AWBh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("5V4q");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "Anpv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aqa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"span":_vm.span}},[(!_vm.editing)?_c('span',[_vm._v(_vm._s(_vm.taxType.toUpperCase())+" "+_vm._s(_vm.value)+"%")]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('el-input',{attrs:{"size":"small","controls":false,"max":100,"min":0},model:{value:(_vm.value),callback:function ($$v) {_vm.value=_vm._n($$v)},expression:"value"}},[_c('template',{slot:"append"},[_c('el-button',{attrs:{"icon":"el-icon-check","size":"small"},on:{"click":function($event){_vm.editing = false; _vm.updateTax()}}}),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-close","size":"small"},on:{"click":function($event){_vm.editing = false}}})],1)],2):_vm._e(),_vm._v(" "),(!_vm.editing && _vm.$isFullAdmin)?_c('el-button',{attrs:{"icon":"el-icon-edit","size":"small"},on:{"click":function($event){_vm.editing = true}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "At//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSelector_vue__ = __webpack_require__("XOLM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211ad81f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSelector_vue__ = __webpack_require__("ITxE");
function injectStyle (ssrContext) {
  __webpack_require__("YGYR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-211ad81f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_211ad81f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ayk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");

var store = {
  state: {
    count: 0
  },
  setCount: function setCount(newCount) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(this.state, 'count', newCount); // Use Vue.set to make state updates reactive
  }
};
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "B6QW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("e9Ki");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e32f5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("KTZb");
function injectStyle (ssrContext) {
  __webpack_require__("YoMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49e32f5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BHZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/resolutioncodes/export', {
            productId: filter.productId,
            categoryId: filter.categoryId,
            description: filter.text,
            code: filter.text
        });
    },
    getCodes: function getCodes(page, productId, categoryId, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodes/table', {
            params: {
                page: page,
                productId: productId,
                categoryId: categoryId,
                description: text,
                code: text
            }
        });
    },
    getCode: function getCode(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodes/table/' + id);
    },
    saveCode: function saveCode(id, code) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/resolutioncodes/' + id, code);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/resolutioncodes', code);
    },
    deleteCode: function deleteCode(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/resolutioncodes/' + id);
    },

    // downloadCategories(filter) {
    //     return axios.download('/api/resolutioncodecategories/export',
    //         {
    //             productId: filter.productId,
    //             name: filter.text,
    //             description: filter.text
    //         });
    // },
    getCategories: function getCategories(page, productId, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodecategories/table', {
            params: {
                page: page,
                productId: productId,
                name: text,
                description: text
            }
        });
    },
    getCategory: function getCategory(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodecategories/' + id);
    },
    saveCategory: function saveCategory(id, category) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/resolutioncodecategories/' + id, category);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/resolutioncodecategories', category);
    },
    deleteCategory: function deleteCategory(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/resolutioncodecategories/' + id);
    }
});

/***/ }),

/***/ "Btwz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.ticketNumber'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.ticketId),callback:function ($$v) {_vm.$set(_vm.filter, "ticketId", $$v)},expression:"filter.ticketId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":"Email","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.email),callback:function ($$v) {_vm.$set(_vm.filter, "email", $$v)},expression:"filter.email"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-cascader',{staticClass:"selector",attrs:{"placeholder":"Status","options":_vm.options,"change-on-select":"","clearable":""},on:{"change":_vm.emailStatusFilter}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-cascader',{staticClass:"selector",attrs:{"placeholder":"SelfService","options":_vm.selfServiceoptions,"change-on-select":"","clearable":""},on:{"change":_vm.selfServiceFilter}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.emails},on:{"sort-change":_vm.sortChanged}},[_c('el-table-column',{attrs:{"prop":"serviceTicketId","label":"Service Ticket Id"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerName","label":"WHS #"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompanyName","label":"Service Company"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":"Email Address"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"subject","label":"Subject"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"emailStatus","label":"Status"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"isSelfRequest","label":"Self-Service"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.isSelfRequest ? "Yes" : "No")+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"createdDate","label":"Created Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.createdDate))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"200px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.resend(scope.row.id)}}},[_vm._v("\n                    Resend\n                ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.emailDetailsVisibleMethod(scope.row)}}},[_vm._v("\n                    Details\n                ")])]}}])})],1),_vm._v(" "),_c('email-details-dialog',{attrs:{"ticketId":_vm.ticketIdToShow,"subject":_vm.subject,"body":_vm.body,"visible":_vm.emailDetailsVisible},on:{"dialogClosed":_vm.emailDetailsFinished}}),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C+VW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C/Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("fboY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateClaimDialog__ = __webpack_require__("Lj1T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreviewClaimDialog__ = __webpack_require__("LoMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "claim-list",
    components: {
        CreateUpdateClaimDialog: __WEBPACK_IMPORTED_MODULE_1__CreateUpdateClaimDialog__["a" /* default */],
        PreviewClaimDialog: __WEBPACK_IMPORTED_MODULE_2__PreviewClaimDialog__["a" /* default */]
    },
    data: function data(vm) {
        return {
            loading: false,
            loadingComments: false,
            isForPartial: false,
            claims: [],
            claimToView: undefined,
            claimToEdit: undefined,
            updateClaimVisible: false,
            previewClaimVisible: false,
            filter: {
                q: "",
                status: this.$route.params.status || null
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            placeholder: vm.$t('common.searchAllClaims'),
            placeHolderDateFrom: "",
            placeHolderDateTo: "",
            statusForShowingDates: "-1",
            newTotal: null,
            mircTotal: null,
            prpcTotal: null,
            prccTotal: null,
            modifiedTotal: null,
            rejectedTotal: null,
            deletedTotal: null,
            paidTotal: null,
            techReviewTotal: null,
            exporting: false,
            claimIdComments: undefined
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(data) {
                switch (this.filter.status) {
                    case null:
                        this.placeholder = this.$t('common.searchAllClaims');
                        break;
                    case 1:
                        this.placeholder = this.$t('common.searchInNewClaims');
                        this.placeHolderDateFrom = this.$t('common.fromCreatedDate');
                        this.placeHolderDateTo = this.$t('common.toCreatedDate');
                        this.statusForShowingDates = 1;
                        break;
                    case 3:
                        this.placeholder = this.$t('common.searchInMoreInformationRequiredClaims');
                        this.placeHolderDateFrom = this.$t('common.fromCommentDate');
                        this.placeHolderDateTo = this.$t('common.toCommentDate');
                        this.statusForShowingDates = 3;
                        break;
                    case 7:
                        this.placeholder = this.$t('common.searchInPendingReturnPartClaims');
                        this.placeHolderDateFrom = this.$t('common.fromCommentDate');
                        this.placeHolderDateTo = this.$t('common.toCommentDate');
                        this.statusForShowingDates = 7;
                        break;
                    case 8:
                        this.placeholder = this.$t('common.searchInPendingReturnCodeCorrectionsClaims');
                        this.placeHolderDateFrom = "";
                        this.placeHolderDateTo = "";
                        this.statusForShowingDates = 8;
                        break;
                    case 5:
                        this.placeholder = this.$t('common.searchInModifiedClaims');
                        this.placeHolderDateFrom = this.$t('common.fromModifiedDate');
                        this.placeHolderDateTo = this.$t('common.toModifiedDate');
                        this.statusForShowingDates = 5;
                        break;
                    case 4:
                        this.placeholder = this.$t('common.searchInRejectedClaims');
                        this.placeHolderDateFrom = this.$t('common.fromRejectedDate');
                        this.placeHolderDateTo = this.$t('common.toRejectedDate');
                        this.statusForShowingDates = 4;
                        break;
                    case 0:
                        this.placeholder = this.$t('common.searchInDeletedClaims');
                        this.placeHolderDateFrom = this.$t('common.fromDeletedDate');
                        this.placeHolderDateTo = this.$t('common.toDeletedDate');
                        this.statusForShowingDates = 0;
                        break;
                    case 6:
                        this.placeholder = this.$t('common.searchInPaidClaims');
                        this.placeHolderDateFrom = this.$t('common.fromPaidDate');
                        this.placeHolderDateTo = this.$t('common.toPaidDate');
                        this.statusForShowingDates = 6;
                        break;
                    case 10:
                        this.placeholder = this.$t('common.searchInPendingTechReviewClaims');
                        this.placeHolderDateFrom = this.$t('common.fromAssignedDate');
                        this.placeHolderDateTo = this.$t('common.toAssignedDate');
                        this.statusForShowingDates = 10;
                        break;
                    case 11:
                        this.placeholder = this.$t('common.searchInPendingTechReviewClaims');
                        break;
                }

                if (this.filter.status === null && this.$route.params.status != null) {
                    window.location.href = "/#/claims";
                }
                this.loadClaims();
                this.loadCategories();
            }
        }
    },
    created: function created() {
        this.loadClaims();
        this.loadCategories();
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$on("claim-created", function () {
            _this.loadCategories();
            _this.loadClaims();
        });
        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$on("showClaimConfirm", function (claimId) {
            _this.showClaimConfirm(claimId);
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$off("claim-created");
        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$off("showClaimConfirm");
    },

    methods: {
        loadClaims: function loadClaims() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getClaims(this.currentPage, this.filter, this.sorting).then(function (response) {
                _this2.loading = false;
                _this2.claims = response.data.items;
                _this2.total = response.data.total;
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadClaims();
        },
        viewClaim: function viewClaim(id) {
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        showClaimConfirm: function showClaimConfirm(id) {
            this.claimToView = id;
            this.isForPartial = true;
            this.previewClaimVisible = true;
        },
        editClaim: function editClaim(id) {
            this.claimToEdit = id;
            this.updateClaimVisible = true;
        },
        deleteClaim: function deleteClaim(id) {
            var _this3 = this;

            this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteClaim(id).then(function () {
                    _this3.loadClaims();
                    _this3.$message({
                        type: "success",
                        message: _this3.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        download: function download() {
            var _this4 = this;

            this.exporting = true;
            if (!this.filter.dateFrom && !this.filter.dateTo) {
                var dateToday = new Date();
                var day = dateToday.getDate();
                var month = Number(dateToday.getMonth() + 1);
                var year = Number(dateToday.getFullYear());
                this.$confirm(this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].exportView(_this4.currentPage, _this4.filter, _this4.sorting).then(function () {
                        _this4.exporting = false;
                        _this4.$message({
                            title: _this4.$t('common.success'),
                            message: _this4.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }).catch(function (_) {
                    _this4.exporting = false;
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].exportView(this.currentPage, this.filter, this.sorting).then(function () {
                    _this4.exporting = false;
                    _this4.$message({
                        title: _this4.$t('common.success'),
                        message: _this4.$t('common.exportWasGeneratedSuccesfully'),
                        type: "success"
                    });
                });
            }
        },
        sortClaims: function sortClaims(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadClaims();
            } else {
                this.currentPage = 1;
            }
        },
        loadCategories: function loadCategories() {
            var _this5 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCategories().then(function (response) {
                _this5.loading = false;
                _this5.newTotal = response.data.find(function (x) {
                    return x.status === 1;
                }).total;
                _this5.mircTotal = response.data.find(function (x) {
                    return x.status === 3;
                }).total;
                _this5.prpcTotal = response.data.find(function (x) {
                    return x.status === 7;
                }).total;
                _this5.prccTotal = response.data.find(function (x) {
                    return x.status === 8;
                }).total;
                _this5.modifiedTotal = response.data.find(function (x) {
                    return x.status === 5;
                }).total;
                _this5.rejectedTotal = response.data.find(function (x) {
                    return x.status === 4;
                }).total;
                _this5.deletedTotal = response.data.find(function (x) {
                    return x.status === 0;
                }).total;
                _this5.paidTotal = response.data.find(function (x) {
                    return x.status === 6;
                }).total;
                _this5.techReviewTotal = response.data.find(function (x) {
                    return x.status === 10;
                }).total + (response.data.find(function (x) {
                    return x.status === 11;
                }) || { total: 0 }).total;
            });
        },
        updateClaimFinished: function updateClaimFinished() {
            this.claimToEdit = undefined;
            this.updateClaimVisible = false;
        },
        previewClaimFinished: function previewClaimFinished() {
            this.isForPartial = false;
            this.claimToView = undefined;
            this.previewClaimVisible = false;
        },
        showClaimPreview: function showClaimPreview(id) {
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        claimPublished: function claimPublished() {
            this.$notify({
                title: this.$t('common.success'),
                message: this.$t('common.claimWasSubmittedSuccesfully'),
                type: "success"
            });
            this.loadCategories();
            this.loadClaims();
        },
        handleStatusChange: function handleStatusChange(id, newStatus) {
            var _this6 = this;

            this.claims.status = newStatus;
            this.claims.statusFr = newStatus;
            this.$confirm(this.$t('common.areYouSureYouWantToChangeStatusOfClaim'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].changeStatusOfClaim(id, newStatus).then(function () {
                    if (newStatus === 6) {
                        _this6.$notify({
                            title: _this6.$t('common.success'),
                            message: _this6.$t('common.claimStatusWasUpdatedSuccesfully'),
                            type: "success"
                        });
                    }
                    if (newStatus == 10 || newStatus == 11) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].sendEmailToReviewer(id, newStatus);
                        _this6.$notify({
                            title: _this6.$t('common.success'),
                            message: _this6.$t('common.claimStatusWasUpdatedSuccesfully'),
                            type: "success"
                        });
                    }
                    _this6.loadClaims();
                });
            }).catch(function (_) {});
        },

        //showCommentsDialog(claimId) {
        //    this.claimIdComments = claimId;
        //    api.loadComments(claimId).then(response => {
        //        this.comments = response.data;
        //        this.commentShowDialog = true;
        //    });
        //},
        //postComment() {
        //    this.$refs["commentForm"].validate(valid => {
        //        if (valid) {
        //            // if (typeof this.commentForm.status != "undefined") {
        //            //   this.$confirm(
        //            //     "Are you sure you want to change status of claim?",
        //            //     "Warning",
        //            //     {
        //            //       confirmButtonText: this.$t('common.OK'),
        //            //       cancelButtonText: this.$t('common.cancel'),
        //            //       type: "warning"
        //            //     }
        //            //   )
        //            //     .then(() => {
        //            this.loadingComments = true;
        //            api
        //                .submitComment(this.claimIdComments, this.commentForm)
        //                .then(response => {
        //                    this.$refs["commentForm"].resetFields();
        //                    this.comments.push(response.data);
        //                    this.loadingComments = false;
        //                });
        //            // })
        //            // .catch(_ => {});
        //            // } else {
        //            // this.loadingComments = true;
        //            // api
        //            //   .submitComment(this.claimIdComments, this.commentForm)
        //            //   .then(response => {
        //            //     this.$refs["commentForm"].resetFields();
        //            //     this.comments.push(response.data);
        //            //     this.loadingComments = false;
        //            //   });
        //            // }
        //        } else {
        //            return false;
        //        }
        //    });
        //},
        //closeDialog() {
        //    this.commentShowDialog = false;
        //    this.claimIdComments = null;
        //    this.comments = [];
        //    this.loadClaims();
        //},
        statusChanged: function statusChanged() {
            this.loadClaims();
        },
        showDateOfComment: function showDateOfComment(commentObject) {
            if (!commentObject.comments.length) {
                return "";
            }

            return commentObject.comments[commentObject.comments.length - 1].on;
        }
    }
});

/***/ }),

/***/ "C/aA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("fboY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__ = __webpack_require__("fEXR");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "preview-claim-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        claimId: {
            required: true
        },
        hideSave: {
            type: Boolean,
            default: false
        },
        noDetails: {
            type: Boolean,
            default: false
        },
        claimModel: {
            type: Object,
            default: null
        },
        isForPartial: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            claim: {
                rates: {}
            },
            loading: false,
            printing: false,
            showDialog: this.visible,
            isUserServiceCompany: false,
            claimStatus: null
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        claimStatus: function claimStatus(val) {
            this.claim.status = val;
        }
    },
    methods: {
        loadClaim: function loadClaim() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getClaimPreview(this.claimId).then(function (response) {
                _this.isUserServiceCompany = _this.$currentUser.profile.role != "admin";
                _this.claim = response.data;
                _this.claim.taxId = _this.claim.serviceCompany.taxId;
                if (_this.$i18n.locale == 'en') _this.claimStatus = response.data.status;else _this.claimStatus = response.data.statusFr;
                _this.loading = false;
            });
        },
        printClaim: function printClaim() {
            var _this2 = this;

            this.printing = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].printClaim(this.claimId).then(function (response) {
                _this2.printing = false;
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);
                dstDoc.close();
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    }, 500);
                }
            }, function () {
                return _this2.printing = false;
            });
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            for (var property in this.claim) {
                if (this.claim.hasOwnProperty(property)) {
                    switch (_typeof(this.claim[property])) {
                        case "string":
                            this.claim[property] = null;
                            break;
                        case "number":
                            this.claim[property] = null;
                            break;
                        case "object":
                            this.claim[property] = null;
                            break;
                        case "undefined":
                            break;
                    }
                }
            }
            this.$emit("dialogClosed");
        },
        save: function save() {
            var _this3 = this;

            this.$confirm(this.$t('common.areYouSureYouWantToProcess'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].processClaim(_this3.claim.id).then(function (response) {
                    _this3.$emit("claimPublished");
                    _this3.closeDialog();
                });
            }).catch(function (_) {});
        },
        editClaim: function editClaim(id) {
            this.closeDialog();
            this.$emit("editClaim", id);
        },
        handleStatusChange: function handleStatusChange(id, newStatus) {
            var _this4 = this;

            this.$confirm(this.$t('common.areYouSureYouWantToChangeStatusOfClaim'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].changeStatusOfClaim(id, newStatus).then(function () {
                    if (newStatus !== 6) {
                        _this4.$emit("statusChanged");
                        _this4.$notify({
                            title: _this4.$t('common.success'),
                            message: _this4.$t('common.claimStatusWasUpdatedSuccesfully'),
                            type: "success"
                        });
                    }
                    if (newStatus == 10 || newStatus == 11) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].sendEmailToReviewer(id, newStatus);
                    }
                });
            }).catch(function (_) {});
        },
        confirm: function confirm() {
            var _this5 = this;

            // if (this.claim.status === "Partial" && this.isForPartial) {
            // api.changeStatusOfClaim(this.claim.id, 1).then(() => {
            this.loading = true;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].publishClaim(this.claim.id).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__["a" /* EventBus */].$emit("confirmed");
                _this5.closeDialog();
            });

            // });
            // } else {
            //   this.$notify({
            //     title: "Error",
            //     message: "You can't change this claim.",
            //     type: "error"
            //   });
            // }

            this.loading = false;
        },
        showProcessedByUser: function showProcessedByUser() {
            if (this.claim.processedBy) {
                return this.claim.processedBy.normalizedUserName;
            }
            return null;
        }
    }
});

/***/ }),

/***/ "CXBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
    var messages = {};

    //Main locales
    var locales = __webpack_require__("7eYv");
    locales.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    //Accounting locales
    var accounting = __webpack_require__("QV+2");
    accounting.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].accounting = accounting(key);
        }
    });

    //Claims locales
    var claims = __webpack_require__("rpgD");
    claims.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].claims = claims(key);
        }
    });

    //Dashboard locales
    var dashboard = __webpack_require__("UiDJ");
    dashboard.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].dashboard = dashboard(key);
        }
    });

    //Equipment locales
    var equipments = __webpack_require__("wkbZ");
    equipments.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].equipments = equipments(key);
        }
    });

    //Masters locales
    var masters = __webpack_require__("lqfw");
    masters.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].masters = masters(key);
        }
    });

    //Orders locales
    var orders = __webpack_require__("G6Zw");
    orders.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].orders = orders(key);
        }
    });

    //Rma locales
    var rma = __webpack_require__("pJZO");
    rma.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].rma = rma(key);
        }
    });

    //Shared locales
    var shared = __webpack_require__("UyV3");
    shared.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].shared = shared(key);
        }
    });

    //Technical Documentation locales
    var technicaldocumentation = __webpack_require__("fO0/");
    technicaldocumentation.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].technicaldocumentation = technicaldocumentation(key);
        }
    });

    //Service Tickets locales
    var serviceTickets = __webpack_require__("TQ7+");
    serviceTickets.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].serviceTickets = serviceTickets(key);
        }
    });

    //Reports locales
    var reports = __webpack_require__("z4cC");
    reports.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].reports = reports(key);
        }
    });

    //Common locales
    var common = __webpack_require__("Gj7M");
    common.keys().forEach(function (key) {
        var matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            var locale = matched[1];
            messages[locale].common = common(key);
        }
    });

    return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_LOCALE || 'en',
    fallbackLocale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_FALLBACK_LOCALE || 'en',
    messages: loadLocaleMessages()
}));

/***/ }),

/***/ "DJwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"rma-dialog",attrs:{"width":"950px","visible":_vm.showDialog,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadRma,"close":_vm.closeDialog}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.rmaForm.claimNumber)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"rmaForm"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaNum')))]),_vm._v(_vm._s(_vm.rmaForm.rmaNumber))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaDate')))]),_vm._v(" "+_vm._s(_vm.rmaForm.rmaDate))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between","flex-wrap":"wrap"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.statusColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[(_vm.rmaForm.status == 1 && !_vm.isUserServiceCompany)?_c('rma-status-selector',{model:{value:(_vm.rmaForm.status),callback:function ($$v) {_vm.$set(_vm.rmaForm, "status", $$v)},expression:"rmaForm.status"}}):_vm._e(),_vm._v(" "),(_vm.rmaForm.status == 0 || _vm.rmaForm.status == 2)?_c('rma-status-selector',{model:{value:(_vm.rmaForm.status),callback:function ($$v) {_vm.$set(_vm.rmaForm, "status", $$v)},expression:"rmaForm.status"}}):_vm._e()],1)]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('rma.returnTo')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-bottom":"15px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.hardtEquipmentManufacturing')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.fifthAvenue')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.montrealQuebec')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.canadaH8T2V3')))]),_vm._v(" "),_c('p',[_c('attn-selector',{attrs:{"attns":_vm.rmaForm.attns},model:{value:(_vm.rmaForm.attn),callback:function ($$v) {_vm.$set(_vm.rmaForm, "attn", $$v)},expression:"rmaForm.attn"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.reasonForReturn')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('common.pleseSelectReasonForReturn')},model:{value:(_vm.rmaForm.reason),callback:function ($$v) {_vm.$set(_vm.rmaForm, "reason", $$v)},expression:"rmaForm.reason"}},[_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromRDLabManager'),"value":"Return Request from R&D Lab Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProductManager'),"value":"Return Request from Product Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProjectLeader'),"value":"Return Request from Project Leader"}})],1)],1)]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.customerSiteInfo')))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.name"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.name))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.phone"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.phone))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.serviceCoInfo')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.street))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.city)+", "+_vm._s(_vm.rmaForm.serviceCompany.zip))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.phone))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.contactPersonName))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.equipmentInformation')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.modelColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('product-selector',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.productId),callback:function ($$v) {_vm.$set(_vm.rmaForm, "productId", $$v)},expression:"rmaForm.productId"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serialNumColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serialNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceCoverageColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('service-coverage-selector',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.rmaForm, "serviceCoverage", $$v)},expression:"rmaForm.serviceCoverage"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.reportSymptomColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.complaint))])])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v("\n                        "+_vm._s(_vm.$t('common.returnAuthorizationNum'))+"\n                    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.authNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.authNumDateAndTimeColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.raisedOn))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v("TSR:")]),_vm._v(" "),_c('span',{staticStyle:{"width":"80%"}},[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.tsr))])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-top":"20px"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtServiceTicketNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "serviceTicketNumber", $$v)},expression:"rmaForm.serviceTicketNumber"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtClaimNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.claimNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtInvoicePartPurchaseNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "invoiceNumber", $$v)},expression:"rmaForm.invoiceNumber"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.shippingMethodColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.shippingMethod))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.trackingNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.trackingNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "trackingNumber", $$v)},expression:"rmaForm.trackingNumber"}})],1)]),_vm._v(" "),(_vm.isTrackInfoLoaded)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"10px 0"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.service))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.weightColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.weight))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.shippedOnColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.date))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.referenceNumbersColon')))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.trackForm.referenceNumbers))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"80px","display":"flex","flex-direction":"row","align-self":"flex-end","margin":"10px 0"}},[_c('el-button',{attrs:{"id":"trackBtn","disabled":_vm.loading,"type":"primary"},on:{"click":_vm.getTrackInfo}},[_vm._v(_vm._s(_vm.$t('common.track')))])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.comment')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.comment),callback:function ($$v) {_vm.$set(_vm.rmaForm, "comment", $$v)},expression:"rmaForm.comment"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.rmaForm.parts,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.part.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.part.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.name","label":_vm.$t('common.name'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.coo')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                    "+_vm._s(scope.row.part.countryOfOrigin)+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                    "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.extendedPrice","label":_vm.$t('common.extPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                    "+_vm._s(_vm._f("money")((Number.isInteger(scope.row.quantity) ? (scope.row.part.extendedPrice * scope.row.quantity) : scope.row.part.extendedPrice)))+"\n                                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('el-button',{attrs:{"id":"saveBtn","disabled":_vm.loading,"type":"primary"},on:{"click":_vm.saveRma}},[_vm._v(_vm._s(_vm.$t('common.save')))])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DTo4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dcm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("bheM");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "Dghl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscalationList_vue__ = __webpack_require__("f7dn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bc4b69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscalationList_vue__ = __webpack_require__("7M95");
function injectStyle (ssrContext) {
  __webpack_require__("VoBc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscalationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09bc4b69_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscalationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DxmK":
/***/ (function(module, exports) {

module.exports = {"claimNumber":"Claim Number","invoiceNumber":"Invoice Number","serviceTicketNumber":"Service Ticket #","customerName":"Customer Name","customerPhone":"Customer Phone","serialNumber":"Serial Number","serviceCoverage":"Service Coverage","accounting":"Accounting","status":"Status","new":"New","acceptAndProcess":"Accept And Process","moreinfoRequired":"More Information Required","rejected":"Rejected","paid":"Paid","pendingReturnPart":"Pending Return Part","pendingRepairCodeCorrections":"Pending Repair Code Corrections","correctedRepairCodes":"Corrected Repair Codes","customerZip":"Customer Zip","serviceCompany":"Service Company","partNumber":"Part Number","model":"Model","category":"Category","code":"Code","generate":"Generate","dateOfDispatch":"Date of dispatch","mileage":"Mileage","ProcessedBy":"Processed By","serviceCompanyName":"Service Company Name","technicianName":"Technician Name","deSelectAll":"(De)Select all","customer":"Customer","product":"Product","acceptedDate":"Accepted Date","address":"Address","city":"City","region":"Region","regional":"Regional","workOrder":"Work Order","labor":"Labor","parts":"Parts","freight":"Freight","total":"Total","repairCode":"Repair Code","misc":"Misc","pleaseChoose":"Please choose","whatYouWantToDo":"What you want to do","nothing":"Nothing","view":"View","export":"Export","part":"Part","number":"Number","description":"Description","listPrice":"List Price","extendedPrice":"Extended Price","maxTime":"Max Time","serviceTicketNum":"Service Ticket Number","rmaNumber":"RMA Number","shippingMethod":"Shipping Method","trackingNumber":"Tracking Number","rmaCreationDate":"Rma Creation Date","opened":"Opened","closed":"Closed","flagged":"Flagged","flaggedClosed":"FlaggedClosed","escalation":"Escalation","escalationClosed":"EscalationClosed","postInstallInstall":"PostInstallInstall","dateFrom":"Date From","dateTo":"Date to","quantity":"Quantity","raisedBy":"Raised By","operations":"Operations","pay":"Pay","no":"No","yes":"Yes","add":"Add","name":"Name","altName":"Alternative Name","cancel":"Cancel","edit":"Edit","regularTime":"Regular Time","overTime":"Over Time","pleaseSelectPart":"Please select part","summary":"Summary","comment":"Comment","hours":"Hours","rate":"Rate","partNum":"Part #","extPrice":"Ext. Price","back":"Back","close":"Close","rmaNum":"RMA #","rmaDate":"RMA Date:","hardtEquipmentManufacturing":"Hardt Equipment Manufacturing","fifthAvenue":"1400, 50th Avenue","montrealQuebec":"Montreal, Quebec","canadaH8T2V3":"Canada, H8T 2V3","reasonForReturn":"Reason for Return","pleseSelectReasonForReturn":"Plese select Reason for Return","returnRequestFromRDLabManager":"Return Request from R&D Lab Manager","returnRequestFromProductManager":"Return Request from Product Manager","returnRequestFromProjectLeader":"Return Request from Project Leader","customerSiteInfo":"Customer Site Info","serviceCoInfo":"Service Co. Info","equipmentInformation":"Equipment Information","modelColon":"Model:","serialNumColon":"Serial #:","serviceCoverageColon":"Service Coverage:","reportSymptomColon":"Report Symptom:","returnAuthorizationNum":"Return Authorization #","authNumDateAndTimeColon":"Auth # Date & Time:","hardtServiceTicketNum":"Hardt Service Ticket (W/O) #","hardtClaimNum":"Hardt Claim #","hardtInvoicePartPurchaseNum":"Hardt Invoice (Part Purchase) #","shippingMethodColon":"Shipping Method:","trackingNum":"Tracking #","serviceColon":"Service:","weightColon":"Weight:","shippedOnColon":"Shipped on:","referenceNumbersColon":"Reference Number(s):","track":"Track","coo":"COO","price":"Price","save":"Save","pendingTechnicalReview":"Pending Technical Review","pendingTechnicalReviewGillesB":"Pending Technical Review Gilles B","details":"Details","subContractor":"Sub-contractor","claimInformation":"Claim Information","serviceTicketNumColon":"Service Ticket #:","claimColon":"Claim:","statusColon":"Status:","createdColon":"Created:","dispatchColon":"Dispatch:","acceptedDateColon":"Accepted Date:","workCompletedColon":"Work Completed:","invoiceColon":"Invoice:","serviceWorkOrderColon":"Service Work Order:","subAgentColon":"Sub Agent:","serviceRequestedBy":"Service Requested By","workOrderSignedAndApprovedBy":"Work Order Signed And Approved By","productModelColon":"Product Model:","serialColon":"Serial:","reportSymptomsColon":"Report Symptoms:","processedByColon":"Processed By:","codes":"Codes","laborAndTravel":"Labor and Travel","maxAllowed":"Max allowed","suplementary":"Suplementary","tripsExplanation":"Trips explanation","extendedTotal":"Extended Total","glCode":"Gl Code","taxEIN":"Tax-EIN","taxEINNum":"Tax-EIN #","hardtOriginalInvColon":"Hardt original inv:","gstHstNum":"GST/HST #","pstNum":"PST #","comments":"Comments","process":"Process","submit":"Submit","pleaseSelectRepairCode":"Please select repair code","partOrders":"Part Orders","modelNum":"Model #","warrantyStart":"Warranty Start","warrantyEnd":"Warranty End","update":"Update","partDescription":"Part Description","delete":"Delete","contactPerson":"Contact Person","phone":"Phone","email":"Email","equipment":"Equipment","zip":"Zip","state":"State","country":"Country","ok":"Ok","extended":"Extended","nonWarranty":"Non-Warranty","otherCompany":"Other Company","import":"Import","link":"Link","resetPassword":"Reset password","all":"All","pending":"Pending","user":"User","companyName":"Company Name","selectDate":"Select Date","express":"Express","expressSAT":"Express SAT","standard":"Standard","notSelected":"Not Selected","thisWillDeleteClaimContinue":"This will delete claim. Continue?","OK":"OK","deleteCompleted":"Delete completed","claimSuccesfullySubmitted":"Claim successfully submitted.","success":"Success","pleaseEnterName":"Please enter name","pleaseEnterPrice":"Please enter price","pleaseEnterExtendedPrice":"Please enter extended price","pleaseEnterQuantity":"Please enter quantity","pleaseRegularTime":"Please regular time","pleaseOvertime":"Please overtime","supplementaryCommentRequired":"Supplementary comment required","searchAllClaims":"Search all claims","searchInNewClaims":"Search in new claims","fromCreatedDate":"***From Created Date***","toCreatedDate":"***To Created Date***","searchInMoreInformationRequiredClaims":"Search in more information required claims","fromCommentDate":"***From Comment Date***","toCommentDate":"****To Comment Date***","searchInPendingReturnPartClaims":"Search in pending return part claims","searchInPendingReturnCodeCorrectionsClaims":"Search in pending return code corrections claims","searchInModifiedClaims":"Search in modified claims","fromModifiedDate":"***From Modified Date***","toModifiedDate":"***To Modified Date***","searchInRejectedClaims":"Search in rejected claims","fromRejectedDate":"***From Rejected Date***","toRejectedDate":"***To Rejected Date***","searchInDeletedClaims":"Search in deleted claims","fromDeletedDate":"***From Deleted Date***","toDeletedDate":"***To Deleted Date***","searchInPaidClaims":"Search in paid claims","fromPaidDate":"***From Paid Date***","toPaidDate":"***To Paid Date***","searchInPendingTechReviewClaims":"Search in pending tech review claims","fromAssignedDate":"***From Assigned Date***","toAssignedDate":"***To Assigned Date***","theExportWillBeGeneratedForAPeriodOfOneYear":"The export will be generated for a period of one year eg. (","sinceTheDateRangeWasNotSelectedPleaseConfirm":") since the date range was not selected. Please confirm!","exportWasGeneratedSuccesfully":"Export was generated successfully!","claimWasSubmittedSuccesfully":"Claim was submitted successfully.","areYouSureYouWantToChangeStatusOfClaim":"Are you sure you want to change status of claim?","claimStatusWasUpdatedSuccesfully":"Claim status was updated successfully.","pleaseEnterServiceWorkOrderNumber":"Please enter service work order number","pleaseEnterInvoiceNumber":"Please enter invoice number","invoiceNumberMustBeUnique":"Invoice number must be unique","pleaseEnterDateOfDispatch":"Please enter date of dispatch","dateOfDispatchMustBeBeforeToday":"Date of dispatch must be before today","pleaseEnterDateWorkCompleted":"Please enter date work completed","dateWorkCompletedMustBeBeforeToday":"Date work completed must be before today","dateWorkCompletedMustBeAfterOrEqualDateOfDispatch":"Date work completed must be after or equal date of dispatch","pleaseSelectModel":"Please select model","pleaseEnterSerialNumber":"Please enter serial number","pleaseSelectProductFirst":"Please select product first","pleaseSelectServiceCoverageFirst":"Please select service coverage first","pleaseSelectOvertimeApproved":"Please select overtime approved","workOrderIsRequired":"Work order is required","pleaseEnterCustomerId":"Please enter customer id","pleaseEnterOrderSignedBy":"Please enter order signed by","pleaseEnterTechnicianName":"Please enter technician name","pleaseEnterServiceRequestedBy":"Please enter service requested by","pleaseEnterSymptoms":"Please enter symptoms","pleaseEnterNumberOfTrips":"Please enter number of trips","pleaseEnterRegularTravelHours":"Please enter regular travel hours","regularTravelHoursMustBeANumber":"Regular travel hours must be a number","pleaseEnterOvertimeTravelHours":"Please enter overtime travel hours","overtimeTravelHoursMustBeANumber":"Overtime travel hours must be a number","pleaseEnterRegularMileage":"Please enter regular mileage","mileageMustBeANumber":"Mileage (miles) must be a number","pleaseEnterOvertimeMileage":"Please enter overtime mileage","overtimeMileageMustBeANumber":"Overtime mileage (miles) must be a number","pleaseEnterFuel":"Please enter fuel","serviceFuelChargeMustBeANumber":"Service & fuel charge must be a number","invoiceIsRequired":"Invoice is required","freightMustBeANumber":"Freight must be a number","taxMustBeANumber":"Tax must be a number","pleaseEnterCommentText":"Please enter comment text","claimSuccesfullySaved":"Claim successfully saved.","areYouSureYouWantToProcess":"Are you sure you want to process?","thisWillDeleteRMAContinue":"This will delete RMA. Continue?","thisWillDeleteEquipmentContinue":"This will delete equipment. Continue?","invalidSerialShouldBeginWith":"Invalid serial. Should begin with","pleaseSelectGasType":"Please select gas type","pleaseSelectShippingDate":"Please select shipping date","pleaseEnterWarrantyStartDate":"Please enter warranty start date","pleaseEnterWarrantyEndDate":"Please enter warranty end date","equipmentSuccessfullySaved":"Equipment successfully saved.","duplicateSerialNumber":"Duplicate serial number.","customerOrProductIsNotExists":"Customer or Product is not exists.","thisWillDeleteCodeContinue":"This will delete code. Continue?","pleaseSelectProduct":"Please select product","pleaseEnterCode":"Please enter code","pleaseEntercodeDescription":"Please enter code description","pleaseEnterCategory":"Please enter category","thisWillDeleteCustomerChainContinue":"This will delete customer chain. Continue?","pleaseEnterCounryName":"Please enter Country name","pleaseEnterCounryISOCode":"Please enter Country ISO Code, maximum 2 symbols","countryCreated":"Country created","pleaseEnterCustomerName":"Please enter customer name","pleaseSelectChainFirst":"Please select chain first","customerNameShouldStartWith":"Customer name should start with","pleaseEnterNumber":"Please enter number","pleaseEnterClassification":"Please enter classification","pleaseEnterProvinceAndCountry":"Please enter province and country","pleaseEnterCity":"Please enter city","pleaseEnterAddress":"Please enter address","pleaseEnterZip":"Please enter zip","pleaseEnterPhone":"Please enter phone","pleaseSelectServiceCompany":"Please select service company","pleaseInputCorrectEmailAddress":"Please input correct email address","thisWillDeleteNotificationContinue":"This will delete notification. Continue?","notifySuccesfullySaved":"Notify successfully saved","thisWillDeleteCookingParameterContinue":"This will delete cooking parameter. Continue?","cookingParameterSuccesfullySaved":"Cooking parameter successfully saved.","thisWillDeleteCustomerContinue":"This will delete customer. Continue?","pleaseEnterShippingCompanyName":"Please enter shipping company name","pleaseEnterPart":"Please enter part","pleaseEnterPartDescription":"Please enter part description","pleaseSelectPriceRate":"Please select price rate","pleaseEnterUSListPrice":"Please enter US list price","pleaseEnterCDNListPrice":"Please enter CDN list price","partsSuccesfullyImported":"Parts successfully imported.","allUnsavedChangesWillBeLostContinue":"All unsaved changes will be lost. Continue?","thisWillDeletePartContinue":"This will delete part. Continue?","areYouSure":"Are you sure?","partsWereSuccesfullySubmitted":"Parts were successfully submitted.","pleaseEnterProductNumber":"Please enter product number","pleaseEnterProductName":"Please enter product name","pleaseEnterModel":"Please enter model","pleaseEnterSerialPrefix":"Please enter serial prefix","pleaseEnterLaborGLCode":"Please enter labor GL code","pleaseEnterPartGLCode":"Please enter part GL code","pleaseEnterHandlingGLCode":"Please enter handling GL code","pleaseEnterFreightGLCode":"Please enter freight GL code","pleaseEnterMiscGLCode":"Please enter misc GL code","creationFailed":"Creation failed.","thisWillDeleteProductContinue":"This will delete product. Continue?","pleaseEnterLabor":"Please enter labor","laborMustBeANumber":"Labor must be a number","pleaseEnterMaxTime":"Please enter max time","maxTimeMustBeANumber":"Max time must be a number","pleaseEnterServiceCompanyCode":"Please enter service company code","pleaseEnterServiceCompanyName":"Please enter service company name","pleaseEnterContactPersonName":"Please enter contact person name","pleaseEnterRating":"Please enter rating","gstNumberIsRequired":"GST number is required","pstNumberIsRequired":"PST number is required","pleaseEnterCompanyName":"Please enter company name","pleaseEnterEmail":"Please enter email","pleaseEnterServiceEmail":"Please enter service email","pleaseEnterPartsEmail":"Please enter parts email","pleaseEnterRate":"Please enter rate","pleaseEnterSubContractorName":"Please enter sub-contractor name","pleaseEnterContactName":"Please enter contact name","cantCreateNewCompany":"Oops, can't create new company.","weWillSendEmailToResetPasswordContinue":"We will send email to reset password. Continue?","emailWasSent":"Email was sent.","areYouSureToDeleteTheSubcontractor":"Are you sure to delete the subcontractor?","thisWillDeleteServiceCompanyContinue":"This will delete service company. Continue?","errorWhileDeleteTheServiceCompany":"Error while delete the Service Company","pleaseEnterUsername":"Please enter username","pleaseEnterPhoneNumber":"Please enter phone number","emailWithInstructionsWasSent.":"Email with instructions was sent.","thisWillDeleteUserContinue":"This will delete user. Continue?","pleaseEnterPurchaseOrderNumber":"Please enter purchase order number","pleaseChooseState":"Please choose state","pleaseChooseCountryAndState":"Please choose country and state","pleaseEnterRegional":"Please enter regional","pleaseEnterRegion":"Please enter region","cantCreateUpdateOrder":"Can't create/update order.","partOrderProcessedSuccesfully.":"Part order processed successfully.","pleaseEnterPersonName":"Please enter person name","pleaseEnterDate":"Please enter date","areYouSureYouWantToDeleteThePartOrder":"Are you sure you want to delete the part order?","thePartOrderIsSuccessfullyDeleted":"The part order is successfully deleted","pleaseEnterCost":"Please enter cost","pleaseEnterTrackingNumber":"Please enter tracking number","pleaseEnterServiceOrderNumber":"Please enter service order number","rmaSuccesfullySaved":"Rma successfully saved.","pleaseSelectTitle":"Please select title","pleaseEnterCallerName":"Please enter caller name","pleaseSelectUrgency":"Please select urgency","flaggedCall":"FLAGGED CALL - *** Tech MUST call Hardt at 1-800-387-6847 upon arrival to work with tech support and report findings. **** Please provide techs ETA to service@hardt.ca. Thank you.","escalationNotes":"ESCALATION - ***Tech MUST call tech support from site at 1-800-387-6847 UPON ARRIVAL to report findings and for further support. *** We need a technician scheduled as soon as possible today or 1st call tomorrow at the latest. Thank you.","callCustomer":"***Please call the Customer at the number provided above to SCHEDULE or PROVIDE TECH\\'S ETA upon receiving this ticket.***","ticketSuccessfullySaved":"Ticket successfully saved.","atLeastOneSymptomCodeShouldBeAdded":"At least one symptom code should be added","pleaseSelectPhone":"Please select phone","pleaseEnterRejectedReason":"Please enter rejected reason","areYouSureToDeleteTheComment":"Are you sure to delete the comment?","youDoNotHaveRightsToDeleteThisComment":"You do not have rights to delete this comment","serviceTicketSuccesfullyUpdated":"Service ticket successfully updated","serviceTicketAccepted":"Service ticket accepted.","serviceTicketRejected":"Service ticket rejected.","authNumGenerated":"Auth # generated.","authNumWasntGenerated":"Auth # wasn't generated.","pleaseChooseCountryAndProvince":"Please choose country and province!","pleaseEnterOldPassword":"Please enter old password","pleaseEnterNewPassword":"Please enter new password","warrantyInvoiceHardt":"Warranty - INVOICE HARDT","costcoNonWarrantyInvoiceHardt":"Costco Non-Warranty - INVOICE HARDT","walMartNonWarrantyInvoiceHardt":"Wal-Mart Non-Warranty - INVOICE HARDT","pendingWarrantyInvoiceHardtPendingDecision":"Pending Warranty - INVOICE HARDT PENDING DECISION","warrantyExceptionInvoiceHardt":"Warranty Exception - INVOICE HARDT","installationPostInstall":"Installation / Post Install","nonWarrantyInvoiceHardt":"Non-Warranty / INVOICE Hardt","expressSat":"Express SAT","other":"Other","pleaseSelectFolder":"Please select folder","pleaseSelectDocumentsToUpload":"Please select documents to upload","folderSuccesfullyCreated":"Folder successfully created.","documentsSuccesfullySubmitted":"Documents successfully submitted.","folderSuccesfullyDeleted":"Folder successfully deleted.","documentsSuccesfullyDeleted":"Documents successfully deleted.","areYouSureAllFilesInThisFolderWillBeDeleted":"Are you sure? All files in this folder will be deleted!","create":"Create","descriptionFr":"DescriptionFr","moreInformationRequiredClaims":"More Information Required Claims","pendingReturnPartClaims":"Pending Return Part Claims","modifiedClaims":"Modified Claims","rejectedClaims":"Rejected Claims","deletedClaims":"Deleted Claims","paidClaims":"Paid Claims","pendingTechnicalReviewClaims":"Pending Technical Review Claims","open":"Open","processed":"Processed","deleted":"Deleted","serviceTicketId":"Service Ticket Id","pleaseEnterServiceTicketNumber":"Please Enter Service Ticket Number","serviceTicketNumberNotFound":"Service ticket number not found","deleteServiceRequest":"Are you sure you want to delete the service request?","turnGmailOn":"All emails and notifications from Sims will be Sent using the Gmail account simshardt@gmail.com","turnGmailOff":"All emails and notifications from Sims will be Sent using the HardT email account no-reply@hardt.ca"}

/***/ }),

/***/ "E3ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendEmailDialog__ = __webpack_require__("hoZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DuplicateTicketWarning__ = __webpack_require__("K7v5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H50Z");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-service-ticket-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            type: Number
        }
    },
    components: {
        CustomerSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["h" /* CustomerSelector */],
        EquipmentSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["i" /* EquipmentSelector */],
        ComplaintCodeSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["f" /* ComplaintCodeSelector */],
        CategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["c" /* CategorySelector */],
        ServiceTicketDetailsDialog: __WEBPACK_IMPORTED_MODULE_1__ServiceTicketDetailsDialog__["a" /* default */],
        SendEmailDialog: __WEBPACK_IMPORTED_MODULE_2__SendEmailDialog__["a" /* default */],
        DuplicateTicketWarning: __WEBPACK_IMPORTED_MODULE_3__DuplicateTicketWarning__["a" /* default */]
    },

    data: function data() {
        return {
            showDuplicateTicketWarning: false,
            existingTicketId: '',
            existingTicketDate: '',
            dialogVisible: false,
            isSavingInProgress: false,
            showRsMessage: false,
            serviceCoverageName: undefined,
            callerTitleValue: undefined,
            urgencyValue: undefined,
            copyticket: false,
            isCopy: false,
            form: {
                customerName: undefined,
                customerId: undefined,
                equipmentId: undefined,
                categoryName: undefined,
                equipmentName: undefined,
                subCategoryName: undefined,
                callerTitle: undefined,
                caller: "",
                callerPhoneNumber: "",
                overtimeApproved: undefined,
                isConfirmationOnly: false,
                urgency: undefined,
                notes: "",
                status: undefined,
                serviceCoverage: undefined,
                complaintCodes: [],
                attachments: [],
                categories: [],
                subCategories: [],
                responseTime: -1
            },
            rules: _defineProperty({
                customerId: [{
                    type: "number",
                    required: true,
                    message: this.$t('shared.pleaseSelectCustomer'),
                    trigger: "change"
                }],
                equipmentId: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseSelectEquipment'),
                    trigger: "change"
                }],
                callerTitle: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseSelectTitle'),
                    trigger: "change"
                }],
                caller: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCallerName'),
                    trigger: "blur"
                }],
                urgency: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseSelectUrgency'),
                    trigger: "change"
                }],
                serviceCoverage: [{
                    type: "number",
                    required: true,
                    message: this.$t('shared.pleaseSelectServiceCoverage'),
                    trigger: "change"
                }],
                overtimeApproved: [{
                    required: true,
                    message: "Please select overtime approved",
                    trigger: "change"
                }]
            }, "overtimeApproved", [{
                required: true,
                message: this.$t('shared.pleaseSelectOvertimeApproved'),
                trigger: "change"
            }]),
            formChangeEmail: {
                serviceCompany: null,
                phone: null,
                email: null,
                useCustom: false
            },
            loading: false,
            showDialog: this.visible,
            fileUrlPreview: null,
            showImagePreview: false,
            serviceTicketNumber: null,
            previousTickets: [],
            showSaveDialog: false,
            loadingChangeEmail: false,
            ticketToEdit: null,
            equipmentWrtEnd: null,
            currentPreviousTicketsPage: 1,
            previousTicketsPageSize: 4,
            previousTicketsTotal: 0,
            previousTicketsButtonDisabled: false
        };
    },

    watch: {
        "form.customerId": function formCustomerId(val, oldVal) {
            var _this = this;

            if (this.form.customerId) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].customerIsRs(this.form.customerId).then(function (response) {
                    if (response && response.data && response.data === true) {
                        _this.showRsMessage = true;
                    }
                });
            }
            this.getServiceCompanyCredentials();
            if (this.form.customerId && oldVal === undefined) {
                return;
            }
            this.form.equipmentId = undefined;
        },
        "form.equipmentId": function formEquipmentId(val, oldVal) {
            var _this2 = this;

            if (val != undefined && val != null && val != "") {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getPreviousTickets(val, this.previousTicketsPage, this.previousTicketsPageSize).then(function (response) {
                    _this2.previousTickets = response.data.items;
                    _this2.previousTicketsTotal = response.data.total;
                    if (response.data.items.length < _this2.previousTicketsPageSize || response.data.items.length === response.data.total) {
                        _this2.previousTicketsButtonDisabled = true;
                    }
                });
            }
        },
        "form.categoryName": function formCategoryName(val) {
            if (val != undefined && val != null && val != "") {
                this.form.subCategories = this.form.categories.filter(function (e) {
                    return e.category == val;
                })[0].subCategories;
                this.form.subCategoryName = undefined;
            } else {
                this.form.subCategories = [];
                this.form.subCategoryName = undefined;
            }
        },
        "form.status": function formStatus(val, oldVal) {
            switch (val) {
                case 1:
                    this.form.notes = "";
                    break;
                case 3:
                    this.form.notes = this.$t('common.flaggedCall');
                    break;
                case 5:
                    this.form.notes = this.$t('common.escalationNotes');
                    break;
                case 8:
                    this.form.notes = this.$t('common.callCustomer');
                    break;
            }
        },
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        scrollToElement: function scrollToElement(options) {
            var el = this.$el.getElementsByClassName('Customer')[0];

            if (el) {
                el.scrollIntoView(options);
            }
        },
        loadTicket: function loadTicket() {
            var _this3 = this;

            if (this.ticketId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getTicket(this.ticketId).then(function (response) {
                    _this3.loading = false;
                    console.log(response.data);
                    if (response.data.success) {
                        response.data.ticket['caller'] = response.data.ticket.callBy.split("(")[0];
                        _this3.form = Object.assign({}, response.data.ticket);

                        _this3.form.serviceCoverage = response.data.ticket.coverageNumber;
                        _this3.serviceCoverageName = response.data.ticket.coverageName;

                        _this3.form.callerTitle = Number(response.data.ticket.callerTitle);
                        _this3.callerTitleValue = response.data.ticket.callerTitleValue;

                        _this3.urgencyValue = response.data.ticket.urgencyValue;
                        _this3.form.urgency = response.data.ticket.urgencyNumber;

                        _this3.form.complaintCodes = [];
                        _this3.form.categories = [];
                        _this3.form.status = '';

                        _this3.copyticket = true;
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getServiceTicketNumber().then(function (response) {
                            _this3.loading = false;
                            _this3.serviceTicketNumber = response.data.data;
                        });
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
                            _this3.loading = false;
                            _this3.form.categories = response.data;
                        });
                    } else {
                        _this3.$notify({
                            title: "Error",
                            message: response.data.message,
                            type: "error"
                        });
                        _this3.copyticket = false;
                    }
                });
            }
        },
        appendCode: function appendCode(code) {
            if (this.form.complaintCodes.indexOf(code) === -1) {
                this.form.complaintCodes.push(code);
            }
        },
        removeCode: function removeCode(code) {
            this.form.complaintCodes = this.form.complaintCodes.filter(function (c) {
                return c.id != code;
            });
        },
        closeDialog: function closeDialog() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getServiceTicketNumber().then(function (response) {
                _this4.loading = false;
                _this4.serviceTicketNumber = response.data.data;
            });
            this.formChangeEmail.serviceCompany = null;
            this.formChangeEmail.phone = null;
            this.formChangeEmail.email = null;
            this.formChangeEmail.useCustom = false;
            this.$refs["form"].resetFields();
            this.form.complaintCodes = [];
            this.showDialog = false;
            this.previousTickets = [];
            this.loading = false;
            this.showSaveDialog = false;
            this.isCopy = false;
            this.isSavingInProgress = false;
            this.$emit("dialogClosed");
            this.previousTicketsTotal = 0;
            this.previousTicketsButtonDisabled = false;
            this.currentPreviousTicketsPage = 1;
        },
        save: function save(sendEmail, isEmailFormValied) {
            var _this5 = this;

            this.showSaveDialog = false;
            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this5.$refs["form"].loading = true;
                    _this5.isSavingInProgress = true;
                    _this5.form.status = _this5.form.status || "1"; // service ticket opened value
                    if (_this5.formChangeEmail.useCustom) {
                        if (isEmailFormValied) {
                            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveTicket(sendEmail, _this5.form, _this5.serviceTicketNumber, _this5.formChangeEmail).then(function () {
                                _this5.$notify({
                                    title: _this5.$t('common.success'),
                                    message: _this5.$t('common.ticketSuccessfullySaved'),
                                    type: "success"
                                });
                                _this5.closeDialog();
                            }).catch(function (response) {
                                _this5.$notify({
                                    title: "Error",
                                    message: response.response.data,
                                    type: "error"
                                });
                                _this5.loading = false;
                                _this5.isSavingInProgress = false;
                            });
                        } else {
                            return false;
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveTicket(sendEmail, _this5.form, _this5.serviceTicketNumber).then(function () {
                            if (!_this5.isCopy) {
                                _this5.$notify({
                                    title: _this5.$t('common.success'),
                                    message: _this5.$t('common.ticketSuccessfullySaved'),
                                    type: "success"
                                });
                                _this5.closeDialog();
                            } else {
                                _this5.$notify({
                                    title: _this5.$t('common.success'),
                                    message: _this5.$t('common.ticketSuccessfullySaved'),
                                    type: "success"
                                });
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getServiceTicketNumber().then(function (response) {
                                    _this5.serviceTicketNumber = response.data.data;
                                });
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
                                    _this5.form.categories = response.data;
                                });
                                _this5.form.status = undefined;
                                _this5.form.equipmentId = undefined;
                                _this5.form.categoryName = undefined;
                                _this5.form.equipmentName = undefined;
                                _this5.form.subCategoryName = undefined;
                                _this5.form.overtimeApproved = undefined;
                                _this5.form.isConfirmationOnly = false;
                                _this5.form.urgency = undefined;
                                _this5.form.notes = "";
                                _this5.form.status = undefined;
                                _this5.form.serviceCoverage = undefined;
                                _this5.form.complaintCodes = [];
                                _this5.form.attachments = [];
                                _this5.form.subCategories = [];
                                _this5.form.responseTime = -1;
                                _this5.isSavingInProgress = false;
                                _this5.isCopy = false;

                                _this5.scrollToElement({ behavior: 'smooth' });
                            }
                        }).catch(function (response) {
                            _this5.$notify({
                                title: "Error",
                                message: response.response.data,
                                type: "error"
                            });
                            _this5.loading = false;
                            _this5.isSavingInProgress = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        close: function close() {
            var _this6 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this6.loading = true;
                    _this6.form.status = _this6.form.status || "1"; // service ticket opened value
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveTicket(null, _this6.form, _this6.serviceTicketNumber).then(function () {
                        _this6.closeDialog();
                    }).catch(function (response) {
                        _this6.$notify({
                            title: "Error",
                            message: response.response.data,
                            type: "error"
                        });
                        _this6.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        attachmentChanged: function attachmentChanged(file, fileList) {
            this.form.attachments.push(file.raw);
        },
        handlePreview: function handlePreview(file) {
            var split = file.name.split(".");
            var fileExtension = split[split.length - 1];
            if (!file.url) {
                return;
            }
            if (fileExtension !== "pdf") {
                window.open(file.url);
                return;
            }
            this.fileUrlPreview = file.url;
            this.showImagePreview = true;
        },
        getServiceCompanyCredentials: function getServiceCompanyCredentials() {
            var _this7 = this;

            if (this.form && this.form.customerId) {
                this.loadingChangeEmail = true;
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getServiceCompanyCredentials(this.form.customerId).then(function (response) {
                    _this7.formChangeEmail.email = response.data.email;
                    _this7.formChangeEmail.phone = response.data.phone;
                    _this7.formChangeEmail.serviceCompany = response.data.serviceCompany;
                    _this7.loadingChangeEmail = false;
                });
            }
        },
        copyAndSave: function copyAndSave() {
            this.saveHandle();
            this.isCopy = true;
        },
        handleDialogClose: function handleDialogClose() {
            this.showDuplicateTicketWarning = false;
        },
        handleDialogCancel: function handleDialogCancel() {
            this.showDuplicateTicketWarning = false;
            this.closeDialog();
        },
        handleDialogContinue: function handleDialogContinue() {
            this.showDuplicateTicketWarning = false;
            this.showEmailDialog();
        },
        saveHandle: function saveHandle() {
            var _this8 = this;

            var days = 10;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getOpenedServiceTicketForEquipmentInLastXDays(this.form.equipmentId, days).then(function (response) {
                if (response.data) {
                    _this8.existingTicketId = response.data.id;
                    _this8.existingTicketDate = response.data.raisedOn;
                    _this8.showDuplicateTicketWarning = true;
                } else {
                    _this8.showEmailDialog();
                }
            });
        },
        showEmailDialog: function showEmailDialog() {
            var _this9 = this;

            if (this.form.complaintCodes.length === 0) {
                this.$message.error(this.$t('common.atLeastOneSymptomCodeShouldBeAdded'));
                return;
            }
            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this9.showSaveDialog = true;
                } else {
                    return false;
                }
            });
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        },
        editTicket: function editTicket(id) {
            this.ticketToEdit = id;
            this.dialogVisible = true;
        },
        viewrsprocedures: function viewrsprocedures() {
            window.open("static/RS Procedure Technical Support.pdf", "_blank", "width=600,height=800,toolbar=1");
            this.showRsMessage = false;
        },
        equipmentSelected: function equipmentSelected(equipment) {
            this.equipmentWrtEnd = equipment.warrantyEndFormatted;
            this.form.equipmentName = equipment.model;
            this.form.equipmentNote = equipment.modelNote;
        },
        getMorePreviousTickets: function getMorePreviousTickets() {
            var _this10 = this;

            if (this.currentPreviousTicketsPage * this.previousTicketsPageSize < this.previousTicketsTotal) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getPreviousTickets(this.form.equipmentId, this.currentPreviousTicketsPage + 1, this.previousTicketsPageSize).then(function (response) {
                    if (response.data.items.length > 0) {
                        _this10.currentPreviousTicketsPage = _this10.currentPreviousTicketsPage + 1;
                        _this10.previousTickets = [].concat(_toConsumableArray(_this10.previousTickets), _toConsumableArray(response.data.items));
                        _this10.previousTicketsTotal = response.data.total;

                        if (response.data.items.length < _this10.previousTicketsPageSize || _this10.currentPreviousTicketsPage * _this10.previousTicketsPageSize === _this10.previousTicketsTotal) {
                            _this10.previousTicketsButtonDisabled = true;
                        }
                    } else {
                        _this10.previousTicketsButtonDisabled = true;
                    }
                });
            } else {
                this.previousTicketsButtonDisabled = true;
            }
        }
    },
    mounted: function mounted() {
        var _this11 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getServiceTicketNumber().then(function (response) {
            _this11.loading = false;
            _this11.serviceTicketNumber = response.data.data;
        });
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
            _this11.loading = false;
            _this11.form.categories = response.data;
        });
    }
});

/***/ }),

/***/ "EDq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmaStatusSelector_vue__ = __webpack_require__("1zRy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a47ee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmaStatusSelector_vue__ = __webpack_require__("n0TB");
function injectStyle (ssrContext) {
  __webpack_require__("k9z6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98a47ee8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RmaStatusSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98a47ee8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RmaStatusSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Es/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("S7QI");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "company-selector",
    props: ["value", "country", "state", "city", "address", "zip", "serviceCompany", "previousState"],
    data: function data() {
        return {
            loading: false,
            companies: [],
            allowedDistance: null,
            formState: {
                country: undefined,
                state: undefined,
                city: undefined,
                address: undefined,
                zip: undefined,
                serviceCompany: undefined,
                distance: null,
                lastId: undefined
            }
        };
    },

    watch: {
        country: function country(val) {
            this.value = "";
            this.companies = [];
        },
        state: function state(val) {
            this.value = "";
            this.companies = [];
        },
        city: function city(val) {
            this.value = "";
            this.companies = [];
        },
        address: function address(val) {
            this.value = "";
            this.companies = [];
        },
        zip: function zip(val) {
            this.value = "";
            this.companies = [];
        },
        value: function value(val) {
            if (+val && typeof +val === "number") {
                this.formState.lastId = val;
                this.$emit('update:serviceCompany', this.value);
            }
        },
        serviceCompany: function serviceCompany(val) {},
        allowedDistance: function allowedDistance(val) {
            this.value = "";
            this.companies = [];
        },
        previousState: function previousState(val) {}
    },
    mounted: function mounted() {
        this.allowedDistance = null;
    },
    methods: {
        getServiceCompanies: function getServiceCompanies() {
            if (this.value === undefined || !this.formState.country && !this.formState.state && !this.formState.city && !this.formState.address && !this.formState.zip && !this.formState.serviceCompany) {
                this.resetFields();
                this.searchCompanies();
            } else {
                if (this.formState.country !== this.country) {
                    this.resetFields();
                    this.searchCompanies();
                } else if (this.formState.state !== this.state) {
                    this.resetFields();
                    this.searchCompanies();
                } else if (this.formState.city !== this.city) {
                    this.resetFields();
                    this.searchCompanies();
                } else if (this.formState.address !== this.address) {
                    this.resetFields();
                    this.searchCompanies();
                } else if (this.formState.zip !== this.zip) {
                    this.resetFields();
                    this.searchCompanies();
                } else if (this.formState.serviceCompany !== this.serviceCompany) {
                    this.formState.serviceCompany = this.serviceCompany;
                } else if (this.formState.distance !== this.allowedDistance) {
                    this.resetFields();
                    this.searchCompanies();
                }
            }
        },
        resetFields: function resetFields() {
            this.formState.country = this.country ? this.country.toString() : undefined;
            this.formState.state = this.state ? this.state.toString() : undefined;
            this.formState.city = this.city ? this.city.toString() : undefined;
            this.formState.address = this.address ? this.address.toString() : undefined;
            this.formState.zip = this.zip ? this.zip.toString() : undefined;
            this.formState.serviceCompany = this.serviceCompany ? this.serviceCompany.toString() : undefined;
            this.formState.distance = this.allowedDistance ? this.allowedDistance.toString() : null;
        },
        cleanFields: function cleanFields() {
            this.formState.country = undefined;
            this.formState.state = undefined;
            this.formState.city = undefined;
            this.formState.address = undefined;
            this.formState.zip = undefined;
            this.formState.serviceCompany = undefined;
            this.formState.distance = null;
        },
        searchCompanies: function searchCompanies() {
            var self = this;
            if (!this.country || !this.state) {
                alert(this.$t('common.pleaseChooseCountryAndProvince'));
                return;
            }
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getServiceCompanyList(this.country, this.state, this.city, this.address, this.zip, this.serviceCompany, this.allowedDistance).then(function (response) {
                self.loading = false;
                self.companies = response.data;
                console.log(self.companies);
            }).catch(function () {
                self.loading = false;
                self.companies = [];
            });
        }
    }
});

/***/ }),

/***/ "Et0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CostcoServiceRequestsList__ = __webpack_require__("wViC");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CostcoServiceRequestsList__["a"]; });


/***/ }),

/***/ "F/Gy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("YZek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_components_RmaStatusSelector_vue__ = __webpack_require__("EDq/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__ = __webpack_require__("fEXR");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-update-rma-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rmaId: {
            required: true
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */],
        AttnSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["b" /* AttnSelector */],
        ServiceCoverageSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["o" /* ServiceCoverageSelector */],
        RmaStatusSelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components_RmaStatusSelector_vue__["a" /* default */]
    },
    data: function data() {
        return {
            rmaForm: {},
            trackForm: {},
            loading: false,
            showDialog: this.visible,
            isUserServiceCompany: false,
            isTrackInfoLoaded: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadRma: function loadRma() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getRma(this.rmaId).then(function (response) {
                _this.isUserServiceCompany = _this.$currentUser.profile.role != "admin";
                _this.rmaForm = response.data;
                _this.loading = false;
            });
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            for (var property in this.rmaForm) {
                if (this.rmaForm.hasOwnProperty(property)) {
                    switch (_typeof(this.rmaForm[property])) {
                        case "string":
                            this.rmaForm[property] = null;
                            break;
                        case "number":
                            this.rmaForm[property] = null;
                            break;
                        case "object":
                            this.rmaForm[property] = null;
                            break;
                        case "undefined":
                            break;
                    }
                }
            }

            this.$emit("dialogClosed");
        },
        openTrackingWindow: function openTrackingWindow() {
            var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
            window.open(url);
        },
        saveRma: function saveRma() {
            var _this2 = this;

            console.log(this.rmaForm);
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].saveRma(this.rmaForm).then(function (response) {
                _this2.loading = false;
                _this2.$notify({
                    title: _this2.$t('common.success'),
                    message: _this2.$t('common.rmaSuccesfullySaved'),
                    type: "success"
                });
                _this2.closeDialog();
            }).catch(function (err) {
                console.log(err);
            });
        },
        getTrackInfo: function getTrackInfo() {
            var _this3 = this;

            if (!this.rmaForm.trackingNumber) {
                return;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getTrackingInfo(this.rmaForm.trackingNumber).then(function (response) {
                _this3.trackForm = response.data;
                _this3.isTrackInfoLoaded = true;
                _this3.loading = false;
            }).catch(function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),

/***/ "F0e/":
/***/ (function(module, exports) {

module.exports = {"purchaseOrder":"Bon de commande","orderNotes":"Notes d'ordre","orderDate":"Date de commande","billingAddress":"adresse de facturation","shippingAddressSameAsBillTo":"Adresse de livraison, identique à celle de facturation","shippingAddress":"adresse de livraison","addPart":"Ajouter une pièce","serviceOrderNumber":"Numéro de commande de service","shippingCost":"Frais de port","signedBy":"Signé par","signedOn":"Signé le","printAndProcess":"Imprimer et traiter","selectDateAndTime":"Sélectionnez la date et l'heure","purchaseOrderNumber":"Numéro de commande","orderNumber":"Numéro de commande","serviceCompanyName":"Nom de la société de services","orderNum":"Commande","timeStamp":"Horodatage","purchaseOrderNum":"Bon de commande","svcCompany":"Svc. ","serviceOrderNum":"Demande de service","shippingCharges":"Frais d'expédition","deliverySignedBy":"Livraison signée par","deliverySignedOn":"Livraison signée"}

/***/ }),

/***/ "FD1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":_vm.$t('orders.shippingCost'),"prop":"shippingCharges"}},[_c('el-input',{model:{value:(_vm.form.shippingCharges),callback:function ($$v) {_vm.$set(_vm.form, "shippingCharges", _vm._n($$v))},expression:"form.shippingCharges"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('common.save')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FDz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("VXsX");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'complaint-code-selector',
    props: {
        value: {},
        equipmentId: {
            type: Number,
            default: undefined
        },
        categoryName: {
            type: String,
            default: undefined
        },
        subCategoryName: {
            type: String,
            default: undefined
        }
    },
    data: function data() {
        return {
            loading: false,
            complaints: [],
            filteredComplaints: []
        };
    },

    watch: {
        equipmentId: function equipmentId(val) {
            var _this = this;

            if (!val) {
                this.complaints = [];
            } else {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getComplaints(this.equipmentId).then(function (response) {
                    _this.loading = false;
                    _this.complaints = response.data;
                    _this.filteredComplaints = response.data;
                });
            }
        },
        categoryName: function categoryName(val) {
            if (!val) {
                this.complaints = this.filteredComplaints.slice();
            } else {
                this.complaints = this.filteredComplaints.slice();
                this.complaints = this.complaints.filter(function (e) {
                    return e.category === val;
                });
            }
        },
        subCategoryName: function subCategoryName(val) {
            var _this2 = this;

            if (!val) {
                this.complaints = this.filteredComplaints.slice();
                if (this.categoryName) this.complaints = this.complaints.filter(function (e) {
                    return e.category === _this2.categoryName;
                });
            } else {
                this.complaints = this.filteredComplaints.slice();
                this.complaints = this.complaints.filter(function (e) {
                    return e.subCategory === val;
                });
            }
        }
    },
    methods: {
        change: function change(val) {
            if (val) {
                var code = val ? this.complaints.find(function (p) {
                    return p.id === val;
                }) : undefined;
                this.$emit('code-selected', code);
                this.value = undefined;
            }
        },
        truncate: function truncate(text, length) {
            if (text.length <= length) {
                return text;
            } else {
                return text.substring(0, length) + '...';
            }
        }
    }
});

/***/ }),

/***/ "FJcX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ColoredBoxWithNumber',
  props: {
    number: {
      type: Number,
      required: true
    },
    boxColor: {
      type: String,
      required: true
    }
  }
});

/***/ }),

/***/ "FnK0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('masters.searchNotifications')},model:{value:(_vm.filter.notification),callback:function ($$v) {_vm.$set(_vm.filter, "notification", $$v)},expression:"filter.notification"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('country-selector',{attrs:{"clearable":""},model:{value:(_vm.filter.countryId),callback:function ($$v) {_vm.$set(_vm.filter, "countryId", $$v)},expression:"filter.countryId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('chain-selector',{model:{value:(_vm.filter.chainId),callback:function ($$v) {_vm.$set(_vm.filter, "chainId", $$v)},expression:"filter.chainId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.name')},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.customers},on:{"sort-change":_vm.sortChanged,"expand-change":_vm.expanded}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.customerNotifications[props.row.id] && _vm.customerNotifications[props.row.id].length > 0)?_c('el-table',{staticClass:"tablewithshading",attrs:{"size":"mini","data":_vm.customerNotifications[props.row.id]}},[_c('el-table-column',{attrs:{"prop":"message","label":_vm.$t('masters.messages')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"160px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editNotification(props.row.id, scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteNotification(props.row.id, scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])})],1):_vm._e(),_vm._v(" "),(!_vm.customerNotifications[props.row.id] || _vm.customerNotifications[props.row.id].length === 0)?_c('el-alert',{attrs:{"closable":false,"title":_vm.$t('masters.customerHasNoNotifications'),"type":"info"}}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","prop":"no","label":_vm.$t('common.number')}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","prop":"name","label":_vm.$t('common.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"country","label":_vm.$t('common.country')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.phone')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'callto:'+scope.row.phone}},[_vm._v(_vm._s(scope.row.phone))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"count","label":_vm.$t('masters.numberOfNotifications')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"160px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.addNotification(scope.row.id)}}},[_c('i',{staticClass:"el-icon-plus"})])]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('promptDialog',{attrs:{"visible":_vm.dialogVisible,"notificationMessage":_vm.notification},on:{"promptDialogClosed":_vm.closePromptDialog,"notification":_vm.addNote}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fpq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("vkL+");
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'chain-selector',
  props: ['value'],
  data: function data() {
    return {
      loading: false,
      chains: []
    };
  },
  created: function created() {
    var _this = this;

    this.loading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getChains().then(function (response) {
      _this.loading = false;
      _this.chains = response.data;
    });
  }
});

/***/ }),

/***/ "Frfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeCategoryList_vue__ = __webpack_require__("I5+k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36f51f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeCategoryList_vue__ = __webpack_require__("S7Db");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeCategoryList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b36f51f8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeCategoryList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FuKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("WrkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TaxInput__ = __webpack_require__("7Mi9");
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'canadian-tax-list',
    data: function data() {
        return {
            loading: false,
            dialogVisible: false,
            taxes: []
        };
    },

    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].download(this.filter);
        },

        taxUpdated: function taxUpdated(taxId, value) {
            _this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].updateTaxForState(taxId, value).then(function () {
                return _this.loading = false;
            });
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getTaxes().then(function (response) {
            _this2.loading = false;
            _this2.taxes = response.data;
        });
    },

    components: {
        TaxInput: __WEBPACK_IMPORTED_MODULE_1__TaxInput__["a" /* default */]
    }
});

/***/ }),

/***/ "FxqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("SiCf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-customer-chain-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        customerChainId: {
            required: false
        }
    },
    data: function data() {
        return {
            form: {
                name: '',
                storeNumberRequired: false,
                validationRules: [{
                    value: ''
                }]
            },
            rules: {
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterName'),
                    trigger: 'blur'
                }]
            },
            showDialog: this.visible,
            loading: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadCustomerChain: function loadCustomerChain() {
            var _this = this;

            if (this.customerChainId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCustomerChain(this.customerChainId).then(function (response) {
                    _this.loading = false;
                    _this.form.name = response.data.name;
                    _this.form.storeNumberRequired = response.data.storeNumberRequired;
                    _this.form.validationRules = response.data.validationRules.map(function (rule) {
                        return { value: rule };
                    });
                });
            }
        },
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        addRule: function addRule() {
            this.form.validationRules.push({ value: '' });
        },
        removeRule: function removeRule(rule) {
            this.form.validationRules = this.form.validationRules.filter(function (r) {
                return r !== rule;
            });
        },
        save: function save() {
            var _this2 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].saveCustomerChain(_this2.customerChainId, _this2.form).then(function () {
                        _this2.$emit('save', {
                            new: _this2.customerChainId === undefined,
                            id: _this2.customerChainId,
                            data: _this2.form
                        });
                        _this2.closeDialog();
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ "G6Zw":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "UGjV",
	"./fr.json": "F0e/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "G6Zw";

/***/ }),

/***/ "GQ0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.subject,"visible":_vm.showDialog,"width":"650px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadTicket,"close":_vm.closeDialog}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GSbF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'shipping-info',
    data: function data() {
        return {
            form: {
                shippingCharges: ''
            },
            rules: {
                shippingCharges: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseEnterCost'),
                    trigger: 'blur'
                }]
            }
        };
    },

    methods: {
        submit: function submit() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this.$emit('update', _this.form);
                }
            });
        }
    }
});

/***/ }),

/***/ "GW79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingInfo_vue__ = __webpack_require__("GSbF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52667d2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingInfo_vue__ = __webpack_require__("FD1y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52667d2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GZvB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form-item',{attrs:{"label":_vm.$t('common.trackingNumber'),"prop":"trackingNumber"}},[_c('el-input',{model:{value:(_vm.form.trackingNumber),callback:function ($$v) {_vm.$set(_vm.form, "trackingNumber", $$v)},expression:"form.trackingNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.serviceOrderNumber'),"prop":"serviceOrderNumber"}},[_c('el-input',{model:{value:(_vm.form.serviceOrderNumber),callback:function ($$v) {_vm.$set(_vm.form, "serviceOrderNumber", $$v)},expression:"form.serviceOrderNumber"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('common.save')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ggy9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"rma-dialog",attrs:{"width":"950px","visible":_vm.showDialog,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadRma,"close":_vm.closeDialog}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.rmaForm.claimNumber)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"rmaForm"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaNum')))]),_vm._v(_vm._s(_vm.rmaForm.rmaNumber))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaDate')))]),_vm._v(" "+_vm._s(_vm.rmaForm.rmaDate))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between","flex-wrap":"wrap"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v("Status:")]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('rma-status-selector',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.status),callback:function ($$v) {_vm.$set(_vm.rmaForm, "status", $$v)},expression:"rmaForm.status"}})],1)]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('rma.returnTo')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-bottom":"10px"}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.hardtEquipmentManufacturing')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.fifthAvenue')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.montrealQuebec')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.canadaH8T2V3')))]),_vm._v(" "),_c('p',[_c('attn-selector',{attrs:{"disabled":"","attns":_vm.rmaForm.attns},model:{value:(_vm.rmaForm.attn),callback:function ($$v) {_vm.$set(_vm.rmaForm, "attn", $$v)},expression:"rmaForm.attn"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.reasonForReturn')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('common.pleseSelectReasonForReturn')},model:{value:(_vm.rmaForm.reason),callback:function ($$v) {_vm.$set(_vm.rmaForm, "reason", $$v)},expression:"rmaForm.reason"}},[_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromRDLabManager'),"value":"Return Request from R&D Lab Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProductManager'),"value":"Return Request from Product Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProjectLeader'),"value":"Return Request from Project Leader"}})],1)],1)]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.customerSiteInfo')))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.name"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.name))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.phone"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.phone))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.serviceCoInfo')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.street))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.city)+", "+_vm._s(_vm.rmaForm.serviceCompany.zip))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.phone))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.contactPersonName))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.equipmentInformation')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.modelColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('product-selector',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.productId),callback:function ($$v) {_vm.$set(_vm.rmaForm, "productId", $$v)},expression:"rmaForm.productId"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serialNumColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serialNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceCoverageColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('service-coverage-selector',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.rmaForm, "serviceCoverage", $$v)},expression:"rmaForm.serviceCoverage"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.reportSymptomColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.complaint))])])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v("\n                        "+_vm._s(_vm.$t('common.returnAuthorizationNum'))+"\n                    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.authNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.authNumDateAndTimeColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.raisedOn))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v("TSR:")]),_vm._v(" "),_c('span',{staticStyle:{"width":"80%"}},[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.tsr))])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-top":"20px"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtServiceTicketNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "serviceTicketNumber", $$v)},expression:"rmaForm.serviceTicketNumber"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtClaimNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.claimNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtInvoicePartPurchaseNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "invoiceNumber", $$v)},expression:"rmaForm.invoiceNumber"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.shippingMethodColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.shippingMethod))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.trackingNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.rmaForm.trackingNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "trackingNumber", $$v)},expression:"rmaForm.trackingNumber"}})],1)]),_vm._v(" "),(_vm.isTrackInfoLoaded)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"10px 0"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.service))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.weightColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.weight))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.shippedOnColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.date))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.referenceNumbersColon')))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.trackForm.referenceNumbers))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"80px","display":"flex","flex-direction":"row","align-self":"flex-end","margin":"10px 0"}},[_c('el-button',{attrs:{"id":"trackBtn","disabled":_vm.loading,"type":"primary"},on:{"click":_vm.getTrackInfo}},[_vm._v(_vm._s(_vm.$t('common.track')))])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.comment')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.comment),callback:function ($$v) {_vm.$set(_vm.rmaForm, "comment", $$v)},expression:"rmaForm.comment"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.rmaForm.parts,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.part.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.part.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.name","label":_vm.$t('common.name'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.coo')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(scope.row.part.countryOfOrigin)+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.extendedPrice","label":_vm.$t('common.extPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("money")((Number.isInteger(scope.row.quantity) ? (scope.row.part.extendedPrice * scope.row.quantity) : scope.row.part.extendedPrice)))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('el-button',{attrs:{"id":"printBtn","loading":_vm.printing,"disabled":_vm.rmaForm.id == 0},on:{"click":function($event){_vm.printRma()}}},[_c('i',{staticClass:"el-icon-printer"})])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Gj7M":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "DxmK",
	"./fr.json": "aG6Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Gj7M";

/***/ }),

/***/ "GnMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"change-password-dilog",attrs:{"title":_vm.$t('shared.changePassword'),"visible":_vm.showDialog,"width":"300px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-position":"top"}},[_c('el-form-item',{attrs:{"label":_vm.$t('shared.oldPassword'),"prop":"oldPassword"}},[_c('el-input',{attrs:{"type":"password"},model:{value:(_vm.form.oldPassword),callback:function ($$v) {_vm.$set(_vm.form, "oldPassword", $$v)},expression:"form.oldPassword"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('shared.newPassword'),"prop":"newPassword"}},[_c('el-input',{attrs:{"type":"password"},model:{value:(_vm.form.newPassword),callback:function ($$v) {_vm.$set(_vm.form, "newPassword", $$v)},expression:"form.newPassword"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('shared.change')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GyRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("065F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "promptDialog",
    props: {
        visible: {
            type: Boolean,
            default: false

        },
        notificationMessage: {
            type: String
        }
    },
    data: function data() {
        return {
            showDialog: this.visible,
            message: this.notificationMessage

        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        notificationMessage: function notificationMessage(val) {
            this.message = val;
        }

    },
    methods: {
        closePage: function closePage() {
            this.showDialog = false;
            this.$emit("promptDialogClosed", false);

            if (!this.notificationMessage) {
                this.message = '';
            }
        },
        addNotification: function addNotification() {
            if (!this.message.trim()) {
                this.closePage();
            } else {
                this.$emit("notification", this.message);
                this.showDialog = false;
                this.$emit("promptDialogClosed", false);
                if (!this.notificationMessage) {
                    this.message = '';
                }
            }
        }
    }

});

/***/ }),

/***/ "GzPh":
/***/ (function(module, exports) {

module.exports = {"createFolder":"Create Folder","parentFolder":"Parent Folder","newFolderName":"New folder name","uploadDocument":"Upload document","folder":"Folder","documents":"Documents","uploadedFilesLength":"Uploaded files length:","upload":"Upload","totalFilesLength":"Total files length:"}

/***/ }),

/***/ "H3FJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getCodes: function getCodes(id, categoryId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodes/lookup/' + id, {
            params: {
                categoryId: categoryId,
                details: true
            }
        });
    }
});

/***/ }),

/***/ "H50Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getTickets: function getTickets(page, filter, sorting) {
        var params = {
            page: page,
            customer: filter.customer,
            customerId: filter.customerId,
            ticket: filter.ticket,
            city: filter.city,
            serviceCompany: filter.serviceCompany,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            state: filter.state,
            chainId: filter.chainId,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder,
            source: filter.source
        };
        if (filter.type !== 0) {
            params.status = filter.type;
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets', {
            params: params
        });
    },
    getTicket: function getTicket(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id);
    },
    saveTicket: function saveTicket(dispatch, ticket, number, changeEmail) {
        var fd = new FormData();
        for (var prop in ticket) {
            if (ticket.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (var i = 0; i < ticket.attachments.length; i++) {
                        if (ticket.attachments[i] instanceof File) {
                            fd.append('attachments', ticket.attachments[i]);
                        }
                    }
                } else if (prop === 'complaintCodes') {
                    for (var _i = 0; _i < ticket.complaintCodes.length; _i++) {
                        fd.append('complaintCodes', ticket.complaintCodes[_i].id);
                    }
                } else {
                    fd.append(prop, ticket[prop]);
                }
            }
        }
        if (changeEmail && changeEmail.useCustom) {
            fd.append('customEmailAddress[serviceCompany]', changeEmail.serviceCompany);
            fd.append('customEmailAddress[phone]', changeEmail.phone);
            fd.append('customEmailAddress[email]', changeEmail.email);
            fd.append('customEmailAddress[custom]', changeEmail.useCustom);
        }

        var url = '/api/servicetickets/create?number=' + number;

        if (dispatch) {
            url += '&dispatch=' + dispatch;
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteTicket: function deleteTicket(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/servicetickets/' + id);
    },
    resolveTicket: function resolveTicket(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/resolve');
    },
    resendTicket: function resendTicket(id) {
        //return axios.post('/api/');
    },
    reopenTicket: function reopenTicket(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/reopen');
    },
    printTicket: function printTicket(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/print');
    },
    submitComment: function submitComment(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/comments', {
            id: form.commentId,
            message: form.comment
        });
    },
    editServiceTicketStatus: function editServiceTicketStatus(id, ticketStatus) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/editticketstatus', ticketStatus, {
            headers: { "Content-Type": "application/json" }
        });
    },
    deleteComment: function deleteComment(id, comment) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/deletecomment', {
            id: comment.id
        });
    },
    submitWhatWasDone: function submitWhatWasDone(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/whatwasdone', {
            id: form.whatWasDoneId,
            message: form.whatWasDone
        });
    },
    deleteWhatWasDone: function deleteWhatWasDone(id, whatWasDone) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/deletewhatwasdone', {
            id: whatWasDone.id
        });
    },
    submitEscalationCommentNextStep: function submitEscalationCommentNextStep(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/escalationcommentnextstep', {
            id: form.escalationCommentNextStepId,
            message: form.escalationCommentNextStep
        });
    },
    deleteEscalationCommentNextStep: function deleteEscalationCommentNextStep(id, escalationCommentNextStep) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/deleteescalationnextstep', {
            id: escalationCommentNextStep.id
        });
    },
    submitEscalationSubscriber: function submitEscalationSubscriber(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/escalationsubscriberupdate', {
            id: form.escalationCommentNextStepId,
            isSubscribedByEmail: form.isSubscribedByEmail,
            isSubsribedBySms: form.isSubsribedBySms
        });
    },
    getStatuses: function getStatuses() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/statuses');
    },
    updateTicket: function updateTicket(details) {
        var fd = new FormData();
        fd.append('id', details.id);
        if (details.escalationPart != null) {
            fd.append('escalationNeededPart.salesOrderNumber', details.escalationPart.salesOrderNumber);
            fd.append('escalationNeededPart.trackingNumber', details.escalationPart.trackingNumber);
            fd.append('escalationNeededPart.workflowStage', details.escalationPart.workflowStage);
            fd.append('escalationNeededPart.smsSubscription', details.escalationPart.smsSubscription);
            fd.append('escalationNeededPart.emailSubscription', details.escalationPart.emailSubscription);
            fd.append('escalationNeededPart.escallationContactName', details.escalationPart.escallationContactName);
            fd.append('escalationNeededPart.escallationContactPhone', details.escalationPart.escallationContactPhone);
            fd.append('escalationNeededPart.escallationContactEmail', details.escalationPart.escallationContactEmail);
            fd.append('escalationNeededPart.escalatedBy', details.escalationPart.escalatedBy);
            //fd.append('escalationNeededPart.parts', JSON.stringify(details.escalationPart.parts));

            for (var i = 0; i < details.escalationPart.parts.length; i++) {
                console.log(JSON.stringify(details.escalationPart.parts[i].part));
                fd.append('escalationNeededPart.parts[' + i + '].id', details.escalationPart.parts[i].part.id);
                fd.append('escalationNeededPart.parts[' + i + '].quantity', details.escalationPart.parts[i].quantity);
            }
        }
        console.log(fd);
        for (var _i2 = 0; _i2 < details.attachments.length; _i2++) {
            if (details.attachments[_i2] instanceof File) {
                fd.append('attachments', details.attachments[_i2]);
            } else {
                fd.append('oldAttachmentIds', details.attachments[_i2].id);
            }
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/update', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getCategories: function getCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/servicetickets');
    },
    getServiceTicketNumber: function getServiceTicketNumber() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/getnumber');
    },
    getOpenedServiceTicketForEquipmentInLastXDays: function getOpenedServiceTicketForEquipmentInLastXDays(idEquipment, days) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/getopenedserviceticketforequipmentinlastxdays/' + idEquipment + '/' + days);
    },
    getComplaintCodeCategories: function getComplaintCodeCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/complaintcodes/categories');
    },
    getPreviousTickets: function getPreviousTickets(id, pageNumber, previousTicketsPageSize) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/previoustickets', {
            params: {
                page: pageNumber,
                perPage: previousTicketsPageSize
            }
        });
    },
    getServiceCompanyCredentials: function getServiceCompanyCredentials(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/getServiceCompanyCredentials');
    },
    download: function download(filter) {
        var params = {
            customer: filter.customer,
            ticket: filter.ticket,
            city: filter.city,
            serviceCompany: filter.serviceCompany,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            state: filter.state,
            source: filter.source,
            chainId: filter.chainId
        };
        if (filter.type !== 0) {
            params.status = filter.type;
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/servicetickets/export', params);
    },
    sendEmail: function sendEmail(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/confirmEmailReceived');
    },
    customerIsRs: function customerIsRs(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/customerIsRs');
    },
    resendEmail: function resendEmail(id, email) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/resendEmail/' + id + '/' + email);
    },
    accept: function accept(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/accept/' + id);
    },
    reject: function reject(id, reason) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/reject/' + id + '/' + reason);
    },
    generateAuthNumber: function generateAuthNumber(id, form) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/' + id + '/generateAuthNumber', {
            qty: form.qty,
            partNumber: form.partNumber,
            techName: form.techName,
            serviceTicketId: form.serviceTicketId
        });
    },
    getIsPendingPart: function getIsPendingPart(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/getIsPendingPart');
    },
    getServiceTicketData: function getServiceTicketData(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/rma');
    },
    getParts: function getParts(term, serviceCompanyId, productId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/lookup', {
            params: {
                term: term,
                serviceCompanyId: serviceCompanyId,
                productId: productId,
                unavailableForClaims: true
            }
        });
    },
    getPartById: function getPartById(id, serviceCompanyId, isNotWarrantyClaim) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/' + id + '/' + serviceCompanyId + '/' + isNotWarrantyClaim + '/dashboard');
    },
    updateSubscriber: function updateSubscriber(serviceTicketId, subscriberForm) {
        var fd = new FormData();
        fd.append('serviceTicketId', serviceTicketId);
        subscriberForm.forEach(function (subscriber, index) {
            fd.append('subscribers[' + index + '].id', subscriber.id);
            fd.append('subscribers[' + index + '].name', subscriber.name);
            fd.append('subscribers[' + index + '].email', subscriber.email);
            fd.append('subscribers[' + index + '].sms', subscriber.sms);
            fd.append('subscribers[' + index + '].isSubscribedByEmail', subscriber.isSubscribedByEmail);
            fd.append('subscribers[' + index + '].isSubscribedBySms', subscriber.isSubscribedBySms);
        });
        console.log(fd);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/updatesubscriber', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    updateEmailStatus: function updateEmailStatus(serviceTicketId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/servicetickets/updateEmailStatus/' + serviceTicketId);
    }
});

/***/ }),

/***/ "HKIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"repair-dialog",attrs:{"title":(_vm.codeToEdit ? _vm.$t('common.edit') : _vm.$t('common.add')) + ' ' + _vm.$t('common.repairCode'),"visible":_vm.showDialog,"width":"500px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.repairCode'),"prop":"repairCode"}},[_c('repair-code-selector',{ref:"code-selector",attrs:{"preselect":_vm.selectedCode,"productId":_vm.productId,"multiple":_vm.multiple},on:{"repair-code-selected":_vm.codeSelected,"repair-codes-selected":_vm.codesSelected}})],1),_vm._v(" "),_c('el-row',_vm._l((_vm.selectedCodes),function(code){return _c('div',{key:code.id},[_c('p',{staticStyle:{"font-size":"10px"}},[_vm._v("\n                    "+_vm._s(code.name)+"\n                    "),_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){_vm.deleteCode(code.id)}}})])])})),_vm._v(" "),_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.regularTime'),"prop":"regularTime"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"debounce":0,"controls":false,"disabled":_vm.selectedCode === undefined && _vm.selectedCodes.length === 0,"min":0,"max":10},on:{"blur":_vm.regularChange},model:{value:(_vm.form.regularTime),callback:function ($$v) {_vm.$set(_vm.form, "regularTime", $$v)},expression:"form.regularTime"}})],1),_vm._v(" "),(!_vm.multiple)?_c('el-form-item',{attrs:{"label":_vm.$t('claims.supplementaryRegularTime'),"prop":"supplementaryRegularTime"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"controls":false,"debounce":0,"disabled":true},model:{value:(_vm.form.supplementaryRegularTime),callback:function ($$v) {_vm.$set(_vm.form, "supplementaryRegularTime", $$v)},expression:"form.supplementaryRegularTime"}})],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.overTime'),"prop":"overTime"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"debounce":0,"controls":false,"disabled":_vm.selectedCode === undefined && _vm.selectedCodes.length === 0,"min":0,"max":10},on:{"blur":_vm.overTimeChange},model:{value:(_vm.form.overTime),callback:function ($$v) {_vm.$set(_vm.form, "overTime", $$v)},expression:"form.overTime"}})],1),_vm._v(" "),(!_vm.multiple)?_c('el-form-item',{attrs:{"label":_vm.$t('common.supplementaryOverTime'),"prop":"supplementaryOverTime"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"controls":false,"debounce":0,"disabled":true},model:{value:(_vm.form.supplementaryOverTime),callback:function ($$v) {_vm.$set(_vm.form, "supplementaryOverTime", $$v)},expression:"form.supplementaryOverTime"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.supplementaryComment'),"prop":"supplementaryComment"}},[_c('el-input',{attrs:{"disabled":!_vm.commentEnabled,"type":"textarea","rows":3},model:{value:(_vm.form.supplementaryComment),callback:function ($$v) {_vm.$set(_vm.form, "supplementaryComment", $$v)},expression:"form.supplementaryComment"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addCode}},[_vm._v(_vm._s(_vm.codeToEdit ? _vm.$t('common.save') : _vm.$t('common.add')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HchN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RMA_vue__ = __webpack_require__("ufXc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52834db0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RMA_vue__ = __webpack_require__("qRCb");
function injectStyle (ssrContext) {
  __webpack_require__("Q3I8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52834db0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RMA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52834db0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RMA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hlr1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hpq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_reports_components_LineChart__ = __webpack_require__("e4AD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "graphs",
  components: {
    "line-chart": __WEBPACK_IMPORTED_MODULE_0__app_reports_components_LineChart__["a" /* default */]
  },
  mounted: function mounted() {
    this.getData();
  },
  created: function created() {
    this.loadFilters();
  },

  watch: {
    productId: {
      deep: true,
      handler: function handler() {
        this.getData();
      }
    },
    periodType: {
      deep: true,
      handler: function handler() {
        this.getData();
      }
    }
  },
  data: function data() {
    return {
      productId: 1,
      products: [],
      periodType: 24,
      periodTypes: [],
      graphVisible: false,
      chartData: {},
      options: {},
      showGraph: false
    };
  },

  methods: {
    loadFilters: function loadFilters() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getFilterForGraph().then(function (response) {
        _this.products = response.data.products;
        _this.periodTypes = response.data.periodTypes;
      });
    },
    choosePeriod: function choosePeriod(period) {
      this.periodType = period;
    },
    chooseProduct: function chooseProduct(product) {
      this.productId = product;
    },
    getData: function getData() {
      var _this2 = this;

      var filter = {
        productId: this.productId,
        periodType: this.periodType
      };
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getDataForGraph(filter).then(function (response) {
        var labels = [];
        var datasets = [{
          label: "Claims Totals",
          borderColor: "red",
          fill: "false",
          data: []
        }];
        response.data.forEach(function (x) {
          labels.push(x.yearDate + "/" + x.monthDate);
          datasets[0].data.push(x.total);
        });
        _this2.chartData = {
          labels: labels,
          datasets: datasets
        };
        _this2.options = {
          responsive: true,
          maintainAspectRatio: false
        };
        _this2.showGraph = true;
      });
    }
  }
});

/***/ }),

/***/ "HxW8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("pK4f");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "I5+k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateResolutionCodeCategoryDialog__ = __webpack_require__("0wdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("BHZN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "resolution-code-category-list",
    components: {
        CreateUpdateResolutionCodeCategoryDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateResolutionCodeCategoryDialog__["a" /* default */],
        ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */]
    },
    data: function data() {
        return {
            categories: [],
            loading: true,
            dialogVisible: false,
            categoryToEdit: null,
            filter: {
                productId: undefined,
                text: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadCategories();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadCategories();
            }
        }
    },
    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].downloadCategories(this.filter);
        },
        loadCategories: function loadCategories() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCategories(this.currentPage, this.filter.productId, this.filter.text).then(function (response) {
                _this.loading = false;
                _this.categories = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendCategory: function appendCategory(event) {
            if (event.new) {
                this.categories.push(event.data);
                this.total += 1;
            } else {
                this.loadCategories();
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadCategories();
        },
        editCategory: function editCategory(id) {
            this.categoryToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.categoryToEdit = null;
            this.dialogVisible = false;
        },
        deleteCategory: function deleteCategory(id) {
            var _this2 = this;

            this.$confirm(this.$t('masters.thisWillDeleteCategoryContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteCategory(id).then(function () {
                    _this2.loadCategories();
                    _this2.$message({
                        type: "success",
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        }
    }
});

/***/ }),

/***/ "IJD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartList_vue__ = __webpack_require__("jLoY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6579a888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartList_vue__ = __webpack_require__("kJnH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6579a888_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IOUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("PSZQ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "ITxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectProduct'),"disabled":_vm.disabled,"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.products),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IkBD":
/***/ (function(module, exports) {

module.exports = {"toBePaid":"To Be Paid","paidAndPrinted":"Paid And Printed","claimInvoiceCustomer":"Claim #, Invoice #, Customer Name","payAndPrintSelectedClaims":"Pay and print selected claims","payClaim":"Pay claim","printClaim":"Print claim","areYouSureThatYouWantoProcessClaim":"Are you sure that you want to process claim?","thisActionWillChangeStatusOfThisClaim":"This action will change status of this claim and send email notification to service company","areYouSureThatYouWantToPayClaim":"Are you sure that you want to pay claim?","areYouSureThatYouWantToPayAndPrintAllSelectedClaims":"Are you sure that you want to pay and print all selected claims?"}

/***/ }),

/***/ "IyOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimHistory_vue__ = __webpack_require__("W09U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efaf277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimHistory_vue__ = __webpack_require__("PgIb");
function injectStyle (ssrContext) {
  __webpack_require__("evo4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3efaf277"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3efaf277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J64k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getEquipment: function getEquipment(customerId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + customerId + '/equipment');
    }
});

/***/ }),

/***/ "J9fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graphs_vue__ = __webpack_require__("Hpq9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ed9668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graphs_vue__ = __webpack_require__("KzQl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Graphs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ed9668_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Graphs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JMN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showRma)?_c('el-dialog',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingClaim),expression:"loadingClaim"}],staticClass:"claim-dialog",attrs:{"title":(_vm.claimNumber ? _vm.claimNumber : _vm.$t('common.create')) + ' ' + _vm.$t('claims.claim'),"visible":_vm.showDialog,"width":"701px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadClaim,"close":_vm.closeDialog}},[_c('template',{slot:"title"},[_c('span',[_vm._v("\n            "+_vm._s((_vm.claimNumber ? _vm.claimNumber : 'Create') + ' Claim')+"\n            "),_c('el-button',{on:{"click":function($event){_vm.previewClaim(_vm.mutatedClaimId)}}},[_vm._v("\n                "+_vm._s(_vm.$t('common.summary'))+"\n            ")])],1)]),_vm._v(" "),_c('el-tabs',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],model:{value:(_vm.activeStep),callback:function ($$v) {_vm.activeStep=$$v},expression:"activeStep"}},[_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('claims.claimAccountInformation'),"name":"claimInfo"}},[_c('el-form',{ref:"general",attrs:{"model":_vm.generalForm,"rules":_vm.generalRules,"size":"small","label-width":"200px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceTicketNumber'),"prop":"serviceTicketNumber"}},[_c('service-ticket-selector',{model:{value:(_vm.generalForm.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.generalForm, "serviceTicketNumber", $$v)},expression:"generalForm.serviceTicketNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.90daysWarranty'),"prop":"is90DaysWarranty"}},[_c('el-switch',{model:{value:(_vm.generalForm.is90DaysWarranty),callback:function ($$v) {_vm.$set(_vm.generalForm, "is90DaysWarranty", $$v)},expression:"generalForm.is90DaysWarranty"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.serviceWorkOrderNumber'),"prop":"serviceWorkOrder"}},[_c('el-input',{model:{value:(_vm.generalForm.serviceWorkOrder),callback:function ($$v) {_vm.$set(_vm.generalForm, "serviceWorkOrder", $$v)},expression:"generalForm.serviceWorkOrder"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.invoiceNumber'),"prop":"invoiceNumber"}},[_c('el-input',{model:{value:(_vm.generalForm.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.generalForm, "invoiceNumber", $$v)},expression:"generalForm.invoiceNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCoverage'),"prop":"serviceCoverage"}},[_c('service-coverage-selector',{attrs:{"forExclude":"8"},model:{value:(_vm.generalForm.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.generalForm, "serviceCoverage", $$v)},expression:"generalForm.serviceCoverage"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.dateOfDispatch'),"prop":"dateOfDispatch"}},[_c('el-date-picker',{attrs:{"type":"date"},model:{value:(_vm.generalForm.dateOfDispatch),callback:function ($$v) {_vm.$set(_vm.generalForm, "dateOfDispatch", $$v)},expression:"generalForm.dateOfDispatch"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.dateWorkCompleted'),"prop":"dateWorkCompleted"}},[_c('el-date-picker',{attrs:{"type":"date"},model:{value:(_vm.generalForm.dateWorkCompleted),callback:function ($$v) {_vm.$set(_vm.generalForm, "dateWorkCompleted", $$v)},expression:"generalForm.dateWorkCompleted"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.model'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.generalForm.productId),callback:function ($$v) {_vm.$set(_vm.generalForm, "productId", $$v)},expression:"generalForm.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serialNumber'),"prop":"serialNumber"}},[_c('el-input',{model:{value:(_vm.generalForm.serialNumber),callback:function ($$v) {_vm.$set(_vm.generalForm, "serialNumber", $$v)},expression:"generalForm.serialNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.workOrders'),"prop":"workOrders"}},[_c('el-upload',{attrs:{"name":"workOrders","drag":"","multiple":"","file-list":_vm.generalForm.workOrders,"auto-upload":false,"limit":5,"action":"","on-change":_vm.workOrderChanged,"on-remove":_vm.workOrderRemoved,"on-preview":_vm.handlePreview}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                            "+_vm._s(_vm.$t('serviceTickets.dropFile'))+"\n                            "),_c('em',[_vm._v(_vm._s(_vm.$t('serviceTickets.clicktoUpload')))])])])],1)],1)],1),_vm._v(" "),(_vm.localClaimId)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('claims.siteInformation'),"name":"siteInfo"}},[_c('el-form',{ref:"siteInfo",attrs:{"model":_vm.siteInfoForm,"rules":_vm.siteInfoRules,"size":"small","label-width":"200px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('claims.clientStore'),"prop":"customerId"}},[_c('customer-selector',{ref:"customerIdSelector",model:{value:(_vm.siteInfoForm.customerId),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "customerId", $$v)},expression:"siteInfoForm.customerId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Work Order Signed & Approved By","prop":"orderSignedBy"}},[_c('el-input',{model:{value:(_vm.siteInfoForm.orderSignedBy),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "orderSignedBy", $$v)},expression:"siteInfoForm.orderSignedBy"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.subContractor')}},[_c('el-select',{attrs:{"placeholder":_vm.$t('claims.pleaseSelectSubContractor'),"loading":_vm.loading},model:{value:(_vm.siteInfoForm.subcontractorId),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "subcontractorId", $$v)},expression:"siteInfoForm.subcontractorId"}},_vm._l((_vm.subcontractors),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1),_vm._v(" "),(_vm.companyType == 2)?_c('el-form-item',{attrs:{"label":"Sub-Agent"}},[_c('el-select',{attrs:{"placeholder":_vm.$t('claims.pleaseSelectSubAgent'),"loading":_vm.loading},model:{value:(_vm.siteInfoForm.subagentId),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "subagentId", $$v)},expression:"siteInfoForm.subagentId"}},_vm._l((_vm.childCompanies),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.serviceTechnicianName'),"prop":"technicianName"}},[_c('el-input',{model:{value:(_vm.siteInfoForm.technicianName),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "technicianName", $$v)},expression:"siteInfoForm.technicianName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.serviceRequestedBy'),"prop":"serviceRequestedBy"}},[_c('el-input',{model:{value:(_vm.siteInfoForm.serviceRequestedBy),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "serviceRequestedBy", $$v)},expression:"siteInfoForm.serviceRequestedBy"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.reportSymptoms'),"prop":"complaint"}},[_c('el-input',{attrs:{"type":"textarea","rows":3},model:{value:(_vm.siteInfoForm.complaint),callback:function ($$v) {_vm.$set(_vm.siteInfoForm, "complaint", $$v)},expression:"siteInfoForm.complaint"}})],1),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.showRepairCodeDialog}},[_vm._v("\n                    "+_vm._s(_vm.$t('claims.clickHereToAddRepairCodes'))+"\n                ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.showMultiRepairCodeDialog}},[_vm._v("\n                    "+_vm._s(_vm.$t('claims.clickHereToAddMultipleRepairCodesPerformedWithSingleLaborTime'))+"\n                ")]),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.repairCodes,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.code'),"width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.code.name.split(' - ')[1],"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.code.name.split(' - ')[0]))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"regularTime","label":_vm.$t('claims.regTime'),"width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"overTime","label":_vm.$t('common.overTime'),"width":"53"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplementaryRegularTime","label":_vm.$t('claims.suppRegTime'),"width":"53"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplementaryOverTime","label":_vm.$t('claims.suppOverTime'),"width":"53"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplementaryComment","label":_vm.$t('common.comment'),"align":"center","width":"286"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"align":"center","width":"85"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{staticClass:"el-icon-edit",on:{"click":function($event){_vm.editCode(scope.row)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){_vm.deleteCode(scope.row.code.id)}}})]}}])})],1)],1),_vm._v(" "),_c('add-repair-code-dialog',{attrs:{"visible":_vm.repairCodeDialogVisible,"productId":_vm.generalForm.productId,"codeToEdit":_vm.repairCodeToEdit,"multiple":_vm.isMultiCodeAdd},on:{"update:visible":function($event){_vm.repairCodeDialogVisible=$event},"codes-selected":_vm.codesAdded,"dialogClosed":_vm.repairCodeDialogClosed}})],1):_vm._e(),_vm._v(" "),(_vm.localClaimId)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":"Labor & Travel","name":"laborTravel"}},[_c('el-row',{attrs:{"gutter":50}},[_c('el-col',{attrs:{"span":24}},[_c('el-form',{ref:"laborTravel",attrs:{"model":_vm.laborTravelForm,"rules":_vm.laborTravelRules,"size":"small","label-width":"300px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('claims.numberOfTrips'),"prop":"numberOfTrips"}},[_c('el-input-number',{attrs:{"debounce":0,"min":1},model:{value:(_vm.laborTravelForm.numberOfTrips),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "numberOfTrips", $$v)},expression:"laborTravelForm.numberOfTrips"}})],1),_vm._v(" "),(_vm.laborTravelForm.numberOfTrips > 1)?_c('el-form-item',{attrs:{"label":_vm.$t('claims.chooseExplanation'),"prop":"tripsExplanationEnum"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.laborTravelForm.tripsExplanationEnum),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "tripsExplanationEnum", $$v)},expression:"laborTravelForm.tripsExplanationEnum"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('claims.customerRequestedWeReturn')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('claims.didNotHaveThePartsOnHandInStock')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('claims.technicalKnowledgeIssue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('claims.hardtRequestedWeReturn')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('claims.ovenInUse')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('claims.otherExplanation')}})],1)],1):_vm._e(),_vm._v(" "),(_vm.laborTravelForm.tripsExplanationEnum == 6 && _vm.laborTravelForm.numberOfTrips > 1)?_c('el-form-item',{attrs:{"label":_vm.$t('claims.enterExplanation'),"prop":"tripsExplanation"}},[_c('el-input',{attrs:{"type":"text","maxLength":200},model:{value:(_vm.laborTravelForm.tripsExplanation),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "tripsExplanation", $$v)},expression:"laborTravelForm.tripsExplanation"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.regularTravelHours'),"prop":"regularTravelHours"}},[_c('el-input',{attrs:{"type":"number","min":0,"max":_vm.maxRegularTravel},on:{"blur":_vm.recalculateRegularTravelHours},model:{value:(_vm.laborTravelForm.regularTravelHours),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "regularTravelHours", $$v)},expression:"laborTravelForm.regularTravelHours"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.overtimeTravelHours'),"prop":"overtimeTravelHours"}},[_c('el-input',{attrs:{"min":0,"max":_vm.maxOvertimeTravel},on:{"blur":_vm.recalculateOvertimeTravelHours},model:{value:(_vm.laborTravelForm.overtimeTravelHours),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "overtimeTravelHours", $$v)},expression:"laborTravelForm.overtimeTravelHours"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.mileageMiles'),"prop":"regularMileage"}},[_c('el-input',{attrs:{"min":0,"max":_vm.maxRegularMileage},on:{"blur":_vm.recalculateRegularMileage},model:{value:(_vm.laborTravelForm.regularMileage),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "regularMileage", $$v)},expression:"laborTravelForm.regularMileage"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.overtimeMileageMiles'),"prop":"overtimeMileage"}},[_c('el-input',{attrs:{"min":0,"max":_vm.maxOvertimeMileage},on:{"blur":_vm.recalculateOvertimeMileage},model:{value:(_vm.laborTravelForm.overtimeMileage),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "overtimeMileage", $$v)},expression:"laborTravelForm.overtimeMileage"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.serviceFuelCharge'),"prop":"serviceFuel"}},[_c('el-input',{attrs:{"min":0,"max":999},model:{value:(_vm.laborTravelForm.serviceFuel),callback:function ($$v) {_vm.$set(_vm.laborTravelForm, "serviceFuel", $$v)},expression:"laborTravelForm.serviceFuel"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('table',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.hours')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.rate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.total')))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.labor')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborHours || 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.laborRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborHours * _vm.rates.laborRate)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.laborSupplementary')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborSupplementaryHours || 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.laborRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborSupplementaryHours * _vm.rates.laborRate)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.laborOvertime')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborOvertimeHours || 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.laborRateOverTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborOvertimeHours * _vm.rates.laborRateOverTime)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.laborOvertimeSupplementary')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborOvertimeSupplementaryHours || 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.laborRateOverTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborOvertimeSupplementaryHours * _vm.rates.laborRateOverTime)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.travel')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborTravelForm.regularTravelHours))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.travelRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborTravelForm.regularTravelHours * _vm.rates.travelRate)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.travelOvertime')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborTravelForm.overtimeTravelHours))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.travelRateOverTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborTravelForm.overtimeTravelHours * _vm.rates.travelRateOverTime)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.mileage')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborTravelForm.regularMileage))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.mileageRate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborTravelForm.regularMileage * _vm.rates.mileageRate)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.mileageOvertime')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborTravelForm.overtimeMileage))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.rates.mileageRateOverTime)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborTravelForm.overtimeMileage * _vm.rates.mileageRateOverTime)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Service & Fuel")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.laborTravelForm.serviceFuel))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.laborTravelForm.serviceFuel)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(_vm._f("money")(_vm.freightTaxTotal))+"\n                            ")])])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.localClaimId)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('common.parts'),"name":"parts"}},[_c('h3',[_vm._v("Rma")]),_vm._v(" "),_c('div',[(_vm.showRmaButton)?_c('el-button',{attrs:{"disabled":this.parts.length == 0,"type":"primary"},on:{"click":_vm.openRmaForm}},[_vm._v(_vm._s(_vm.$t('claims.rmaCreateRMA')))]):_vm._e(),_vm._v(" "),(_vm.isServiceCompany == false && _vm.showRmaButton)?_c('el-button',{attrs:{"disabled":_vm.rmaForm.id != 0,"type":"primary"},on:{"click":_vm.sendRmaFormLink}},[_vm._v(_vm._s(_vm.$t('claims.createRMALink')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.printing,"disabled":_vm.rmaForm.id == 0},on:{"click":function($event){_vm.printRma()}}},[_c('i',{staticClass:"el-icon-printer"})])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("\n                Parts\n                "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.showAddPart}},[_vm._v(_vm._s(_vm.$t('claims.clickHereToAddParts')))])],1),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.parts,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.part.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.part.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.name","label":_vm.$t('common.name'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.extendedPrice","label":_vm.$t('common.extPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.part.extendedPrice * scope.row.quantity))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){_vm.deletePart(scope.row.part.id)}}})]}}])})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("\n                "+_vm._s(_vm.$t('claims.miscParts'))+"\n                "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.showAddMiscPart}},[_vm._v(_vm._s(_vm.$t('claims.clickHereToAddMiscellaneousParts')))])],1),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",staticStyle:{"width":"100%"},attrs:{"data":_vm.miscParts,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"part.name","label":_vm.$t('claims.partName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.extendedPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")((Number(scope.row.part.price) * Number(scope.row.quantity))))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('i',{staticClass:"el-icon-delete",on:{"click":function($event){_vm.deleteMiscPart(scope.row.part.name)}}})]}}])})],1),_vm._v(" "),_c('add-part-dialog',{attrs:{"visible":_vm.partDialogVisible,"serviceCompanyId":_vm.siteInfoForm.serviceCompanyId,"productId":_vm.generalForm.productId,"misc":_vm.isMiscPartDialog,"isNotWarrantyClaim":_vm.isNotWarrantyClaim},on:{"update:visible":function($event){_vm.partDialogVisible=$event},"part-added":_vm.partAdded,"dialogClosed":_vm.partDialogClosed}})],1):_vm._e(),_vm._v(" "),(_vm.localClaimId)?_c('el-tab-pane',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"label":_vm.$t('common.total'),"name":"freightTax"}},[_c('el-row',[_c('table',{staticClass:"freight-total",staticStyle:{"margin-bottom":"20px"}},[_c('tr',[_c('td',[_vm._v("\n                            "+_vm._s(_vm.$t('claims.labourTravel'))+"\n                        ")]),_vm._v(" "),_c('td',[_vm._v("\n                            "+_vm._s(_vm._f("money")(_vm.freightTaxTotal))+"\n                        ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.parts')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.partsTotal)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.handling')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.handling)))])])])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form',{ref:"freightTax",attrs:{"model":_vm.totalForm,"rules":_vm.totalRules,"size":"small","label-width":"200px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.freight'),"prop":"freight"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"controls":false},model:{value:(_vm.totalForm.freight),callback:function ($$v) {_vm.$set(_vm.totalForm, "freight", $$v)},expression:"totalForm.freight"}})],1),_vm._v(" "),(_vm.totalForm.freight >= 50)?_c('el-form-item',{staticClass:"full-width",attrs:{"label":_vm.$t('claims.hardtOriginalInvoice'),"prop":"hardtInvoice"}},[_c('el-input',{staticClass:"full-width",model:{value:(_vm.totalForm.hardtInvoice),callback:function ($$v) {_vm.$set(_vm.totalForm, "hardtInvoice", $$v)},expression:"totalForm.hardtInvoice"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.tax'),"prop":"tax"}},[_c('el-input-number',{staticClass:"full-width",attrs:{"controls":false},model:{value:(_vm.totalForm.tax),callback:function ($$v) {_vm.$set(_vm.totalForm, "tax", $$v)},expression:"totalForm.tax"}})],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v("\n                     \n                ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',[(_vm.activeStep !== 'claimInfo' && _vm.activeStep !== 'comments'&& (_vm.$isUser || _vm.$isFullAdmin))?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.back}},[_vm._v(_vm._s(_vm.$t('common.back')))]):_vm._e(),_vm._v(" "),(_vm.activeStep !== 'comments'&& (_vm.$isUser || _vm.$isFullAdmin))?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.nextButton))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.close')))])],1),_vm._v(" "),(_vm.claimId)?_c('div',[_c('el-scrollbar',{staticStyle:{"margin":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.comments),function(comment){return _c('li',{key:comment.id},[(comment.attachments && comment.attachments.length > 0)?_c('el-row',[_c('el-col',{attrs:{"span":12}},_vm._l((comment.attachments),function(attachment){return _c('div',{key:attachment.id},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.handleAttachmentPreview(attachment)}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v("\n                                        "+_vm._s(attachment.fileName)+"\n                                    ")])])})),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('p',[_vm._v("\n                                    "+_vm._s(comment.message)+"\n                                ")]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm._f("date")(comment.at))+" by "+_vm._s(comment.author))])])],1):_c('div',[_c('p',[_vm._v("\n                                "+_vm._s(comment.message)+"\n                            ")]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm._f("date")(comment.at))+" by "+_vm._s(comment.author))])])],1)}))]),_vm._v(" "),(_vm.$isUser || _vm.$isFullAdmin)?_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"commentForm",attrs:{"model":_vm.commentForm,"rules":_vm.commentRules,"size":"small"}},[_c('el-form-item',{attrs:{"prop":"comment","show-message":false}},[_c('el-input',{attrs:{"type":"textarea","size":"small","rows":4,"placeholder":_vm.$t('claims.newComment')},model:{value:(_vm.commentForm.comment),callback:function ($$v) {_vm.$set(_vm.commentForm, "comment", $$v)},expression:"commentForm.comment"}})],1),_vm._v(" "),(!_vm.$isUser)?_c('el-form-item',{attrs:{"prop":"status","show-message":false}},[_c('el-select',{attrs:{"placeholder":_vm.$t('claims.newClaimStatus')},model:{value:(_vm.commentForm.status),callback:function ($$v) {_vm.$set(_vm.commentForm, "status", $$v)},expression:"commentForm.status"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('claims.attachment'),"prop":"attachments"}},[_c('el-upload',{attrs:{"name":"attachments","drag":"","multiple":"","file-list":_vm.commentForm.attachments,"auto-upload":false,"limit":10,"action":"","on-change":_vm.attachmentsChanged,"on-preview":_vm.handlePreview}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                            "+_vm._s(_vm.$t('serviceTickets.dropFile'))+"\n                            "),_c('em',[_vm._v(_vm._s(_vm.$t('serviceTickets.clicktoUpload')))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.$isUser || _vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.postComment}},[_vm._v(_vm._s(_vm.$t('claims.postComment')))]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showImagePreview,"width":"60%","append-to-body":""},on:{"update:visible":function($event){_vm.showImagePreview=$event}}},[(_vm.fileExtension!=='pdf')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.fileUrlPreview,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.fileExtension==='pdf')?_c('embed',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.fileUrlPreview,"type":"application/pdf"}}):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showImagePreview = false}}},[_vm._v(_vm._s(_vm.$t('common.close')))])],1)],2):(_vm.showRma)?_c('el-dialog',{staticClass:"claim-dialog",attrs:{"title":_vm.$t('claims.rma'),"visible":_vm.showRma,"width":"701px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showRma=$event},"close":_vm.closeRma}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"id":"rmaForm"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaNum')))]),_vm._v(_vm._s(_vm.rmaForm.rmaNumber))]),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('common.rmaDate')))]),_vm._v(" "+_vm._s(_vm.rmaForm.rmaDate))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v("Return To")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.hardtEquipmentManufacturing')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.fifthAvenue')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.montrealQuebec')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.canadaH8T2V3')))]),_vm._v(" "),_c('p',[_c('attn-selector',{attrs:{"attns":_vm.rmaForm.attns},model:{value:(_vm.rmaForm.attn),callback:function ($$v) {_vm.$set(_vm.rmaForm, "attn", $$v)},expression:"rmaForm.attn"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.reasonForReturn')))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":_vm.$t('common.pleseSelectReasonForReturn')},model:{value:(_vm.rmaForm.reason),callback:function ($$v) {_vm.$set(_vm.rmaForm, "reason", $$v)},expression:"rmaForm.reason"}},[_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromRDLabManager'),"value":"Return Request from R&D Lab Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProductManager'),"value":"Return Request from Product Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.returnRequestFromProjectLeader'),"value":"Return Request from Project Leader"}})],1)],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.customerSiteInfo')))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.name"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.name))]),_vm._v(" "),_c('span',{attrs:{"for":"rmaForm.selectedCustomer.phone"}},[_vm._v(_vm._s(_vm.rmaForm.selectedCustomer.phone))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.serviceCoInfo')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.street))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.city)+", "+_vm._s(_vm.rmaForm.serviceCompany.zip))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.phone))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceCompany.contactPersonName))])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.equipmentInformation')))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.modelColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('product-selector',{attrs:{"disabled":""},model:{value:(_vm.generalForm.productId),callback:function ($$v) {_vm.$set(_vm.generalForm, "productId", $$v)},expression:"generalForm.productId"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serialNumColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.generalForm.serialNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceCoverageColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('service-coverage-selector',{attrs:{"disabled":""},model:{value:(_vm.generalForm.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.generalForm, "serviceCoverage", $$v)},expression:"generalForm.serviceCoverage"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","height":"30px","margin-bottom":"15px","justify-content":"space-between"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.reportSymptomColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"80%"}},[_c('span',[_vm._v(_vm._s(_vm.siteInfoForm.complaint))])])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v("\n                "+_vm._s(_vm.$t('common.returnAuthorizationNum'))+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.authNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"25%","font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.authNumDateAndTimeColon')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.raisedOn))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"20%","font-weight":"600"}},[_vm._v("TSR:")]),_vm._v(" "),_c('span',{staticStyle:{"width":"80%"}},[_vm._v(_vm._s(_vm.rmaForm.serviceTicket.tsr))])])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-top":"20px"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtServiceTicketNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "serviceTicketNumber", $$v)},expression:"rmaForm.serviceTicketNumber"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtClaimNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('span',[_vm._v(_vm._s(_vm.rmaForm.claimNumber))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.hardtInvoicePartPurchaseNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "invoiceNumber", $$v)},expression:"rmaForm.invoiceNumber"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h3',[_vm._v(_vm._s(_vm.$t('common.shippingMethodColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.rmaForm.shippingMethod))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-top":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.trackingNum')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.trackingNumber),callback:function ($$v) {_vm.$set(_vm.rmaForm, "trackingNumber", $$v)},expression:"rmaForm.trackingNumber"}})],1)]),_vm._v(" "),(_vm.isTrackInfoLoaded)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin":"10px 0"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.serviceColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.service))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.weightColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.weight))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","min-height":"40px"}},[_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.shippedOnColon')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.trackForm.date))])]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","display":"flex","flex-direction":"column"}},[_c('label',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.$t('common.referenceNumbersColon')))]),_vm._v(" "),_c('span',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.trackForm.referenceNumbers))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"80px","display":"flex","flex-direction":"row","align-self":"flex-end","margin":"10px 0"}},[_c('el-button',{attrs:{"id":"trackBtn","disabled":_vm.loading,"type":"primary"},on:{"click":_vm.getTrackInfo}},[_vm._v(_vm._s(_vm.$t('common.track')))])],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center","margin-bottom":"10px"}},[_c('label',{staticStyle:{"width":"35%"}},[_vm._v(_vm._s(_vm.$t('common.comment')))]),_vm._v(" "),_c('div',{staticStyle:{"width":"65%"}},[_c('el-input',{model:{value:(_vm.rmaForm.comment),callback:function ($$v) {_vm.$set(_vm.rmaForm, "comment", $$v)},expression:"rmaForm.comment"}})],1)])]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.parts,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.part.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.part.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.name","label":_vm.$t('common.name'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.coo')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(scope.row.part.countryOfOrigin)+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.extendedPrice","label":_vm.$t('common.extPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")((Number.isInteger(scope.row.quantity) ? (scope.row.part.extendedPrice * scope.row.quantity) : scope.row.part.extendedPrice)))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}})],1)],1),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%"}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"flex-end","width":"auto"}},[_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.saveRma}},[_vm._v(_vm._s(_vm.$t('common.save')))])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JVhq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JfhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"part-dialog",attrs:{"title":_vm.$t('common.add') + (_vm.misc ? ' Misc ' : ' ') + _vm.$t('common.part'),"visible":_vm.showDialog,"width":"500px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"100px","label-position":"left"}},[(!_vm.misc)?_c('el-form-item',{attrs:{"label":_vm.$t('common.part'),"prop":"part"}},[_c('claim-part-selector',{ref:"part-selector",attrs:{"serviceCompanyId":_vm.currentCompanyId,"productId":_vm.productId,"isNotWarrantyClaim":_vm.isNotWarrantyClaim},on:{"part-selected":_vm.partSelected}})],1):_vm._e(),_vm._v(" "),(_vm.selectedPart)?_c('el-form-item',{attrs:{"label-width":"0"}},[_c('ul',{staticStyle:{"margin":"0","padding":"0","list-style":"none","line-height":"20px"}},[_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('common.part')))]),_vm._v(" "+_vm._s(_vm.selectedPart.name))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('claims.listPrice')))]),_vm._v(" "+_vm._s(_vm._f("money")(_vm.selectedPart.price)))]),_vm._v(" "),_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('claims.extendedPrice')))]),_vm._v(" "+_vm._s(_vm._f("money")(_vm.selectedPart.extendedPrice)))]),_vm._v(" "),(_vm.selectedPart.needsReturn)?_c('li',[_c('b',[_vm._v(_vm._s(_vm.$t('claims.returnNeeded')))]),_vm._v(" "),_c('i',{staticClass:"el-icon-check"})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.misc)?_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1):_vm._e(),_vm._v(" "),(_vm.misc)?_c('el-form-item',{attrs:{"label":_vm.$t('claims.price'),"prop":"price"}},[_c('el-input-number',{attrs:{"min":0.01,"max":10000},model:{value:(_vm.form.price),callback:function ($$v) {_vm.$set(_vm.form, "price", $$v)},expression:"form.price"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.quantity'),"prop":"quantity"}},[_c('el-input-number',{attrs:{"min":1,"max":1000},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}})],1),_vm._v(" "),(_vm.misc && _vm.form.price && _vm.form.quantity)?_c('el-form-item',{attrs:{"label":_vm.$t('common.extendedPrice')}},[_c('span',[_vm._v(_vm._s(Number(_vm.form.price) * Number(_vm.form.quantity)))])]):_vm._e()],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addPart}},[_vm._v(_vm._s(_vm.$t('common.add')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jhwe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCategorySelector_vue__ = __webpack_require__("g71Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b2a722_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCategorySelector_vue__ = __webpack_require__("0dYb");
function injectStyle (ssrContext) {
  __webpack_require__("nb5a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-96b2a722"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCategorySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96b2a722_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCategorySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jq0s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('product-selector',{attrs:{"placeholder":_vm.$t('common.product')},model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('resolution-category-selector',{attrs:{"productId":_vm.filter.productId},model:{value:(_vm.filter.categoryId),callback:function ($$v) {_vm.$set(_vm.filter, "categoryId", $$v)},expression:"filter.categoryId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":"$t('common.description')"},model:{value:(_vm.filter.description),callback:function ($$v) {_vm.$set(_vm.filter, "description", $$v)},expression:"filter.description"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tablewithshading",attrs:{"size":"mini","data":_vm.codes}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('common.code'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"model","label":_vm.$t('common.model')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"category","label":_vm.$t('common.category')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"labor","label":_vm.$t('common.labor'),"width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"maxTime","label":_vm.$t('common.maxTime'),"width":"80"}})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JvoI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__("fEXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_components_Navigation__ = __webpack_require__("pIAk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__claims_components__ = __webpack_require__("w9Cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__orders_components__ = __webpack_require__("iqu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__equipment_components__ = __webpack_require__("7fbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__servicetickets_components__ = __webpack_require__("LY9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__masters_customers_components__ = __webpack_require__("AKRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__costcoservicerequests_components__ = __webpack_require__("Et0o");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    name: "app",
    components: {
        Navigation: __WEBPACK_IMPORTED_MODULE_1__shared_components_Navigation__["a" /* default */],
        CreateUpdateClaimDialog: __WEBPACK_IMPORTED_MODULE_2__claims_components__["b" /* CreateUpdateClaimDialog */],
        CreateUpdatePartOrderDialog: __WEBPACK_IMPORTED_MODULE_3__orders_components__["a" /* CreateUpdatePartOrderDialog */],
        EquipmentRegistrationDialog: __WEBPACK_IMPORTED_MODULE_4__equipment_components__["b" /* EquipmentRegistrationDialog */],
        CreateServiceTicketDialog: __WEBPACK_IMPORTED_MODULE_5__servicetickets_components__["a" /* CreateServiceTicketDialog */],
        CreateUpdateCustomerDialog: __WEBPACK_IMPORTED_MODULE_6__masters_customers_components__["c" /* CreateUpdateCustomerDialog */],
        CreateCountryDialog: __WEBPACK_IMPORTED_MODULE_6__masters_customers_components__["b" /* CreateCountryDialog */],
        CostcoServiceRequestsDetailsDialog: __WEBPACK_IMPORTED_MODULE_7__costcoservicerequests_components__["CostcoServiceRequestsDetailsDialog"]
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on("createCustomer", function (id) {
            _this.customerCreateDialogVisible = true;
        });
        __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on("editEquipment", function (equipmentId) {
            _this.equipmentId = equipmentId;
            _this.registerEquipmentDialogVisible = true;
        });
        __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$on("createCountry", function (id) {
            _this.countryCreateDialogVisible = true;
        });
    },
    data: function data() {
        return {
            claimDialogVisible: false,
            orderDialogVisible: false,
            registerEquipmentDialogVisible: false,
            createServiceTicketDialogVisible: false,
            customerCreateDialogVisible: false,
            equipmentId: undefined,
            countryCreateDialogVisible: false,
            env: location.hostname == 'localhost' ? "dev" : location.hostname.split("-").length > 1 ? "test" : "prod"
        };
    },

    methods: {
        showPlaceOrderDialog: function showPlaceOrderDialog() {
            this.orderDialogVisible = true;
        },
        showNewClaimDialog: function showNewClaimDialog() {
            this.claimDialogVisible = true;
        },
        showRegisterEquipmentDialog: function showRegisterEquipmentDialog() {
            this.registerEquipmentDialogVisible = true;
        },
        showCreateServiceTicketDialog: function showCreateServiceTicketDialog() {
            this.createServiceTicketDialogVisible = true;
        },
        equipmentDialogClose: function equipmentDialogClose() {
            this.registerEquipmentDialogVisible = false;
            this.equipmentId = undefined;
        }
    }
});

/***/ }),

/***/ "JxAT":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "K/j1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K6Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsedPartsList_vue__ = __webpack_require__("rbm1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97494322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsedPartsList_vue__ = __webpack_require__("wXjU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsedPartsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97494322_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsedPartsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K7v5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DuplicateTicketWarning_vue__ = __webpack_require__("w+3a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5780a8c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DuplicateTicketWarning_vue__ = __webpack_require__("0wAw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DuplicateTicketWarning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5780a8c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DuplicateTicketWarning_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KF1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPartDialog_vue__ = __webpack_require__("vaJH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b5f2fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPartDialog_vue__ = __webpack_require__("JfhW");
function injectStyle (ssrContext) {
  __webpack_require__("p2L6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65b5f2fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPartDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b5f2fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPartDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KL0F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getOrders: function getOrders(page, filter, sorting) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/partorders', {
            params: {
                page: page,
                status: filter.status,
                partOrderNumber: filter.partOrderNumber,
                serviceCompanyName: filter.serviceCompanyName,
                purchaseOrderNumber: filter.purchaseOrderNumber,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder
            }
        });
    },
    getOrder: function getOrder(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/partorders/' + id);
    },
    saveOrder: function saveOrder(id, order) {
        var request = Object.assign({}, order);
        request.parts = request.parts.map(function (c) {
            return { id: c.id, quantity: c.quantity };
        });
        if (request.selectedCountryState) {
            request.countryId = request.selectedCountryState[0];
            request.stateId = request.selectedCountryState[1];
            delete request.selectedCountryState;
        }

        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/partorders/' + id, request);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/partorders', request);
    },
    deleteOrder: function deleteOrder(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/partorders/' + id);
    },
    getCategories: function getCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/partorders');
    },
    printAndProcessOrder: function printAndProcessOrder(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/partorders/' + id + '/print');
    },
    getOrderId: function getOrderId() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/partorders/nextId');
    },
    exportOrderParts: function exportOrderParts(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/partorders/' + id + '/export');
    }
});

/***/ }),

/***/ "KR1a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'attn-selector',
    props: ['value', 'disabled', 'attns'],
    data: function data() {
        return {
            loading: false
        };
    }
});

/***/ }),

/***/ "KRB6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CategorySelector__ = __webpack_require__("/x2I");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CategorySelector__["a"]; });


/***/ }),

/***/ "KTZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Service Invoice Frequently Asked Questions")]),_vm._v(" "),[_c('div',[_c('el-row',[_c('el-collapse',{attrs:{"accordion":"","id":"faqAccordion"}},[_c('el-collapse-item',{attrs:{"name":"1","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("1. General SIMS inquiries: Parts are not loading, can't log in to SIMS, locked out of SIMS, etc.")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Please call 888-848-4408 ext 202 or 298 for assistance.\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"2","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("2. Can't find the client's store location in a claim.")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("⮚ Open your claim. Click the \"details\" button at the top, then click on the \"Site Information\" heading. ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("⮚ In the \"Client Store\" field, enter the store number. ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("⮚ A list related to that number will appear. Choose the appropriate client. ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("3. Who should we call for assistance with claims?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Please call 888-848-4408 ext 202 or 298 or send an email to invoicing@hardt.ca\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("4. How to find repair codes.")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Open your claim. Click the \"Details\" button at the top, then click on the \"Site Information\" heading.\n                                ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Select the \"Click Here to Add Repair Codes\" box.\n                                ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ In the repair code box, type a keyword from the work performed, then select the appropriate repair code from the list.\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"5","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("5. What is the deadline for submitting claims to Hardt?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ All claims must be submitted within 30 days of the date completed.\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"6","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("6. Where to submit an estimate for an equipment repair that exceeds the Do Not Exceed amount?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ All estimates must be submitted to costcoestimate@hardt.ca\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"7","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("\n                                7. Why is my claim in \"partial\" status?\n                            ")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Partial status means that the claim has been started and not completed. Note: this is only visible to service partners.\n                                ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Click on \"Dashboard\", click on the pencil beside the partial claim to complete the claim.\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"8","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("8. How can I reach technical support?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Please call 800-387-6847 ext 2\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"9","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("9. How to submit claims for installations")])]),_vm._v(" "),_c('el-collapse',[_c('el-collapse-item',[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("USA")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                            ⮚ Costco installs and post installs need to be submitted on separate claims.\n                                        ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n                                            o\tCostco installs must be submitted with service coverage Costco non-warranty (for all the units at 1 warehouse).\n                                        ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n                                            o\tCostco post-installs must be submitted with service coverage Installation/Post installs (for all the units at 1 location).\n                                        ")])])],1)],2)],1),_vm._v(" "),_c('el-collapse',[_c('el-collapse-item',[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("CAN")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                            ⮚ Costco installs must be billed directly to the store. Do not submit a claim.\n                                        ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                            ⮚ Costco post-installs must be submitted with service coverage Installation/Post-Install.\n                                        ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("Sam's Club")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                            ⮚ Submit 1 claim for the Installation and Post-Install for all units at the same location. The service coverage is Installation/Post-Install.\n                                        ")])])],1)],2)],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"10","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("10. Can we submit repairs for multiple ovens at the same location on 1 claim?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ No. A separate claim must be submitted for each oven repaired, unless it is for an install.\n                                ")])])],1)],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"11","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('span',{staticClass:"title",staticStyle:{"text-align":"left"}},[_vm._v("11. How can we request a SIMS Service Partner manual?")])]),_vm._v(" "),_c('el-row',[_c('el-col',[_c('span',[_vm._v("\n                                    ⮚ Please email invoicing@hardt.ca\n                                ")])])],1)],2)],1)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KUXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.$t('masters.createCountry'),"visible":_vm.showDialog,"width":"40%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"ISO Code","prop":"ISOCode"}},[_c('el-input',{model:{value:(_vm.form.ISOCode),callback:function ($$v) {_vm.$set(_vm.form, "ISOCode", $$v)},expression:"form.ISOCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('span',[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kc0/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("YZek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_components_RmaStatusSelector_vue__ = __webpack_require__("EDq/");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "preview-rma-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rmaId: {
            required: true
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */],
        AttnSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["b" /* AttnSelector */],
        ServiceCoverageSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["o" /* ServiceCoverageSelector */],
        RmaStatusSelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components_RmaStatusSelector_vue__["a" /* default */]
    },
    data: function data() {
        return {
            rmaForm: {},
            trackForm: {},
            loading: false,
            printing: false,
            showDialog: this.visible,
            isUserServiceCompany: false,
            isTrackInfoLoaded: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadRma: function loadRma() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getRma(this.rmaId).then(function (response) {
                _this.isUserServiceCompany = _this.$currentUser.profile.role != "admin";
                _this.rmaForm = response.data;
                _this.loading = false;
            });
        },
        printRma: function printRma() {
            var _this2 = this;

            this.printing = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].printRma(this.rmaId).then(function (response) {
                _this2.printing = false;
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);

                dstDoc.close();
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    }, 500);
                }
            }, function () {
                return _this2.printing = false;
            });
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            for (var property in this.rmaForm) {
                if (this.rmaForm.hasOwnProperty(property)) {
                    switch (_typeof(this.rmaForm[property])) {
                        case "string":
                            this.rmaForm[property] = null;
                            break;
                        case "number":
                            this.rmaForm[property] = null;
                            break;
                        case "object":
                            this.rmaForm[property] = null;
                            break;
                        case "undefined":
                            break;
                    }
                }
            }

            this.$emit("dialogClosed");
        },
        openTrackingWindow: function openTrackingWindow() {
            var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
            window.open(url);
        },
        getTrackInfo: function getTrackInfo() {
            var _this3 = this;

            if (!this.rmaForm.trackingNumber) {
                return;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getTrackingInfo(this.rmaForm.trackingNumber).then(function (response) {
                _this3.trackForm = response.data;
                _this3.isTrackInfoLoaded = true;
                _this3.loading = false;
            }).catch(function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),

/***/ "Kcxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.multiple)?_c('el-select',{staticClass:"select",attrs:{"disabled":_vm.preselect === true,"clearable":"","filterable":"","remote":"","remote-method":_vm.searchRepairCodes,"placeholder":_vm.$t('common.pleaseSelectRepairCode'),"loading":_vm.loading},on:{"change":_vm.singleRepairCodeSelected},model:{value:(_vm.selectedRepairCode),callback:function ($$v) {_vm.selectedRepairCode=$$v},expression:"selectedRepairCode"}},_vm._l((_vm.repairCodes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})})):_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","remote":"","remote-method":_vm.searchRepairCodes,"placeholder":_vm.$t('common.pleaseSelectRepairCode'),"loading":_vm.loading},on:{"change":_vm.multiRepairCodeSelected},model:{value:(_vm.selectedRepairCode),callback:function ($$v) {_vm.selectedRepairCode=$$v},expression:"selectedRepairCode"}},_vm._l((_vm.repairCodes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KlKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerSelector_vue__ = __webpack_require__("ReaT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3141626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerSelector_vue__ = __webpack_require__("jPsR");
function injectStyle (ssrContext) {
  __webpack_require__("Q2Ri")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3141626"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3141626_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kmfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("0KeK");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "Ks6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"inline":true,"size":"mini"}},[_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedBy'),"prop":"deliverySignedBy"}},[_c('el-input',{model:{value:(_vm.form.deliverySignedBy),callback:function ($$v) {_vm.$set(_vm.form, "deliverySignedBy", $$v)},expression:"form.deliverySignedBy"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('orders.signedOn'),"prop":"deliveryDate"}},[_c('el-date-picker',{attrs:{"type":"datetime","placeholder":_vm.$t('orders.selectDateAndTime')},model:{value:(_vm.form.deliveryDate),callback:function ($$v) {_vm.$set(_vm.form, "deliveryDate", $$v)},expression:"form.deliveryDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('common.save')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ky6T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KzQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ActivityGraphWrapper"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$t('reports.claimsPerModel')))])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":4}},[_c('el-select',{attrs:{"value":"","reserve-keyword":"","placeholder":_vm.$t('reports.choosePeriod'),"title":_vm.$t('reports.choosePeriod')},on:{"change":function($event){_vm.choosePeriod($event)}},model:{value:(_vm.periodType),callback:function ($$v) {_vm.periodType=$$v},expression:"periodType"}},_vm._l((_vm.periodTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1),_vm._v(" "),_c('el-col',{attrs:{"span":20}},[_c('el-select',{attrs:{"value":"","reserve-keyword":"","placeholder":_vm.$t('reports.chooseModel'),"title":"$t('reports.chooseModel')"},on:{"change":function($event){_vm.chooseProduct($event)}},model:{value:(_vm.productId),callback:function ($$v) {_vm.productId=$$v},expression:"productId"}},_vm._l((_vm.products),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1)],1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('line-chart',{attrs:{"chartData":_vm.chartData,"options":_vm.options}})],1)])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L7kv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getCategories: function getCategories(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodes/lookup/' + id);
  }
});

/***/ }),

/***/ "LY9n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceTicketList__ = __webpack_require__("sV98");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceTicketList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateServiceTicketDialog__ = __webpack_require__("rb25");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CreateServiceTicketDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* unused harmony reexport ServiceTicketDetailsDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SendEmailDialog__ = __webpack_require__("hoZv");
/* unused harmony reexport SendEmailDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DuplicateTicketWarning__ = __webpack_require__("K7v5");
/* unused harmony reexport DuplicateTicketWarning */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ServiceTicketListFromEmail__ = __webpack_require__("gqlD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__ServiceTicketListFromEmail__["a"]; });







/***/ }),

/***/ "Lj1T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateClaimDialog_vue__ = __webpack_require__("xutu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b80d56d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateClaimDialog_vue__ = __webpack_require__("JMN2");
function injectStyle (ssrContext) {
  __webpack_require__("w1zW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b80d56d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateClaimDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b80d56d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateClaimDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lo50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emailDetailsDialog_vue__ = __webpack_require__("sH+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01883cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emailDetailsDialog_vue__ = __webpack_require__("GQ0N");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emailDetailsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01883cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emailDetailsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LoMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewClaimDialog_vue__ = __webpack_require__("C/aA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa2c60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewClaimDialog_vue__ = __webpack_require__("V1kj");
function injectStyle (ssrContext) {
  __webpack_require__("y85y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eaa2c60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewClaimDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eaa2c60_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewClaimDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M0Cj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintCodeList_vue__ = __webpack_require__("Y2Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283ef217_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintCodeList_vue__ = __webpack_require__("/a9S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintCodeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_283ef217_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintCodeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDFF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MFWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackingInfo_vue__ = __webpack_require__("Mb/K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6887fcf5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackingInfo_vue__ = __webpack_require__("GZvB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackingInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6887fcf5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackingInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MHJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-radio-group',{model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}},[_c('el-radio-button',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('accounting.toBePaid')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":6}},[_vm._v(_vm._s(_vm.$t('accounting.paidAndPrinted')))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.$t('common.dateFrom')},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.$t('common.dateTo')},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('accounting.claimInvoiceCustomer')},model:{value:(_vm.filter.q),callback:function ($$v) {_vm.$set(_vm.filter, "q", $$v)},expression:"filter.q"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[(_vm.IsShownPayAndPrint)?_c('el-col',{attrs:{"span":3}},[_c('el-button',{attrs:{"title":_vm.$t('accounting.payAndPrintSelectedClaims')},on:{"click":_vm.payAndPrintConfirm}},[_vm._v(_vm._s(_vm.$t('accounting.payAndPrintSelectedClaims')))])],1):_vm._e()],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"claims-table tablewithshading",attrs:{"size":"mini","data":_vm.claims},on:{"selection-change":_vm.handleSelectionChange}},[(_vm.filter.type == 2)?_c('el-table-column',{attrs:{"type":"selection","width":"55"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"claimNumber","label":_vm.$t('common.claimNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('common.invoiceNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.total')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.total))+"\n            ")]}}])}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status')}}):_c('el-table-column',{attrs:{"prop":"statusFr","label":_vm.$t('common.status')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"raisedBy","label":_vm.$t('common.raisedBy')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.raisedOn')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("date")(scope.row.raisedOn))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),(_vm.filter.type == 2)?_c('el-button',{attrs:{"size":"mini","title":_vm.$t('accounting.payClaim')},on:{"click":function($event){_vm.payClaimConfirm(scope.row.id)}}},[_vm._v("\n                    "+_vm._s(_vm.$t('common.pay'))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.filter.type == 6)?_c('el-button',{attrs:{"size":"mini","title":_vm.$t('accounting.printClaim')},on:{"click":function($event){_vm.printClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-printer"})]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin || (_vm.$isUser && scope.row.status == 'Partial'))?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('preview-claim-dialog',{attrs:{"claimId":_vm.claimToView,"noDetails":true,"visible":_vm.previewClaimVisible},on:{"dialogClosed":_vm.previewClaimFinished}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('accounting.areYouSureThatYouWantoProcessClaim'),"visible":_vm.processClaimConfirmationVisible,"width":"40%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.processClaimConfirmationVisible=$event}}},[_c('span',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_vm._v(_vm._s(_vm.$t('accounting.thisActionWillChangeStatusOfThisClaim')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.processClaimConfirmationVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.processClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.yes')))])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('accounting.areYouSureThatYouWantToPayClaim'),"visible":_vm.payClaimConfirmationVisible,"width":"40%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.payClaimConfirmationVisible=$event}}},[_c('span',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_vm._v(_vm._s(_vm.$t('accounting.thisActionWillChangeStatusOfThisClaim')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.payClaimConfirmationVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.payClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.yes')))])],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('accounting.areYouSureThatYouWantToPayAndPrintAllSelectedClaims'),"visible":_vm.payAndPrintConfirmationVisible,"width":"50%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.payAndPrintConfirmationVisible=$event}}},[_c('span',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_vm._v(_vm._s(_vm.$t('accounting.thisActionWillChangeStatusOfThisClaim')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.payAndPrintConfirmationVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.payAndPrint(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.yes')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MNom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gJWU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "escalation-ticket-details-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            required: true
        }
    },
    data: function data() {
        return {
            details: {},
            loading: false,
            showDialog: this.visible,
            showSubscriptionDialog: false,
            showImagePreview: false,
            showRsMessage: false,
            statuses: [],
            subscriberForm: []
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadTicket: function loadTicket() {
            var _this = this;

            if (this.ticketId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getTicketDetail(this.ticketId).then(function (response) {
                    _this.loading = false;
                    if (response.data.success) {
                        _this.details = Object.assign({}, response.data.ticket);
                        console.log(_this.details);
                        if (_this.details.isRs) {
                            _this.showRsMessage = true;
                        }
                        _this.serviceCompanyId = response.data.ticket.serviceCompanyId;
                        _this.subscriberForm = response.data.subscriberList;
                    } else {
                        _this.$notify({
                            title: "Error",
                            message: response.data.message,
                            type: "error"
                        });
                        _this.$emit("dialogClosed");
                    }
                });
            }
        },
        showCommentFullTime: function showCommentFullTime(comment) {
            console.log(comment);
            var commentTime = new Date(comment.at);
            return commentTime.toLocaleString();
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.$emit("dialogClosed");
        },
        ShowRecommendedParts: function ShowRecommendedParts(complaint) {
            if (complaint.partSelected.length > 0) {
                var recommendedParts = "";
                complaint.partSelected.forEach(function (element) {
                    if (element.isRecommendedPart && element.part != null) {
                        recommendedParts += '' + element.part.no + '\n';
                    }
                });
                return recommendedParts;
            } else {
                return "";
            }
        },
        ShowDescriptionForRecommendedParts: function ShowDescriptionForRecommendedParts(complaint) {
            if (complaint.partSelected.length > 0) {
                var recommendedPartsDescription = "";
                complaint.partSelected.forEach(function (element) {
                    if (element.isRecommendedPart && element.part != null) {
                        recommendedPartsDescription += '' + element.part.description + '\n';
                    }
                });
                return recommendedPartsDescription;
            } else {
                return "";
            }
        },
        ShowMandatoryParts: function ShowMandatoryParts(complaint) {
            if (complaint.partSelected.length > 0) {
                var mandatoryParts = "";
                complaint.partSelected.forEach(function (element) {
                    if (element.isRequiredPart && element.part != null) {
                        mandatoryParts += '' + element.part.no + '\n';
                    }
                });
                return mandatoryParts;
            } else {
                return "";
            }
        },
        ShowDescriptionForMandatoryParts: function ShowDescriptionForMandatoryParts(complaint) {
            if (complaint.partSelected.length > 0) {
                var mandatoryPartsDescription = "";
                complaint.partSelected.forEach(function (element) {
                    if (element.isRequiredPart && element.part != null) {
                        mandatoryPartsDescription += '' + element.part.description + '\n';
                    }
                });
                return mandatoryPartsDescription;
            } else {
                return "";
            }
        }
    }
});

/***/ }),

/***/ "MPtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromptDialog_vue__ = __webpack_require__("GyRt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04deda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromptDialog_vue__ = __webpack_require__("q1KM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromptDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a04deda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromptDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MVm2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("uHJs");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/reports/costco',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["c" /* Costco */],
    name: 'costcoreport',
    meta: { admin: true }
}, {
    path: '/reports/claims',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["b" /* ClaimHistory */],
    name: 'claimreport',
    meta: { admin: true }
}, {
    path: '/reports/parts',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["e" /* PriceList */],
    name: 'partsreport'
}, {
    path: '/reports/resolutioncodes',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["g" /* ResolutionCodeList */],
    name: 'resolutioncodesreport'
}, {
    path: '/reports/usedparts',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["i" /* UsedPartsList */],
    name: 'usedpartsreport'
}, {
    path: '/reports/graphs',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["d" /* Graphs */],
    name: 'graphs',
    meta: { admin: true }

}, {
    path: '/reports/serviceTickets',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["h" /* ServiceTickets */],
    name: 'servicetickets',
    meta: { admin: true }
}, {
    path: '/reports/rma',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["f" /* RMA */],
    name: 'reports_rma',
    meta: { admin: true }
}, {
    path: '/reports/simsApReport',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ApReport */],
    name: 'simsapreport',
    meta: { admin: true }
}]);

/***/ }),

/***/ "Mb/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tracking-info",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        trackingNumber: "",
        serviceOrderNumber: ""
      },
      rules: {
        trackingNumber: [{
          required: true,
          message: this.$t('common.pleaseEnterTrackingNumber'),
          trigger: "blur"
        }],
        serviceOrderNumber: [{
          required: true,
          message: this.$t('common.pleaseEnterServiceOrderNumber'),
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.$emit("update", _this.form);
        }
      });
    }
  }
});

/***/ }),

/***/ "Mc52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateServiceTicketFromDraftDialog_vue__ = __webpack_require__("tRBQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b58551_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateServiceTicketFromDraftDialog_vue__ = __webpack_require__("3hN2");
function injectStyle (ssrContext) {
  __webpack_require__("NOOQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b58551"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateServiceTicketFromDraftDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b58551_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateServiceTicketFromDraftDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MnOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("ZcFj");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });

//export { default as store } from './store';

/***/ }),

/***/ "N+sg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("KL0F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-update-part-order",
    components: {
        AddressSelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components__["a" /* AddressSelector */],
        ShippingMethodSelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components__["q" /* ShippingMethodSelector */],
        PartSelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components__["j" /* PartSelector */]
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        orderId: {
            required: false,
            default: null
        }
    },
    data: function data() {
        var _this = this;

        return {
            form: {
                purchaseOrderNumber: "",
                shippingAddressAsBillTo: true,
                shippingMethod: undefined,
                selectedCountryState: undefined,
                selectedCountryStateName: "",
                shipToName: "",
                shipToPhone: "",
                parts: [],
                placedAt: Number(new Date().getMonth() + 1) + "/" + new Date().getDate() + "/" + new Date().getFullYear(),
                trackingNumber: "",
                serviceOrderNumber: "",
                shippingCharges: "",
                deliverySignedBy: "",
                deliveryDate: new Date()
            },
            rules: {
                purchaseOrderNumber: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPurchaseOrderNumber'),
                    trigger: "blur"
                }],
                shippingMethod: [{
                    required: true,
                    message: this.$t('shared.pleaseSelectShippingMethod'),
                    trigger: "change"
                }],
                otherCompany: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingMethod === "5" && !value) {
                            // other company
                            return callback(new Error(_this.$t('common.pleaseEnterShippingCompanyName')));
                        } else {
                            return callback();
                        }
                    },
                    trigger: "blur"
                }],
                selectedCountryState: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value && Array.isArray(value) && value[0] && value[1]) return callback();else if (value && Array.isArray(value) && !value[1]) return callback(new Error(_this.$t('common.pleaseChooseState')));else return callback(new Error(_this.$t('common.pleaseChooseCountryAndState')));
                    },
                    trigger: "blur"
                }],
                address: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterAddress')));
                    },
                    trigger: "blur"
                }],
                city: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterCity')));
                    },
                    trigger: "blur"
                }],
                regional: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterRegional')));
                    },
                    trigger: "blur"
                }],
                region: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterRegion')));
                    },
                    trigger: "blur"
                }],
                zip: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterZip')));
                    },
                    trigger: "blur"
                }],
                shipToPhone: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$t('common.pleaseEnterPhone')));
                    },
                    trigger: "blur"
                }],
                shipToName: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingAddressAsBillTo || _this.form.shippingMethod === "5" || _this.orderId != null) return callback();
                        if (value) return callback();else return callback(new Error(_this.$confirm(_this.$t('common.pleaseEnterCompanyName'))));
                    },
                    trigger: "blur"
                }]
            },
            serviceCompany: Object.assign({}, window.currentCompany),
            options: [],
            value: "",
            loading: false,
            showDialog: this.visible,
            previewSummaryVisible: false,
            orderStatus: null,
            mutatedOrderId: null,
            disableForm: false
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.loading = false;
            this.form.address = null;
            this.form.selectedCountryState = null;
            this.form.city = null;
            this.form.regional = null;
            this.form.region = null;
            this.form.zip = null;
            this.form.parts = [];
            this.form.purchaseOrderNumber = null;
            this.form.shippingMethod = null;
            this.form.selectedCountryState = null;
            this.form.shipToName = null;
            this.form.shipToPhone = null;
            this.form.placedAt = null;
            this.form.notes = null;
            this.form.shippingAddressAsBillTo = true;
            if (this.previewSummaryVisible == true) {
                this.previewSummaryVisible = false;
            }
            this.$emit("dialogClosed");
        },
        showSummary: function showSummary() {
            var _this2 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    if (_this2.orderId != null) {
                        _this2.save();
                    } else {
                        _this2.previewSummaryVisible = true;
                    }
                } else {
                    return false;
                }
            });
        },
        save: function save() {
            var _this3 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveOrder(this.orderId, this.form).then(function (response) {
                _this3.closeDialog();
                if (!_this3.orderId) {
                    __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$emit("order-placed");
                }
                if (_this3.form.status == 2) {
                    _this3.$message({
                        type: 'success',
                        message: response.data
                    });
                }
            }, function (err) {
                _this3.loading = false;
                var message = "";
                try {
                    message = Object.values(err.response.data).join(" ");
                } catch (e) {
                    message = _this3.$t('common.cantCreateUpdateOrder');
                }
                _this3.$message.error(message);
            });
        },
        loadOrder: function loadOrder() {
            var _this4 = this;

            if (this.orderId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getOrder(this.orderId).then(function (response) {
                    _this4.orderStatus = response.data.status;
                    _this4.serviceCompany = Object.assign({}, response.data.serviceCompany);
                    delete response.data.serviceCompany;
                    _this4.form = Object.assign({}, response.data);
                    _this4.form.shippingMethod = _this4.form.shippingMethod.toString();
                    _this4.form.placedAt = new Date(_this4.form.placedAt).toLocaleDateString();
                    _this4.form.selectedCountryState = [_this4.form.countryId, _this4.form.state];
                    _this4.loading = false;
                });
            } else {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getOrderId().then(function (response) {
                    debugger;
                    _this4.mutatedOrderId = response.data.data;
                    if (_this4.$isSubAgentUser) _this4.serviceCompany = response.data.serviceCompany;
                    _this4.serviceCompany.code = response.data.serviceCompany.code;
                    _this4.form.placedAt = Number(new Date().getMonth() + 1) + "/" + new Date().getDate() + "/" + new Date().getFullYear();
                    _this4.loading = false;
                });
            }
            this.disableForm = this.orderId != null && this.$isUser;
        },
        partsTotals: function partsTotals(param) {
            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = "Total";
                    return;
                }
                if (index === 4 || index === 1) {
                    sums[index] = "N/A";
                    return;
                }
                var values = data.map(function (item) {
                    return Number(item[column.property]) * Number(item["quantity"]);
                });
                if (!values.every(function (value) {
                    return isNaN(value);
                })) {
                    sums[index] = "$" + values.reduce(function (prev, curr) {
                        var value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0).toFixed(2);
                }
            });
            return sums;
        },
        quantityChanged: function quantityChanged(val, id) {
            var _this5 = this;

            if (val === 0) {
                setTimeout(function () {
                    _this5.form.parts = _this5.form.parts.filter(function (p) {
                        return p.id !== id;
                    });
                });
            }
        },
        partSelected: function partSelected(addedPart) {
            var part = this.form.parts.find(function (p) {
                return p.id === addedPart.id;
            });
            if (part === undefined) {
                addedPart.quantity = 1;
                this.form.parts.push(addedPart);
            }
        },
        closePreviewDialog: function closePreviewDialog() {
            this.previewSummaryVisible = false;
        },
        printAndProcessOrder: function printAndProcessOrder() {
            var _this6 = this;

            var self = this;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].printAndProcessOrder(this.orderId).then(function (response) {
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                    self.$message({
                        showClose: true,
                        message: _this6.$t('common.partOrderProcessedSuccesfully'),
                        type: "success"
                    });
                    _this6.closeDialog();
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                        self.$message({
                            showClose: true,
                            message: this.$t('common.partOrderProcessedSuccesfully'),
                            type: "success"
                        });
                    }, 500);
                    _this6.closeDialog();
                }
            });
        },
        openTrackingWindow: function openTrackingWindow() {
            var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
            if (this.form.trackingNumber) {
                url = url + "&trackNums=" + this.form.trackingNumber;
            }
            window.open(url);
        },
        exportParts: function exportParts() {
            var _this7 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].exportOrderParts(this.orderId).then(function () {
                _this7.loading = false;
            }).catch(function () {
                _this7.loading = false;
            });
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    computed: {
        title: function title() {
            return this.$isFullAdmin ? "Update Part Order #" + this.orderId : this.orderId == null && this.mutatedOrderId != null ? "Place New Part Order #" + this.mutatedOrderId : "View Part Order #" + this.orderId;
        }
    }
});

/***/ }),

/***/ "N/Ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getCountries: function getCountries() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/countries/lookup');
    }
});

/***/ }),

/***/ "N/vI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateResolutionCodeDialog__ = __webpack_require__("oOrt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("BHZN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "resolution-code-list",
  components: {
    CreateUpdateResolutionCodeDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateResolutionCodeDialog__["a" /* default */],
    ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */],
    ResolutionCategorySelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["m" /* ResolutionCategorySelector */]
  },
  data: function data() {
    return {
      codes: [],
      loading: true,
      dialogVisible: false,
      codeToEdit: null,
      filter: {
        productId: undefined,
        categoryId: undefined,
        text: undefined
      },
      currentPage: 1,
      total: 0
    };
  },
  created: function created() {
    this.loadCodes();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        if (!this.filter.productId) {
          this.filter.categoryId = null;
        }
        this.loadCodes();
      }
    }
  },
  methods: {
    download: function download() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].download(this.filter);
    },
    loadCodes: function loadCodes() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCodes(this.currentPage, this.filter.productId, this.filter.categoryId, this.filter.text).then(function (response) {
        _this.loading = false;
        _this.codes = response.data.items;
        _this.total = response.data.total;
      });
    },
    appendCode: function appendCode(event) {
      if (event.new) {
        this.codes.push(event.data);
        this.total += 1;
      } else {
        this.loadCodes();
      }
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadCodes();
    },
    editCode: function editCode(id) {
      this.codeToEdit = id;
      this.dialogVisible = true;
    },
    editFinished: function editFinished() {
      this.codeToEdit = null;
      this.dialogVisible = false;
    },
    deleteCode: function deleteCode(id) {
      var _this2 = this;

      this.$confirm(this.$t('common.thisWillDeleteCodeContinue'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteCode(id).then(function () {
          _this2.loadCodes();
          _this2.$message({
            type: "success",
            message: _this2.$t('common.deleteCompleted')
          });
        });
      }).catch(function (_) {});
    }
  }
});

/***/ }),

/***/ "NAUj":
/***/ (function(module, exports) {

module.exports = {"returnTo":"Return To","authorNum":"Author. #","rmaDate":"RMA Date","reopen":"Reopen"}

/***/ }),

/***/ "NMra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateRma_vue__ = __webpack_require__("F/Gy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e559061_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateRma_vue__ = __webpack_require__("DJwV");
function injectStyle (ssrContext) {
  __webpack_require__("QhcI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e559061"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateRma_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e559061_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateRma_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NOOQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NSPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CountrySelector__ = __webpack_require__("sAAO");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CountrySelector__["a"]; });


/***/ }),

/***/ "Nx7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("j2Ll");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "O3Mh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OKu3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerNotificationList_vue__ = __webpack_require__("xooi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0259a659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerNotificationList_vue__ = __webpack_require__("FnK0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerNotificationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0259a659_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerNotificationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OMHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Faq__ = __webpack_require__("B6QW");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Faq__["a"]; });


/***/ }),

/***/ "OkWW":
/***/ (function(module, exports) {

module.exports = {"returnTo":"Retourner à","authorNum":"No. d’autorisation","rmaDate":"Date RMA","reopen":"Rouvrir"}

/***/ }),

/***/ "Ory7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "POLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectCode'),"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.complaints),function(item){return _c('el-option',{key:item.id,attrs:{"label":_vm.truncate(item.name, 150),"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PRS+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',{staticStyle:{"margin-top":"11px","font-size":"18px"},attrs:{"span":7}},[_c('small',[_vm._v("Costco Service Requests Count: "+_vm._s(_vm.store.state.count))])]),_vm._v(" "),_c('el-row',{staticStyle:{"display":"flex","justify-content":"flex-end","margin-right":"35px","margin-bottom":"20px"}},[_c('el-col',{attrs:{"span":3}},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.filter.isHistory),callback:function ($$v) {_vm.$set(_vm.filter, "isHistory", $$v)},expression:"filter.isHistory"}},[[_c('el-radio-button',{attrs:{"label":1,"value":1}},[_vm._v("All")]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0,"value":0}},[_vm._v("Active")])]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1.8}},[(_vm.$isAdmin)?_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('serviceTickets.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"Serial Number","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.serialNumber),callback:function ($$v) {_vm.$set(_vm.filter, "serialNumber", $$v)},expression:"filter.serialNumber"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"22.25%"},attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":"***Look-Up***Service Company contains, e.g. DCS-","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.serviceCompany),callback:function ($$v) {_vm.$set(_vm.filter, "serviceCompany", $$v)},expression:"filter.serviceCompany"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"***From Raised on Date***"},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"***To Raised on Date***"},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tickets-table",attrs:{"size":"mini","data":_vm.tickets,"row-class-name":_vm.tableRowEscalationTime},on:{"sort-change":_vm.sortServiceTickets}},[_c('el-table-column',{attrs:{"prop":"isForInstallation","width":"90","label":"Is For Installation"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.isForInstallation ? 'Yes' : 'No'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customerName","label":"Customer Name","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date Created","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.dateCreated))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modelName","label":"Model Name","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":"Serial #","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Code-Description","min-width":"175"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.explanationOfIssue,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v("\n                        "+_vm._s(scope.row.explanationOfIssue)+"\n                    ")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"equipmentOperational","label":'Equipment Operational'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.isForInstallation ? 'Yes' : 'No'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Service Number"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(!scope.row.serviceTicketNumber	? '-' : scope.row.serviceTicketNumber))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations","fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!scope.row.isDeleted && !scope.row.isProcessed)?_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editTicket(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]):_vm._e(),_vm._v(" "),(scope.row.isDeleted || scope.row.isProcessed)?_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.showHistoryInfo(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-service-ticket-from-draft-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"isHistory":_vm.isHistory,"visible":_vm.createServiceTicketDialogVisible},on:{"dialogClosed":_vm.editFinished,"updated":_vm.ticketUpdated}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PSZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("ecgv");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/resolution-codes',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["b" /* ResolutionCodeList */],
  name: 'resolutionCodeList',
  meta: { admin: true }
}, {
  path: '/masters/resolution-code-categories',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ResolutionCodeCategoryList */],
  name: 'resolutionCodeCategoryList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "PWOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClaimsList__ = __webpack_require__("TFT1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClaimsList__["a"]; });


/***/ }),

/***/ "PgIb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{attrs:{"size":"mini"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.createdFrom'),"prop":"createdOnFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.createdOnFrom),callback:function ($$v) {_vm.$set(_vm.form, "createdOnFrom", $$v)},expression:"form.createdOnFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.acceptedDateFrom'),"prop":"dateFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateFrom),callback:function ($$v) {_vm.$set(_vm.form, "dateFrom", $$v)},expression:"form.dateFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.claimNumber'),"prop":"claimNumber"}},[_c('el-input',{model:{value:(_vm.form.claimNumber),callback:function ($$v) {_vm.$set(_vm.form, "claimNumber", $$v)},expression:"form.claimNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.invoiceNumber'),"prop":"invoiceNumber"}},[_c('el-input',{model:{value:(_vm.form.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.form, "invoiceNumber", $$v)},expression:"form.invoiceNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceTicketNumber'),"prop":"serviceTicketNumber"}},[_c('el-input',{model:{value:(_vm.form.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.form, "serviceTicketNumber", $$v)},expression:"form.serviceTicketNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.customerChain'),"prop":"chainId"}},[_c('chain-selector',{model:{value:(_vm.form.chainId),callback:function ($$v) {_vm.$set(_vm.form, "chainId", $$v)},expression:"form.chainId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerName'),"prop":"customerName"}},[_c('el-input',{model:{value:(_vm.form.customerName),callback:function ($$v) {_vm.$set(_vm.form, "customerName", $$v)},expression:"form.customerName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerPhone'),"prop":"customerPhone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.form.customerPhone),callback:function ($$v) {_vm.$set(_vm.form, "customerPhone", $$v)},expression:"form.customerPhone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serialNumber'),"prop":"serialNumber"}},[_c('el-input',{model:{value:(_vm.form.serialNumber),callback:function ($$v) {_vm.$set(_vm.form, "serialNumber", $$v)},expression:"form.serialNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCoverage'),"prop":"serviceCoverage"}},[_c('service-coverage-selector',{model:{value:(_vm.form.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.form, "serviceCoverage", $$v)},expression:"form.serviceCoverage"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.createdTo'),"prop":"createdOnTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.createdOnTo),callback:function ($$v) {_vm.$set(_vm.form, "createdOnTo", $$v)},expression:"form.createdOnTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.acceptedDateTo'),"prop":"dateTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateTo),callback:function ($$v) {_vm.$set(_vm.form, "dateTo", $$v)},expression:"form.dateTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.status'),"prop":"status"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('reports.modifiedStatus'),"value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerZip'),"prop":"customerZip"}},[_c('el-input',{model:{value:(_vm.form.customerZip),callback:function ($$v) {_vm.$set(_vm.form, "customerZip", $$v)},expression:"form.customerZip"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCompany'),"prop":"serviceCompany"}},[_c('el-input',{model:{value:(_vm.form.serviceCompany),callback:function ($$v) {_vm.$set(_vm.form, "serviceCompany", $$v)},expression:"form.serviceCompany"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.partNumber'),"prop":"partNumber"}},[_c('el-input',{model:{value:(_vm.form.partNumber),callback:function ($$v) {_vm.$set(_vm.form, "partNumber", $$v)},expression:"form.partNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.model'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.category'),"prop":"categoryId"}},[_c('resolution-category-selector',{attrs:{"productId":_vm.form.productId},model:{value:(_vm.form.categoryId),callback:function ($$v) {_vm.$set(_vm.form, "categoryId", $$v)},expression:"form.categoryId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.code'),"prop":"codeId"}},[_c('repair-code-selector',{attrs:{"productId":_vm.form.productId,"categoryId":_vm.form.categoryId},model:{value:(_vm.form.codeId),callback:function ($$v) {_vm.$set(_vm.form, "codeId", $$v)},expression:"form.codeId"}})],1)],1)],1),_vm._v(" "),_c('el-checkbox-group',{ref:"group",staticClass:"fields",model:{value:(_vm.form.fields),callback:function ($$v) {_vm.$set(_vm.form, "fields", $$v)},expression:"form.fields"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('reports.createdOn')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"3"}},[_vm._v(_vm._s(_vm.$t('common.invoiceNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"4"}},[_vm._v(_vm._s(_vm.$t('common.claimNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"45"}},[_vm._v(_vm._s(_vm.$t('common.serviceTicketNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"5"}},[_vm._v(_vm._s(_vm.$t('reports.workOrderNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"6"}},[_vm._v(_vm._s(_vm.$t('common.dateOfDispatch')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"7"}},[_vm._v(_vm._s(_vm.$t('reports.dateCompleted')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"8"}},[_vm._v(_vm._s(_vm.$t('common.customerName')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"9"}},[_vm._v(_vm._s(_vm.$t('reports.customerChain')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"10"}},[_vm._v(_vm._s(_vm.$t('common.serialNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"11"}},[_vm._v(_vm._s(_vm.$t('reports.claimReportSymptoms')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"12"}},[_vm._v(_vm._s(_vm.$t('reports.repairDescription')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"13"}},[_vm._v(_vm._s(_vm.$t('reports.repairCategory')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"14"}},[_vm._v(_vm._s(_vm.$t('common.partNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"15"}},[_vm._v(_vm._s(_vm.$t('reports.laborTime')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"16"}},[_vm._v(_vm._s(_vm.$t('reports.laborCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"17"}},[_vm._v(_vm._s(_vm.$t('reports.travelTime')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"18"}},[_vm._v(_vm._s(_vm.$t('reports.travelCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"19"}},[_vm._v(_vm._s(_vm.$t('common.mileage')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"20"}},[_vm._v(_vm._s(_vm.$t('reports.truckCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"21"}},[_vm._v(_vm._s(_vm.$t('reports.partsCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"22"}},[_vm._v(_vm._s(_vm.$t('reports.handlingFee')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"44"}},[_vm._v(_vm._s(_vm.$t('common.ProcessedBy')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('reports.dateProcessed')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"23"}},[_vm._v(_vm._s(_vm.$t('reports.originalHardtInvoice')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"24"}},[_vm._v(_vm._s(_vm.$t('reports.freightCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"25"}},[_vm._v(_vm._s(_vm.$t('reports.salesTax')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"26"}},[_vm._v("Qst/Hst")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"27"}},[_vm._v("Gst")]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"28"}},[_vm._v(_vm._s(_vm.$t('reports.totalCharge')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"29"}},[_vm._v(_vm._s(_vm.$t('reports.customerAddress')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"30"}},[_vm._v(_vm._s(_vm.$t('reports.customerCity')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"31"}},[_vm._v(_vm._s(_vm.$t('reports.customerProvince')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"32"}},[_vm._v(_vm._s(_vm.$t('reports.customerCountry')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"33"}},[_vm._v(_vm._s(_vm.$t('reports.customerZip')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"34"}},[_vm._v(_vm._s(_vm.$t('common.customerPhone')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"35"}},[_vm._v(_vm._s(_vm.$t('common.serviceCompanyName')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"36"}},[_vm._v(_vm._s(_vm.$t('reports.serviceCompanyProvince')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"37"}},[_vm._v(_vm._s(_vm.$t('reports.serviceCompanyZip')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"38"}},[_vm._v(_vm._s(_vm.$t('common.serviceCoverage')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"39"}},[_vm._v(_vm._s(_vm.$t('common.model')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"40"}},[_vm._v(_vm._s(_vm.$t('common.technicianName')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"41"}},[_vm._v(_vm._s(_vm.$t('reports.tripsNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"42"}},[_vm._v(_vm._s(_vm.$t('common.status')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"43"}},[_vm._v(_vm._s(_vm.$t('reports.wasModified')))])],1)],1)],1),_vm._v(" "),_c('el-button',{on:{"click":_vm.selectAll}},[_vm._v(_vm._s(_vm.$t('common.deSelectAll')))]),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.generateReport}},[_vm._v(_vm._s(_vm.$t('common.generate')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q2Ri":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q3I8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q9NL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getUsers: function getUsers(page, filter, sorting) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/users', {
      params: {
        page: page,
        email: filter.email,
        userName: filter.userName,
        sortBy: sorting.sortBy,
        sortOrder: sorting.sortOrder
      }
    });
  },
  getUser: function getUser(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/users/' + id);
  },
  saveUser: function saveUser(id, user) {
    if (id) {
      return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/users/' + id, user);
    }
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/users', user);
  },
  deleteUser: function deleteUser(id) {
    console.log('/api/users/' + id);
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/users/' + id);
  },
  resetPassword: function resetPassword(userId) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/users/reset/' + userId);
  }
});

/***/ }),

/***/ "QBFw":
/***/ (function(module, exports) {

module.exports = {"toBePaid":"Être payé","paidAndPrinted":"Payé et imprimé","claimInvoiceCustomer":"Réclamation","payAndPrintSelectedClaims":"Payer et imprimer les réclamations sélectionnées","payClaim":"Demande de paiement","printClaim":"Demande d'impression","areYouSureThatYouWantoProcessClaim":"Êtes-vous sûr de vouloir traiter la réclamation ?","thisActionWillChangeStatusOfThisClaim":"Cette action modifiera le statut de cette réclamation et enverra une notification par e-mail à la société de services","areYouSureThatYouWantToPayClaim":"Êtes-vous sûr de vouloir payer la réclamation ?","areYouSureThatYouWantToPayAndPrintAllSelectedClaims":"Êtes-vous sûr de vouloir payer et imprimer toutes les réclamations sélectionnées ?"}

/***/ }),

/***/ "QC7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("2XZ0");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/customer-chains',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* CustomerChainList */],
  name: 'customerChainList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "QCCL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimPartSelector_vue__ = __webpack_require__("ijhd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3db6864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimPartSelector_vue__ = __webpack_require__("QSZO");
function injectStyle (ssrContext) {
  __webpack_require__("lXaJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3db6864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimPartSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3db6864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimPartSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QG3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordDialog_vue__ = __webpack_require__("bEz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65388983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordDialog_vue__ = __webpack_require__("GnMz");
function injectStyle (ssrContext) {
  __webpack_require__("65DM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65388983"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePasswordDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65388983_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePasswordDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QHf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ "QSZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","remote":"","remote-method":_vm.searchParts,"placeholder":_vm.$t('common.pleaseSelectPart'),"loading":_vm.loading},on:{"change":_vm.partSelected},model:{value:(_vm.selectedPart),callback:function ($$v) {_vm.selectedPart=$$v},expression:"selectedPart"}},_vm._l((_vm.parts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QV+2":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "IkBD",
	"./fr.json": "QBFw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QV+2";

/***/ }),

/***/ "QhcI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qoor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.selectedPart,"filterable":"","remote":"","remote-method":_vm.searchParts,"placeholder":_vm.$t('common.pleaseSelectPart'),"loading":_vm.loading,"disabled":_vm.disabled},on:{"change":_vm.partSelected}},_vm._l((_vm.parts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R847":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ROTR":
/***/ (function(module, exports) {

module.exports = {"listPrice":"Liste des prix","extendedPrice":"Prix ​​prolongée","returnNeeded":"Retour nécessaire","price":"Prix","supplementaryRegularTime":"Temps réglementaire supplémentaire","supplementaryOverTime":"Supplémentaire au fil du temps","supplementaryComment":"Commentaire supplémentaire","active":"Actif","daysCompletion":"Jours d'achèvement","commentDate":"Date du commentaire","modifiedDate":"Date modifiée","rejectedDate":"Date de rejet","deletedDate":"Date de suppression","assignedDate":"Date d'attribution","claim":"Réclamation","claimAccountInformation":"Demander des informations sur le compte","90daysWarranty":"Garantie de 90 jours","serviceWorkOrderNumber":"Numéro d'ordre de travail de service","dateWorkCompleted":"Date de fin des travaux","workOrders":"Bons de travail","siteInformation":"Informations sur le site","clientStore":"Magasin client","pleaseSelectSubContractor":"Veuillez sélectionner un sous-traitant","pleaseSelectSubAgent":"Veuillez sélectionner un sous-agent","serviceTechnicianName":"Nom du technicien de service","serviceRequestedBy":"Service demandé par","reportSymptoms":"Signaler les symptômes","clickHereToAddRepairCodes":"Cliquez ici pour ajouter des codes de réparation","clickHereToAddMultipleRepairCodesPerformedWithSingleLaborTime":"Cliquez ici pour ajouter plusieurs codes de réparation effectués avec un seul temps de travail","regTime":"Heure d'enregistrement","suppRegTime":"Supp Reg Time","suppOverTime":"Souper au fil du temps","numberOfTrips":"Nombre de voyages","chooseExplanation":"Choisissez l'explication","customerRequestedWeReturn":"Le client a demandé que nous retournions","didNotHaveThePartsOnHandInStock":"N'avait pas les pièces sous la main/en stock","technicalKnowledgeIssue":"Problème de connaissance technique","hardtRequestedWeReturn":"Hardt a demandé que nous revenions","ovenInUse":"Four en cours d'utilisation","otherExplanation":"Autre explication","enterExplanation":"Entrez l'explication","regularTravelHours":"Heures de voyage régulières","overtimeTravelHours":"Heures de déplacement supplémentaires","mileageMiles":"Kilométrage (miles)","overtimeMileageMiles":"Kilométrage des heures supplémentaires (miles)","serviceFuelCharge":"Service","laborSupplementary":"Travail Supplémentaire","laborOvertime":"Heures supplémentaires","laborOvertimeSupplementary":"Travail Supplémentaire Heures Supplémentaires","travel":"Voyage","travelOvertime":"Heures supplémentaires de voyage","mileageOvertime":"Heures supplémentaires","rmaCreateRMA":"RMA","createRMALink":"Créer un lien RMA","clickHereToAddParts":"Cliquez ici pour ajouter des pièces","miscParts":"Pièces diverses","clickHereToAddMiscellaneousParts":"Cliquez ici pour ajouter des pièces diverses","partName":"Nom de la pièce","labourTravel":"Travail","handling":"Manutention","hardtOriginalInvoice":"Facture originale HARDT","tax":"Taxe (le cas échéant)","newComment":"Nouveau commentaire","newClaimStatus":"Nouveau statut de réclamation","attachment":"Pièce jointe","postComment":"Poster un commentaire","rma":"RMA Retour de pièces"}

/***/ }),

/***/ "ReaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("d03X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "customer-selector",
    props: ["value", "customerName"],
    watch: {
        customerName: function customerName(newValue) {
            console.info(newValue);
            if (newValue) {
                this.searchCustomers(newValue);
            }
        }
    },
    data: function data() {
        return {
            loading: false,
            customers: []
        };
    },

    methods: {
        searchCustomers: function searchCustomers(term) {
            var self = this;
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCustomers(term).then(function (response) {
                self.loading = false;
                self.customers = response.data;
            });
        },
        selectCustomer: function selectCustomer(event) {
            var _this = this;

            if (event != "" && this.$isAdmin) {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getNotifications(event).then(function (response) {
                    if (response.data.length > 0) {
                        _this.$alert(response.data.map(function (x) {
                            return x.message;
                        }).join("<br/> <hr>"), "", {
                            confirmButtonText: _this.$t('common.OK'),
                            callback: function callback(action) {},
                            dangerouslyUseHTMLString: true
                        });
                    }
                });
            }
            this.$emit("input", event);
        },
        searchCustomersById: function searchCustomersById(id, callback) {
            var self = this;
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCustomersById(id).then(function (response) {
                self.loading = false;
                self.customers = response.data;

                if (callback) {
                    callback();
                }
            });
        },
        getCustomers: function getCustomers() {
            return this.customers;
        }
    },
    created: function created() {
        this.searchCustomers("");
    }
});

/***/ }),

/***/ "Rhgp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("Q9NL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "create-update-user-dialog",
  components: {
    RoleSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["n" /* RoleSelector */]
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      required: false
    }
  },
  data: function data() {
    return {
      form: {
        userName: "",
        name: "",
        email: "",
        isReadOnly: false,
        isSuperAdmin: false,
        phoneNumber: "",
        address: ""
      },
      rules: {
        userName: [{
          required: true,
          message: this.$t('common.pleaseEnterUsername'),
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: this.$t('common.pleaseEnterEmail'),
          trigger: "blur"
        }],
        phoneNumber: [{
          required: true,
          message: this.$t('common.pleaseEnterPhoneNumber'),
          trigger: "blur"
        }],
        address: [{
          required: true,
          message: this.$t('common.pleaseEnterAddress'),
          trigger: "blur"
        }]
      },
      showDialog: this.visible,
      loading: false
    };
  },

  watch: {
    visible: function visible(val) {
      this.showDialog = val;
    }
  },
  methods: {
    loadUser: function loadUser() {
      var _this = this;

      if (this.userId) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUser(this.userId).then(function (response) {
          _this.loading = false;
          _this.form = Object.assign({}, response.data);
        });
      }
    },
    closeDialog: function closeDialog() {
      this.$refs["form"].resetFields();
      this.showDialog = false;
      this.loading = false;
      this.$emit("dialogClosed");
    },
    save: function save() {
      var _this2 = this;

      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveUser(_this2.userId, _this2.form).then(function (response) {
            _this2.$emit("save", {
              new: _this2.userId === undefined,
              id: _this2.userId,
              data: _this2.form
            });
            _this2.closeDialog();
          }).catch(function (err) {
            if (err && err.response && err.response.data) {
              _this2.$message({
                type: "error",
                message: err.response.data[""][0]
              });
              _this2.loading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetPassword: function resetPassword() {
      var _this3 = this;

      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].resetPassword(_this3.userId).then(function () {
          _this3.$message({
            type: "success",
            message: _this3.$t('common.emailWithInstructionsWasSent')
          });
        });
      }).catch(function (_) {});
    }
  }
});

/***/ }),

/***/ "S1Cx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S7Db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[(_vm.$isFullAdmin)?_c('el-col',{attrs:{"span":8}},[_vm._v("\n             \n            "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))])],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('product-selector',{model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.categories}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('common.name'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"productName","label":_vm.$t('common.product')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 160 : 116 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editCategory(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isFullAdmin && _vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteCategory(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-resolution-code-category-dialog',{attrs:{"categoryId":_vm.categoryToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendCategory}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S7QI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getServiceCompanyList: function getServiceCompanyList(country, state, city, address, zip, serviceCompany, allowedDistance) {
        var url = '/api/customers/service?country=' + country + '&state=' + state;
        if (city) {
            url = url + '&city=' + city;
        }
        if (address) {
            url = url + '&address=' + address;
        }
        if (zip) {
            url = url + '&zip=' + zip;
        }
        if (serviceCompany) {
            url = url + '&serviceCompany=' + serviceCompany;
        }
        if (allowedDistance) {
            url = url + '&allowedDistance=' + allowedDistance;
        }
        // return axios.get(`/api/customers/service?country=${country}&state=${state}&city=${city}&address=${address}&zip=${zip}&serviceCompany=${serviceCompany}`);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url);
    }
});

/***/ }),

/***/ "SIBk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("fFT0");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "SiCf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/customerchains/export', {
            name: filter.text
        });
    },
    getCustomerChains: function getCustomerChains(page, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customerchains/table', {
            params: {
                page: page,
                name: text
            }
        });
    },
    getCustomerChain: function getCustomerChain(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customerchains/table/' + id);
    },
    saveCustomerChain: function saveCustomerChain(id, customerChain) {
        var request = Object.assign({}, customerChain);
        request.validationRules = customerChain.validationRules.map(function (r) {
            return r.value;
        }).join(',');
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/customerchains/' + id, request);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/customerchains', request);
    },
    deleteCustomerChain: function deleteCustomerChain(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/customerchains/' + id);
    }
});

/***/ }),

/***/ "SlQP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{attrs:{"size":"mini"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.createdFrom'),"prop":"createdOnFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.createdOnFrom),callback:function ($$v) {_vm.$set(_vm.form, "createdOnFrom", $$v)},expression:"form.createdOnFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.acceptedDateFrom'),"prop":"dateFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateFrom),callback:function ($$v) {_vm.$set(_vm.form, "dateFrom", $$v)},expression:"form.dateFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.claimNumber'),"prop":"claimNumber"}},[_c('el-input',{model:{value:(_vm.form.claimNumber),callback:function ($$v) {_vm.$set(_vm.form, "claimNumber", $$v)},expression:"form.claimNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.invoiceNumber'),"prop":"invoiceNumber"}},[_c('el-input',{model:{value:(_vm.form.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.form, "invoiceNumber", $$v)},expression:"form.invoiceNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceTicketNumber'),"prop":"serviceTicketNumber"}},[_c('el-input',{model:{value:(_vm.form.serviceTicketNumber),callback:function ($$v) {_vm.$set(_vm.form, "serviceTicketNumber", $$v)},expression:"form.serviceTicketNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.customerChain'),"prop":"chainId"}},[_c('chain-selector',{model:{value:(_vm.form.chainId),callback:function ($$v) {_vm.$set(_vm.form, "chainId", $$v)},expression:"form.chainId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerName'),"prop":"customerName"}},[_c('el-input',{model:{value:(_vm.form.customerName),callback:function ($$v) {_vm.$set(_vm.form, "customerName", $$v)},expression:"form.customerName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerPhone'),"prop":"customerPhone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.form.customerPhone),callback:function ($$v) {_vm.$set(_vm.form, "customerPhone", $$v)},expression:"form.customerPhone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serialNumber'),"prop":"serialNumber"}},[_c('el-input',{model:{value:(_vm.form.serialNumber),callback:function ($$v) {_vm.$set(_vm.form, "serialNumber", $$v)},expression:"form.serialNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCoverage'),"prop":"serviceCoverage"}},[_c('service-coverage-selector',{model:{value:(_vm.form.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.form, "serviceCoverage", $$v)},expression:"form.serviceCoverage"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.createdTo'),"prop":"createdOnTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.createdOnTo),callback:function ($$v) {_vm.$set(_vm.form, "createdOnTo", $$v)},expression:"form.createdOnTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.acceptedDateTo'),"prop":"dateTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateTo),callback:function ($$v) {_vm.$set(_vm.form, "dateTo", $$v)},expression:"form.dateTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.status'),"prop":"status"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"label":"","value":""}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('reports.modifiedStatus'),"value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customerZip'),"prop":"customerZip"}},[_c('el-input',{model:{value:(_vm.form.customerZip),callback:function ($$v) {_vm.$set(_vm.form, "customerZip", $$v)},expression:"form.customerZip"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCompany'),"prop":"serviceCompany"}},[_c('el-input',{model:{value:(_vm.form.serviceCompany),callback:function ($$v) {_vm.$set(_vm.form, "serviceCompany", $$v)},expression:"form.serviceCompany"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.partNumber'),"prop":"partNumber"}},[_c('el-input',{model:{value:(_vm.form.partNumber),callback:function ($$v) {_vm.$set(_vm.form, "partNumber", $$v)},expression:"form.partNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.model'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.category'),"prop":"categoryId"}},[_c('resolution-category-selector',{attrs:{"productId":_vm.form.productId},model:{value:(_vm.form.categoryId),callback:function ($$v) {_vm.$set(_vm.form, "categoryId", $$v)},expression:"form.categoryId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.code'),"prop":"codeId"}},[_c('repair-code-selector',{attrs:{"productId":_vm.form.productId,"categoryId":_vm.form.categoryId},model:{value:(_vm.form.codeId),callback:function ($$v) {_vm.$set(_vm.form, "codeId", $$v)},expression:"form.codeId"}})],1)],1)],1),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.generateReport}},[_vm._v(_vm._s(_vm.$t('common.generate')))]),_vm._v(" "),_c('el-button',{attrs:{"typeof":"secondary"},on:{"click":_vm.clearFields}},[_vm._v("Clear")]),_vm._v(" "),_c('p',{staticClass:"labelInfo"},[_vm._v(_vm._s(_vm.$t('reports.noDatesChoosenMessage')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "T4VY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainSelector_vue__ = __webpack_require__("rKfw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_742afdbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainSelector_vue__ = __webpack_require__("knv9");
function injectStyle (ssrContext) {
  __webpack_require__("7GoO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-742afdbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChainSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_742afdbe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChainSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TDmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("J64k");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'equipment-selector',
    props: {
        value: {},
        customerId: {
            type: Number,
            default: undefined
        }
    },
    data: function data() {
        return {
            loading: false,
            equipmentList: []
        };
    },

    watch: {
        customerId: function customerId(val) {
            var _this = this;

            if (!val) {
                this.equipmentList = [];
            } else {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEquipment(this.customerId).then(function (response) {
                    _this.loading = false;
                    _this.equipmentList = response.data;
                });
            }
        }
    },
    methods: {
        buildFromItem: function buildFromItem(item) {
            return item.model + ' (' + item.serialNumber + ')';
        },
        change: function change(val) {
            this.$emit('input', val);

            var equipment = val ? this.equipmentList.find(function (p) {
                return p.id === val;
            }) : undefined;
            this.$emit('equipmentSelected', equipment);
        }
    }
});

/***/ }),

/***/ "TFT1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimsList_vue__ = __webpack_require__("9otv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4946214c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimsList_vue__ = __webpack_require__("MHJ5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4946214c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TPw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("H50Z");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "service-ticket-part-selector",

  props: {
    serviceCompanyId: {
      type: Number
    },
    productId: {
      type: Number
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedPart: undefined,
      parts: []
    };
  },

  methods: {
    searchParts: function searchParts(term) {
      if (term !== "") {
        var self = this;
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getParts(term, this.serviceCompanyId, this.productId).then(function (response) {
          self.loading = false;
          self.parts = response.data;
        });
      }
    },
    partSelected: function partSelected(value) {
      if (value === "") {
        this.parts = [];
      }

      console.log(value);
      this.$emit("part-selected", this.parts.find(function (c) {
        return c.id === value;
      }));
    },
    reset: function reset() {
      this.selectedPart = undefined;
      this.parts = [];
    }
  }
});

/***/ }),

/***/ "TQ7+":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "07Nn",
	"./fr.json": "0RgM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TQ7+";

/***/ }),

/***/ "TRBT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('shared.technicalDocumentation')))]),_vm._v(" "),_c('el-collapse',[(_vm.$isFullAdmin)?_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('p',{staticStyle:{"background-color":"#ececec"}},[_vm._v("\n                    "+_vm._s(_vm.$t('technicaldocumentation.createFolder'))+"\n                    "),_c('i',{staticClass:"header-icon el-icon-info"})])]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-form',{ref:"form",staticStyle:{"margin-top":"15px"},attrs:{"inline":true,"model":_vm.form,"rules":_vm.rules,"size":"small"}},[_c('el-form-item',{attrs:{"label":_vm.$t('technicaldocumentation.parentFolder')}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.form.parent),callback:function ($$v) {_vm.$set(_vm.form, "parent", $$v)},expression:"form.parent"}},_vm._l((_vm.folderList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('technicaldocumentation.newFolderName'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addFolder}},[_vm._v(_vm._s(_vm.$t('common.create')))])],1):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('p',{staticStyle:{"background-color":"#ececec"}},[_vm._v("\n                    "+_vm._s(_vm.$t('technicaldocumentation.uploadDocument'))+"\n                    "),_c('i',{staticClass:"header-icon el-icon-info"})])]),_vm._v(" "),_c('el-form',{ref:"uploadForm",staticStyle:{"margin-top":"15px"},attrs:{"model":_vm.uploadForm,"rules":_vm.uploadRules,"label-position":"top","size":"small"}},[_c('el-form-item',{attrs:{"label":_vm.$t('technicaldocumentation.folder')}},[_c('el-select',{attrs:{"clearable":""},model:{value:(_vm.uploadForm.folderId),callback:function ($$v) {_vm.$set(_vm.uploadForm, "folderId", $$v)},expression:"uploadForm.folderId"}},_vm._l((_vm.folderList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('technicaldocumentation.documents')}},[_c('el-upload',{ref:"uploader",attrs:{"drag":"","multiple":"","auto-upload":false,"limit":10,"action":"","on-change":_vm.documentPlaced,"on-remove":_vm.deleteAttachment}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                            "+_vm._s(_vm.$t('serviceTickets.dropFile'))+"\n                            "),_c('em',[_vm._v(_vm._s(_vm.$t('serviceTickets.clicktoUpload')))])])]),_vm._v(" "),_c('div',{model:{value:(_vm.uploadFilesLength),callback:function ($$v) {_vm.uploadFilesLength=$$v},expression:"uploadFilesLength"}},[_vm._v(_vm._s(_vm.$t('technicaldocumentation.uploadedFilesLength'))+" "+_vm._s(_vm.uploadFilesLength)+" kB")])],1),_vm._v(" "),_c('el-button',{attrs:{"disable":_vm.uploading},on:{"click":_vm.uploadDocuments}},[_vm._v(_vm._s(_vm.$t('technicaldocumentation.upload')))]),_vm._v(" "),_c('progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.uploading),expression:"uploading"}],attrs:{"max":"100"},domProps:{"value":_vm.uploadPercentage}})],1)],2):_vm._e()],1),_vm._v(" "),_c('node-tree',{attrs:{"nodes":_vm.folders},on:{"folderDeleted":_vm.folderDeleted,"documentDeleted":_vm.loadDocumentation}}),_vm._v(" "),_c('div',{model:{value:(_vm.totalFilesLength),callback:function ($$v) {_vm.totalFilesLength=$$v},expression:"totalFilesLength"}},[_vm._v(_vm._s(_vm.$t('technicaldocumentation.totalFilesLength'))+" "+_vm._s(_vm.totalFilesLength)+" MB")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TW/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"id":"attnSelectorInput","value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectATTN'),"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.attns),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TmYv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocumentationList__ = __webpack_require__("d2TH");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DocumentationList__["a"]; });


/***/ }),

/***/ "UGjV":
/***/ (function(module, exports) {

module.exports = {"purchaseOrder":"Purchase Order","orderNotes":"Order Notes","orderDate":"Order Date","billingAddress":"Billing Address","shippingAddressSameAsBillTo":"Shipping address, same as Bill to","shippingAddress":"Shipping Address","addPart":"Add part","serviceOrderNumber":"Service Order Number","shippingCost":"Shipping Cost","signedBy":"Signed By","signedOn":"Signed On","printAndProcess":"Print And Process","selectDateAndTime":"Select date and time","purchaseOrderNumber":"Purchase order number","orderNumber":"Order number","serviceCompanyName":"Service company name","orderNum":"Order #","timeStamp":"Time Stamp","purchaseOrderNum":"Purchase Order #","svcCompany":"Svc. Company","serviceOrderNum":"Service Order #","shippingCharges":"Shipping Charges","deliverySignedBy":"Delivery Signed By","deliverySignedOn":"Delivery Signed On"}

/***/ }),

/***/ "UTxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimList_vue__ = __webpack_require__("C/Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_504ad719_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimList_vue__ = __webpack_require__("fZCd");
function injectStyle (ssrContext) {
  __webpack_require__("dT8a")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-504ad719"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClaimList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_504ad719_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClaimList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZ+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeTree_vue__ = __webpack_require__("t559");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fffb7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeTree_vue__ = __webpack_require__("9U2S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NodeTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fffb7b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NodeTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UiDJ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "Vv/e",
	"./fr.json": "bDAA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UiDJ";

/***/ }),

/***/ "UrNm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("H3FJ");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'repair-code-selector',
    props: {
        value: {},
        productId: {
            type: Number,
            default: undefined
        },
        categoryId: {
            type: Number,
            default: undefined
        }
    },
    data: function data() {
        return {
            loading: false,
            categories: []
        };
    },

    watch: {
        productId: function productId(val) {
            var _this = this;

            if (!val) {
                this.categories = [];
            } else {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCodes(val, this.categoryId).then(function (response) {
                    _this.loading = false;
                    _this.categories = response.data;
                });
            }
        },
        categoryId: function categoryId(val) {
            var _this2 = this;

            if (!val) {
                this.categories = [];
            } else {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCodes(this.productId, val).then(function (response) {
                    _this2.loading = false;
                    _this2.categories = response.data;
                });
            }
        }
    }
});

/***/ }),

/***/ "UyV3":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "mIN7",
	"./fr.json": "qx1m"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UyV3";

/***/ }),

/***/ "V1kj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"claim-dialog",attrs:{"width":"950px","visible":_vm.showDialog,"append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadClaim,"close":_vm.closeDialog}},[_c('template',{slot:"title"},[_vm._v("\n        Preview claim "+_vm._s(_vm.claim.claimNumber)+"\n        "),(_vm.$isFullAdmin && !_vm.isForPartial)?_c('el-select',{attrs:{"disabled":_vm.claim.status === 'Paid' || _vm.noDetails},on:{"change":function($event){_vm.handleStatusChange(_vm.claim.id, _vm.claimStatus)}},model:{value:(_vm.claimStatus),callback:function ($$v) {_vm.claimStatus=$$v},expression:"claimStatus"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingTechnicalReview'),"value":"10"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingTechnicalReviewGillesB'),"value":"11"}})],1):_vm._e(),_vm._v(" "),(!_vm.noDetails && !_vm.isForPartial && (_vm.claim.status === 'Partial' || _vm.claim.status === 'MoreInformationRequired' || _vm.$isAdmin))?_c('el-button',{on:{"click":function($event){_vm.editClaim(_vm.claim.id)}}},[_vm._v("\n            "+_vm._s(_vm.$t('common.details'))+"\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.claim.serviceCompany || _vm.claim.customer)?_c('el-row',[(_vm.claim.serviceCompany.code != null)?_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v(_vm._s(_vm.$t('common.serviceCompany')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.code))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.street))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.city)+", "+_vm._s(_vm.claim.serviceCompany.zip)+" "+_vm._s(_vm.claim.serviceCompany.stateCode))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.claim.serviceCompany.phone))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.contactPersonName))]),_vm._v(" "),(_vm.claim.serviceCompany.subContractorName != null)?_c('div',[_c('b',[_vm._v(_vm._s(_vm.$t('common.subContractor')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.subContractorName))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.subContractorPhone))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.subContractorEmail))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.serviceCompany.subContractorContactName))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.claim.customer.name != null)?_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v(_vm._s(_vm.$t('claims.siteInformation')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.customer.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.customer.street))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.customer.city)+", "+_vm._s(_vm.claim.customer.zip)+" "+_vm._s(_vm.claim.customer.code))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.claim.customer.phone))])]):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('h4',[_vm._v(_vm._s(_vm.$t('common.claimInformation')))]),_vm._v(" "),(_vm.claim.serviceTicketNumber != null)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceTicketNumColon')))]),_vm._v(" "+_vm._s(_vm.claim.serviceTicketNumber)+"\n                ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.claimColon')))]),_vm._v(" "+_vm._s(_vm.claim.claimNumber)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.statusColon')))]),_vm._v(" "+_vm._s(_vm.claim.status)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.createdColon')))]),_vm._v(" "+_vm._s(_vm._f("date")(_vm.claim.raisedOn))+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.dispatchColon')))]),_vm._v(" "+_vm._s(_vm._f("date")(_vm.claim.dateOfDispatch))+"\n                ")]),_vm._v(" "),(_vm.claim.acceptedDate != null)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.acceptedDateColon')))]),_vm._v(" "+_vm._s(_vm._f("date")(_vm.claim.acceptedDate))+"\n                ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.workCompletedColon')))]),_vm._v(" "+_vm._s(_vm._f("date")(_vm.claim.dateWorkCompleted))+"\n                ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.invoiceColon')))]),_vm._v(" "+_vm._s(_vm.claim.invoiceNumber)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceWorkOrderColon')))]),_vm._v(" "+_vm._s(_vm.claim.serviceWorkOrder)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceCoverage')))]),_vm._v(" "+_vm._s(_vm.claim.serviceCoverage)+"\n                ")])])],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":16}},[(_vm.claim.subAgent != null)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.subAgentColon')))]),_vm._v(" "+_vm._s(_vm.claim.subAgent.name)+"\n                ")]):_vm._e(),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceTicketNumber')))]),_vm._v(" "+_vm._s(_vm.claim.serviceTicketId)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serviceRequestedBy')))]),_vm._v(" "+_vm._s(_vm.claim.serviceRequestedBy)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.workOrderSignedAndApprovedBy')))]),_vm._v(" "+_vm._s(_vm.claim.orderSignedBy)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('claims.serviceTechnicianName')))]),_vm._v(" "+_vm._s(_vm.claim.technicianName)+"\n                ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.productModelColon')))]),_vm._v(" "+_vm._s(_vm.claim.product)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.serialColon')))]),_vm._v(" "+_vm._s(_vm.claim.serialNumber)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.reportSymptomsColon')))]),_vm._v(" "+_vm._s(_vm.claim.complaint)+"\n                ")]),_vm._v(" "),(_vm.claim.processedBy != null)?_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('common.processedByColon')))]),_vm._v(" "+_vm._s(_vm.showProcessedByUser())+"\n                ")]):_vm._e()])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"preview"},[_c('h4',[_vm._v(_vm._s(_vm.$t('common.codes')))]),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.claim.repairCodes,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('common.code'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"regularTime","label":_vm.$t('common.regularTime'),"width":"100"}})],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('common.laborAndTravel')))]),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.claim.laborTravel,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"name","label":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.regularTime')}},[_c('el-table-column',{attrs:{"prop":"regular","label":_vm.$t('common.maxAllowed')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplementary","label":_vm.$t('common.suplementary')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.rate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.rate)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.total')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.total)+"\n                    ")]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.overTime')}},[_c('el-table-column',{attrs:{"prop":"overtime","label":_vm.$t('common.maxAllowed')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"supplementaryOvertime","label":_vm.$t('common.suplementary')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.rate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.rateOvertime)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.total')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.totalOvertime)+"\n                    ")]}}])})],1)],1),_vm._v(" "),_c('table',{staticClass:"trips-table"},[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('claims.numberOfTrips')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.tripsExplanation')))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.claim.numberOfTrips))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.claim.tripsExplanation))])])]),_vm._v(" "),(_vm.claim.parts && _vm.claim.parts.length > 0)?_c('h4',[_vm._v(_vm._s(_vm.$t('common.parts')))]):_vm._e(),_vm._v(" "),(_vm.claim.parts && _vm.claim.parts.length > 0)?_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.claim.parts,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"no","label":_vm.$t('common.no')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")(scope.row.price))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"extendedPrice","label":_vm.$t('common.extendedPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total","label":_vm.$t('common.extendedTotal')}})],1):_vm._e(),_vm._v(" "),(_vm.claim.miscParts && _vm.claim.miscParts.length > 0)?_c('h4',[_vm._v(_vm._s(_vm.$t('claims.miscParts')))]):_vm._e(),_vm._v(" "),(_vm.claim.miscParts && _vm.claim.miscParts.length > 0)?_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.claim.miscParts,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('claims.partName')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.price')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")(scope.row.price))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.extendedPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity')}})],1):_vm._e(),_vm._v(" "),_c('table',{staticClass:"nowrap totals",staticStyle:{"width":"auto"}},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('common.total')))]),_vm._v(" "),(_vm.claim.isWarrantyClaim)?_c('th',[_vm._v(_vm._s(_vm.$t('common.glCode')))]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.laborAndTravel')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.laborTotal)))]),_vm._v(" "),(_vm.claim.isWarrantyClaim)?_c('td',[_vm._v(_vm._s(_vm.claim.laborGLCode))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.parts')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.partsTotal)))]),_vm._v(" "),(_vm.claim.isWarrantyClaim)?_c('td',[_vm._v(_vm._s(_vm.claim.partGLCode))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.freight')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.freight)))]),_vm._v(" "),(_vm.claim.isWarrantyClaim)?_c('td',[_vm._v(_vm._s(_vm.claim.freightGLCode))]):_vm._e()]),_vm._v(" "),(_vm.claim.tax && (_vm.claim.taxId === null))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.taxEIN')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.tax)))]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.claim.freight > 50)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.hardtOriginalInvColon')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.claim.hardtInvoice))]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.claim.isUS && _vm.claim.tax && (_vm.claim.taxId !== null))?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.taxEINNum'))+_vm._s(_vm.claim.taxId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.tax)))]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('claims.handling')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.handling)))]),_vm._v(" "),(_vm.claim.isWarrantyClaim)?_c('td',[_vm._v(_vm._s(_vm.claim.handlingGLCode))]):_vm._e()]),_vm._v(" "),(_vm.claim.isCanadian)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.gstHstNum'))+_vm._s(_vm.claim.gstNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.gst)))]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),(_vm.claim.isQuebec)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('common.pstNum'))+_vm._s(_vm.claim.qstNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.qst)))]),_vm._v(" "),_c('td')]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('b',[_vm._v(_vm._s(_vm.$t('common.total')))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("money")(_vm.claim.total)))])]),_vm._v(" "),_c('td')])])]),_vm._v(" "),(_vm.isUserServiceCompany)?_c('div',[(_vm.claim.comments && _vm.claim.comments.length > 0)?_c('h4',[_vm._v(_vm._s(_vm.$t('common.comments')))]):_vm._e(),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.claim.comments),function(comment){return _c('li',{key:comment.id},[_c('div',[_c('p',[_vm._v(_vm._s(comment.text))]),_vm._v(" "),_c('strong',[_vm._v("On "+_vm._s(_vm._f("date")(comment.on))+" by "+_vm._s(comment.by ? comment.by.name : "--MISSING--"))])])])}))])],1):_vm._e()],1),_vm._v(" "),(!_vm.isForPartial)?_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(!_vm.noDetails && (_vm.claim.status === 'Partial' || _vm.claim.status === 'MoreInformationRequired' || _vm.$isAdmin))?_c('el-button',{on:{"click":function($event){_vm.editClaim(_vm.claim.id)}}},[_c('i',{staticClass:"el-icon-edit"}),_vm._v(_vm._s(_vm.$t('common.details'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.printing},on:{"click":function($event){_vm.printClaim()}}},[_c('i',{staticClass:"el-icon-printer"})]),_vm._v(" "),(!_vm.hideSave && _vm.$isAdmin && !_vm.noDetails)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('common.process')))]):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.close')))])],1):_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.back')))]),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.printing},on:{"click":function($event){_vm.printClaim()}}},[_c('i',{staticClass:"el-icon-printer"})]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirm}},[_vm._v(_vm._s(_vm.$t('common.submit')))])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VA0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("fboY");
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'repair-code-selector',

    props: {
        productId: {
            type: Number
        },
        multiple: {
            type: Boolean,
            default: false
        },
        preselect: {
            default: false
        }
    },
    data: function data() {
        return {
            loading: false,
            selectedRepairCode: undefined,
            repairCodes: []
        };
    },

    methods: {
        searchRepairCodes: function searchRepairCodes(term) {
            if (term !== '') {
                var self = this;
                self.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getRepairCodes(this.productId, term).then(function (response) {
                    self.loading = false;
                    self.repairCodes = response.data;
                });
            }
        },
        singleRepairCodeSelected: function singleRepairCodeSelected(value) {
            if (value === '') {
                this.repairCodes = [];
            }
            this.$emit('repair-code-selected', this.repairCodes.find(function (c) {
                return c.id === value;
            }));
        },
        multiRepairCodeSelected: function multiRepairCodeSelected(value) {
            if (value === '') {
                this.repairCodes = [];
            }
            this.selectedRepairCode = undefined;
            this.$emit('repair-codes-selected', this.repairCodes.find(function (c) {
                return c.id === value;
            }));
        },
        reset: function reset() {
            this.selectedRepairCode = undefined;
            this.repairCodes = [];
        }
    },
    watch: {
        preselect: function preselect(val) {
            if (!val) {
                return;
            }
            this.selectedRepairCode = val.id;
            this.repairCodes = [val];
        }
    }
});

/***/ }),

/***/ "VA7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.userId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('common.user'),"visible":_vm.showDialog,"width":"500px","autoComplete":"false","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadUser,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('masters.userName'),"prop":"userName"}},[_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.form.userName),callback:function ($$v) {_vm.$set(_vm.form, "userName", $$v)},expression:"form.userName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.email'),"prop":"email"}},[_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.isReadOnly'),"prop":"role"}},[_c('el-switch',{model:{value:(_vm.form.isReadOnly),callback:function ($$v) {_vm.$set(_vm.form, "isReadOnly", $$v)},expression:"form.isReadOnly"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.isSuperAdmin'),"prop":"role"}},[_c('el-switch',{model:{value:(_vm.form.isSuperAdmin),callback:function ($$v) {_vm.$set(_vm.form, "isSuperAdmin", $$v)},expression:"form.isSuperAdmin"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.phone'),"prop":"phoneNumber"}},[_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.form.phoneNumber),callback:function ($$v) {_vm.$set(_vm.form, "phoneNumber", $$v)},expression:"form.phoneNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.address'),"prop":"address"}},[_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.userId !== null)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.resetPassword}},[_vm._v(_vm._s(_vm.$t('common.resetPassword')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.userId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VNfK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceTicketSelector__ = __webpack_require__("2iVs");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceTicketSelector__["a"]; });


/***/ }),

/***/ "VO/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getEmails: function getEmails(page, filter, sorting) {
        var params = {
            page: page,
            serviceTicketId: filter.ticketId,
            email: filter.email,
            emailStatus: filter.emailStatus,
            selfService: filter.selfService,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/emails', {
            params: params
        });
    },
    resend: function resend(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/emails/' + id + '/resend');
    }
});

/***/ }),

/***/ "VPW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartSelector_vue__ = __webpack_require__("gtb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac82ec4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartSelector_vue__ = __webpack_require__("Qoor");
function injectStyle (ssrContext) {
  __webpack_require__("K/j1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ac82ec4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ac82ec4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VQzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","remote":"","remote-method":_vm.searchParts,"placeholder":"Please select part","loading":_vm.loading},on:{"change":_vm.partSelected},model:{value:(_vm.selectedPart),callback:function ($$v) {_vm.selectedPart=$$v},expression:"selectedPart"}},_vm._l((_vm.parts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VTOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__ = __webpack_require__("fEXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("sT8e");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "equipment-registration-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        equipmentId: {
            required: false
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        CustomerSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["h" /* CustomerSelector */]
    },
    data: function data() {
        var _this = this;

        var checkSerial = function checkSerial(rule, value, callback) {
            if (!value) {
                return callback(new Error("Please input serial number"));
            }

            if (!_this.serialPrefix) {
                return callback(new Error(_this.$t('common.pleaseSelectProductFirst')));
            }

            var validSerial = false;
            var errorMessage = _this.$t('common.pleaseEnterName') + (" YYMM" + _this.serialPrefix);
            var regex = new RegExp("^(\\d{2})(\\d{2})(" + _this.serialPrefix + ")(\\w+)$");
            if (_this.form.productId == 108) {
                regex = new RegExp("^(\\d{2})(\\d{2})(" + _this.serialPrefix + ")(.{4})$");
                errorMessage = _this.$t('common.pleaseEnterName') + (" YYMM" + _this.serialPrefix + "****");
            }
            if (regex.test(value)) {
                var month = Number.parseInt(regex.exec(value)[2]);
                if (month > 0 && month <= 12) {
                    validSerial = true;
                }
            }

            if (validSerial) {
                return callback();
            } else {
                return callback(new Error(errorMessage));
            }
        };
        return {
            form: {
                customerId: undefined,
                productId: undefined,
                serialNumber: "",
                gasType: 0,
                shippingDate: "",
                warrantyStart: "",
                warrantyEnd: "",
                installationDate: ""
            },
            rules: {
                customerId: [{
                    type: "number",
                    required: true,
                    message: this.$t('shared.pleaseSelectCustomer'),
                    trigger: "change"
                }],
                productId: [{
                    type: "number",
                    required: true,
                    message: this.$t('shared.pleaseSelectProduct'),
                    trigger: "change"
                }],
                serialNumber: [{
                    validator: checkSerial,
                    required: true,
                    trigger: "blur"
                }],
                gasType: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseSelectGasType'),
                    trigger: "change"
                }],
                shippingDate: [{
                    type: "date",
                    required: true,
                    message: this.$t('common.pleaseSelectShippingDate'),
                    trigger: "blur"
                }],
                warrantyStart: [{
                    type: "date",
                    required: true,
                    message: this.$t('common.pleaseEnterWarrantyStartDate'),
                    trigget: "blur"
                }],
                warrantyEnd: [{
                    type: "date",
                    required: true,
                    message: this.$t('common.pleaseEnterWarrantyEndDate'),
                    trigget: "blur"
                }]
            },
            loading: false,
            showDialog: this.visible,
            customerCreateDialogVisible: false,
            serialPrefix: undefined,
            updateMode: false,
            installationDatePickerOptions: {
                disabledDate: this.disabledInstallationDate
            },
            installationDateChanged: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        "form.productId": function formProductId(val) {
            if (this.form.serialNumber) {
                this.$refs.form.validateField("serialNumber");
            }
        },
        "form.shippingDate": function formShippingDate(val) {
            if (!this.updateMode || this.form.warrantyStart == "") {
                var shippingDatePlus8 = new Date(this.form.shippingDate); // add 8 weeks to ship date or installation date whichever occurred first
                shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
                this.form.warrantyStart = this.form.installationDate == "" || shippingDatePlus8 < this.form.installationDate ? new Date(shippingDatePlus8) : new Date(this.form.installationDate);
            }
        },
        "form.installationDate": function formInstallationDate(val) {
            var shippingDatePlus8 = new Date(this.form.shippingDate);
            shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
            this.form.warrantyStart = this.form.shippingDate == "" || shippingDatePlus8 > this.form.installationDate ? new Date(this.form.installationDate) : shippingDatePlus8;
            this.installationDateChanged = true;
        },
        "form.warrantyStart": function formWarrantyStart(val) {
            if (!this.updateMode || this.form.warrantyEnd == "" || this.installationDateChanged) {
                this.form.warrantyEnd = new Date(this.form.warrantyStart);
                this.form.warrantyEnd.setFullYear(this.form.warrantyEnd.getFullYear() + 2); // add 2 years
                this.installationDateChanged = false;
            }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        var self = this;
        __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__["a" /* EventBus */].$on("saveCustomer", function (id) {
            _this2.form.customerId = id;
        });
    },

    methods: {
        serialUpdated: function serialUpdated(serial) {
            this.serialPrefix = serial;
        },
        loadEquipment: function loadEquipment() {
            var _this3 = this;

            if (this.equipmentId) {
                this.loading = true;
                this.updateMode = true;
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getEquipment(this.equipmentId).then(function (equipment) {
                    _this3.form.customerId = equipment.data.customerId;
                    _this3.form.productId = equipment.data.productId;
                    _this3.form.serialNumber = equipment.data.serialNumber;
                    _this3.form.gasType = equipment.data.gasType;
                    _this3.form.shippingDate = new Date(equipment.data.shippingDate);
                    _this3.form.warrantyStart = new Date(equipment.data.warrantyStart);
                    _this3.form.warrantyEnd = new Date(equipment.data.warrantyEnd);
                    _this3.form.installationDate = equipment.data.installationDate ? new Date(equipment.data.installationDate) : "";
                    _this3.serialPrefix = equipment.data.serialPrefix;
                    _this3.loading = false;
                });
            } else {
                this.updateMode = false;
            }
        },
        closeDialog: function closeDialog() {
            this.$refs["form"].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit("dialogClosed");
        },
        save: function save(copyFlag) {
            var _this4 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this4.loading = true;
                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].saveEquipment(_this4.equipmentId, _this4.form).then(function () {
                        _this4.$emit("save");
                        _this4.$notify({
                            title: _this4.$t('common.success'),
                            message: _this4.$t('common.equipmentSuccessfullySaved'),
                            type: "success"
                        });
                        if (!copyFlag) {
                            _this4.closeDialog();
                        } else {
                            _this4.form.productId = undefined, _this4.form.serialNumber = "", _this4.loading = false;
                        }
                    }).catch(function (err) {
                        if (err.response.status == 400) {
                            _this4.form.serialNumber = '';
                            _this4.$notify({
                                title: "Error",
                                message: _this4.$t('common.duplicateSerialNumber'),
                                type: "error"
                            });
                        } else {
                            _this4.form.customerId = '';
                            _this4.form.productId = '';
                            _this4.$notify({
                                title: "Error",
                                message: _this4.$t('common.customerOrProductIsNotExists'),
                                type: "error"
                            });
                        }
                        _this4.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        createCustomer: function createCustomer() {
            __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__["a" /* EventBus */].$emit("createCustomer");
        },
        disabledInstallationDate: function disabledInstallationDate(time) {
            var shippingDatePlus8 = new Date(this.form.shippingDate);
            shippingDatePlus8.setDate(shippingDatePlus8.getDate() + 8 * 7);
            return time.getTime() < this.form.shippingDate || time.getTime() > shippingDatePlus8;
        }
    }
});

/***/ }),

/***/ "VVmc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VXsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getComplaints: function getComplaints(equipmentId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/equipment/' + equipmentId + '/complaints');
    }
});

/***/ }),

/***/ "VoBc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vv/e":
/***/ (function(module, exports) {

module.exports = {"claims":"Claims","searchForClaimByNumber":"Search for claim by number","date":"Date","operations":"Operations","view":"View","serviceTickets":"Service Tickets","CostcoServiceRequests":"Costco Service Requests","searchServiceTicketByNumberOrCustomer":"Search service ticket by number or customer","searchForPartByNumberOrServiceCompanyName":"Search for part by number or service company name","activeOrders":"Active Orders","salesOrder":"Sales Order","purchaseOrderNumber":"Purchase Order Number","shipping":"Shipping","searchForRMAByNumber":"Search for RMA by number","rmaRequestor":"RMA Requestor","claimNum":"Claim #"}

/***/ }),

/***/ "Vxr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[(_vm.$isAdmin)?_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.serialNumber')},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.equipmentList},on:{"sort-change":_vm.sortEquipment}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.customerAddressColon')))]),_vm._v("\n                    "+_vm._s(props.row.customerAddress)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.customerPhoneColon')))]),_vm._v("\n                    "+_vm._s(props.row.customerPhone)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.gasTypeColon')))]),_vm._v("\n                    "+_vm._s(props.row.gasType)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.serviceCompanyColon')))]),_vm._v("\n                    "+_vm._s(props.row.serviceCompany)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.serviceCompanyEmailColon')))]),_vm._v("\n                    "+_vm._s(props.row.serviceCompanyEmail)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.serviceCompanyServiceEmailColon')))]),_vm._v("\n                    "+_vm._s(props.row.serviceCompanyServiceEmail)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.serviceCompanyPartsEmailColon')))]),_vm._v("\n                    "+_vm._s(props.row.serviceCompanyPartsEmail)+"\n                ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.$t('equipments.serviceCompanyPhoneColon')))]),_vm._v("\n                    "+_vm._s(props.row.serviceCompanyPhone)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"model","label":_vm.$t('common.model')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":_vm.$t('equipments.serial'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"shippingDate","label":_vm.$t('equipments.shippingDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("date")(scope.row.shippingDate))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyStart","label":_vm.$t('common.warrantyStart'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("date")(scope.row.warrantyStart))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyEnd","label":_vm.$t('common.warrantyEnd'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("date")(scope.row.warrantyEnd))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":_vm.$t('common.customer'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompany","label":_vm.$t('common.serviceCompany'),"sortable":"custom"}}),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteEquipment(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])}):_vm._e()],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W09U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_masters_customers_components__ = __webpack_require__("AKRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "claim-history-report",
    components: {
        ChainSelector: __WEBPACK_IMPORTED_MODULE_1__app_masters_customers_components__["a" /* ChainSelector */],
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        ServiceCoverageSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["o" /* ServiceCoverageSelector */],
        ResolutionCategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["m" /* ResolutionCategorySelector */],
        RepairCodeSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["l" /* RepairCodeSelector */]
    },
    data: function data() {
        return {
            form: {
                fields: [],
                categoryId: null,
                codeId: null
            },
            loading: false
        };
    },

    watch: {
        "form.productId": function formProductId() {
            this.form.categoryId = null;
        },
        "form.categoryId": function formCategoryId() {
            this.form.codeId = null;
        }
    },
    methods: {
        generateReport: function generateReport() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].downloadClaimReport(this.form).then(function (response) {
                _this.loading = false;
                var blob = response.data;
                var fileName = response.headers["content-disposition"].split(";")[1].split("=")[1];
                fileName = fileName.replace(/"/g, '');
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", fileName);

                    // Safari thinks _blank anchor are pop ups. We only want to set _blank
                    // target if the browser does not support the HTML5 download attribute.
                    // This allows you to download files in desktop safari if pop up blocking
                    // is enabled.
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
            });
        },
        selectAll: function selectAll() {
            if (this.form.fields.length === 46) {
                this.form.fields = [];
            } else {
                for (var i = 1; i <= 46; i++) {
                    this.form.fields.push(i + "");
                }
            }
        }
    }
});

/***/ }),

/***/ "W2s3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanadianTaxList__ = __webpack_require__("1AEj");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CanadianTaxList__["a"]; });


/***/ }),

/***/ "WiWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getClaims: function getClaims(page) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/claims', {
            params: {
                page: page
            }
        });
    },
    getClaimsForSearch: function getClaimsForSearch(text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/claims', {
            params: {
                q: text
            }
        });
    },
    getPartsForSearch: function getPartsForSearch(text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/orders/search', {
            params: {
                partOrderNumber: text
            }
        });
    },
    getServiceTicketsForSearch: function getServiceTicketsForSearch(text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/servicetickets/search', {
            params: {
                serviceTicketName: text
            }
        });
    },
    getOrders: function getOrders(page) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/orders', {
            params: {
                page: page
            }
        });
    },
    getClaimsCategories: function getClaimsCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/claims');
    },
    getServiceTicketsCategories: function getServiceTicketsCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/servicetickets');
    },
    getPartOrdersCategories: function getPartOrdersCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/partorders');
    },
    deleteClaim: function deleteClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/claims/' + id);
    },
    getRMAs: function getRMAs(page) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/rmas', {
            params: {
                page: page
            }
        });
    },
    getRMAsForSearch: function getRMAsForSearch(text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/rmas/search', {
            params: {
                rmaNumber: text
            }
        });
    },
    deleteRMA: function deleteRMA(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/rmas/' + id);
    }
});

/***/ }),

/***/ "WrkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/canadiantaxes/export');
    },
    getTaxes: function getTaxes() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/canadiantaxes');
    },
    updateTaxForState: function updateTaxForState(stateId, value) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/canadiantaxes/' + stateId, value);
    }
});

/***/ }),

/***/ "WwkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttnSelector_vue__ = __webpack_require__("KR1a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fc794f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttnSelector_vue__ = __webpack_require__("TW/N");
function injectStyle (ssrContext) {
  __webpack_require__("3MN1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55fc794f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttnSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55fc794f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttnSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XAVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingMethodSelector_vue__ = __webpack_require__("0HqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6775cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingMethodSelector_vue__ = __webpack_require__("le7S");
function injectStyle (ssrContext) {
  __webpack_require__("zcLs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c6775cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShippingMethodSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c6775cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShippingMethodSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XExK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{attrs:{"size":"mini"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.raiseOnDate'),"prop":"dateFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateFrom),callback:function ($$v) {_vm.$set(_vm.form, "dateFrom", $$v)},expression:"form.dateFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.customer'),"prop":"custNumber"}},[_c('el-input',{model:{value:(_vm.form.custNumber),callback:function ($$v) {_vm.$set(_vm.form, "custNumber", $$v)},expression:"form.custNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"$t('serviceTickets.ticketNumber')","prop":"ticketNumber"}},[_c('el-input',{model:{value:(_vm.form.ticketNumber),callback:function ($$v) {_vm.$set(_vm.form, "ticketNumber", $$v)},expression:"form.ticketNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.symptoms'),"prop":"complaint"}},[_c('el-input',{model:{value:(_vm.form.complaint),callback:function ($$v) {_vm.$set(_vm.form, "complaint", $$v)},expression:"form.complaint"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.toRaisedDate'),"prop":"dateTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateTo),callback:function ($$v) {_vm.$set(_vm.form, "dateTo", $$v)},expression:"form.dateTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceCompany'),"prop":"serviceCompany"}},[_c('el-input',{model:{value:(_vm.form.serviceCompany),callback:function ($$v) {_vm.$set(_vm.form, "serviceCompany", $$v)},expression:"form.serviceCompany"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('reports.state'),"prop":"state"}},[_c('el-input',{model:{value:(_vm.form.state),callback:function ($$v) {_vm.$set(_vm.form, "state", $$v)},expression:"form.state"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.status'),"prop":"status"}},[_c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"label":_vm.$t('common.opened'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.closed'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.flagged'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.flaggedClosed'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.escalation'),"value":"5"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.escalationClosed'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.postInstallInstall'),"value":"7"}})],1)],1)],1)],1),_vm._v(" "),_c('el-checkbox-group',{ref:"group",staticClass:"fields",model:{value:(_vm.form.fields),callback:function ($$v) {_vm.$set(_vm.form, "fields", $$v)},expression:"form.fields"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.ticketNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.openedBy')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"3"}},[_vm._v(_vm._s(_vm.$t('common.customer')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"4"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.raisedOn')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"5"}},[_vm._v(_vm._s(_vm.$t('reports.serialNumber')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"6"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.symptoms')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"7"}},[_vm._v(_vm._s(_vm.$t('common.status')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"8"}},[_vm._v(_vm._s(_vm.$t('common.serviceCompany')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"9"}},[_vm._v(_vm._s(_vm.$t('reports.serviceCompanyPhoneNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"10"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.confirmation')))])],1)],1)],1),_vm._v(" "),_c('el-button',{on:{"click":_vm.selectAll}},[_vm._v(_vm._s(_vm.$t('common.deSelectAll')))]),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.generateReport}},[_vm._v(_vm._s(_vm.$t('common.generate')))]),_vm._v(" "),(this.form.fields.length == 0)?_c('p',{ref:"labelInfo",staticClass:"labelInfo"},[_vm._v(_vm._s(_vm.$t('reports.pleaseSelectatLeastOneColumn')))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"labelInfo"},[_vm._v(_vm._s(_vm.$t('reports.noDatesChoosenMessage')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XKyj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":18}},[_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.part')},model:{value:(_vm.filter.part),callback:function ($$v) {_vm.$set(_vm.filter, "part", $$v)},expression:"filter.part"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tablewithshading",attrs:{"size":"mini","data":_vm.parts}},[_c('el-table-column',{attrs:{"prop":"partNo","label":_vm.$t('common.number'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.listPrice'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.price))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.extendedPrice'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n            ")]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XOLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("akY4");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'product-selector',
    props: ['value', 'disabled'],
    data: function data() {
        return {
            loading: false,
            products: []
        };
    },

    methods: {
        change: function change(val) {
            this.$emit('input', val);

            var targetSerial = val ? this.products.find(function (p) {
                return p.id === val;
            }).serialPrefix : undefined;
            this.$emit('serialUpdate', targetSerial);
        }
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getProducts().then(function (response) {
            _this.loading = false;
            _this.products = response.data;
        });
    }
});

/***/ }),

/***/ "XQmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateCustomerDialog_vue__ = __webpack_require__("nnwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773fc8dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateCustomerDialog_vue__ = __webpack_require__("gdxB");
function injectStyle (ssrContext) {
  __webpack_require__("nRd/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateCustomerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_773fc8dd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateCustomerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XUke":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XXsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getParts: function getParts(term, serviceCompanyId) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/lookup', {
            params: {
                term: term,
                serviceCompanyId: serviceCompanyId,
                unavailableForPartsOrders: true
            }
        });
    }
});

/***/ }),

/***/ "XZ6V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.$t('serviceTickets.sendAsEmail'),"width":"40%","visible":_vm.showDialog,"loadingChangeEmail":"loadingChangeEmail","formChangeEmail":"formChangeEmail","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('el-dialog',{attrs:{"visible":_vm.showChangeEmailDialog,"width":"40%","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showChangeEmailDialog=$event}}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingChangeEmail),expression:"loadingChangeEmail"}],ref:"formChangeEmail",attrs:{"model":_vm.formChangeEmail,"rules":_vm.rulesChangeEmail,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.serviceCompany'),"prop":"serviceCompany"}},[_c('el-input',{attrs:{"disabled":!_vm.formChangeEmail.useCustom},model:{value:(_vm.formChangeEmail.serviceCompany),callback:function ($$v) {_vm.$set(_vm.formChangeEmail, "serviceCompany", $$v)},expression:"formChangeEmail.serviceCompany"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.phone'),"prop":"phone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],attrs:{"disabled":!_vm.formChangeEmail.useCustom},model:{value:(_vm.formChangeEmail.phone),callback:function ($$v) {_vm.$set(_vm.formChangeEmail, "phone", $$v)},expression:"formChangeEmail.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.email'),"prop":"email"}},[_c('el-input',{attrs:{"disabled":!_vm.formChangeEmail.useCustom},model:{value:(_vm.formChangeEmail.email),callback:function ($$v) {_vm.$set(_vm.formChangeEmail, "email", $$v)},expression:"formChangeEmail.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.useCustom'),"prop":"useCustom"}},[_c('el-switch',{model:{value:(_vm.formChangeEmail.useCustom),callback:function ($$v) {_vm.$set(_vm.formChangeEmail, "useCustom", $$v)},expression:"formChangeEmail.useCustom"}})],1),_vm._v(" "),_c('el-button',{key:_vm.buttonkey,attrs:{"disabled":_vm.loadingChangeEmail,"type":"primary"},on:{"~click":function($event){_vm.save(true)}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.send')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loadingChangeEmail},on:{"click":function($event){_vm.showChangeEmailDialog = false}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.cancel')))])],1)],1),_vm._v(" "),_c('el-button',{key:_vm.buttonkey,attrs:{"type":"primary"},on:{"click":function($event){_vm.showChangeEmailDialog = true}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.yesSaveSend')))]),_vm._v(" "),_c('el-button',{key:_vm.buttonkey,on:{"~click":function($event){_vm.save(false)}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.noSaveClose')))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xrf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.codeId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('masters.resolutionCode'),"visible":_vm.showDialog,"width":"500px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadCode,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.category'),"prop":"categoryId"}},[_c('resolution-category-selector',{attrs:{"productId":_vm.form.productId},model:{value:(_vm.form.categoryId),callback:function ($$v) {_vm.$set(_vm.form, "categoryId", $$v)},expression:"form.categoryId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.code'),"prop":"code"}},[_c('el-input',{model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.description'),"prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.labor'),"prop":"labor"}},[_c('el-input',{model:{value:(_vm.form.labor),callback:function ($$v) {_vm.$set(_vm.form, "labor", _vm._n($$v))},expression:"form.labor"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.maxTime'),"prop":"maxTime"}},[_c('el-input',{model:{value:(_vm.form.maxTime),callback:function ($$v) {_vm.$set(_vm.form, "maxTime", _vm._n($$v))},expression:"form.maxTime"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.codeId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xxyi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xy8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("sXP7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-part-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        partId: {
            required: false
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        ShippingMethodSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["q" /* ShippingMethodSelector */]
    },
    data: function data() {
        var _this = this;

        return {
            form: {
                productId: undefined,
                no: '',
                description: '',
                descriptionFr: '',
                needsReturn: false,
                extendedPriceRate: 1,
                usListPrice: undefined,
                cdnListPrice: undefined,
                unavailableForClaims: false,
                unavailableForPartsOrders: false,
                isAuthRequired: false,
                shippingMethod: undefined,
                countryOfOrigin: ''
            },
            rules: {
                productId: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectProduct'),
                    trigger: 'change'
                }],
                shippingMethod: [{
                    required: true,
                    message: this.$t('shared.pleaseSelectShippingMethod'),
                    trigger: "change"
                }],
                otherCompany: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.form.shippingMethod === "0" && !value) {
                            // other company
                            return callback(new Error(_this.$t('common.pleaseEnterShippingCompanyName')));
                        } else {
                            return callback();
                        }
                    },
                    trigger: "blur"
                }],
                no: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPart'),
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPartDescription'),
                    trigger: 'blur'
                }],
                descriptionFr: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPartDescription'),
                    trigger: 'blur'
                }],
                extendedPriceRate: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectPriceRate'),
                    trigger: 'change'
                }],
                usListPrice: [{
                    required: true,
                    message: this.$t('common.pleaseEnterUSListPrice')
                }],
                cdnListPrice: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCDNListPrice')
                }]
            },
            loading: false,
            showDialog: this.visible,
            showDeactivateComment: false
        };
    },

    computed: {
        priceMultiplier: function priceMultiplier() {
            return this.form.extendedPriceRate === 2 ? 0.5 : 0.65;
        },
        usExtendedPrice: function usExtendedPrice() {
            return this.form.usListPrice * this.priceMultiplier;
        },
        usNonWarrantyPrice: function usNonWarrantyPrice() {
            return this.form.usListPrice * 0.75; // taken from old system
        },
        cdnExtendedPrice: function cdnExtendedPrice() {
            return this.form.cdnListPrice * this.priceMultiplier;
        },
        cdnNonWarrantyPrice: function cdnNonWarrantyPrice() {
            return this.form.cdnListPrice * 0.75; // taken from old system
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadPart: function loadPart() {
            var _this2 = this;

            if (this.partId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getPart(this.partId).then(function (response) {
                    _this2.loading = false;
                    _this2.form.no = response.data.no;
                    _this2.form.productId = response.data.productId;
                    _this2.form.description = response.data.description;
                    _this2.form.descriptionFr = response.data.descriptionFr;
                    _this2.form.needsReturn = response.data.needsReturn;
                    _this2.form.extendedPriceRate = response.data.extendedPriceRate;
                    _this2.form.usListPrice = response.data.usPrice.listPrice;
                    _this2.form.cdnListPrice = response.data.cdnPrice.listPrice;
                    _this2.form.unavailableForPartsOrders = response.data.unavailableForPartsOrders;
                    _this2.form.unavailableForClaims = response.data.unavailableForClaims;
                    _this2.form.deactivateComment = response.data.deactivateComment;
                    _this2.showDeactivateComment = _this2.form.unavailableForClaims || _this2.form.unavailableForPartsOrders;
                    _this2.form.isAuthRequired = response.data.isAuthRequired;
                    _this2.form.shippingMethod = response.data.shippingMethod;
                    _this2.form.countryOfOrigin = response.data.countryOfOrigin;
                });
            }
        },
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        save: function save() {
            var _this3 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this3.loading = true;
                    _this3.form.shippingMethod = _this3.form.shippingMethod == '5' ? 'Other Company' : _this3.form.shippingMethod == '0' ? 'Express' : _this3.form.shippingMethod == '1' ? 'Express SAT' : _this3.form.shippingMethod == '4' ? 'Standard' : 'Not selected';
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].savePart(_this3.partId, _this3.form).then(function (response) {
                        _this3.$emit('save', {
                            new: _this3.partId === undefined,
                            id: _this3.partId,
                            data: _this3.form
                        });
                        _this3.closeDialog();
                    });
                } else {
                    return false;
                }
            });
        },
        deactivate: function deactivate() {
            this.showDeactivateComment = this.form.unavailableForClaims || this.form.unavailableForPartsOrders;
        }
    }
});

/***/ }),

/***/ "Y2Rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateComplaintCodeDialog__ = __webpack_require__("xMBn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("xaXQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "complaint-code-list",
    components: {
        CreateUpdateComplaintCodeDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateComplaintCodeDialog__["a" /* default */],
        ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */],
        PartSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["j" /* PartSelector */]
    },
    data: function data() {
        return {
            codes: [],
            loading: true,
            dialogVisible: false,
            codeToEdit: null,
            filter: {
                productId: undefined,
                text: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadCodes();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadCodes();
            }
        }
    },
    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].download(this.filter);
        },
        loadCodes: function loadCodes() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCodes(this.currentPage, this.filter.productId, this.filter.text).then(function (response) {
                _this.loading = false;
                _this.codes = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendCode: function appendCode(event) {
            if (event.new) {
                this.codes.push(event.data);
                this.total += 1;
            } else {
                var toUpdateIndex = this.codes.findIndex(function (x) {
                    return x.id == event.id;
                });
                if (toUpdateIndex >= 0) {
                    Object.assign(this.codes[toUpdateIndex], event.data);
                }
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadCodes();
        },
        editCode: function editCode(id) {
            this.codeToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.codeToEdit = null;
            this.dialogVisible = false;
        },
        deleteCode: function deleteCode(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteCodeContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteCode(id).then(function () {
                    _this2.loadCodes();
                    _this2.$message({
                        type: "success",
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        }
    }
});

/***/ }),

/***/ "YFZB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YGYR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YN2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("h88m");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/emails',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* EmailsList */],
    name: 'emailList',
    meta: { admin: true }
}]);

/***/ }),

/***/ "YZek":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/* harmony default export */ __webpack_exports__["a"] = ({
    getRMAs: function getRMAs(page, sorting, filter) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/dashboard/rmas', {
            params: {
                page: page,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder
            }
        });
    },
    getRmaList: function getRmaList(page, text, sorting) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/table', {
            params: {
                page: page,
                rmaNumber: text,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder
            }
        });
    },
    deleteRma: function deleteRma(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/api/rma/' + id);
    },
    getRma: function getRma(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/' + id);
    },
    getRmaNumber: function getRmaNumber() {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/getRmaNumber');
    },
    printRma: function printRma(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/' + id + '/print');
    },
    saveRma: function saveRma(form) {
        var data = {
            attnId: form.attn,
            serviceTicket: _extends({}, form.serviceTicket, { rmaId: form.rmaNumber, raisedOn: form.serviceTicket.raisedOn }),
            serviceCompany: _extends({}, form.serviceCompany),
            serviceTicketId: form.serviceTicketId,
            serviceCompanyId: form.serviceCompanyId,
            claimId: form.claimId,
            shippingMethod: form.shippingMethod,
            countryOfOrigin: form.countryOfOrigin,
            serviceTicketNumber: form.serviceTicketNumber,
            invoiceNumber: form.invoiceNumber,
            claimNumber: form.claimNumber,
            id: form.rmaNumber,
            attns: [],
            claimStatus: form.claimStatus,
            rmaDate: form.rmaDate,
            customer: form.selectedCustomer,
            status: form.status,
            trackingNumber: form.trackingNumber,
            comment: form.comment,
            reason: form.reason
        };

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/rma/saveRma', data);
    },
    getTrackingInfo: function getTrackingInfo(trackNumber) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var result;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/rma/getTrackingInfo', { trackNumber: trackNumber });

                        case 2:
                            result = _context.sent;
                            return _context.abrupt('return', result);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    }
});

/***/ }),

/***/ "YoMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ysa+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"router":true}},[_c('el-select',{staticClass:"language-select",attrs:{"placeholder":_vm.$t('shared.selectLanguage'),"size":"small"},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}},[_c('el-option',{staticClass:"language-select",attrs:{"label":_vm.$t('shared.english'),"value":"en"}},[_c('span',[_vm._v(_vm._s(_vm.$t('shared.english')))])]),_vm._v(" "),_c('el-option',{staticClass:"language-select",attrs:{"label":_vm.$t('shared.french'),"value":"fr"}},[_c('span',[_vm._v(_vm._s(_vm.$t('shared.french')))])])],1),_vm._v(" "),_c('li',{staticClass:"action-button",staticStyle:{"text-align":"center"}},[_c('small',[_vm._v(_vm._s(_vm.$t('shared.loggedIn'))+_vm._s(_vm.$currentUser.profile.name))]),_vm._v(" "),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.changePassword}},[_vm._v(_vm._s(_vm.$t('shared.changePassword')))]),_vm._v(" "),(!_vm.$isImpersonateUser)?_c('el-button',{staticStyle:{"margin-left":"0"},attrs:{"type":"text"},on:{"click":_vm.signout}},[_vm._v(_vm._s(_vm.$t('shared.logout')))]):_vm._e(),_vm._v(" "),(_vm.$isImpersonateUser)?_c('el-button',{staticStyle:{"margin-left":"0"},attrs:{"type":"text"},on:{"click":_vm.returnToAdminAccount}},[_vm._v(_vm._s(_vm.$t('shared.returnToMyAccount')))]):_vm._e()],1),_vm._v(" "),(_vm.$isUser || _vm.$isSubAgentUser)?_c('li',{staticClass:"action-button"},[_c('el-button',{staticStyle:{"overflow":"hidden"},on:{"click":function($event){_vm.$emit('place-order')}}},[_vm._v(_vm._s(_vm.$t('shared.orderParts')))])],1):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('li',{staticClass:"action-button"},[_c('el-button',{staticStyle:{"overflow":"hidden"},on:{"click":function($event){_vm.$emit('new-claim')}}},[_vm._v(_vm._s(_vm.$t('shared.newClaim')))])],1):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('div',{style:({ display: 'flex', justifyContent: 'center', border: _vm.store.state.count > 0 ? '5px solid red' : 'none' })},[_c('p',{style:({ color: _vm.store.state.count > 0 ? 'red' : 'black' })},[_vm._v("Costco Service Requests: "+_vm._s(_vm.store.state.count))])]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin)?_c('li',{staticClass:"action-button"},[_c('el-button',{staticStyle:{"overflow":"hidden"},on:{"click":function($event){_vm.$emit('new-service-ticket')}}},[_vm._v(_vm._s(_vm.$t('shared.newServiceTicket')))])],1):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin)?_c('li',{staticClass:"action-button"},[_c('el-button',{staticStyle:{"overflow":"hidden"},on:{"click":function($event){_vm.$emit('register-equipment')}}},[_vm._v(_vm._s(_vm.$t('shared.registerEquipment')))])],1):_vm._e(),_vm._v(" "),_c('el-menu-item',{class:{'is-active': _vm.isDashboard},attrs:{"index":"/","id":"dashboard-special"}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shared.dashboard')))])]),_vm._v(" "),(!_vm.$isSubAgentUser)?_c('el-menu-item',{class:{'is-active': _vm.isClaims},attrs:{"index":"/claims"}},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.claims')))])]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-menu-item',{class:{'is-active': _vm.isClaimsFAQ},attrs:{"index":"/FAQ"}},[_c('i',{staticClass:"el-icon-question"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shared.claimsFAQ')))])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{class:{'is-active': _vm.isRma},attrs:{"index":"/rma"}},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('claims.rma')))])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/accounting"}},[_c('i',{staticClass:"el-icon-view"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.accounting')))])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{class:{'is-active': _vm.isServiceTickets},attrs:{"index":"/service-tickets"}},[_c('i',{staticClass:"el-icon-service"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.serviceTickets')))])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{class:{'is-active': _vm.isEscalationTickets},attrs:{"index":"/escalation-tickets"},on:{"click":function($event){_vm.openInNewTab('/#/escalation-tickets')}}},[_c('i',{staticClass:"el-icon-service"}),_vm._v(" "),_c('span',[_vm._v("Escalation Report")])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/emails"}},[_c('i',{staticClass:"el-icon-message"}),_vm._v(" "),_c('span',[_vm._v("Emailed Service Tickets")])]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{class:{'is-active': _vm.isCostcoServiceRequests},attrs:{"index":"/costco-service-requests"}},[_c('i',{staticClass:"el-icon-service"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('dashboard.CostcoServiceRequests'))+" ("+_vm._s(_vm.store.state.count)+")")])]):_vm._e(),_vm._v(" "),_c('el-menu-item',{class:{'is-active': _vm.isPartOrders},attrs:{"index":"/part-orders"}},[_c('i',{staticClass:"el-icon-goods"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.partOrders')))])]),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/equipment"}},[_c('i',{staticClass:"el-icon-location"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('common.equipment')))])]):_vm._e(),_vm._v(" "),_c('el-submenu',{attrs:{"index":"/reports"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-view"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shared.reports')))])]),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/reports/costco"}},[_vm._v("Costco")]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/reports/claims"}},[_vm._v(_vm._s(_vm.$t('shared.claimHistory')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/reports/servicetickets"}},[_vm._v(_vm._s(_vm.$t('dashboard.serviceTickets')))]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-menu-item',{attrs:{"index":"/reports/parts"}},[_vm._v(_vm._s(_vm.$t('shared.priceList')))]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-menu-item',{attrs:{"index":"/reports/resolutioncodes"}},[_vm._v(_vm._s(_vm.$t('shared.resolutionCodes')))]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-menu-item',{attrs:{"index":"/reports/usedparts"}},[_vm._v(_vm._s(_vm.$t('shared.usedParts')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{class:{'is-active': _vm.isRmaReport},attrs:{"index":"/reports/rma"}},[_vm._v("R&D RMAs")]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-menu-item',{attrs:{"index":"/reports/simsApReport"}},[_vm._v(_vm._s(_vm.$t('shared.simsAPReport')))]):_vm._e()],2),_vm._v(" "),(_vm.$isAdmin)?_c('el-submenu',{attrs:{"index":"/masters/customers"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-setting"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shared.masterData')))])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/customers"}},[_vm._v(_vm._s(_vm.$t('shared.customers')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/customersnotifications"}},[_vm._v(_vm._s(_vm.$t('shared.customersNotifications')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/customer-chains"}},[_vm._v(_vm._s(_vm.$t('shared.customerChains')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/service-companies"}},[_vm._v(_vm._s(_vm.$t('shared.serviceCompanies')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/products"}},[_vm._v(_vm._s(_vm.$t('shared.products')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/parts"}},[_vm._v(_vm._s(_vm.$t('common.parts')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/resolution-codes"}},[_vm._v(_vm._s(_vm.$t('shared.resolutionCodes')))]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-menu-item',{attrs:{"index":"/masters/resolution-code-categories"}},[_vm._v(_vm._s(_vm.$t('shared.resolutionCodeCategories')))]):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/complaint-codes"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.symptomCodes')))]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/masters/canadian-taxes"}},[_vm._v(_vm._s(_vm.$t('shared.canadianTaxes')))]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-menu-item',{attrs:{"index":"/masters/users"}},[_vm._v(_vm._s(_vm.$t('shared.users')))]):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"padding-left":"20px","padding-top":"10px","display":"flex","align-items":"center"}},[_c('el-switch',{on:{"change":_vm.updateGmailConfiguration},model:{value:(_vm.isGmailActive),callback:function ($$v) {_vm.isGmailActive=$$v},expression:"isGmailActive"}}),_vm._v(" "),_c('p',{staticStyle:{"margin-left":"10px"}},[_vm._v("Gmail Email Delivery")])],1),_vm._v(" "),_c('change-password-dialog',{attrs:{"visible":_vm.passwordChangeVisible},on:{"dialogClosed":function($event){_vm.passwordChangeVisible = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z2aN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("VO/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emailDetailsDialog__ = __webpack_require__("Lo50");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "email-list",
    components: {
        EmailDetailsDialog: __WEBPACK_IMPORTED_MODULE_2__emailDetailsDialog__["a" /* default */]
    },
    data: function data() {
        return {
            options: [{ value: 0, label: 'Sent' }, { value: 1, label: 'Failed' }, { value: 2, label: 'Confirmed' }, { value: 3, label: 'Saved' }],
            selfServiceoptions: [{ value: 1, label: 'Yes' }, { value: 0, label: 'No' }],
            emails: [],
            ticketIdToShow: null,
            subject: "",
            body: "",
            emailDetailsVisible: false,
            loading: true,
            dialogVisible: false,
            filter: {
                ticketId: "",
                email: "",
                emailStatus: "",
                selfService: ""
            },
            sort: {},
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadEmails();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadEmails();
            }
        }
    },
    methods: {
        emailStatusFilter: function emailStatusFilter(val) {
            if (val.length > 0) this.filter.emailStatus = val[0];else this.filter.emailStatus = null;
            this.loadEmails();
        },
        selfServiceFilter: function selfServiceFilter(val) {
            if (val.length > 0) this.filter.selfService = val[0];else this.filter.selfService = null;
            this.loadEmails();
        },
        emailDetailsVisibleMethod: function emailDetailsVisibleMethod(val) {
            console.log(val);
            this.ticketIdToShow = val.serviceTicketId;
            this.subject = val.subject;
            this.body = val.body;
            this.emailDetailsVisible = true;
            console.log(this.emailDetailsVisible);
        },
        emailDetailsFinished: function emailDetailsFinished() {
            this.ticketIdToShow = null;
            this.emailDetailsVisible = false;
            this.subject = "";
            this.body = "";
        },
        sortChanged: function sortChanged(sort) {
            this.sort = sort;
            if (this.currentPage === 1) {
                this.loadCustomers();
            } else {
                this.currentPage = 1;
            }
        },
        loadEmails: function loadEmails() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getEmails(this.currentPage, this.filter, this.sort).then(function (response) {
                _this.loading = false;
                _this.emails = response.data.items;
                _this.total = response.data.total;
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadEmails();
        },
        resend: function resend(id) {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].resend(id).then(function (response) {
                _this2.loading = false;
                if (response.data) {
                    _this2.$message({
                        title: _this2.$t('common.success'),
                        message: "Email sent",
                        type: "success"
                    });
                } else {
                    _this2.$message.error("Failed to sent Email");
                }
            });
        }
    }
});

/***/ }),

/***/ "Z7Se":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdatePartDialog_vue__ = __webpack_require__("Xy8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15681528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdatePartDialog_vue__ = __webpack_require__("sEg5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdatePartDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15681528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdatePartDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZA9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-tickets-report",
    components: {},

    data: function data() {
        return {
            form: {
                fields: []
            },
            loading: false
        };
    },


    methods: {
        generateReport: function generateReport() {
            var _this = this;

            if (this.form.fields.length == 0) {
                this.$refs["labelInfo"].focus();
                return;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadServiceTicketsReport(this.form).then(function (response) {
                _this.loading = false;
                var blob = response.data;
                var fileName = response.headers["content-disposition"].split(";")[1].split("=")[1];
                fileName = fileName.replace(/"/g, '');
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", fileName);

                    // Safari thinks _blank anchor are pop ups. We only want to set _blank
                    // target if the browser does not support the HTML5 download attribute.
                    // This allows you to download files in desktop safari if pop up blocking
                    // is enabled.
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
            });
        },
        selectAll: function selectAll() {
            if (this.form.fields.length === 10) {
                this.form.fields = [];
            } else {
                for (var i = 1; i <= 10; i++) {
                    this.form.fields.push(i + "");
                }
            }
        }
    }
});

/***/ }),

/***/ "ZAFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.products}},[_c('el-table-column',{attrs:{"prop":"no","label":_vm.$t('common.number'),"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"model","label":_vm.$t('masters.type')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('common.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 160 : 116 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editProduct(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isFullAdmin && _vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteProduct(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-product-dialog',{attrs:{"productId":_vm.productToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendProduct}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZPea":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("N/Ej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "address-selector",
    props: {
        value: Object,
        showRegional: {
            type: Boolean,
            default: false
        },
        showAsPreview: {
            type: Boolean,
            default: false
        },
        disable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value: {
            deep: true,
            handler: function handler(val) {
                this.$emit("input", val);
            }
        }
    },
    data: function data() {
        return {
            countriesWithStates: []
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCountries().then(function (response) {
            _this.countriesWithStates = response.data;
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__["a" /* EventBus */].$on("countryCreated", function (id) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCountries().then(function (response) {
                _this2.countriesWithStates = response.data;
            });
        });
    },

    computed: {
        selectedCountryState: function selectedCountryState() {
            var _this3 = this;

            var result = "";
            if (this.value && this.value.selectedCountryState && this.value.selectedCountryState[0]) {
                this.countriesWithStates.forEach(function (x) {
                    if (x.value === _this3.value.selectedCountryState[0]) {
                        result = x.label;
                        if (_this3.value.selectedCountryState[1]) {
                            x.children.forEach(function (c) {
                                if (c.value === _this3.value.selectedCountryState[1]) {
                                    result = result + " / " + c.label;
                                }
                            });
                        }
                    }
                });
            }
            return result;
        }
    }
});

/***/ }),

/***/ "ZQmh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateProductDialog__ = __webpack_require__("oznG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("p4R0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'product-list',
    components: {
        CreateUpdateProductDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateProductDialog__["a" /* default */]
    },
    data: function data() {
        return {
            products: [],
            loading: true,
            dialogVisible: false,
            productToEdit: null,
            filter: {
                text: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadProducts();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadProducts();
            }
        }
    },
    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].download(this.filter);
        },
        loadProducts: function loadProducts() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getProducts(this.currentPage, this.filter.text).then(function (response) {
                _this.loading = false;
                _this.products = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendProduct: function appendProduct(event) {
            if (event.new) {
                this.products.push(event.data);
                this.total += 1;
            } else {
                this.loadProducts();
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadProducts();
        },
        editProduct: function editProduct(id) {
            this.productToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.productToEdit = null;
            this.dialogVisible = false;
        },
        deleteProduct: function deleteProduct(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteProductContinue'), 'Warning', {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteProduct(id).then(function () {
                    _this2.loadProducts();
                    _this2.$message({
                        type: 'success',
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        }
    }
});

/***/ }),

/***/ "ZcFj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("0cFl");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/service-companies',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ServiceCompanyList */],
  name: 'serviceCompanyList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "ZpMc":
/***/ (function(module, exports) {

module.exports = {"createdFrom":"Created from","acceptedDateFrom":"Accepted Date From","customerChain":"Customer Chain","createdTo":"Created to","acceptedDateTo":"Accepted Date To","modifiedStatus":"Modified Status","noDatesChoosenMessage":"If no dates are choosen the report will be generated default for a period of time one year to today!","createdOn":"Created On","workOrderNumber":"Work Order Number","dateCompleted":"Date Completed","claimReportSymptoms":"Claim report symptoms","repairDescription":"Repair Description","repairCategory":"Repair Category","laborTime":"Labor Time","laborCharge":"Labor Charge","travelTime":"Travel Time","travelCharge":"Travel Charge","truckCharge":"Truck Charge","partsCharge":"Parts Charge","handlingFee":"Handling Fee","dateProcessed":"Date Processed","originalHardtInvoice":"Original Hardt Invoice","freightCharge":"Freight Charge","salesTax":"Sales Tax","totalCharge":"Total Charge","customerAddress":"Customer Address","customerCity":"Customer City","customerProvince":"Customer Province","customerCountry":"Customer Country","customerZip":"Customer Zip","serviceCompanyProvince":"Service Company Province","serviceCompanyZip":"Service Company Zip","tripsNumber":"Trips Number","wasModified":"Was Modified","pleaseSelectType":"Please select type","parameters":"Parameters","dateFromAcceptedDate":"Date From (Accepted Date)","dateToAcceptedDate":"Date To (Accepted Date)","sortBy":"Sort By","customerNumber":"Customer Number","province":"Province","company":"Company","dateOfCompletion":"Date Of Completion","sortDescending":"Sort Descending","exportToExcel":"Export to Excel","claimCreationDate":"Claim Creation Date","dateOfCompletition":"Date of Completition","daysToInvoice":"Days to Invoice","customerNo":"Customer No","laborHours":"Labor Hours","travelTruckMileage":"Travel, Truck and Mileage","laborRegularHours":"Labor Regular Hours","laborRegularTotal":"Labor Regular Total","laborOvertimeHours":"Labor Overtime Hours","laborOvertimeTotal":"Labor Overtime Total","noDataFound":"No data found with this parameters. Please check parameters.","viewMore":"View more","edit":"Edit","claimsPerModel":"$ Claims per model","choosePeriod":"Choose period","chooseModel":"Choose model","from":"From","to":"To","attn":"Attn","rmaStatus":"Rma Status","countryOfOrigin":"Country Of Origin","authorizationNumber":"Authorization Number","modelNumber":"Model Number","pleaseSelectatLeastOneColumn":"Please select at least one column to generate the report!","raiseOnDate":"Raised On Date","toRaisedDate":"To Raisd Date","state":"State","serialNumber":"Serial #","serviceCompanyPhoneNumber":"Service Company Phone Number","claimDate":"Claim Date"}

/***/ }),

/***/ "Zu5x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("gFtL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "aA7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productselector__ = __webpack_require__("+kGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resolutioncategoryselector__ = __webpack_require__("/PYK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addressselector__ = __webpack_require__("glOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chainselector__ = __webpack_require__("6dq+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__partselector__ = __webpack_require__("xONh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__customerselector__ = __webpack_require__("7u+r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__countryselector__ = __webpack_require__("NSPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__equipmentselector__ = __webpack_require__("ojtX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__complaintcodeselector__ = __webpack_require__("kj/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__categoryselector__ = __webpack_require__("KRB6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__repaircodeselector__ = __webpack_require__("ajF+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__companyselector__ = __webpack_require__("1lX2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RoleSelector__ = __webpack_require__("l++A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AttnSelector__ = __webpack_require__("WwkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ChangePasswordDialog__ = __webpack_require__("QG3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ShippingMethodSelector__ = __webpack_require__("XAVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ServiceCoverageSelector__ = __webpack_require__("5avN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__serviceticketselector__ = __webpack_require__("VNfK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Navigation__ = __webpack_require__("pIAk");
/* unused harmony reexport Navigation */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__productselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__resolutioncategoryselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__addressselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__chainselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__RoleSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_15__ShippingMethodSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__partselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__customerselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__countryselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__equipmentselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__complaintcodeselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_9__categoryselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__ServiceCoverageSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__repaircodeselector__["a"]; });
/* unused harmony reexport ChangePasswordDialog */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__companyselector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__AttnSelector__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_17__serviceticketselector__["a"]; });






















/***/ }),

/***/ "aG6Z":
/***/ (function(module, exports) {

module.exports = {"claimNumber":"Numéro de réclamation","invoiceNumber":"Numéro de facture","serviceTicketNumber":"Billet de service","customerName":"Nom du client","customerPhone":"Téléphone du client","serialNumber":"Numéro de série","serviceCoverage":"Comptabilité","accounting":"Accounting","status":"Statut","new":"Nouveau","acceptAndProcess":"Accepter et traiter","moreinfoRequired":"Plus d'informations requises","rejected":"Rejeté","paid":"Payé","pendingReturnPart":"Retour de pièeces en attente","pendingRepairCodeCorrections":"Réclamations en attente de correction(s)","correctedRepairCodes":"Codes de réparation corrigés","customerZip":"Code postal du client","serviceCompany":"Compagnie de Service","partNumber":"Numéro d'article","model":"Modèle","category":"Catégorie","code":"Code","generate":"Générer","dateOfDispatch":"Date d'envoi","mileage":"Kilométrage","ProcessedBy":"Traité par","serviceCompanyName":"Nom de la société de services","technicianName":"Nom du technicien","deSelectAll":"(Tout déselectionner","customer":"Client","product":"Produit","acceptedDate":"Date d'acceptation","address":"Adresse","city":"Ville","region":"Région","regional":"Régional","workOrder":"Demande de service","labor":"Travail","parts":"les pièces","freight":"Fret","total":"Total","repairCode":"Code de réparation","misc":"Divers","pleaseChoose":"Choisissez s'il vous plaît","whatYouWantToDo":"Que veux-tu faire","nothing":"Rien","view":"Voir","export":"Exporter","part":"Partie","number":"Nombre","description":"Description","listPrice":"Liste des prix","extendedPrice":"Prix ​​prolongée","maxTime":"Temps maximum","serviceTicketNum":"Billet de Service","rmaNumber":"Numéro RMA","shippingMethod":"Mode de livraison","trackingNumber":"Numéro de suivi","rmaCreationDate":"Date de création de l'RMA","opened":"Ouvert","closed":"Fermé","flagged":"Marqué","flaggedClosed":"MarquéFermé","escalation":"Escalade","escalationClosed":"EscaladeFermée","postInstallInstall":"PostInstall","dateFrom":"Dater de","dateTo":"Date à","quantity":"Quantité","raisedBy":"Soumisse par","operations":"Opérations","pay":"Payer","no":"Non","yes":"Oui","add":"Ajouter","name":"Nom","altName":"Alt Nom","cancel":"Annuler","edit":"Modifier","regularTime":"Temps régulier","overTime":"Au fil du temps","pleaseSelectPart":"Veuillez sélectionner une partie","summary":"Résumé","comment":"Commentaire","hours":"Heures","rate":"Taux","partNum":"No. de Pièce","extPrice":"Ext. ","back":"Dos","close":"Fermer","rmaNum":"RMA","rmaDate":"Date RMA :","hardtEquipmentManufacturing":"Fabrication d'équipement Hardt","fifthAvenue":"1400, 50e Avenue","montrealQuebec":"Montreal, Quebec","canadaH8T2V3":"Canada, H8T 2V3","reasonForReturn":"Raison du retour","pleseSelectReasonForReturn":"Veuillez sélectionner la raison du retour","returnRequestFromRDLabManager":"Demande de retour de R","returnRequestFromProductManager":"Demande de retour du chef de produit","returnRequestFromProjectLeader":"Demande de retour du chef de projet","customerSiteInfo":"Informations sur le site du client","serviceCoInfo":"Service Co. Infos","equipmentInformation":"Informations sur l'équipement","modelColon":"Modèle:","serialNumColon":"En série","serviceCoverageColon":"Comptabilité :","reportSymptomColon":"Signaler le symptôme :","returnAuthorizationNum":"Autorisation de retour","authNumDateAndTimeColon":"Authentification","hardtServiceTicketNum":"Ticket de service Hardt (sans)","hardtClaimNum":"Réclamation Hardt","hardtInvoicePartPurchaseNum":"Facture Hardt (achat partiel)","shippingMethodColon":"Mode de livraison:","trackingNum":"Suivi","serviceColon":"Service:","weightColon":"Lester:","shippedOnColon":"Expédiés sur:","referenceNumbersColon":"Numéros de référence):","track":"Piste","coo":"ROUCOULER","price":"Prix","save":"Sauvegarder","pendingTechnicalReview":"Revue technique en attente","pendingTechnicalReviewGillesB":"Revue technique en attente Gilles B","details":"Détails","subContractor":"Sous-traitant","claimInformation":"Informations sur la réclamation","serviceTicketNumColon":"Billet de service","claimColon":"Réclamation:","statusColon":"Statut:","createdColon":"Créé:","dispatchColon":"Expédition:","acceptedDateColon":"Date d'acceptation :","workCompletedColon":"Travaux achevés:","invoiceColon":"Facture:","serviceWorkOrderColon":"Ordre de travail de service :","subAgentColon":"Sous-agent :","serviceRequestedBy":"Service demandé par","workOrderSignedAndApprovedBy":"Ordre de travail signé et approuvé par","productModelColon":"Modèle du produit:","serialColon":"En série:","reportSymptomsColon":"Signaler les symptômes :","processedByColon":"Traité par:","codes":"Codes","laborAndTravel":"Travail et voyage","maxAllowed":"Max autorisé","suplementary":"Supplémentaire","tripsExplanation":"Explication des trajets","extendedTotal":"Total étendu","glCode":"Code Gl","taxEIN":"Impôt-EIN","taxEINNum":"Impôt-EIN","hardtOriginalInvColon":"Hardt original inv :","gstHstNum":"TPS/TVH","pstNum":"TVP","comments":"commentaires","process":"Processus","submit":"Soumettre","pleaseSelectRepairCode":"Veuillez sélectionner le code de réparation","partOrders":"Commandes de pièces","modelNum":"Modèle","warrantyStart":"Début de la garantie","warrantyEnd":"Fin de garantie","update":"Mise à jour","partDescription":"Description de la pièce","delete":"Supprimer","contactPerson":"Personne de contact","phone":"Téléphone","email":"E-mail","equipment":"Équipement","zip":"Zipper","state":"État","country":"Pays","ok":"D'accord","extended":"Étendu","nonWarranty":"Non-garantie","otherCompany":"Autre entreprise","import":"Importer","link":"Lien","resetPassword":"Réinitialiser le mot de passe","all":"Tous","pending":"En attente","user":"Utilisateur","companyName":"Nom de l'entreprise","selectDate":"Sélectionner une date","express":"Exprimer","expressSAT":"Express SAT","standard":"Standard","notSelected":"Non séléctionné","thisWillDeleteClaimContinue":"Cela supprimera la réclamation. ","OK":"D'ACCORD","deleteCompleted":"Suppression terminée","claimSuccesfullySubmitted":"Réclamation soumise avec succès.","success":"Succès","pleaseEnterName":"Veuillez entrer le nom","pleaseEnterPrice":"Veuillez entrer le prix","pleaseEnterExtendedPrice":"Veuillez entrer le prix total","pleaseEnterQuantity":"Veuillez entrer la quantité","pleaseRegularTime":"S'il vous plaît temps régulier","pleaseOvertime":"Veuillez faire des heures supplémentaires","supplementaryCommentRequired":"Commentaire supplémentaire requis","searchAllClaims":"Rechercher toutes les réclamations","searchInNewClaims":"Rechercher dans les nouvelles revendications","fromCreatedDate":"***Depuis la date de création***","toCreatedDate":"***Jusqu'à la date de création***","searchInMoreInformationRequiredClaims":"Rechercher dans plus d'informations les revendications requises","fromCommentDate":"***À partir de la date du commentaire***","toCommentDate":"****Pour commenter la date***","searchInPendingReturnPartClaims":"Rechercher dans les réclamations de pièces de retour en attente","searchInPendingReturnCodeCorrectionsClaims":"Rechercher dans les demandes de correction de code de retour en attente","searchInModifiedClaims":"Rechercher dans les revendications modifiées","fromModifiedDate":"***À partir de la date de modification***","toModifiedDate":"***À date de modification***","searchInRejectedClaims":"Rechercher dans les réclamations rejetées","fromRejectedDate":"***À partir de la date de rejet***","toRejectedDate":"***Jusqu'à la date de rejet***","searchInDeletedClaims":"Rechercher dans les revendications supprimées","fromDeletedDate":"***Depuis la date de suppression***","toDeletedDate":"***Jusqu'à la date de suppression***","searchInPaidClaims":"Rechercher dans les réclamations payées","fromPaidDate":"***À partir de la date de paiement***","toPaidDate":"***Jusqu'à la date de paiement***","searchInPendingTechReviewClaims":"Rechercher dans les demandes d'examen technique en attente","fromAssignedDate":"***À partir de la date attribuée***","toAssignedDate":"***Jusqu'à la date assignée***","theExportWillBeGeneratedForAPeriodOfOneYear":"L'exportation sera générée pour une période d'un an, par exemple. ","sinceTheDateRangeWasNotSelectedPleaseConfirm":") puisque la plage de dates n'a pas été sélectionnée. ","exportWasGeneratedSuccesfully":"L'exportation a été générée avec succès !","claimWasSubmittedSuccesfully":"La demande a été soumise avec succès.","areYouSureYouWantToChangeStatusOfClaim":"Voulez-vous vraiment modifier le statut de la réclamation ?","claimStatusWasUpdatedSuccesfully":"L'état de la demande a été mis à jour avec succès.","pleaseEnterServiceWorkOrderNumber":"Veuillez entrer le numéro de l'ordre de travail de service","pleaseEnterInvoiceNumber":"Veuillez entrer le numéro de facture","invoiceNumberMustBeUnique":"Le numéro de facture doit être unique","pleaseEnterDateOfDispatch":"Veuillez saisir la date d'envoi","dateOfDispatchMustBeBeforeToday":"La date d'envoi doit être antérieure à aujourd'hui","pleaseEnterDateWorkCompleted":"Veuillez entrer la date de fin des travaux","dateWorkCompletedMustBeBeforeToday":"La date de fin des travaux doit être antérieure à aujourd'hui","dateWorkCompletedMustBeAfterOrEqualDateOfDispatch":"La date d'achèvement des travaux doit être postérieure ou égale à la date d'expédition","pleaseSelectModel":"Veuillez sélectionner le modèle","pleaseEnterSerialNumber":"Veuillez entrer le numéro de série","pleaseSelectProductFirst":"Veuillez d'abord sélectionner le produit","pleaseSelectServiceCoverageFirst":"Veuillez d'abord sélectionner la couverture du service","pleaseSelectOvertimeApproved":"Veuillez d'abord sélectionner heures supplémentaires approuvées","workOrderIsRequired":"Un ordre de travail est requis","pleaseEnterCustomerId":"Veuillez entrer l'identifiant client","pleaseEnterOrderSignedBy":"Veuillez entrer la commande signée par","pleaseEnterTechnicianName":"Veuillez entrer le nom du technicien","pleaseEnterServiceRequestedBy":"Veuillez entrer le service demandé par","pleaseEnterSymptoms":"Veuillez entrer les symptômes","pleaseEnterNumberOfTrips":"Veuillez entrer le nombre de trajets","pleaseEnterRegularTravelHours":"Veuillez entrer les heures de voyage régulières","regularTravelHoursMustBeANumber":"Les heures de voyage régulières doivent être un nombre","pleaseEnterOvertimeTravelHours":"Veuillez saisir les heures de déplacement supplémentaires","overtimeTravelHoursMustBeANumber":"Les heures de déplacement supplémentaires doivent être un nombre","pleaseEnterRegularMileage":"Veuillez entrer le kilométrage régulier","mileageMustBeANumber":"Le kilométrage (miles) doit être un nombre","pleaseEnterOvertimeMileage":"Veuillez entrer le kilométrage des heures supplémentaires","overtimeMileageMustBeANumber":"Le kilométrage des heures supplémentaires (miles) doit être un nombre","pleaseEnterFuel":"Veuillez entrer le carburant","serviceFuelChargeMustBeANumber":"Service","invoiceIsRequired":"Une facture est requise","freightMustBeANumber":"Le fret doit être un nombre","taxMustBeANumber":"La taxe doit être un nombre","pleaseEnterCommentText":"Veuillez saisir le texte du commentaire","claimSuccesfullySaved":"Revendication enregistrée avec succès.","areYouSureYouWantToProcess":"Êtes-vous sûr de vouloir traiter ?","thisWillDeleteRMAContinue":"Cela supprimera RMA. ","thisWillDeleteEquipmentContinue":"Cela supprimera l'équipement. ","invalidSerialShouldBeginWith":"Numéro de série invalide. ","pleaseSelectGasType":"Veuillez sélectionner le type de gaz","pleaseSelectShippingDate":"Veuillez sélectionner la date d'expédition","pleaseEnterWarrantyStartDate":"Veuillez saisir la date de début de la garantie","pleaseEnterWarrantyEndDate":"Veuillez entrer la date de fin de garantie","equipmentSuccessfullySaved":"Équipement enregistré avec succès.","duplicateSerialNumber":"Numéro de série en double.","customerOrProductIsNotExists":"Le client ou le produit n'existe pas.","thisWillDeleteCodeContinue":"Cela supprimera le code. ","pleaseSelectProduct":"Veuillez sélectionner le produit","pleaseEnterCode":"Veuillez entrer le code","pleaseEntercodeDescription":"Veuillez entrer la description du code","pleaseEnterCategory":"Veuillez saisir une catégorie","thisWillDeleteCustomerChainContinue":"Cela supprimera la chaîne de clients. ","pleaseEnterCounryName":"Veuillez entrer le nom du pays","pleaseEnterCounryISOCode":"Veuillez entrer le code ISO du pays, maximum 2 symboles","countryCreated":"Pays créé","pleaseEnterCustomerName":"Veuillez entrer le nom du client","pleaseSelectChainFirst":"Veuillez d'abord sélectionner la chaîne","customerNameShouldStartWith":"Le nom du client doit commencer par","pleaseEnterNumber":"Veuillez entrer le numéro","pleaseEnterClassification":"Veuillez entrer la classification","pleaseEnterProvinceAndCountry":"Veuillez entrer la province et le pays","pleaseEnterCity":"Veuillez entrer la ville","pleaseEnterAddress":"Veuillez entrer l'adresse","pleaseEnterZip":"Veuillez saisir le code postal","pleaseEnterPhone":"Veuillez entrer le téléphone","pleaseSelectServiceCompany":"Veuillez sélectionner la société de services","pleaseInputCorrectEmailAddress":"Veuillez saisir l'adresse e-mail correcte","thisWillDeleteNotificationContinue":"Cela supprimera la notification. ","notifySuccesfullySaved":"Notification enregistrée avec succès","thisWillDeleteCookingParameterContinue":"Cela supprimera le paramètre de cuisson. ","cookingParameterSuccesfullySaved":"Paramètre de cuisson enregistré avec succès.","thisWillDeleteCustomerContinue":"Cela supprimera le client. ","pleaseEnterShippingCompanyName":"Veuillez saisir le nom de la société de transport","pleaseEnterPart":"Veuillez saisir une partie","pleaseEnterPartDescription":"Veuillez entrer la description de la pièce","pleaseSelectPriceRate":"Veuillez sélectionner le tarif","pleaseEnterUSListPrice":"Veuillez saisir le prix catalogue américain","pleaseEnterCDNListPrice":"Veuillez entrer le prix courant CDN","partsSuccesfullyImported":"Pièces importées avec succès.","allUnsavedChangesWillBeLostContinue":"Toutes les modifications non enregistrées seront perdues. ","thisWillDeletePartContinue":"Cela supprimera une partie. ","areYouSure":"Es-tu sûr?","partsWereSuccesfullySubmitted":"Pièces ont été envoyées avec succès.","pleaseEnterProductNumber":"Veuillez entrer le numéro de produit","pleaseEnterProductName":"Veuillez entrer le nom du produit","pleaseEnterModel":"Veuillez entrer le modèle","pleaseEnterSerialPrefix":"Veuillez entrer le préfixe de série","pleaseEnterLaborGLCode":"Veuillez saisir le code GL de la main-d'œuvre","pleaseEnterPartGLCode":"Veuillez entrer le code GL de la partie","pleaseEnterHandlingGLCode":"Veuillez entrer le code GL de traitement","pleaseEnterFreightGLCode":"Veuillez entrer le code GL de fret","pleaseEnterMiscGLCode":"Veuillez entrer le code GL divers","creationFailed":"La création a échoué.","thisWillDeleteProductContinue":"Cela supprimera le produit. ","pleaseEnterLabor":"Veuillez entrer la main-d'oeuvre","laborMustBeANumber":"Le travail doit être un nombre","pleaseEnterMaxTime":"Veuillez entrer le temps maximum","maxTimeMustBeANumber":"Le temps maximum doit être un nombre","pleaseEnterServiceCompanyCode":"Veuillez saisir le code de la société de services","pleaseEnterServiceCompanyName":"Veuillez saisir le nom de la société de services","pleaseEnterContactPersonName":"Veuillez saisir le nom de la personne à contacter","pleaseEnterRating":"Veuillez saisir une évaluation","gstNumberIsRequired":"Le numéro de TPS est requis","pstNumberIsRequired":"Le numéro PST est requis","pleaseEnterCompanyName":"Veuillez saisir le nom de l'entreprise","pleaseEnterEmail":"Veuillez saisir un e-mail","pleaseEnterServiceEmail":"Veuillez entrer l'e-mail de service","pleaseEnterPartsEmail":"Veuillez saisir l'e-mail des pièces","pleaseEnterRate":"Veuillez saisir le tarif","pleaseEnterSubContractorName":"Veuillez entrer le nom du sous-traitant","pleaseEnterContactName":"Veuillez entrer le nom du contact","cantCreateNewCompany":"Oups, impossible de créer une nouvelle société.","weWillSendEmailToResetPasswordContinue":"Nous vous enverrons un e-mail pour réinitialiser le mot de passe. ","emailWasSent":"L'e-mail a été envoyé.","areYouSureToDeleteTheSubcontractor":"Êtes-vous sûr de supprimer le sous-traitant ?","thisWillDeleteServiceCompanyContinue":"Cela supprimera la société de services. ","errorWhileDeleteTheServiceCompany":"Erreur lors de la suppression de la société de services","pleaseEnterUsername":"Veuillez entrer le nom d'utilisateur","pleaseEnterPhoneNumber":"Veuillez entrer le numéro de téléphone","emailWithInstructionsWasSent.":"Un e-mail avec des instructions a été envoyé.","thisWillDeleteUserContinue":"Cela supprimera l'utilisateur. ","pleaseEnterPurchaseOrderNumber":"Veuillez entrer le numéro de bon de commande","pleaseChooseState":"Veuillez choisir l'état","pleaseChooseCountryAndState":"Veuillez choisir le pays et l'état","pleaseEnterRegional":"Veuillez saisir la région","pleaseEnterRegion":"Veuillez entrer la région","cantCreateUpdateOrder":"Impossible de créer/mettre à jour la commande.","partOrderProcessedSuccesfully.":"Commande de pièce traitée avec succès.","pleaseEnterPersonName":"Veuillez entrer le nom de la personne","pleaseEnterDate":"Veuillez entrer la date","areYouSureYouWantToDeleteThePartOrder":"Voulez-vous vraiment supprimer la commande de pièces ?","thePartOrderIsSuccessfullyDeleted":"La commande de pièce a été supprimée avec succès","pleaseEnterCost":"Veuillez entrer le coût","pleaseEnterTrackingNumber":"Veuillez entrer le numéro de suivi","pleaseEnterServiceOrderNumber":"Veuillez entrer le numéro de commande de service","rmaSuccesfullySaved":"Rma enregistré avec succès.","pleaseSelectTitle":"Veuillez sélectionner le titre","pleaseEnterCallerName":"Veuillez entrer le nom de l'appelant","pleaseSelectUrgency":"Veuillez sélectionner l'urgence","flaggedCall":"APPEL SIGNALÉ - *** Le technicien DOIT appeler Hardt au 1-800-387-6847 à son arrivée pour travailler avec le support technique et signaler les résultats. ","escalationNotes":"ESCALADE - *** Le technicien DOIT appeler le support technique du site au 1-800-387-6847 À L'ARRIVÉE pour signaler les résultats et pour une assistance supplémentaire. ","callCustomer":"***Veuillez appeler le client au numéro fourni ci-dessus pour PLANIFIER ou FOURNIR L'ETA du TECH à la réception de ce ticket.***","ticketSuccessfullySaved":"Billet enregistré avec succès.","atLeastOneSymptomCodeShouldBeAdded":"Au moins un code de symptôme doit être ajouté","pleaseSelectPhone":"Veuillez sélectionner un téléphone","pleaseEnterRejectedReason":"Veuillez entrer la raison du rejet","areYouSureToDeleteTheComment":"Voulez-vous vraiment supprimer le commentaire ?","youDoNotHaveRightsToDeleteThisComment":"Vous n'avez pas le droit de supprimer ce commentaire","serviceTicketSuccesfullyUpdated":"Ticket de service mis à jour avec succès","serviceTicketAccepted":"Ticket de service accepté.","serviceTicketRejected":"Ticket de service rejeté.","authNumGenerated":"Authentification","authNumWasntGenerated":"Authentification","pleaseChooseCountryAndProvince":"Veuillez choisir le pays et la province !","pleaseEnterOldPassword":"Veuillez entrer l'ancien mot de passe","pleaseEnterNewPassword":"Veuillez saisir un nouveau mot de passe","warrantyInvoiceHardt":"Garantie - FACTURE HARDT","costcoNonWarrantyInvoiceHardt":"Non-garantie Costco - FACTURATION HARDT","walMartNonWarrantyInvoiceHardt":"Non-garantie Wal-Mart - FACTURE HARDT","pendingWarrantyInvoiceHardtPendingDecision":"En attente de garantie - FACTURATION HARDT EN ATTENTE DE DECISION","warrantyExceptionInvoiceHardt":"Exception de garantie - FACTURE HARDT","installationPostInstall":"Installation / Post-installation","nonWarrantyInvoiceHardt":"Hors garantie / FACTURE Hardt","expressSat":"Express SAT","other":"Autre","pleaseSelectFolder":"Veuillez sélectionner le dossier","pleaseSelectDocumentsToUpload":"Veuillez sélectionner les documents à télécharger","folderSuccesfullyCreated":"Dossier créé avec succès.","documentsSuccesfullySubmitted":"Documents soumis avec succès.","folderSuccesfullyDeleted":"Dossier supprimé avec succès.","documentsSuccesfullyDeleted":"Documents supprimés avec succès.","areYouSureAllFilesInThisFolderWillBeDeleted":"Es-tu sûr? ","create":"Créer","descriptionFr":"DescriptionFr","moreInformationRequiredClaims":"Réclamations en attente d’information(s)","pendingReturnPartClaims":"Réclamations en attente de retour de pièces","modifiedClaims":"Réclamations modifiées","rejectedClaims":"Réclamations rejetées","deletedClaims":"Réclamations supprimées","paidClaims":"Réclamations payées","pendingTechnicalReviewClaims":"En attente d’évaluation technique","open":"Ouvrir","processed":"Traité","deleted":"Supprimé","serviceTicketId":"Identifiant du ticket de service","pleaseEnterServiceTicketNumber":"Veuillez saisir le numéro du ticket de service","serviceTicketNumberNotFound":"Numéro de ticket de service introuvable"}

/***/ }),

/***/ "aU7l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "acN8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_claims_components_CreateUpdateClaimDialog__ = __webpack_require__("Lj1T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_orders_components_CreateUpdatePartOrderDialog__ = __webpack_require__("+9af");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_claims_components_PreviewClaimDialog__ = __webpack_require__("LoMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_servicetickets_components_ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_servicetickets_components_SendEmailDialog__ = __webpack_require__("hoZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_rma_components_CreateUpdateRma__ = __webpack_require__("NMra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_rma_components_PreviewRmaDialog__ = __webpack_require__("z0Xr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__ = __webpack_require__("fEXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__("WiWB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    name: "dasboard",
    components: {
        CreateUpdateClaimDialog: __WEBPACK_IMPORTED_MODULE_0__app_claims_components_CreateUpdateClaimDialog__["a" /* default */],
        CreateUpdatePartOrderDialog: __WEBPACK_IMPORTED_MODULE_1__app_orders_components_CreateUpdatePartOrderDialog__["a" /* default */],
        PreviewClaimDialog: __WEBPACK_IMPORTED_MODULE_2__app_claims_components_PreviewClaimDialog__["a" /* default */],
        ServiceTicketDetailsDialog: __WEBPACK_IMPORTED_MODULE_3__app_servicetickets_components_ServiceTicketDetailsDialog__["a" /* default */],
        SendEmailDialog: __WEBPACK_IMPORTED_MODULE_4__app_servicetickets_components_SendEmailDialog__["a" /* default */],
        CreateUpdateRmaDialog: __WEBPACK_IMPORTED_MODULE_5__app_rma_components_CreateUpdateRma__["a" /* default */],
        PreviewRmaDialog: __WEBPACK_IMPORTED_MODULE_6__app_rma_components_PreviewRmaDialog__["a" /* default */]
    },
    data: function data() {
        return {
            loading: false,
            claimId: 0,
            chooseActionVisible: false,
            isForPartial: false,
            isUserHardt: false,
            claimsLoading: false,
            foundClaims: [],
            claimToView: undefined,
            claimToEdit: undefined,
            updateClaimVisible: false,
            previewClaimVisible: false,
            claims: [],
            claimsPage: 1,
            claimsTotal: 0,

            partsLoading: false,
            foundParts: [],
            orderToView: undefined,
            orderDialogVisible: false,
            orders: [],
            ordersPage: 1,
            ordersTotal: 0,

            ticketToEdit: null,
            serviceTicketsLoading: false,
            serviceTicketDialogVisible: false,
            foundServiceTickets: [],

            claimsCategories1: [],
            claimsCategories2: [],
            claimsCategories3: [],
            claimsCategories4: [],

            serviceTicketsCategories1: [],
            serviceTicketsCategories2: [],
            serviceTicketsCategories3: [],
            serviceTicketsCategories4: [],

            partOrdersCategories1: [],
            partOrdersCategories2: [],
            partOrdersCategories3: [],
            partOrdersCategories4: [],

            activemenu: "1",

            rmas: [],
            rmasTotal: 0,
            rmaToEdit: null,
            rmasLoading: false,
            foundRMAs: [],
            updateRMAVisible: false,
            previewRMAVisible: false,
            rmaToView: null
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler() {
                this.loadClaims();
                this.loadOrders();
                this.loadClaimsCategories();
                this.loadServiceTicketsCategories();
                this.loadPartOrdersCategories();
            }
        }
    },
    created: function created() {
        this.loadClaims();
        this.loadOrders();
        this.loadClaimsCategories();
        this.loadServiceTicketsCategories();
        this.loadPartOrdersCategories();
        this.loadRMAs();
    },
    mounted: function mounted() {
        var _this = this;

        var self = this;
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$on("order-placed", function (order) {
            _this.loadPartOrdersCategories();
            _this.loadOrders();
        });
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$on("claim-created", function () {
            _this.loadClaimsCategories();
            _this.loadClaims();
        });
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$on("showClaimConfirm", function (claimId) {
            _this.showClaimConfirm(claimId);
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$off("order-placed");
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$off("claim-created");
        __WEBPACK_IMPORTED_MODULE_7__app_event_bus_js__["a" /* EventBus */].$off("showClaimConfirm");
    },

    methods: {
        searchForClaims: function searchForClaims(term) {
            var _this2 = this;

            this.claimsLoading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getClaimsForSearch(term).then(function (response) {
                _this2.foundClaims = response.data.items;
                _this2.claimsLoading = false;
            }, function () {
                _this2.claimsLoading = false;
            });
        },
        searchForParts: function searchForParts(term) {
            var _this3 = this;

            this.partsLoading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getPartsForSearch(term).then(function (response) {
                _this3.foundParts = response.data.items;
                _this3.partsLoading = false;
            }, function () {
                _this3.partsLoading = false;
            });
        },
        searchForServiceTickets: function searchForServiceTickets(term) {
            var _this4 = this;

            this.serviceTicketsLoading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getServiceTicketsForSearch(term).then(function (response) {
                _this4.foundServiceTickets = response.data.items;
                _this4.serviceTicketsLoading = false;
            }, function () {
                _this4.serviceTicketsLoading = false;
            });
        },
        searchForRMAs: function searchForRMAs(term) {
            var _this5 = this;

            this.rmasLoading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getRMAsForSearch(term).then(function (response) {
                _this5.foundRMAs = response.data.items;
                _this5.rmasLoading = false;
            }, function () {
                _this5.rmasLoading = false;
            });
        },
        filterClaimClear: function filterClaimClear() {
            this.claimsLoading = false;
            this.foundClaims = [];
        },
        filterPartClear: function filterPartClear() {
            this.partsLoading = false;
            this.foundParts = [];
        },
        filterServiceTicketClear: function filterServiceTicketClear() {
            this.serviceTicketsLoading = false;
            this.foundServiceTickets = [];
        },
        filterRMAClear: function filterRMAClear() {
            this.rmasLoading = false;
            this.foundRMAs = [];
        },
        chooseAction: function chooseAction(id) {
            this.isUserHardt = this.$currentUser.profile.role == "admin";
            this.claimId = id;
            this.chooseActionVisible = true;
        },
        viewClaim: function viewClaim(id) {
            if (this.chooseActionVisible == true) {
                this.chooseActionVisible = false;
            }
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        viewServiceTicket: function viewServiceTicket(id) {
            this.ticketToEdit = id;
            this.serviceTicketDialogVisible = true;
        },
        viewRMA: function viewRMA(id) {
            this.rmaToView = id;
            this.previewRMAVisible = true;
        },
        editClaim: function editClaim(id) {
            if (this.chooseActionVisible == true) {
                this.chooseActionVisible = false;
            }
            this.claimToEdit = id;
            this.updateClaimVisible = true;
        },
        showClaimPreview: function showClaimPreview(id) {
            this.claimToView = id;
            this.previewClaimVisible = true;
        },
        showClaimConfirm: function showClaimConfirm(id) {
            this.claimToView = id;
            this.isForPartial = true;
            this.previewClaimVisible = true;
        },
        updateClaimFinished: function updateClaimFinished() {
            this.claimToEdit = undefined;
            this.updateClaimVisible = false;
            this.filterClaimClear();
        },
        previewClaimFinished: function previewClaimFinished() {
            this.claimToView = undefined;
            this.previewClaimVisible = false;
            this.isForPartial = false;
            this.filterClaimClear();
        },
        serviceTicketViewFinished: function serviceTicketViewFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        },
        viewOrder: function viewOrder(id) {
            this.orderToView = id;
            this.orderDialogVisible = true;
        },
        viewOrderFinished: function viewOrderFinished() {
            this.orderToView = undefined;
            this.orderDialogVisible = false;
        },
        loadClaims: function loadClaims() {
            var _this6 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getClaims(this.claimsPage).then(function (response) {
                _this6.loading = false;
                _this6.claims = response.data.items;
                _this6.claimsTotal = response.data.total;
            });
        },
        loadOrders: function loadOrders() {
            var _this7 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getOrders(this.ordersPage).then(function (response) {
                _this7.loading = false;
                _this7.orders = response.data.items;
                _this7.ordersTotal = response.data.total;
            });
        },
        loadRMAs: function loadRMAs() {
            var _this8 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getRMAs(this.ordersPage).then(function (response) {
                _this8.loading = false;
                _this8.rmas = response.data.items;
                _this8.rmasTotal = response.data.total;
            });
        },
        loadClaimsCategories: function loadClaimsCategories() {
            var _this9 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getClaimsCategories().then(function (response) {
                _this9.loading = false;
                _this9.claimsCategories1 = response.data.splice(0, 2);
                _this9.claimsCategories2 = response.data.splice(0, 2);
                _this9.claimsCategories3 = response.data.splice(0, 2);
                _this9.claimsCategories4 = response.data.splice(0, 2);
            });
        },
        loadServiceTicketsCategories: function loadServiceTicketsCategories() {
            var _this10 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getServiceTicketsCategories().then(function (response) {
                _this10.loading = false;
                _this10.serviceTicketsCategories1 = response.data.splice(0, 2);
                _this10.serviceTicketsCategories2 = response.data.splice(0, 2);
                _this10.serviceTicketsCategories3 = response.data.splice(0, 2);
                _this10.serviceTicketsCategories4 = response.data.splice(0, 2);
            });
        },
        loadPartOrdersCategories: function loadPartOrdersCategories() {
            var _this11 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].getPartOrdersCategories().then(function (response) {
                _this11.loading = false;
                _this11.partOrdersCategories1 = response.data.splice(0, 1);
                _this11.partOrdersCategories2 = response.data.splice(0, 1);
                _this11.partOrdersCategories3 = response.data.splice(0, 1);
                _this11.partOrdersCategories4 = response.data.splice(0, 1);
            });
        },
        handleClaimPageChange: function handleClaimPageChange(page) {
            this.claimsPage = page;
            this.loadClaims();
        },
        handleOrderPageChange: function handleOrderPageChange(page) {
            this.ordersPage = page;
            this.loadOrders();
        },
        goToClaimCategory: function goToClaimCategory(event) {
            window.location.href = "/#/claims/" + event.status;
        },
        goToServiceTicketsCategory: function goToServiceTicketsCategory(event) {
            window.location.href = "/#/service-tickets/" + event.status;
        },
        goToPartOrdersCategory: function goToPartOrdersCategory(event) {
            window.location.href = "/#/part-orders/" + event.status;
        },
        statusChanged: function statusChanged() {
            this.loadClaims();
        },
        claimPublished: function claimPublished() {
            this.$notify({
                title: this.$t('common.success'),
                message: this.$t('common.claimSuccesfullySubmitted'),
                type: "success"
            });
            this.loadClaims();
        },
        deleteClaim: function deleteClaim(id) {
            var _this12 = this;

            this.$confirm(this.$t('common.thisWillDeleteClaimContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].deleteClaim(id).then(function () {
                    _this12.loadClaims();
                    _this12.$message({
                        type: "success",
                        message: _this12.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        editRMA: function editRMA(id) {
            if (this.previewRMAVisible == true) {
                this.previewRMAVisible = false;
            }
            this.rmaToEdit = id;
            this.updateRMAVisible = true;
        },
        deleteRMA: function deleteRMA(id) {
            var _this13 = this;

            this.$confirm(this.$t('common.thisWillDeleteRMAContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_8__api__["a" /* default */].deleteRMA(id).then(function () {
                    _this13.loadRMAs();
                    _this13.$message({
                        type: "success",
                        message: _this13.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        updateRMAFinished: function updateRMAFinished() {
            this.rmaToEdit = undefined;
            this.updateRMAVisible = false;
            this.filterRMAClear();
        },
        previewRMAFinished: function previewRMAFinished() {
            this.rmaToView = undefined;
            this.previewRMAVisible = false;
            this.filterRMAClear();
        }
    }
});

/***/ }),

/***/ "ajF+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RepairCodeSelector__ = __webpack_require__("4M/W");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RepairCodeSelector__["a"]; });


/***/ }),

/***/ "akY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getProducts: function getProducts() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/products/lookup');
    }
});

/***/ }),

/***/ "ao2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b1/0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bDAA":
/***/ (function(module, exports) {

module.exports = {"claims":"Réclamations","searchForClaimByNumber":"Rechercher une réclamation par numéro","date":"Date","operations":"Opérations","view":"Voir","serviceTickets":"Billets de service","searchServiceTicketByNumberOrCustomer":"Rechercher un ticket de service par numéro ou client","searchForPartByNumberOrServiceCompanyName":"Rechercher une pièce par numéro ou par nom de société de service","activeOrders":"Commandes actives","salesOrder":"Bon de commande","purchaseOrderNumber":"Numéro de commande","shipping":"Expédition","searchForRMAByNumber":"Rechercher RMA par numéro","rmaRequestor":"Demandeur RMA","claimNum":"Réclamation"}

/***/ }),

/***/ "bEz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'change-password-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            form: {
                oldPassword: '',
                newPassword: ''
            },
            rules: {
                oldPassword: [{
                    required: true,
                    message: this.$t('common.pleaseEnterOldPassword'),
                    trigger: 'blur'
                }],
                newPassword: [{
                    required: true,
                    message: this.$t('common.pleaseEnterNewPassword'),
                    trigger: 'blur'
                }]
            },
            showDialog: this.visible,
            loading: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        save: function save() {
            var _this = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this.loading = true;
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('api/users/change', _this.form).then(function (response) {
                        _this.loading = false;
                        if (response.data.success) {
                            _this.closeDialog();
                        } else {
                            _this.$message.error(response.data.message);
                        }
                    });
                }
            });
        }
    }
});

/***/ }),

/***/ "bL4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$isSubAgentUser)?_c('div',[_c('el-row',[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activemenu),callback:function ($$v) {_vm.activemenu=$$v},expression:"activemenu"}},[_c('el-collapse-item',{attrs:{"name":"1","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('dashboard.claims')))])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"toolbar"},[_c('el-select',{attrs:{"value":"","filterable":"","remote":"","reserve-keyword":"","placeholder":_vm.$t('dashboard.searchForClaimByNumber'),"title":_vm.$t('dashboard.searchForClaimByNumber'),"remote-method":_vm.searchForClaims,"loading":_vm.claimsLoading},on:{"change":function($event){_vm.chooseAction($event)},"clear":_vm.filterClaimClear}},_vm._l((_vm.foundClaims),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.claimNumber + ' (' + item.status + ')' + ' by ' + item.raisedBy,"value":item.id}})}))],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.claimsCategories1,"show-header":false},on:{"row-click":_vm.goToClaimCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.claimsCategories2,"show-header":false},on:{"row-click":_vm.goToClaimCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.claimsCategories3,"show-header":false},on:{"row-click":_vm.goToClaimCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.claimsCategories4,"show-header":false},on:{"row-click":_vm.goToClaimCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)])],1),_vm._v(" "),_c('el-row',[_c('h3'),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"claims-table tablewithshading",attrs:{"size":"mini","data":_vm.claims}},[_c('el-table-column',{attrs:{"prop":"claimNumber","label":_vm.$t('common.claimNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"workOrder","label":_vm.$t('common.workOrder')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('common.invoiceNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('dashboard.date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(_vm._f("date")(scope.row.raisedOn))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$isFullAdmin ? _vm.$t('dashboard.operations') : _vm.$t('dashboard.view'),"fixed":"right","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),(scope.row.status == 'Partial' || scope.row.status == 'MoreInformationRequired')?_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]):_vm._e(),_vm._v(" "),(scope.row.status == 'Partial')?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1)],1),_vm._v(" "),_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.claimsPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.claimsTotal},on:{"current-change":_vm.handleClaimPageChange,"update:currentPage":function($event){_vm.claimsPage=$event}}})],2),_vm._v(" "),(_vm.$isAdmin)?_c('el-collapse-item',{attrs:{"name":"2","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('dashboard.serviceTickets')))])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('div',{staticClass:"toolbar"},[_c('el-select',{staticStyle:{"width":"250px"},attrs:{"value":"","filterable":"","remote":"","reserve-keyword":"","placeholder":_vm.$t('dashboard.searchServiceTicketByNumberOrCustomer'),"title":_vm.$t('dashboard.searchServiceTicketByNumberOrCustomer'),"remote-method":_vm.searchForServiceTickets,"loading":_vm.serviceTicketsLoading},on:{"change":function($event){_vm.viewServiceTicket($event)},"clear":_vm.filterServiceTicketClear}},_vm._l((_vm.foundServiceTickets),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.serialNumber + ' (' + item.status + ')' + ' by ' + item.openedBy,"value":item.id}})}))],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.serviceTicketsCategories1,"show-header":false},on:{"row-click":_vm.goToServiceTicketsCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('div',[_c('el-table',{staticClass:"claims-table tablewithshading",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.serviceTicketsCategories2,"show-header":false},on:{"row-click":_vm.goToServiceTicketsCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.serviceTicketsCategories3,"show-header":false},on:{"row-click":_vm.goToServiceTicketsCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.serviceTicketsCategories4,"show-header":false},on:{"row-click":_vm.goToServiceTicketsCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)])],2):_vm._e(),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3","title":_vm.$t('common.partOrders'),"loading":_vm.loading}},[_c('template',{slot:"title"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('common.partOrders')))])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"toolbar"},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":"","filterable":"","remote":"","reserve-keyword":"","placeholder":_vm.$t('dashboard.searchForPartByNumberOrServiceCompanyName'),"title":_vm.$t('dashboard.searchForPartByNumberOrServiceCompanyName'),"remote-method":_vm.searchForParts,"loading":_vm.partsLoading},on:{"change":function($event){_vm.viewOrder($event)},"clear":_vm.filterPartClear}},_vm._l((_vm.foundParts),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.serviceWorkOrder + ' (' + item.status + ')' + ' by ' + item.serviceCompany,"value":item.id}})}))],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.partOrdersCategories1,"show-header":false},on:{"row-click":_vm.goToPartOrdersCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.partOrdersCategories2,"show-header":false},on:{"row-click":_vm.goToPartOrdersCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"35"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.partOrdersCategories3,"show-header":false},on:{"row-click":_vm.goToPartOrdersCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)]),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('div',[_c('el-table',{staticClass:"claims-table",staticStyle:{"cursor":"pointer"},attrs:{"size":"mini","data":_vm.partOrdersCategories4,"show-header":false},on:{"row-click":_vm.goToPartOrdersCategory}},[_c('el-table-column',{attrs:{"prop":"total","width":"45"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"name"}}):_c('el-table-column',{attrs:{"prop":"nameFr"}})],1)],1)])],1),_vm._v(" "),_c('el-row',[_c('h3',[_vm._v(_vm._s(_vm.$t('dashboard.activeOrders')))]),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"claims-table tablewithshading",attrs:{"size":"mini","data":_vm.orders}},[_c('el-table-column',{attrs:{"prop":"serviceWorkOrder","label":_vm.$t('dashboard.salesOrder')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"purchaseOrderNumber","label":_vm.$t('dashboard.purchaseOrderNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"shippingMethod","label":_vm.$t('dashboard.shipping')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('dashboard.date')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(_vm._f("date")(scope.row.placedAt))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$isFullAdmin ? _vm.$t('dashboard.operations') : _vm.$t('dashboard.view'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewOrder(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})])]}}])})],1)],1),_vm._v(" "),_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.ordersPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.ordersTotal},on:{"current-change":_vm.handleOrderPageChange,"update:currentPage":function($event){_vm.ordersPage=$event}}})],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4","loading":_vm.loading}},[_c('template',{slot:"title"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("R&D RMAs")])]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":5}},[_c('div',{staticClass:"toolbar"},[_c('el-select',{attrs:{"value":"","filterable":"","remote":"","reserve-keyword":"","placeholder":_vm.$t('dashboard.searchForRMAByNumber'),"title":_vm.$t('dashboard.searchForRMAByNumber'),"remote-method":_vm.searchForRMAs,"loading":_vm.rmasLoading},on:{"change":function($event){_vm.viewRMA($event)},"clear":_vm.filterRMAClear}},_vm._l((_vm.foundRMAs),function(item){return _c('el-option',{key:item.id,attrs:{"label":'RMA: ' + item.id + ' (Claim: ' + item.claimId + ')' + ' Invoice: ' + item.invoiceNumber,"value":item.id}})}))],1)])],1),_vm._v(" "),_c('el-row',[_c('h3'),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"claims-table tablewithshading",attrs:{"size":"mini","data":_vm.rmas}},[_c('el-table-column',{attrs:{"prop":"rmaNumber","label":"RMA #"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.rmaCreationDate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                                "+_vm._s(_vm._f("date")(scope.row.rmaDate))+"\n                            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"requestor","label":_vm.$t('dashboard.rmaRequestor')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"partNumber","label":_vm.$t('common.partNum')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompany","label":_vm.$t('common.serviceCompany')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"claimNumber","label":_vm.$t('dashboard.claimNum')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modelNumber","label":"$t('common.modelNum')"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$isFullAdmin ? _vm.$t('dashboard.operations') : _vm.$t('dashboard.view'),"fixed":"right","width":"220"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewRMA(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editRMA(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteRMA(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])})],1)],1)],2)],1)],1),_vm._v(" "),_c('create-update-claim-dialog',{attrs:{"claimId":_vm.claimToEdit,"visible":_vm.updateClaimVisible},on:{"dialogClosed":_vm.updateClaimFinished,"showClaimPreview":_vm.showClaimPreview,"showClaimConfirm":_vm.showClaimConfirm,"previewClaim":_vm.viewClaim}}),_vm._v(" "),_c('preview-claim-dialog',{attrs:{"claimId":_vm.claimToView,"visible":_vm.previewClaimVisible,"isForPartial":_vm.isForPartial},on:{"dialogClosed":_vm.previewClaimFinished,"editClaim":_vm.editClaim,"claimPublished":_vm.claimPublished,"statusChanged":_vm.statusChanged}}),_vm._v(" "),_c('create-update-part-order-dialog',{attrs:{"visible":_vm.orderDialogVisible,"orderId":_vm.orderToView,"save":_vm.loadOrders},on:{"dialogClosed":_vm.viewOrderFinished}}),_vm._v(" "),_c('service-ticket-details-dialog',{attrs:{"visible":_vm.serviceTicketDialogVisible,"ticketId":_vm.ticketToEdit},on:{"dialogClosed":_vm.serviceTicketViewFinished}}),_vm._v(" "),_c('create-update-rma-dialog',{attrs:{"rmaId":_vm.rmaToEdit,"visible":_vm.updateRMAVisible,"save":_vm.loadRMAs},on:{"dialogClosed":_vm.updateRMAFinished}}),_vm._v(" "),_c('preview-rma-dialog',{attrs:{"rmaId":_vm.rmaToView,"visible":_vm.previewRMAVisible},on:{"dialogClosed":_vm.previewRMAFinished}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('common.pleaseChoose'),"visible":_vm.chooseActionVisible,"width":"30%"},on:{"update:visible":function($event){_vm.chooseActionVisible=$event}}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.whatYouWantToDo')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{style:({visibility: _vm.isUserHardt ? 'visible' : 'hidden'}),attrs:{"type":"primary"},on:{"click":function($event){_vm.editClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.edit')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.viewClaim(_vm.claimId)}}},[_vm._v(_vm._s(_vm.$t('common.view')))]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.chooseActionVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.nothing')))])],1)])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bM5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getServiceTicket: function getServiceTicket(term) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/serviceTickets/lookup?Ticket=' + encodeURIComponent(term));
  }
});

/***/ }),

/***/ "bfth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.productId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('masters.product'),"visible":_vm.showDialog,"width":"500px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadProduct,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.number'),"prop":"no"}},[_c('el-input',{model:{value:(_vm.form.no),callback:function ($$v) {_vm.$set(_vm.form, "no", $$v)},expression:"form.no"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.altName'),"prop":"altName"}},[_c('el-input',{model:{value:(_vm.form.altName),callback:function ($$v) {_vm.$set(_vm.form, "altName", $$v)},expression:"form.altName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.model'),"prop":"model"}},[_c('el-input',{model:{value:(_vm.form.model),callback:function ($$v) {_vm.$set(_vm.form, "model", $$v)},expression:"form.model"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.serialPrefix'),"prop":"serialPrefix"}},[_c('el-input',{model:{value:(_vm.form.serialPrefix),callback:function ($$v) {_vm.$set(_vm.form, "serialPrefix", $$v)},expression:"form.serialPrefix"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"mask",rawName:"v-mask",value:('####-###-###'),expression:"'####-###-###'"}],attrs:{"label":_vm.$t('masters.laborGLCode'),"prop":"laborGLCode"}},[_c('el-input',{model:{value:(_vm.form.laborGLCode),callback:function ($$v) {_vm.$set(_vm.form, "laborGLCode", $$v)},expression:"form.laborGLCode"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"mask",rawName:"v-mask",value:('####-###-###'),expression:"'####-###-###'"}],attrs:{"label":_vm.$t('masters.partGLCode'),"prop":"partGLCode"}},[_c('el-input',{model:{value:(_vm.form.partGLCode),callback:function ($$v) {_vm.$set(_vm.form, "partGLCode", $$v)},expression:"form.partGLCode"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"mask",rawName:"v-mask",value:('####-###-###'),expression:"'####-###-###'"}],attrs:{"label":_vm.$t('masters.handlingGLCode'),"prop":"handlingGLCode"}},[_c('el-input',{model:{value:(_vm.form.handlingGLCode),callback:function ($$v) {_vm.$set(_vm.form, "handlingGLCode", $$v)},expression:"form.handlingGLCode"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"mask",rawName:"v-mask",value:('####-###-###'),expression:"'####-###-###'"}],attrs:{"label":_vm.$t('masters.freightGLCode'),"prop":"freightGLCode"}},[_c('el-input',{model:{value:(_vm.form.freightGLCode),callback:function ($$v) {_vm.$set(_vm.form, "freightGLCode", $$v)},expression:"form.freightGLCode"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"mask",rawName:"v-mask",value:('####-###-###'),expression:"'####-###-###'"}],attrs:{"label":_vm.$t('masters.miscGLCode'),"prop":"miscGLCode"}},[_c('el-input',{model:{value:(_vm.form.miscGLCode),callback:function ($$v) {_vm.$set(_vm.form, "miscGLCode", $$v)},expression:"form.miscGLCode"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.note'),"prop":"note"}},[_c('el-input',{attrs:{"type":"textarea","autosize":""},model:{value:(_vm.form.note),callback:function ($$v) {_vm.$set(_vm.form, "note", $$v)},expression:"form.note"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.productId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bheM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("rExp");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/parts',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* PartList */],
  name: 'partList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "bjD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-radio-group',{model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}},[_c('el-radio-button',{attrs:{"label":null}},[_vm._v(_vm._s(_vm.$t('common.all')))]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('el-radio-button',{key:category.status,attrs:{"label":category.status}},[_vm._v(_vm._s(category.total)+_vm._s(_vm.$i18n.locale == 'en' ? category.name : category.nameFr))])})],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('orders.purchaseOrderNumber')},model:{value:(_vm.filter.purchaseOrderNumber),callback:function ($$v) {_vm.$set(_vm.filter, "purchaseOrderNumber", $$v)},expression:"filter.purchaseOrderNumber"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('orders.orderNumber')},model:{value:(_vm.filter.partOrderNumber),callback:function ($$v) {_vm.$set(_vm.filter, "partOrderNumber", $$v)},expression:"filter.partOrderNumber"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('orders.serviceCompanyName')},model:{value:(_vm.filter.serviceCompanyName),callback:function ($$v) {_vm.$set(_vm.filter, "serviceCompanyName", $$v)},expression:"filter.serviceCompanyName"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.orders},on:{"sort-change":_vm.sortPartOrders}},[_c('el-table-column',{attrs:{"prop":"orderNumber","label":_vm.$t('orders.orderNum'),"width":"90","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.orderDate'),"width":"110","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.getDate(scope.row.placedAt))+"\n            ")]}}])}),_vm._v(" "),(_vm.filter.status == 0 || _vm.filter.status == null)?_c('el-table-column',{attrs:{"label":_vm.$t('orders.timeStamp')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.getTime(scope.row.placedAt, scope.row.status))+"\n            ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"purchaseOrderNumber","label":_vm.$t('orders.purchaseOrderNum'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"shippingMethod","label":_vm.$t('common.shippingMethod'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompany","label":_vm.$t('orders.svcCompany'),"sortable":"custom"}}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status'),"width":"100","sortable":"custom"}}):_c('el-table-column',{attrs:{"prop":"statusFr","label":_vm.$t('common.status'),"width":"100","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trackingNumber","label":_vm.$t('common.trackingNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceOrderNumber","label":_vm.$t('orders.serviceOrderNum'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.shippingCharges'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.shippingCharges))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"deliverySignedBy","label":_vm.$t('orders.deliverySignedBy'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('orders.deliverySignedOn'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.deliveryDate))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$isUser ? _vm.$t('common.view') : _vm.$t('common.operations'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewOrder(scope.row.orderNumber)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),(_vm.$isFullAdmin && scope.row.status != 'Processed' && scope.row.status != 'Deleted')?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deletePartOrder(scope.row.orderNumber)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-part-order-dialog',{attrs:{"visible":_vm.dialogVisible,"orderId":_vm.orderToView},on:{"dialogClosed":_vm.dialogClosed}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c5wQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketPartSelector_vue__ = __webpack_require__("TPw0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f986e31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketPartSelector_vue__ = __webpack_require__("VQzl");
function injectStyle (ssrContext) {
  __webpack_require__("lfPk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f986e31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketPartSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f986e31_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketPartSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cFdp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("5W/9");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/complaint-codes',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ComplaintCodeList */],
  name: 'complaintCodeList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "cOmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cnXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("pJr0");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'category-selector',
    data: function data() {
        return {
            loading: false,
            categories: [],
            categoryName: ''
        };
    },

    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCategories().then(function (response) {
            _this.loading = false;
            _this.categories = response.data;
        });
    },
    methods: {
        change: function change(val) {
            if (val) {
                this.categoryName = val;
                this.$emit('category-selected', val);
            }
        }
    }
});

/***/ }),

/***/ "cx5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateServiceCompanyDialog__ = __webpack_require__("qd8r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("9aBF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'service-company-list',
    components: {
        CreateUpdateServiceCompanyDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateServiceCompanyDialog__["a" /* default */],
        CountrySelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["g" /* CountrySelector */]
    },
    data: function data() {
        return {
            serviceCompanies: [],
            loading: true,
            dialogVisible: false,
            serviceCompanyToEdit: null,
            filter: {
                countryId: undefined,
                isActive: '',
                text: undefined,
                state: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadServiceCompanies();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadServiceCompanies();
            }
        }
    },
    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].download(this.filter);
        },
        loadServiceCompanies: function loadServiceCompanies() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getServiceCompanies(this.currentPage, this.filter.isActive, this.filter.countryId, this.filter.text, this.filter.state).then(function (response) {
                _this.loading = false;
                _this.serviceCompanies = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendServiceCompany: function appendServiceCompany(event) {
            if (event.new) {
                this.serviceCompanies.push(event.data);
                this.total += 1;
            } else {
                this.loadServiceCompanies();
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadServiceCompanies();
        },
        editServiceCompany: function editServiceCompany(id) {
            this.serviceCompanyToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.serviceCompanyToEdit = null;
            this.dialogVisible = false;
        },
        deleteServiceCompany: function deleteServiceCompany(id) {
            var _this2 = this;

            this.loading = true;
            this.$confirm(this.$t('common.thisWillDeleteServiceCompanyContinue'), 'Warning', {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            }).then(function () {
                // get servicecompany information
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getServiceCompany(id).then(function (servicecompany) {
                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteUser(servicecompany.code).then(function (response) {
                        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteServiceCompany(id).then(function () {
                            _this2.loadServiceCompanies();
                            _this2.$message({
                                type: 'success',
                                message: _this2.$t('common.deleteCompleted')
                            });
                            _this2.loading = false;
                        }).catch(function (err) {
                            _this2.loading = false;
                            _this2.$message({
                                type: 'error',
                                message: _this2.$t('common.errorWhileDeleteTheServiceCompany')
                            });
                        });
                    }).catch(function (err) {
                        _this2.loading = false;
                        _this2.$message({
                            type: 'error',
                            message: _this2.$t('common.errorWhileDeleteTheServiceCompany')
                        });
                    });
                });
            }).catch(function (_) {
                _this2.loading = false;
            });;
        },
        changeCompanyStatus: function changeCompanyStatus(company, activate) {
            var _this3 = this;

            this.$confirm('This will ' + (activate ? 'activate' : 'deactivate') + ' service company. Continue?', 'Warning', {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'info'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].changeActivationStatus(company.id, activate).then(function (response) {
                    company.isActive = activate;
                    _this3.$message({
                        type: 'success',
                        message: 'Company ' + (activate ? 'activated' : 'deactivated')
                    });
                });
            }).catch(function (_) {});
        },
        impersonateServiceCompany: function impersonateServiceCompany(id) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].impersonate(id).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token;
                localStorage.setItem("isImpersonateUser", "true");
                window.signInManager.signinRedirect();
            });
        }
    }
});

/***/ }),

/***/ "d03X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getCustomers: function getCustomers(term) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/lookup?name=' + encodeURIComponent(term));
  },
  getNotifications: function getNotifications(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/' + id + '/notifications');
  },
  getCustomersById: function getCustomersById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customers/lookup?customerId=' + id);
  }
});

/***/ }),

/***/ "d098":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d2TH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentationList_vue__ = __webpack_require__("2zae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10598042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentationList_vue__ = __webpack_require__("TRBT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DocumentationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10598042_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DocumentationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dCXX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFDocument_vue__ = __webpack_require__("jDMI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c22a534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFDocument_vue__ = __webpack_require__("3HyX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PDFDocument_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c22a534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PDFDocument_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dSIX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"colored-box",style:({ backgroundColor: _vm.boxColor }),on:{"click":function($event){_vm.$emit('click')}}}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dT8a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dkbm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dxgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.codeId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('masters.symptomCode'),"visible":_vm.showDialog,"width":"500px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadCode,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),(_vm.form.productId == 97)?_c('el-form-item',{attrs:{"label":_vm.$t('common.category'),"prop":"category"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.category),callback:function ($$v) {_vm.$set(_vm.form, "category", $$v)},expression:"form.category"}})],1):_vm._e(),_vm._v(" "),(_vm.form.productId == 97)?_c('el-form-item',{attrs:{"label":_vm.$t('masters.subCategory'),"prop":"subCategory"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.subCategory),callback:function ($$v) {_vm.$set(_vm.form, "subCategory", $$v)},expression:"form.subCategory"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.code'),"prop":"code"}},[_c('el-input',{model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.description'),"prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.mandatoryParts')}},[_c('part-selector',{attrs:{"disabled":_vm.disableForm,"title":_vm.$t('masters.toAddAnotherPartPleaseStartTypingNameOrPartNumber')},on:{"part-selected":_vm.mandatoryPartSelected}})],1),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.form.mandatoryParts,"size":"mini"}},[_c('br'),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.partDescription')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('small',[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.removeMandatoryPart(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.recommendedParts')}},[_c('part-selector',{attrs:{"disabled":_vm.disableForm,"title":_vm.$t('masters.toAddAnotherPartPleaseStartTypingNameOrPartNumber')},on:{"part-selected":_vm.recommendedPartSelected}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.form.recommendedParts,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('common.partNum'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.partDescription')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('small',[_vm._v(_vm._s(scope.row.name))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.removeRecommendedPart(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.codeId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "e4AD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__("QHf2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e9Ki":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__masters_servicecompanies_api__ = __webpack_require__("9aBF");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "FAQ",

    data: function data() {
        return {
            loading: false,
            showPage: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showPage = val;
        }

    },
    methods: {
        closePage: function closePage() {
            this.showPage = false;
            this.loading = false;
            this.$emit("faqPageClosed", false);
        }
    }
});

/***/ }),

/***/ "eGIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "price-list-report",
  data: function data() {
    return {
      loading: false,
      parts: [],
      filter: {
        part: undefined,
        serviceCompany: window.currentCompany.id
      },
      currentPage: 1,
      total: 0,
      exporting: false
    };
  },
  created: function created() {
    this.loadParts();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        this.currentPage = 1;
        this.loadParts();
      }
    }
  },
  methods: {
    loadParts: function loadParts() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getParts(this.currentPage, this.filter).then(function (response) {
        _this.loading = false;
        _this.parts = response.data.items;
        _this.total = response.data.total;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadParts();
    },
    download: function download() {
      var _this2 = this;

      this.exporting = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadPriceList(this.filter).then(function () {
        _this2.exporting = false;
      }).catch(function () {
        _this2.exporting = false;
      });
    }
  }
});

/***/ }),

/***/ "eNsn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateUserDialog__ = __webpack_require__("mFvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("Q9NL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'user-list',
    components: {
        CreateUpdateUserDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateUserDialog__["a" /* default */]
    },
    data: function data() {
        return {
            users: [],
            loading: true,
            dialogVisible: false,
            userToEdit: null,
            filter: {
                email: '',
                userName: ''
            },
            currentPage: 1,
            total: 0,
            sorting: {}
        };
    },
    created: function created() {
        this.loadUsers();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadUsers();
            }
        }
    },
    methods: {
        loadUsers: function loadUsers() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getUsers(this.currentPage, this.filter, this.sorting).then(function (response) {
                _this.loading = false;
                _this.users = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendUser: function appendUser(event) {
            if (event.new) {
                this.users.push(event.data);
                this.total += 1;
            } else {
                this.loadUsers();
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadUsers();
        },
        editUser: function editUser(id) {
            this.userToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.userToEdit = null;
            this.dialogVisible = false;
        },
        deleteUser: function deleteUser(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteUserContinue'), 'Warning', {
                confirmButtonText: this.$t('common.delete'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteUser(id).then(function (r) {
                    _this2.loadUsers();
                    _this2.$message({
                        type: 'success',
                        message: _this2.$t('common.deleteCompleted')
                    });
                }).catch(function (err) {
                    _this2.$message({
                        type: 'error',
                        message: err.response.data
                    });
                });
            }).catch(function (_) {});
        },
        sortServiceTickets: function sortServiceTickets(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadUsers();
            } else {
                this.currentPage = 1;
            }
        }
    }
});

/***/ }),

/***/ "ecSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("rYXq");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "ecgv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ResolutionCodeList__ = __webpack_require__("ih/l");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ResolutionCodeList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateResolutionCodeDialog__ = __webpack_require__("oOrt");
/* unused harmony reexport CreateUpdateResolutionCodeDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResolutionCodeCategoryList__ = __webpack_require__("Frfg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ResolutionCodeCategoryList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateUpdateResolutionCodeCategoryDialog__ = __webpack_require__("0wdK");
/* unused harmony reexport CreateUpdateResolutionCodeCategoryDialog */





/***/ }),

/***/ "ej2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectProduct'),"loading":_vm.loading},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.categories),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ekSx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("jTjA");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "esN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
    getClaims: function getClaims(filter, isFirst50Items) {
        filter.isFirst50Items = isFirst50Items;
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/costcoreports', {
            params: filter
        });
    },
    getParts: function getParts(page, filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/report', {
            params: _extends({
                page: page
            }, filter)
        });
    },
    getUsedParts: function getUsedParts(page, filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/usedpartsreport', {
            params: _extends({
                page: page
            }, filter)
        });
    },
    getCodes: function getCodes(page, filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/resolutioncodes/report', {
            params: _extends({
                page: page
            }, filter)
        });
    },
    downloadReport: function downloadReport(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/costcoreports/excel', {
            params: filter,
            responseType: 'blob'
        });
    },
    downloadClaimReport: function downloadClaimReport(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/claimreport/excel', filter, {
            responseType: 'blob'
        });
    },
    downloadServiceTicketsReport: function downloadServiceTicketsReport(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/serviceticketsreport/excel', filter, {
            responseType: 'blob'
        });
    },
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/resolutioncodes/export', {
            productId: filter.productId,
            categoryId: filter.categoryId,
            description: filter.description,
            code: filter.description
        });
    },
    getDataForGraph: function getDataForGraph(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/graphs/' + filter.periodType + '/' + filter.productId);
    },
    getFilterForGraph: function getFilterForGraph() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/graphs/filters');
    },
    downloadPriceList: function downloadPriceList(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/parts/exportpricelist', {
            part: filter.part,
            serviceCompany: filter.serviceCompany
        });
    },
    downloadUsedParts: function downloadUsedParts(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/parts/exportusedparts', {
            part: filter.part,
            claimNumber: filter.claimNumber,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serviceCompany: filter.serviceCompany
        });
    },
    downloadRmaReport: function downloadRmaReport(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/rmareport/excel', filter, {
            responseType: 'blob'
        });
    },
    downloadSimsApReport: function downloadSimsApReport(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/simsapreport/excel', filter, {
            responseType: 'blob'
        });
    }
});

/***/ }),

/***/ "evo4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f19G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["page", "scale"],
  render: function render(h) {
    var attrs = this.canvasAttrs;

    return h("canvas", { attrs: attrs });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyPage(this.page);
  },
  mounted: function mounted() {
    this.drawPage();
  },

  methods: {
    drawPage: function drawPage() {
      var _this = this;

      if (this.renderTask) return;
      var viewport = this.viewport;

      var canvasContext = this.$el.getContext("2d");
      var renderContext = { canvasContext: canvasContext, viewport: viewport };
      // PDFPageProxy#render
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      this.renderTask = this.page.render(renderContext);
      this.renderTask.then(function () {
        return _this.$emit("rendered", _this.page);
      }).catch(this.destroyRenderTask);
    },
    destroyPage: function destroyPage(page) {
      if (!page) return;

      // PDFPageProxy#_destroy
      // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
      page._destroy();

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      if (this.renderTask) this.renderTask.cancel();
    },
    destroyRenderTask: function destroyRenderTask() {
      if (!this.renderTask) return;

      // RenderTask#cancel
      // https://mozilla.github.io/pdf.js/api/draft/RenderTask.html
      this.renderTask.cancel();
      delete this.renderTask;
    }
  },
  watch: {
    page: function page(_page, oldPage) {
      this.destroyPage(oldPage);
    }
  },
  created: function created() {
    // PDFPageProxy#getViewport
    // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
    this.viewport = this.page.getViewport(this.scale);
  },

  computed: {
    canvasAttrs: function canvasAttrs() {
      var _viewport = this.viewport,
          width = _viewport.width,
          height = _viewport.height;

      var _map = [width, height].map(function (dim) {
        return Math.ceil(dim);
      });

      var _map2 = _slicedToArray(_map, 2);

      width = _map2[0];
      height = _map2[1];

      var style = this.canvasStyle;
      return {
        width: width,
        height: height,
        style: style,
        class: "pdf-page"
      };
    },
    canvasStyle: function canvasStyle() {
      var _actualSizeViewport = this.actualSizeViewport,
          actualSizeWidth = _actualSizeViewport.width,
          actualSizeHeight = _actualSizeViewport.height;

      var pixelRatio = window.devicePixelRatio || 1;

      var _map3 = [actualSizeWidth, actualSizeHeight].map(function (dim) {
        return Math.ceil(dim / pixelRatio);
      }),
          _map4 = _slicedToArray(_map3, 2),
          pixelWidth = _map4[0],
          pixelHeight = _map4[1];

      return "width: " + pixelWidth + "px; height: " + pixelHeight + "px;";
    },
    actualSizeViewport: function actualSizeViewport() {
      return this.viewport.clone({ scale: this.scale });
    }
  }
});

/***/ }),

/***/ "f7dn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gJWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components_ColoredBox_vue__ = __webpack_require__("/57N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EscalationListDetailsDialog__ = __webpack_require__("vMsE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "escalation-ticket-list",
    components: {
        ColoredBox: __WEBPACK_IMPORTED_MODULE_1__app_shared_components_ColoredBox_vue__["a" /* default */],
        EscalationListDetailsDialog: __WEBPACK_IMPORTED_MODULE_2__EscalationListDetailsDialog__["a" /* default */]
    },
    data: function data() {
        return {
            tickets: [],
            loading: true,
            sorting: {},
            currentPage: 1,
            total: 0,
            escalationWarningCount: 0,
            escalationCriticalCount: 0,
            escalationNewCount: 0,
            escalationTotalCount: 0,
            escalationSalesFollowUpCount: 0,
            ticketToEdit: null,
            dialogVisible: false,
            filteredBy: "",
            width: window.innerWidth,
            isGrouped: true, // Add this line
            allCommentsNextStepVisible: false,
            filter: {
                type: this.$route.params.status || null,
                customer: "",
                ticket: "",
                serviceCompany: "",
                dateFrom: null,
                dateTo: null,
                serialNumber: ""
            }
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler() {
                if (this.filter.status === null && this.$route.params.status != null) {
                    window.location.href = "/#/escalation-tickets";
                }
                this.loadTickets();
            }
        }
    },
    created: function created() {
        this.loadTickets();
    },
    mounted: function mounted() {
        window.addEventListener('resize', this.updateDimensions);
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener('resize', this.updateDimensions);
    },

    computed: {
        groupedTickets: function groupedTickets() {
            return this.tickets.reduce(function (groups, ticket) {
                (groups[ticket.customer] = groups[ticket.customer] || []).push(ticket);
                return groups;
            }, {});
        }
    },
    methods: {
        toggleAllNextStepComments: function toggleAllNextStepComments() {
            this.allCommentsNextStepVisible = !this.allCommentsNextStepVisible;
        },
        toggleGrouping: function toggleGrouping() {
            this.isGrouped = !this.isGrouped;
        },
        updateDimensions: function updateDimensions() {
            this.width = window.innerWidth;
        },
        handleBoxClick: function handleBoxClick(type) {
            this.filteredBy = type;
            this.loadTickets();
        },
        loadTickets: function loadTickets() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEscalationCounts().then(function (response) {
                _this.escalationWarningCount = response.data.escalationWarningCount;
                _this.escalationCriticalCount = response.data.escalationCriticalCount;
                _this.escalationNewCount = response.data.escalationNewCount;
                _this.escalationTotalCount = response.data.escalationTotalCount;
                _this.escalationSalesFollowUpCount = response.data.escalationSalesFollowUpCount;
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getTickets(this.filteredBy, this.filter, this.currentPage, this.sorting).then(function (response) {
                _this.loading = false;
                _this.tickets = response.data.items;
                _this.total = response.data.total;
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadTickets();
        },
        sortServiceTickets: function sortServiceTickets(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadTickets();
            } else {
                this.currentPage = 1;
            }
        },
        truncateComment: function truncateComment(row, column, cellValue) {
            var limit = 80;
            return this.truncate(cellValue, limit);
        },
        truncate: function truncate(value, limit) {
            if (!value) return '';
            if (value.length <= limit) return value;
            return value.substring(0, limit) + '...';
        },
        formattedHour: function formattedHour(decimalHour) {
            var hour = Math.floor(decimalHour);
            var minute = Math.round((decimalHour - hour) * 60);
            minute = (minute < 10 ? '0' : '') + minute;
            return hour + " hrs: " + minute + " min";
        },
        tableRowEscalationTime: function tableRowEscalationTime(_ref) {
            var row = _ref.row,
                column = _ref.column;

            if (row.status == 'SalesFollowUp') return 'sales-followup-row';
            if (row.daysSinceRaised >= 0 && row.daysSinceRaised <= 4) {
                return 'success-row';
            } else if (row.daysSinceRaised > 4 && row.daysSinceRaised <= 6) {
                return 'warning-row';
            } else if (row.daysSinceRaised > 6) {
                return 'error-row';
            } else {
                return 'default-row';
            }
        },
        daysSinceRaisedFormatter: function daysSinceRaisedFormatter(row, column, cellValue) {
            return cellValue === -1 ? '' : cellValue;
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        },
        handleRowClick: function handleRowClick(row) {
            this.ticketToEdit = row.id;
            this.dialogVisible = true;
        },
        rowKey: function rowKey(row) {
            return row.id;
        }
    }
});

/***/ }),

/***/ "fBw0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("BHZN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-resolution-code-category-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        categoryId: {
            required: false
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */]
    },
    data: function data() {
        return {
            form: {
                productId: undefined,
                name: ''
            },
            rules: {
                productId: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectProduct'),
                    trigger: 'change'
                }],
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterName'),
                    trigger: 'blur'
                }]
            },
            loading: false,
            showDialog: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadCategory: function loadCategory() {
            var _this = this;

            if (this.categoryId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCategory(this.categoryId).then(function (response) {
                    _this.loading = false;
                    _this.form = Object.assign({}, response.data);
                }).catch(function () {
                    _this.loading = false;
                    _this.$message({
                        type: 'error',
                        message: _this.$t('common.errorLoadingData')
                    });
                });
            }
        },
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        save: function save() {
            var _this2 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCategory(_this2.categoryId, _this2.form).then(function () {
                        _this2.loading = false;
                        _this2.$emit('save', {
                            new: _this2.categoryId === undefined,
                            id: _this2.categoryId,
                            data: _this2.form
                        });
                        _this2.$message({
                            type: 'success',
                            message: _this2.categoryId == null ? _this2.$t('masters.categoryCreated') : _this2.$t('masters.categoryUpdated')
                        });
                        _this2.closeDialog();
                    }).catch(function () {
                        _this2.loading = false;
                        _this2.$message({
                            type: 'error',
                            message: _this2.$t('common.errorSavingData')
                        });
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ "fEXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "fFT0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("W2s3");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/canadian-taxes',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* CanadianTaxList */],
  name: 'canadianTaxList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "fO0/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "GzPh",
	"./fr.json": "gqzI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fO0/";

/***/ }),

/***/ "fRW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectCountry'),"loading":_vm.loading},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.countries),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fZCd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_c('el-radio-group',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"size":"small"},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}},[_c('el-radio-button',{attrs:{"label":null}},[_vm._v(_vm._s(_vm.$t('claims.active')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.newTotal)+" "+_vm._s(_vm.$t('common.new')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.mircTotal)+" "+_vm._s(_vm.$t('common.moreInformationRequiredClaims')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":7}},[_vm._v(_vm._s(_vm.prpcTotal)+" "+_vm._s(_vm.$t('common.pendingReturnPartClaims')))]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-radio-button',{attrs:{"label":5}},[_vm._v(_vm._s(_vm.modifiedTotal)+" "+_vm._s(_vm.$t('common.modifiedClaims')))]):_vm._e(),_vm._v(" "),_c('el-radio-button',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.rejectedTotal)+" "+_vm._s(_vm.$t('common.rejectedClaims')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":0}},[_vm._v(_vm._s(_vm.deletedTotal)+" "+_vm._s(_vm.$t('common.deletedClaims')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":6}},[_vm._v(_vm._s(_vm.paidTotal)+" "+_vm._s(_vm.$t('common.paidClaims')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":10}},[_vm._v(_vm._s(_vm.techReviewTotal)+" "+_vm._s(_vm.$t('common.pendingTechnicalReviewClaims')))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":1.8}},[_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))])],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":3}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.raisedBy'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.RaisedBy),callback:function ($$v) {_vm.$set(_vm.filter, "RaisedBy", $$v)},expression:"filter.RaisedBy"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.searchAllClaims'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"display":"flex","justify-content":"flex-end","margin-right":"35px","margin-bottom":"20px"}},[_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.placeHolderDateFrom},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{staticStyle:{"width":"auto"},attrs:{"span":3}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.placeHolderDateTo},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"claims-table tablewithshading",attrs:{"size":"mini","data":_vm.claims},on:{"sort-change":_vm.sortClaims}},[_c('el-table-column',{attrs:{"prop":"claimNumber","label":_vm.$t('common.claimNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('common.invoiceNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.total'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.total))+"\n                    ")]}}])}),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.$i18n.locale == 'en')?_c('el-select',{on:{"change":function($event){_vm.handleStatusChange(scope.row.id, scope.row.status)}},model:{value:(scope.row.status),callback:function ($$v) {_vm.$set(scope.row, "status", $$v)},expression:"scope.row.status"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingTechnicalReview'),"value":"10"}})],1):_c('el-select',{on:{"change":function($event){_vm.handleStatusChange(scope.row.id, scope.row.statusFr)}},model:{value:(scope.row.statusFr),callback:function ($$v) {_vm.$set(scope.row, "statusFr", $$v)},expression:"scope.row.statusFr"}},[_c('el-option',{attrs:{"label":_vm.$t('common.new'),"value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.acceptAndProcess'),"value":"2"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.moreinfoRequired'),"value":"3"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.rejected'),"value":"4"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.paid'),"value":"6"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingReturnPart'),"value":"7"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingRepairCodeCorrections'),"value":"8"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.correctedRepairCodes'),"value":"9"}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('common.pendingTechnicalReview'),"value":"10"}})],1)]}}])}):_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"raisedBy","label":_vm.$t('common.raisedBy'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"Raised On","label":_vm.$t('reports.createdOn'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.raisedOn))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('claims.daysCompletion'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{class:{ 'red-bolded': scope.row.daysCompletion > 30, 'green-bolded': scope.row.daysCompletion <= 30 }},[_vm._v(_vm._s(scope.row.daysCompletion))])]}}])}),_vm._v(" "),(this.statusForShowingDates == 6)?_c('el-table-column',{attrs:{"label":_vm.$t('common.acceptedDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.acceptedDate))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),(this.statusForShowingDates == 3 || this.statusForShowingDates == 7)?_c('el-table-column',{attrs:{"label":_vm.$t('claims.commentDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(_vm.showDateOfComment(scope.row)))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),(this.statusForShowingDates == 5)?_c('el-table-column',{attrs:{"label":_vm.$t('claims.modifiedDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.modifiedDate))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),(this.statusForShowingDates == 4)?_c('el-table-column',{attrs:{"label":_vm.$t('claims.rejectedDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.rejectedDate))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),(this.statusForShowingDates == 0)?_c('el-table-column',{attrs:{"label":_vm.$t('claims.deletedDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.deletedDate))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),(this.statusForShowingDates == 10)?_c('el-table-column',{attrs:{"label":_vm.$t('claims.assignedDate'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("date")(scope.row.assignedDate))+"\n                    ")]}}])}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.serviceTicketNumber'),"prop":"serviceTicketId","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(scope.row.serviceTicketId)+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),(scope.row.status == 'Partial' || scope.row.status == 'MoreInformationRequired' || _vm.$isFullAdmin)?_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.viewClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin || (_vm.$isUser && scope.row.status == 'Partial'))?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteClaim(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-claim-dialog',{attrs:{"claimId":_vm.claimToEdit,"visible":_vm.updateClaimVisible},on:{"dialogClosed":_vm.updateClaimFinished,"previewClaim":_vm.viewClaim,"showClaimPreview":_vm.showClaimPreview,"showClaimConfirm":_vm.showClaimConfirm}}),_vm._v(" "),_c('preview-claim-dialog',{attrs:{"claimId":_vm.claimToView,"visible":_vm.previewClaimVisible,"isForPartial":_vm.isForPartial},on:{"dialogClosed":_vm.previewClaimFinished,"editClaim":_vm.editClaim,"claimPublished":_vm.claimPublished,"statusChanged":_vm.statusChanged}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fabG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("1w+w");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "fapr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "globalapp"
});

/***/ }),

/***/ "fboY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/* harmony default export */ __webpack_exports__["a"] = ({
    saveGeneral: function saveGeneral(id, form) {
        var fd = new FormData();
        for (var prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'workOrders') {
                    for (var i = 0; i < form.workOrders.length; i++) {
                        if (form.workOrders[i] instanceof File) {
                            fd.append('workOrders', form.workOrders[i]);
                        } else {
                            fd.append('oldAttachmentIds', form.workOrders[i].id);
                        }
                    }
                } else {
                    if (form[prop] instanceof Date) {
                        fd.append(prop, form[prop].toISOString());
                    } else {
                        fd.append(prop, form[prop]);
                    }
                }
            }
        }
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/api/claims/' + id, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }

        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/claims', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    saveSiteInfo: function saveSiteInfo(id, form, codes) {
        var request = Object.assign({}, form);
        request.repairCodes = codes.map(function (c) {
            return {
                id: c.code.id,
                regularTime: c.regularTime,
                supplementaryRegularTime: c.supplementaryRegularTime,
                overTime: c.overTime,
                supplementaryOverTime: c.supplementaryOverTime,
                Comment: c.supplementaryComment
            };
        });
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/api/claims/' + id + '/siteinfo', request);
    },
    saveLaborTravel: function saveLaborTravel(id, form) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/api/claims/' + id + '/labor', form);
    },
    saveParts: function saveParts(id, parts, miscParts) {
        var request = {
            parts: parts.map(function (p) {
                return {
                    id: p.part.id,
                    quantity: p.quantity
                };
            }),
            miscParts: miscParts.map(function (p) {
                return {
                    name: p.part.name,
                    price: p.part.price,
                    extendedPrice: p.part.extendedPrice,
                    quantity: p.quantity
                };
            })
        };
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/api/claims/' + id + '/parts', request);
    },
    saveTotal: function saveTotal(id, form, claimId) {
        form.isNewClaim = typeof claimId == 'undefined' || claimId == null;
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/api/claims/' + id + '/totals', form);
    },
    publishClaim: function publishClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/claims/' + id + '/publish');
    },
    getRmaNumber: function getRmaNumber() {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/getRmaNumber');
    },
    processClaim: function processClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/claims/' + id + '/process');
    },
    sendRmaFormLink: function sendRmaFormLink(claimId) {
        var data = { claimId: claimId };
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/rma/sendLinkToRmaCreation', data);
    },
    saveRma: function saveRma(form) {

        var data = {
            attnId: form.attn,
            serviceTicket: _extends({}, form.serviceTicket, { rmaId: form.id, raisedOn: form.serviceTicket.raisedOn }),
            serviceCompany: _extends({}, form.serviceCompany),
            serviceTicketId: form.serviceTicketId,
            serviceCompanyId: form.serviceCompanyId,
            claimId: form.claimId,
            shippingMethod: form.shippingMethod,
            countryOfOrigin: form.countryOfOrigin,
            serviceTicketNumber: form.serviceTicketNumber,
            invoiceNumber: form.invoiceNumber,
            claimNumber: form.claimNumber,
            id: form.id,
            attns: [],
            parts: form.parts,
            claimStatus: form.claimStatus,
            rmaDate: form.rmaDate,
            comment: form.comment,
            reason: form.reason
        };
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/rma/saveRma', data);
    },
    getTrackingInfo: function getTrackingInfo(trackNumber) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            var result;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/rma/getTrackingInfo', { trackNumber: trackNumber });

                        case 2:
                            result = _context.sent;
                            return _context.abrupt('return', result);

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },
    submitComment: function submitComment(id, form) {
        var fd = new FormData();
        for (var prop in form) {
            if (form.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (var i = 0; i < form.attachments.length; i++) {
                        if (form.attachments[i] instanceof File) {
                            fd.append('attachments', form.attachments[i]);
                        }
                    }
                } else {
                    if (form[prop] != null) {
                        fd.append(prop, form[prop]);
                    }
                }
            }
        }
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/claims/' + id + '/comments', fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteClaim: function deleteClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/api/claims/' + id);
    },
    getClaims: function getClaims(page, filter, sorting) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims', {
            params: {
                page: page,
                q: filter.text,
                raisedBy: filter.RaisedBy,
                active: filter.active,
                status: filter.status,
                dateFrom: filter.dateFrom,
                dateTo: filter.dateTo,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder
            }
        });
    },
    getClaim: function getClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/' + id);
    },
    getClaimPreview: function getClaimPreview(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/' + id + '/preview');
    },
    getRepairCodes: function getRepairCodes(productId, text) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/resolutioncodes/lookup/' + productId, {
            params: {
                q: text,
                details: true
            }
        });
    },
    getParts: function getParts(term, serviceCompanyId, productId) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/parts/lookup', {
            params: {
                term: term,
                serviceCompanyId: serviceCompanyId,
                productId: productId,
                unavailableForClaims: true
            }
        });
    },
    validateServiceTicketNumber: function validateServiceTicketNumber(number) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/validateServiceTicketNumber', {
            params: {
                number: number
            }
        });
    },
    validateInvoiceNumber: function validateInvoiceNumber(number, claimId) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/validateinvoice', {
            params: {
                number: number,
                claimId: claimId
            }
        });
    },
    validateSerialNumber: function validateSerialNumber(number, product, coverage, is90Days) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/validateserial', {
            params: {
                number: number,
                productId: product,
                serviceCoverage: coverage,
                is90DaysWarranty: is90Days
            }
        }).then(function (response) {
            return response.data;
        });
    },
    printClaim: function printClaim(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/' + id + '/print');
    },
    printRma: function printRma(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/rma/' + id + '/print');
    },
    getCategories: function getCategories() {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/dashboard/categories/claims');
    },
    getPartById: function getPartById(id, serviceCompanyId, isNotWarrantyClaim) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/parts/' + id + '/' + serviceCompanyId + '/' + isNotWarrantyClaim + '/dashboard');
    },
    changeStatusOfClaim: function changeStatusOfClaim(id, claimStatus) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/claims/' + id + '/' + claimStatus);
    },
    loadComments: function loadComments(id) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/' + id + '/comments');
    },
    download: function download(url) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.download(url);
    },
    sendEmailToReviewer: function sendEmailToReviewer(id, reviewerId) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/claims/' + id + '/sendEmail/' + reviewerId);
    },
    exportView: function exportView(page, filter, sorting) {
        var params = {
            page: page,
            q: filter.text,
            raisedBy: filter.RaisedBy,
            active: filter.active,
            status: filter.status,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.download('/api/claims/export', params);
    }
});

/***/ }),

/***/ "ff6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__("iK3N");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_2__app__["b" /* routes */]
});
router.beforeEach(function (to, from, next) {
    if (to.meta.admin && !__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isAdmin) {
        next('/');
    } else {
        next();
    }
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "fkD9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateCustomerDialog__ = __webpack_require__("XQmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChainSelector__ = __webpack_require__("T4VY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("065F");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "customer-list",
  components: {
    CreateUpdateCustomerDialog: __WEBPACK_IMPORTED_MODULE_1__CreateUpdateCustomerDialog__["a" /* default */],
    CountrySelector: __WEBPACK_IMPORTED_MODULE_3__app_shared_components__["g" /* CountrySelector */],
    ChainSelector: __WEBPACK_IMPORTED_MODULE_2__ChainSelector__["a" /* default */]
  },
  data: function data() {
    return {
      customers: [],
      customerEquipment: [],
      loading: true,
      exporting: false,
      dialogVisible: false,
      customerToEdit: undefined,
      filter: {
        countryId: undefined,
        chainId: undefined,
        text: undefined,
        city: undefined,
        zip: undefined,
        state: undefined
      },
      sort: undefined,
      currentPage: 1,
      total: 0
    };
  },
  created: function created() {
    this.loadCustomers();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        this.loadCustomers();
      }
    }
  },
  methods: {
    download: function download() {
      var _this = this;

      this.exporting = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download(this.filter, this.sort).then(function () {
        _this.exporting = false;
      });
    },
    sortChanged: function sortChanged(sort) {
      this.sort = sort;
      if (this.currentPage === 1) {
        this.loadCustomers();
      } else {
        this.currentPage = 1;
      }
    },
    expanded: function expanded(row, expandedRows) {
      var _this2 = this;

      var isExpanded = expandedRows.indexOf(row);
      if (isExpanded !== -1) {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getEquipment(row.id).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this2.customerEquipment, row.id, response.data);
          //[row.id] = response.data;
        });
      }
    },
    loadCustomers: function loadCustomers() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getCustomers(this.currentPage, this.filter.countryId, this.filter.chainId, this.filter.text, this.filter.city, this.filter.zip, this.filter.state, this.sort, "").then(function (response) {
        _this3.loading = false;
        _this3.customers = response.data.items;
        _this3.total = response.data.total;
      });
    },
    appendCustomer: function appendCustomer(event) {
      this.loadCustomers();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadCustomers();
    },
    editCustomer: function editCustomer(id) {
      this.customerToEdit = id;
      this.dialogVisible = true;
    },
    editFinished: function editFinished() {
      this.customerToEdit = null;
      this.dialogVisible = false;
    },
    deleteCustomer: function deleteCustomer(id) {
      var _this4 = this;

      this.$confirm(this.$t('common.thisWillDeleteCustomerContinue'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].deleteCustomer(id).then(function () {
          _this4.loadCustomers();
          _this4.$message({
            type: "success",
            message: _this4.$t('common.deleteCompleted')
          });
        });
      }).catch(function (_) {});
    }
  }
});

/***/ }),

/***/ "g3GU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTickets_vue__ = __webpack_require__("ZA9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3a2a00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTickets_vue__ = __webpack_require__("XExK");
function injectStyle (ssrContext) {
  __webpack_require__("pX9V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a3a2a00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTickets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3a2a00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTickets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g71Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("L7kv");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'resolution-category-selector',
  props: {
    value: {},
    productId: {
      type: Number,
      default: undefined
    }
  },
  data: function data() {
    return {
      loading: false,
      categories: []
    };
  },

  watch: {
    productId: function productId(val) {
      var _this = this;

      if (!val) {
        this.categories = [];
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCategories(val).then(function (response) {
          _this.loading = false;
          _this.categories = response.data;
        });
      }
    }
  }
});

/***/ }),

/***/ "gFtL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("LY9n");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/service-tickets/:status?',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["b" /* ServiceTicketList */],
    name: 'serviceTicketList',
    meta: { admin: true }
}, {
    path: '/service-tickets/email/:ticketId?',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["c" /* ServiceTicketListFromEmail */],
    name: 'serviceTicketListFromEmail'
}]);

/***/ }),

/***/ "gG23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.categoryId == null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('common.category'),"visible":_vm.showDialog,"width":"500px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadCategory,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v("\n            "+_vm._s(_vm.categoryId === null ? _vm.$t('common.create') : _vm.$t('common.update'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v("\n            "+_vm._s(_vm.$t('common.cancel'))+"\n        ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gJWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getTickets: function getTickets(filteredBy, filter, page, sorting) {
        var params = {
            filteredBy: filteredBy,
            customer: filter.customer,
            ticket: filter.ticket,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo,
            serialNumber: filter.serialNumber,
            page: page,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder
        };
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/escalatedtickets', { params: params });
    },
    getEscalationCounts: function getEscalationCounts() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/escalationcounts');
    },
    getTicketDetail: function getTicketDetail(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/escalationdialog/' + id);
    }
});

/***/ }),

/***/ "gXVo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCountryDialog_vue__ = __webpack_require__("/cZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5292b4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCountryDialog_vue__ = __webpack_require__("KUXf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateCountryDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5292b4ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateCountryDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gdxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.customerId ? 'Update' : 'Create') + ' ' + _vm.$t('common.customer'),"visible":_vm.showDialog,"width":"60%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadCustomer,"close":_vm.closeDialog}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.createCountry}},[_vm._v("\n        "+_vm._s(_vm.$t('masters.createCountry'))+"\n    ")]),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeStep),callback:function ($$v) {_vm.activeStep=$$v},expression:"activeStep"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('masters.customerDetails'),"name":"generalInfo"}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":"Chain","prop":"chainId"}},[_c('chain-selector',{model:{value:(_vm.form.chainId),callback:function ($$v) {_vm.$set(_vm.form, "chainId", $$v)},expression:"form.chainId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.number'),"prop":"no"}},[_c('el-input',{model:{value:(_vm.form.no),callback:function ($$v) {_vm.$set(_vm.form, "no", $$v)},expression:"form.no"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.name'),"prop":"name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.contactPerson'),"prop":"contactPersonName"}},[_c('el-input',{model:{value:(_vm.form.contactPersonName),callback:function ($$v) {_vm.$set(_vm.form, "contactPersonName", $$v)},expression:"form.contactPersonName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.classification'),"prop":"classification"}},[_c('el-radio-group',{model:{value:(_vm.form.classification),callback:function ($$v) {_vm.$set(_vm.form, "classification", $$v)},expression:"form.classification"}},[_c('el-radio',{attrs:{"label":"1"}},[_vm._v("A")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"2"}},[_vm._v("B")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"3"}},[_vm._v("C")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"RS","prop":"isRs"}},[_c('el-switch',{model:{value:(_vm.form.isRs),callback:function ($$v) {_vm.$set(_vm.form, "isRs", $$v)},expression:"form.isRs"}})],1),_vm._v(" "),_c('address-selector',{attrs:{"showRegional":true},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}),_vm._v(" "),(_vm.form.selectedCountryState && !_vm.customerId)?_c('company-selector',{ref:"companySelector",attrs:{"serviceCompany":_vm.form.primaryServiceCompanyId,"country":_vm.form.selectedCountryState[0],"state":_vm.form.selectedCountryState[1],"city":_vm.form.city,"address":_vm.form.address,"zip":_vm.form.zip},on:{"update:serviceCompany":function($event){_vm.$set(_vm.form, "primaryServiceCompanyId", $event)}},model:{value:(_vm.form.empty),callback:function ($$v) {_vm.$set(_vm.form, "empty", $$v)},expression:"form.empty"}}):_vm._e(),_vm._v(" "),(_vm.form.selectedCountryState && _vm.customerId)?_c('company-selector',{ref:"companySelector",attrs:{"serviceCompany":_vm.form.primaryServiceCompanyId,"country":_vm.form.selectedCountryState[0],"state":_vm.form.selectedCountryState[1],"city":_vm.form.city,"address":_vm.form.address,"zip":_vm.form.zip},on:{"update:serviceCompany":function($event){_vm.$set(_vm.form, "primaryServiceCompanyId", $event)}},model:{value:(_vm.form.info),callback:function ($$v) {_vm.$set(_vm.form, "info", $$v)},expression:"form.info"}}):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.$t('masters.contactInfo')))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.phone'),"prop":"phone"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.email'),"prop":"email"}},[_c('el-input',{model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1),_vm._v(" "),(_vm.customerId)?_c('h3',[_vm._v(_vm._s(_vm.$t('common.equipment')))]):_vm._e(),_vm._v(" "),(_vm.customerId)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",staticStyle:{"margin-bottom":"15px"},attrs:{"size":"mini","data":_vm.form.registeredEquipment}},[_c('el-table-column',{attrs:{"prop":"model","label":_vm.$t('common.model')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":_vm.$t('reports.serialNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyStartString","label":_vm.$t('common.warrantyStart')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyEndString","label":_vm.$t('common.warrantyEnd')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"disabled":_vm.loading,"type":"text"},on:{"click":function($event){_vm.editEquipment(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('common.edit')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading,"type":"text"},on:{"click":function($event){_vm.deleteEquipment(scope.row.id)}}},[_vm._v(_vm._s(_vm.$t('common.delete')))])]}}])})],1):_vm._e(),_vm._v(" "),_c('span',[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.customerId ? 'Update' : 'Create'))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('masters.notifications'),"name":"notifications"}},[_c('el-scrollbar',{staticStyle:{"margin":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.notifications),function(notification){return _c('li',{key:notification.id},[_c('p',[_vm._v("\n                            "+_vm._s(notification.message)+"\n                            "),_c('el-button',{staticStyle:{"float":"right","margin":"0 10px"},attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.deleteNotification(notification.id)}}},[_vm._v(_vm._s(_vm.$t('common.delete')))]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin":"0 10px"},attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.editNotification(notification)}}},[_vm._v(_vm._s(_vm.$t('common.edit')))])],1)])}))]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('masters.newNotificationColon'))+"\n                "),_c('el-input',{staticStyle:{"margin-bottom":"10px"},attrs:{"type":"textarea"},model:{value:(_vm.notificationMessage),callback:function ($$v) {_vm.notificationMessage=$$v},expression:"notificationMessage"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.saveNotification()}}},[_vm._v(_vm._s(_vm.isEditNotification ? 'Edit Notification' : 'Add Notification'))]),_vm._v(" "),(_vm.isEditNotification)?_c('el-button',{on:{"click":function($event){_vm.cancelNotification()}}},[_vm._v(_vm._s(_vm.$t('common.cancel')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('masters.cookingParameters'),"name":"cookinParams"}},[_c('el-scrollbar',{staticStyle:{"margin":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.cookingParams),function(cookingParam){return _c('li',{key:cookingParam.id},[_c('p',[_vm._v("\n                            "+_vm._s(cookingParam.cookingParam)+"\n                            "),_c('el-button',{staticStyle:{"float":"right","margin":"0 10px"},attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.deleteCookingParam(cookingParam.id)}}},[_vm._v(_vm._s(_vm.$t('common.delete')))]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","margin":"0 10px"},attrs:{"type":"text","size":"small"},on:{"click":function($event){_vm.editCookingParam(cookingParam)}}},[_vm._v(_vm._s(_vm.$t('common.edit')))])],1)])}))]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(_vm.$t('masters.newCookingParameterColon'))+"\n                "),_c('el-input',{staticStyle:{"margin-bottom":"10px"},attrs:{"type":"textarea"},model:{value:(_vm.cookingParam),callback:function ($$v) {_vm.cookingParam=$$v},expression:"cookingParam"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.saveCookingParam()}}},[_vm._v(_vm._s(_vm.isEditCookingParam ? 'Edit CookingParam' : 'Add CookingParam'))]),_vm._v(" "),(_vm.isEditCookingParam)?_c('el-button',{on:{"click":function($event){_vm.cancelCookingParam()}}},[_vm._v(_vm._s(_vm.$t('common.cancel')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('masters.qrCode'),"name":"qrCode"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[(_vm.form.qrCodeImg)?_c('img',{staticStyle:{"width":"200px","margin":"0 auto"},attrs:{"src":_vm.form.qrCodeImg}}):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"10px"}},[(_vm.form.qrCodeImg)?_c('el-button',{on:{"click":function($event){_vm.downloadQrCode()}}},[_vm._v("Download QR Code")]):_vm._e()],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gkJ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "glOV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AddressSelector__ = __webpack_require__("u1Kk");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AddressSelector__["a"]; });


/***/ }),

/***/ "gq8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("BHZN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-resolution-code-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        codeId: {
            required: false
        }
    },
    components: {
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */], ResolutionCategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["m" /* ResolutionCategorySelector */]
    },
    data: function data() {
        return {
            form: {
                productId: undefined,
                categoryId: undefined,
                code: '',
                description: '',
                labor: null,
                maxTime: null
            },
            rules: {
                productId: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectProduct'),
                    trigger: 'change'
                }],
                categoryId: [{
                    type: 'number',
                    required: true,
                    message: this.$t('common.pleaseSelectProduct'),
                    trigger: 'change'
                }],
                code: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCode'),
                    trigger: 'blur'
                }],
                description: [{
                    required: true,
                    message: this.$t('common.pleaseEntercodeDescription'),
                    trigger: 'blur'
                }],
                labor: [{
                    required: true,
                    message: this.$t('common.pleaseEnterLabor')
                }, { type: 'number', message: this.$t('common.laborMustBeANumber') }],
                maxTime: [{
                    required: true,
                    message: this.$t('common.pleaseEnterMaxTime')
                }, { type: 'number', message: this.$t('common.maxTimeMustBeANumber') }]
            },
            loading: false,
            showDialog: this.visible
        };
    },

    watch: {
        'form.productId': function formProductId(val, oldVal) {
            if (this.codeId && oldVal === undefined) {
                return;
            }
        },
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadCode: function loadCode() {
            var _this = this;

            if (this.codeId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCode(this.codeId).then(function (response) {
                    _this.loading = false;
                    _this.form = Object.assign({}, response.data);
                });
            }
        },
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        save: function save() {
            var _this2 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCode(_this2.codeId, _this2.form).then(function () {
                        _this2.$emit('save', {
                            new: _this2.codeId === undefined,
                            id: _this2.codeId,
                            data: _this2.form
                        });
                        _this2.closeDialog();
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ "gqlD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketListFromEmail_vue__ = __webpack_require__("s3+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99e13234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketListFromEmail_vue__ = __webpack_require__("oFnY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketListFromEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99e13234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketListFromEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gqzI":
/***/ (function(module, exports) {

module.exports = {"createFolder":"Cr�er le dossier","parentFolder":"Dossier parent","newFolderName":"Nouveau nom de dossier","uploadDocument":"T�l�charger un document","folder":"Dossier","documents":"Documents","uploadedFilesLength":"Longueur des fichiers t�l�charg�s�:","upload":"T�l�charger","totalFilesLength":"Longueur totale des fichiers�:"}

/***/ }),

/***/ "gtb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("XXsu");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "part-selector",

  props: {
    serviceCompanyId: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedPart: undefined,
      parts: []
    };
  },

  methods: {
    searchParts: function searchParts(term) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getParts(term, this.serviceCompanyId).then(function (response) {
        self.loading = false;
        self.parts = response.data;
      });
    },
    partSelected: function partSelected(value) {
      if (value) {
        this.$emit("part-selected", Object.assign({}, value));
      }
    }
  }
});

/***/ }),

/***/ "h84l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectServiceCoverage'),"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h88m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EmailsList__ = __webpack_require__("4aim");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EmailsList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmailDetailsDialog__ = __webpack_require__("lNhV");
/* unused harmony reexport EmailDetailsDialog */



/***/ }),

/***/ "hB37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard__ = __webpack_require__("fabG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__orders__ = __webpack_require__("vhVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accounting__ = __webpack_require__("ecSz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__servicetickets__ = __webpack_require__("Zu5x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__costcoservicerequests__ = __webpack_require__("vw1y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__equipment__ = __webpack_require__("Kmfk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__claims__ = __webpack_require__("ekSx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__technicaldocumentation__ = __webpack_require__("AWBh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__masters_canadiantaxes__ = __webpack_require__("SIBk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__masters_complaintcodes__ = __webpack_require__("t8d6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__masters_customerchains__ = __webpack_require__("7ece");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__masters_customers__ = __webpack_require__("HxW8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__masters_parts__ = __webpack_require__("Dcm2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__masters_products__ = __webpack_require__("xQon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__masters_resolutioncodes__ = __webpack_require__("IOUG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__masters_servicecompanies__ = __webpack_require__("MnOV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__emails__ = __webpack_require__("587g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__masters_users__ = __webpack_require__("5KcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reports__ = __webpack_require__("sRsp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rma__ = __webpack_require__("n9Dq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Faq__ = __webpack_require__("Nx7Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__globalapp_escalationdashboard__ = __webpack_require__("tCss");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
























/* harmony default export */ __webpack_exports__["a"] = ([].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0__dashboard__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__orders__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__accounting__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__servicetickets__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__costcoservicerequests__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__equipment__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__claims__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__masters_canadiantaxes__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__masters_complaintcodes__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_18__reports__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__masters_customerchains__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_11__masters_customers__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_12__masters_parts__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_13__masters_products__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_14__masters_resolutioncodes__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_15__masters_servicecompanies__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_17__masters_users__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__technicaldocumentation__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_19__rma__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_20__Faq__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_21__globalapp_escalationdashboard__["a" /* routes */]), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_16__emails__["a" /* routes */])));

/***/ }),

/***/ "hBPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__ = __webpack_require__("ZQmh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425e59da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__ = __webpack_require__("ZAFL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425e59da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hBnb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":4}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('country-selector',{attrs:{"clearable":""},model:{value:(_vm.filter.countryId),callback:function ($$v) {_vm.$set(_vm.filter, "countryId", $$v)},expression:"filter.countryId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.city')},model:{value:(_vm.filter.city),callback:function ($$v) {_vm.$set(_vm.filter, "city", $$v)},expression:"filter.city"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.zip')},model:{value:(_vm.filter.zip),callback:function ($$v) {_vm.$set(_vm.filter, "zip", $$v)},expression:"filter.zip"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('chain-selector',{model:{value:(_vm.filter.chainId),callback:function ($$v) {_vm.$set(_vm.filter, "chainId", $$v)},expression:"filter.chainId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.name')},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":3}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.state')},model:{value:(_vm.filter.state),callback:function ($$v) {_vm.$set(_vm.filter, "state", $$v)},expression:"filter.state"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.customers},on:{"sort-change":_vm.sortChanged,"expand-change":_vm.expanded}},[_c('el-table-column',{attrs:{"type":"expand"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(_vm.customerEquipment[props.row.id] && _vm.customerEquipment[props.row.id].length > 0)?_c('el-table',{staticClass:"tablewithshading",attrs:{"size":"mini","data":_vm.customerEquipment[props.row.id]}},[_c('el-table-column',{attrs:{"prop":"model","label":_vm.$t('common.model')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":_vm.$t('common.serialNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyStart","label":_vm.$t('common.warrantyStart')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.warrantyStart))+"\n                        ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"warrantyEnd","label":_vm.$t('common.warrantyEnd')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                            "+_vm._s(_vm._f("date")(scope.row.warrantyEnd))+"\n                        ")]}}])})],1):_vm._e(),_vm._v(" "),(!_vm.customerEquipment[props.row.id] || _vm.customerEquipment[props.row.id].length === 0)?_c('el-alert',{attrs:{"closable":false,"title":_vm.$t('masters.customerHasNoEquipment'),"type":"info"}}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","prop":"no","label":_vm.$t('common.number')}}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"custom","prop":"name","label":_vm.$t('common.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"country","label":_vm.$t('common.country')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.phone')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'callto:'+scope.row.phone}},[_vm._v(_vm._s(scope.row.phone))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 160 : 116 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editCustomer(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteCustomer(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-customer-dialog',{attrs:{"customerId":_vm.customerToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendCustomer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hTs4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"filterable":"","clearable":"","remote":"","allow-create":"","remote-method":_vm.searchserviceTickets,"placeholder":_vm.$t('shared.pleaseSelectTicket'),"loading":_vm.loading},on:{"change":function($event){_vm.selectCustomer($event)}}},_vm._l((_vm.serviceTickets),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hbpE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("sT8e");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "equipment-list",
    data: function data() {
        return {
            equipmentList: [],
            loading: true,
            filter: {
                text: undefined
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            exporting: false
        };
    },
    created: function created() {
        this.loadEquipment();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadEquipment();
            }
        }
    },
    methods: {
        loadEquipment: function loadEquipment() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getEquipmentList(this.currentPage, this.filter.text, this.sorting).then(function (response) {
                _this.loading = false;
                _this.equipmentList = response.data.items;
                _this.total = response.data.total;
            });
        },
        sortEquipment: function sortEquipment(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadEquipment();
            } else {
                this.currentPage = 1;
            }
        },
        appendEquipment: function appendEquipment(equipment) {
            this.equipmentList.push(equipment);
            this.total += 1;
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadEquipment();
        },
        deleteEquipment: function deleteEquipment(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteEquipmentContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteEquipment(id).then(function () {
                    _this2.loadEquipment();
                    _this2.$message({
                        type: "success",
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        download: function download() {
            var _this3 = this;

            this.exporting = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].download(this.filter.text).then(function () {
                _this3.exporting = false;
            });
        }
    }
});

/***/ }),

/***/ "hdl+":
/***/ (function(module, exports) {

module.exports = {"listPrice":"List Price","extendedPrice":"Extended Price","returnNeeded":"Return needed","price":"Price","supplementaryRegularTime":"Supplementary Regular Time","supplementaryOverTime":"Supplementary Over Time","supplementaryComment":"Supplementary Comment","active":"Active","daysCompletion":"Days Completion","commentDate":"Comment Date","modifiedDate":"Modified Date","rejectedDate":"Rejected Date","deletedDate":"Deleted Date","assignedDate":"Assigned Date","claim":"Claim","claimAccountInformation":"Claim Account Information","90daysWarranty":"90 Days Warranty","serviceWorkOrderNumber":"Service Work Order Number","dateWorkCompleted":"Date Work Completed","workOrders":"Work Orders","siteInformation":"Site Information","clientStore":"Client store","pleaseSelectSubContractor":"Please select sub-contractor","pleaseSelectSubAgent":"Please select sub-agent","serviceTechnicianName":"Service Technician Name","serviceRequestedBy":"Service Requested By","reportSymptoms":"Report Symptoms","clickHereToAddRepairCodes":"Click Here To Add Repair Codes","clickHereToAddMultipleRepairCodesPerformedWithSingleLaborTime":"Click Here To Add Multiple Repair Codes Performed With Single Labor Time","regTime":"Reg Time","suppRegTime":"Supp Reg Time","suppOverTime":"Supp Over Time","numberOfTrips":"Number Of Trips","chooseExplanation":"Choose explanation","customerRequestedWeReturn":"Customer requested we return","didNotHaveThePartsOnHandInStock":"Did not have the parts on hand/in stock","technicalKnowledgeIssue":"Technical knowledge issue","hardtRequestedWeReturn":"Hardt requested we return","ovenInUse":"Oven in use","otherExplanation":"Other explanation","enterExplanation":"Enter explanation","regularTravelHours":"Regular Travel Hours","overtimeTravelHours":"Overtime Travel Hours","mileageMiles":"Mileage (miles)","overtimeMileageMiles":"Overtime Mileage (miles)","serviceFuelCharge":"Service & Fuel Charge","laborSupplementary":"Labor Supplementary","laborOvertime":"Labor Overtime","laborOvertimeSupplementary":"Labor Overtime Supplementary","travel":"Travel","travelOvertime":"Travel Overtime","mileageOvertime":"Mileage Overtime","rmaCreateRMA":"RMA & Create RMA","createRMALink":"Create RMA Link","clickHereToAddParts":"Click Here To Add Parts","miscParts":"Misc Parts","clickHereToAddMiscellaneousParts":"Click Here To Add Miscellaneous Parts","partName":"Part Name","labourTravel":"Labour & Travel","handling":"Handling","hardtOriginalInvoice":"HARDT Original Invoice","tax":"Tax (if applicable)","newComment":"New comment","newClaimStatus":"New claim status","attachment":"Attachment","postComment":"Post Comment","rma":"RMA"}

/***/ }),

/***/ "hoZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendEmailDialog_vue__ = __webpack_require__("yCWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b724aec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendEmailDialog_vue__ = __webpack_require__("XZ6V");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SendEmailDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b724aec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SendEmailDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hpk7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RMA__ = __webpack_require__("HchN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__RMA__["a"]; });


/***/ }),

/***/ "i7TQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.categoryName,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectCode'),"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.categories),function(item){return _c('el-option',{attrs:{"label":item,"value":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iK3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("hB37");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("jKG3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__App__["a"]; });



/***/ }),

/***/ "iNqm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRepairCodeDialog_vue__ = __webpack_require__("1l2M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b5565b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRepairCodeDialog_vue__ = __webpack_require__("HKIw");
function injectStyle (ssrContext) {
  __webpack_require__("mX48")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70b5565b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddRepairCodeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b5565b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddRepairCodeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iXAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SendEmailDialog__ = __webpack_require__("hoZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CreateServiceTicketDialog__ = __webpack_require__("rb25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("H50Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__masters_customers_components_ChainSelector_vue__ = __webpack_require__("T4VY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-ticket-list",
    components: {
        ServiceTicketDetailsDialog: __WEBPACK_IMPORTED_MODULE_1__ServiceTicketDetailsDialog__["a" /* default */],
        CustomerSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["h" /* CustomerSelector */],
        CreateServiceTicketDialog: __WEBPACK_IMPORTED_MODULE_3__CreateServiceTicketDialog__["a" /* default */],
        ChainSelector: __WEBPACK_IMPORTED_MODULE_5__masters_customers_components_ChainSelector_vue__["a" /* default */]
    },
    data: function data() {
        return {
            tickets: [],
            loading: true,
            selfServiceOptions: [{ value: "external", label: 'External' }, { value: "internal", label: 'Internal' }],
            dialogVisible: false,
            ticketToEdit: null,
            createServiceTicketDialogVisible: false,
            filter: {
                type: this.$route.params.status || null,
                customerId: "",
                ticket: "",
                city: "",
                state: "",
                serviceCompany: "",
                fromDate: "",
                toDate: "",
                serialNumber: "",
                source: "",
                chainId: undefined
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            categories: [],
            openTotal: null,
            closedTotal: null,
            flaggedTotal: null,
            flaggedClosedTotal: null,
            escalationTotal: null,
            escalationClosedTotal: null,
            postInstallInstallTotal: null,
            exporting: false,
            emailTicketId: this.$route.params.ticketId
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler() {
                if (this.filter.status === null && this.$route.params.status != null) {
                    window.location.href = "/#/service-tickets";
                }
                this.loadTickets();
            }
        }
    },
    created: function created() {
        this.loadTickets();
        this.loadCategories();
    },

    methods: {
        truncateComment: function truncateComment(row, column, cellValue) {
            var limit = 40;
            return this.truncate(cellValue, limit);
        },
        truncate: function truncate(value, limit) {
            if (!value) return '';
            if (value.length <= limit) return value;
            return value.substring(0, limit) + '...';
        },
        formattedHour: function formattedHour(decimalHour) {
            var hour = Math.floor(decimalHour);
            var minute = Math.round((decimalHour - hour) * 60);
            minute = (minute < 10 ? '0' : '') + minute;
            return hour + " hrs: " + minute + " min";
        },
        showCreateServiceTicketDialog: function showCreateServiceTicketDialog(id) {
            this.ticketToEdit = id;
            this.createServiceTicketDialogVisible = true;
        },
        ticketUpdated: function ticketUpdated() {
            this.loadTickets();
        },
        loadTickets: function loadTickets() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getTickets(this.currentPage, this.filter, this.sorting).then(function (response) {
                _this.loading = false;
                _this.tickets = response.data.items;
                _this.total = response.data.total;
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadTickets();
        },
        editTicket: function editTicket(id) {
            this.ticketToEdit = id;
            this.dialogVisible = true;
        },
        copyTicket: function copyTicket(id) {
            this.ticketToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        },
        loadCategories: function loadCategories() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getCategories().then(function (response) {
                _this2.loading = false;
                _this2.categories = response.data;
            });
        },
        download: function download() {
            var _this3 = this;

            this.exporting = true;
            if (!this.filter.dateFrom && !this.filter.dateTo) {
                var dateToday = new Date();
                var day = dateToday.getDate();
                var month = Number(dateToday.getMonth() + 1);
                var year = Number(dateToday.getFullYear());
                this.$confirm(this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download(_this3.filter).then(function () {
                        _this3.exporting = false;
                        _this3.$message({
                            title: _this3.$t('common.success'),
                            message: _this3.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }).catch(function (_) {
                    _this3.exporting = false;
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download(this.filter).then(function () {
                    _this3.exporting = false;
                    _this3.$message({
                        title: _this3.$t('common.success'),
                        message: _this3.$t('common.exportWasGeneratedSuccesfully'),
                        type: "success"
                    });
                });
            }
        },
        sortServiceTickets: function sortServiceTickets(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadTickets();
            } else {
                this.currentPage = 1;
            }
        },
        calculateNameToBeShown: function calculateNameToBeShown(complaint) {
            return complaint.code + "--" + complaint.description;
        },
        tableRowEscalationTime: function tableRowEscalationTime(_ref) {
            var row = _ref.row,
                column = _ref.column;

            if (row.daysSinceRaised >= 0 && row.daysSinceRaised <= 4) {
                return 'success-row';
            } else if (row.daysSinceRaised > 4 && row.daysSinceRaised <= 6) {
                return 'warning-row';
            } else if (row.daysSinceRaised > 6) {
                return 'error-row';
            } else {
                return 'default-row';
            }
        }
    }
});

/***/ }),

/***/ "iaHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__UserList__ = __webpack_require__("lxc3");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__UserList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateUserDialog__ = __webpack_require__("mFvy");
/* unused harmony reexport CreateUpdateUserDialog */



/***/ }),

/***/ "ih/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeList_vue__ = __webpack_require__("N/vI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130da86e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeList_vue__ = __webpack_require__("5ERq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResolutionCodeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130da86e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResolutionCodeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ihjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartOrderList_vue__ = __webpack_require__("0BtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd7d5588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartOrderList_vue__ = __webpack_require__("bjD9");
function injectStyle (ssrContext) {
  __webpack_require__("JVhq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd7d5588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartOrderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd7d5588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartOrderList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ijhd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("fboY");
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "claim-part-selector",

  props: {
    serviceCompanyId: {
      type: Number
    },
    productId: {
      type: Number
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedPart: undefined,
      parts: []
    };
  },

  methods: {
    searchParts: function searchParts(term) {
      if (term !== "") {
        var self = this;
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getParts(term, this.serviceCompanyId, this.productId).then(function (response) {
          self.loading = false;
          self.parts = response.data;
        });
      }
    },
    partSelected: function partSelected(value) {
      if (value === "") {
        this.parts = [];
      }
      this.$emit("part-selected", this.parts.find(function (c) {
        return c.id === value;
      }));
    },
    reset: function reset() {
      this.selectedPart = undefined;
      this.parts = [];
    }
  }
});

/***/ }),

/***/ "iqu8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartOrderList__ = __webpack_require__("ihjT");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__PartOrderList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdatePartOrderDialog__ = __webpack_require__("+9af");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CreateUpdatePartOrderDialog__["a"]; });



/***/ }),

/***/ "irhS":
/***/ (function(module, exports) {

module.exports = {"subCategory":"Sous-catégorie","mandatoryParts":"Pièces obligatoires","recommendedParts":"Pièces recommandées","toAddAnotherPartPleaseStartTypingNameOrPartNumber":"Pour ajouter une autre pièce, veuillez commencer à taper le nom ou le numéro de pièce","storeNumberRequired":"Numéro de magasin requis","addRule":"Ajouter une règle","validationRules":"Règles de validation","pleaseSelectChain":"Veuillez sélectionner la chaîne","customerDetails":"Détails du client","createCountry":"Créer un pays","classification":"Classification","notifications":"Avis","newNotificationColon":"Nouvelle notification :","cookingParameters":"Paramètres de cuisson","qrCode":"Le QR Code","newCookingParameterColon":"Nouveau paramètre de cuisson :","customerHasNoEquipment":"Le client n'a pas d'équipement","searchNotifications":"Avis de recherche","messages":"messages","customerHasNoNotifications":"Le client n'a pas de notifications","numberOfNotifications":"","pleaseEnterTheNotification":"Veuillez entrer la notification","needsReturn":"Besoin de retour","extDiscountRate":"Ext. ","usListPrice":"Prix ​​de liste aux États-Unis","cdnListPrice":"Prix ​​courant CDN","unavailableForPartsOrders":"Non disponible pour les commandes de pièces","unavailableForClaimsDeactivated":"Indisponible pour les réclamations (Désactivé)","authorizationNumRequired":"Autorisation","pleaseLeaveCommentBeforeDeactivatePart":"Merci de laisser un commentaire avant de désactiver la partie","extendedPriceRate":"Taux de prix étendu","usExtendedPrice":"Prix ​​étendu aux États-Unis","cdnExtendedPrice":"Prix ​​CDN étendu","shipVia":"Transporté par","authReq":"Auth Req.","errorsWhileImporting":"Erreurs lors de l'importation","AreYouSureThatYouWantToImportParts":"Êtes-vous sûr de vouloir importer des pièces ?","partsWillBeUpdated":"les pièces seront mises à jour","partsWillBeDeleted":"les pièces seront supprimées","partsWillBeAdded":"des pièces seront ajoutées","serialPrefix":"Préfixe de série","laborGLCode":"Code GL du travail","partGLCode":"Code partie GL","handlingGLCode":"Gestion du code GL","freightGLCode":"Code GL de fret","miscGLCode":"Code GL divers","note":"FR? Service Ticket Note","type":"Taper","resolutionCode":"Code de résolution","epicorSupplierCode":"Code fournisseur Epicor","companyType":"Type de compagnie","regular":"Régulier","parent":"Parent","subAgent":"Sous-agent","parentAccount":"Compte Parent","rating":"Notation","isLimited":"Est limité","isAuthorized":"Est autorisé","contactInfo":"Informations de contact","bilingAccountEmail":"E-mail du compte de facturation","serviceEmail":"E-mail de service","serviceEmail2":"Courriel de service 2","partsEmail":"E-mail de pièces","warrantyRates":"Tarifs de garantie","lastUpdate":"Dernière mise à jour","regularTimeRates":"Tarifs horaires réguliers","laborRate":"Taux de la main-d'œuvre","travel":"Voyage","travelRate":"Taux de déplacement","mileageRate":"Taux de kilométrage","overtimeRates":"Taux des heures supplémentaires","nonWarrantyRates":"Tarifs hors garantie","branchContractor":"Entrepreneur de succursale","weWillSendEmailToResetPassword":"Nous enverrons un e-mail pour réinitialiser le mot de passe","searchByNameOrCode":"Recherche par nom ou code","suspendServiceCompany":"Suspendre la société de services","activateServiceCompany":"Activer la société de service","impersonate":"Imiter","userName":"Nom d'utilisateur","isReadOnly":"Est en lecture seule","isSuperAdmin":"Est super administrateur","symptomCode":"Code de symptôme","customerChain":"Chaîne de clientèle","part":"Partie","product":"Produit","descriptionlengtherror":"La description ne peut pas dépasser 500 caractères."}

/***/ }),

/***/ "j2Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("OMHR");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/FAQ',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* FAQ */],
  name: 'FAQ'
}]);

/***/ }),

/***/ "j5tU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('shared.pleaseSelectEquipment'),"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.equipmentList),function(item){return _c('el-option',{key:item.id,attrs:{"label":_vm.buildFromItem(item),"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "email-details-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            required: true
        },
        subject: {
            required: true
        },
        body: {
            required: true
        }
    },
    data: function data() {
        return {
            showDialog: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadTicket: function loadTicket() {
            console.log("Load Ticket");
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.$emit("dialogClosed");
        }
    }
});

/***/ }),

/***/ "jCQl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EscalationList__ = __webpack_require__("Dghl");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EscalationList__["a"]; });


/***/ }),

/***/ "jDMI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PDFPage__ = __webpack_require__("7UCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__("tVBY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDFPage: __WEBPACK_IMPORTED_MODULE_0__PDFPage__["a" /* default */]
  },
  props: ["url", "scale"],
  data: function data() {
    return {
      pdf: undefined,
      pages: [],
      pageNumber: 1,
      page: null
    };
  },
  created: function created() {
    this.fetchPDF();
  },

  watch: {
    pdf: function pdf(_pdf) {
      var _this = this;

      var promise = _pdf.getPage(this.pageNumber);
      promise.then(function (page) {
        _this.page = page;
      });
    }
  },
  methods: {
    fetchPDF: function fetchPDF() {
      var _this2 = this;

      __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "N1Pc")).then(function (pdfjs) {
        return pdfjs.getDocument(_this2.url);
      }).then(function (pdf) {
        return _this2.pdf = pdf;
      });
    }
  }
});

/***/ }),

/***/ "jDhz":
/***/ (function(module, exports) {

module.exports = {"customerAddressColon":"Customer address:","customerPhoneColon":"Customer phone:","gasTypeColon":"Gas type:","serviceCompanyColon":"Service company:","serviceCompanyEmailColon":"Service company email:","serviceCompanyServiceEmailColon":"Service company service email:","serviceCompanyPartsEmailColon":"Service company parts email:","serviceCompanyPhoneColon":"Service company phone:","serial":"Serial","shippingDate":"Shipping Date","equipmentRegistration":"Equipment Registration","createCustomer":"Create customer","gasType":"Gas Type","notApplicable":"Not Applicable","natural":"Natural","propane":"Propane","pickDate":"Pick date","installationDate":"Installation Date","copyAndCreate":"Copy & Create"}

/***/ }),

/***/ "jKG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("JvoI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7779e5b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mziX");
function injectStyle (ssrContext) {
  __webpack_require__("DTo4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7779e5b3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jLoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdatePartDialog__ = __webpack_require__("Z7Se");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("sXP7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "part-list",
  components: {
    CreateUpdatePartDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdatePartDialog__["a" /* default */],
    ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */]
  },
  data: function data() {
    return {
      parts: [],
      loading: true,
      dialogVisible: false,
      partToEdit: null,
      filter: {
        productId: undefined,
        text: undefined
      },
      currentPage: 1,
      total: 0,
      showErrors: false,
      errors: undefined,
      isEditMode: false,
      importConfirmVisible: false,
      importConfirm: {
        partsToUpdate: 0,
        partsToDelete: 0,
        newParts: 0
      },
      files: []
    };
  },
  created: function created() {
    this.loadParts();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        this.loadParts();
      }
    }
  },
  methods: {
    download: function download() {
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].download(this.filter);
    },
    upload: function upload() {
      var _this = this;

      this.importConfirmVisible = false;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].upload(this.files.item(0)).then(function (response) {
        _this.files = [];
        _this.$refs["uploader"].value = "";
        if (response.data.success) {
          _this.$notify({
            title: _this.$t('common.success'),
            message: _this.$t('common.partsSuccesfullyImported'),
            type: "success"
          });
          _this.loadParts();
        } else {
          _this.showErrors = true;
          _this.errors = response.data.errors;
        }
      });
    },
    handleFileUpload: function handleFileUpload(event) {
      var _this2 = this;

      if (event.target.files.length > 0 && event.target.files.item(0).name.split(".").pop() == "xlsx") {
        this.files = event.target.files;
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].uploadConfirm(event.target.files.item(0)).then(function (response) {
          if (response.data.success) {
            _this2.importConfirm.partsToUpdate = response.data.partsToUpdate;
            _this2.importConfirm.partsToDelete = response.data.partsToDelete;
            _this2.importConfirm.newParts = response.data.newParts;
            _this2.importConfirmVisible = true;
          } else {
            _this2.showErrors = true;
            _this2.errors = response.data.errors;
          }
        });
      }
    },
    closeDialog: function closeDialog() {
      this.showErrors = false;
      this.errors = undefined;
    },
    loadParts: function loadParts() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getParts(this.currentPage, this.filter.productId, this.filter.text).then(function (response) {
        _this3.parts = response.data.items;
        _this3.parts.forEach(function (x) {
          x.extendedPriceRate = x.extendedPriceRate.toString();
          x.isAuthRequired = x.isAuthRequired ? true : false;
        });
        _this3.total = response.data.total;
        _this3.loading = false;
      });
    },
    appendPart: function appendPart(event) {
      if (event.new) {
        this.parts.push(event.data);
        this.total += 1;
      } else {
        this.loadParts();
      }
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var _this4 = this;

      if (this.isEditMode) {
        this.$confirm(this.$t('common.allUnsavedChangesWillBeLostContinue'), "Warning", {
          confirmButtonText: this.$t('common.OK'),
          cancelButtonText: this.$t('common.cancel'),
          type: "warning"
        }).then(function () {
          _this4.currentPage = page;
          _this4.loadParts();
        }).catch(function (_) {});
      } else {
        this.currentPage = page;
        this.loadParts();
      }
    },
    handleCancelEditMode: function handleCancelEditMode() {
      var _this5 = this;

      if (!this.isEditMode) {
        this.$confirm(this.$t('common.allUnsavedChangesWillBeLostContinue'), "Warning", {
          confirmButtonText: this.$t('common.OK'),
          cancelButtonText: this.$t('common.cancel'),
          type: "warning"
        }).then(function () {
          _this5.loadParts();
        }).catch(function (_) {
          _this5.isEditMode = true;
        });
      }
    },
    editPart: function editPart(id) {
      this.partToEdit = id;
      this.dialogVisible = true;
    },
    editFinished: function editFinished() {
      this.partToEdit = null;
      this.dialogVisible = false;
    },
    deletePart: function deletePart(id) {
      var _this6 = this;

      this.$confirm(this.$t('common.thisWillDeletePartContinue'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deletePart(id).then(function () {
          _this6.loadParts();
          _this6.$message({
            type: "success",
            message: _this6.$t('common.deleteCompleted')
          });
        });
      }).catch(function (_) {});
    },
    saveEdited: function saveEdited() {
      var _this7 = this;

      if (!this.isEditMode) {
        return;
      }
      var self = this;
      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].saveParts(_this7.parts).then(function (response) {
          if (response.data.success) {
            self.$notify({
              title: _this7.$t('common.success'),
              message: _this7.$t('common.partsWereSuccesfullySubmitted'),
              type: "success"
            });
            self.isEditMode = false;
          } else {
            response.data.errors.forEach(function (error) {
              self.$notify({
                title: "Error",
                message: error,
                type: "error"
              });
            });
          }
        });
      }).catch(function (_) {});
    },
    uploadConfirm: function uploadConfirm() {
      this.$refs["uploader"].click();
    },
    backup: function backup() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].backup().then(function (response) {
        _this8.upload();
      });
    }
  }
});

/***/ }),

/***/ "jPsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"filterable":"","clearable":"","remote":"","remote-method":_vm.searchCustomers,"placeholder":_vm.$t('shared.pleaseSelectCustomer'),"loading":_vm.loading},on:{"change":function($event){_vm.selectCustomer($event)}}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jTjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("w9Cu");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/claims/:status?',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ClaimList */],
  name: 'claimList'
}]);

/***/ }),

/***/ "k9z6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kDWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintCodeSelector_vue__ = __webpack_require__("FDz7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e5b710_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintCodeSelector_vue__ = __webpack_require__("POLb");
function injectStyle (ssrContext) {
  __webpack_require__("/mdh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40e5b710"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintCodeSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40e5b710_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintCodeSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kFxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dashboard__ = __webpack_require__("u6Cr");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dashboard__["a"]; });


/***/ }),

/***/ "kJnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e(),_vm._v(" "),_c('input',{ref:"uploader",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-upload"},on:{"click":_vm.uploadConfirm}},[_vm._v(_vm._s(_vm.$t('common.import')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('span',{staticStyle:{"margin-left":"15px"}},[_c('label',[_vm._v("Edit Mode")]),_vm._v(" "),_c('el-switch',{on:{"change":_vm.handleCancelEditMode},model:{value:(_vm.isEditMode),callback:function ($$v) {_vm.isEditMode=$$v},expression:"isEditMode"}}),_vm._v(" "),(_vm.isEditMode)?_c('el-button',{on:{"click":_vm.saveEdited}},[_vm._v(_vm._s(_vm.$t('common.save')))]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('product-selector',{model:{value:(_vm.filter.productId),callback:function ($$v) {_vm.$set(_vm.filter, "productId", $$v)},expression:"filter.productId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.parts}},[_c('el-table-column',{attrs:{"prop":"no","label":_vm.$t('common.number'),"width":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEditMode)?_c('div',{staticClass:"cell"},[_vm._v("\n                    "+_vm._s(scope.row.no)+"\n                ")]):_c('div',[_c('el-input',{model:{value:(scope.row.no),callback:function ($$v) {_vm.$set(scope.row, "no", $$v)},expression:"scope.row.no"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description'),"width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEditMode)?_c('div',{staticClass:"cell"},[_vm._v("\n                    "+_vm._s(_vm.$i18n.locale == 'en' ? scope.row.description : scope.row.descriptionFr)+"\n                ")]):_c('div',[_c('el-input',{model:{value:(scope.row.description),callback:function ($$v) {_vm.$set(scope.row, "description", $$v)},expression:"scope.row.description"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"extendedPriceRate","label":_vm.$t('masters.extendedPriceRate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEditMode)?_c('div',{staticClass:"cell"},[_vm._v("\n                    "+_vm._s(scope.row.extendedPriceRate == 2 ? '50%' : '35%')+"\n                ")]):_c('div',[_c('el-select',{model:{value:(scope.row.extendedPriceRate),callback:function ($$v) {_vm.$set(scope.row, "extendedPriceRate", $$v)},expression:"scope.row.extendedPriceRate"}},[_c('el-option',{attrs:{"label":"35%","value":"1"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"50%","value":"2"}})],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"usPrice.listPrice","label":_vm.$t('masters.usListPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEditMode)?_c('div',{staticClass:"cell"},[_vm._v("\n                    "+_vm._s(scope.row.usPrice.listPrice)+"\n                ")]):_c('div',[_c('el-input',{model:{value:(scope.row.usPrice.listPrice),callback:function ($$v) {_vm.$set(scope.row.usPrice, "listPrice", $$v)},expression:"scope.row.usPrice.listPrice"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"usPrice.extendedPrice","label":_vm.$t('masters.usExtendedPrice')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cdnPrice.listPrice","label":_vm.$t('masters.cdnListPrice')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.isEditMode)?_c('div',{staticClass:"cell"},[_vm._v("\n                    "+_vm._s(scope.row.cdnPrice.listPrice)+"\n                ")]):_c('div',[_c('el-input',{model:{value:(scope.row.cdnPrice.listPrice),callback:function ($$v) {_vm.$set(scope.row.cdnPrice, "listPrice", $$v)},expression:"scope.row.cdnPrice.listPrice"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cdnPrice.extendedPrice","label":_vm.$t('masters.cdnExtendedPrice')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"shippingMethod","label":_vm.$t('masters.shipVia')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"isAuthRequired","label":_vm.$t('masters.authReq')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.isAuthRequired ? _vm.$t('common.yes') : _vm.$t('common.no'))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"countryOfOrigin","label":_vm.$t('common.coo')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"132"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editPart(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deletePart(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('el-dialog',{staticClass:"part-dialog",attrs:{"title":_vm.$t('masters.errorsWhileImporting'),"visible":_vm.showErrors,"width":"60%","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showErrors=$event},"close":_vm.closeDialog}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errors)}})]),_vm._v(" "),_c('create-update-part-dialog',{attrs:{"partId":_vm.partToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendPart}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('masters.AreYouSureThatYouWantToImportParts'),"visible":_vm.importConfirmVisible,"width":"50%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.importConfirmVisible=$event}}},[_c('span',[_vm._v(_vm._s(_vm.importConfirm.partsToUpdate)+" "+_vm._s(_vm.$t('masters.partsWillBeUpdated')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.importConfirm.partsToDelete)+" "+_vm._s(_vm.$t('masters.partsWillBeDeleted')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.importConfirm.newParts)+" "+_vm._s(_vm.$t('masters.partsWillBeAdded')))]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.importConfirmVisible = false}}},[_vm._v(_vm._s(_vm.$t('common.no')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.backup()}}},[_vm._v(_vm._s(_vm.$t('common.yes')))])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kKqp":
/***/ (function(module, exports) {

module.exports = {"createdFrom":"Créé à partir de","acceptedDateFrom":"Date d'acceptation à partir de","customerChain":"Chaîne de clients","createdTo":"Créé jusqu'à","acceptedDateTo":"Date d'acceptation jusqu'à","modifiedStatus":"Statut modifié","noDatesChoosenMessage":"Si aucune date n'est choisie, le rapport sera généré par défaut sur une période d'un an à aujourd'hui !","createdOn":"Créé le","workOrderNumber":"Numéro de commande de travail","dateCompleted":"Date de complétion","claimReportSymptoms":"Symptômes du rapport de réclamation","repairDescription":"Description de la réparation","repairCategory":"Catégorie de réparation","laborTime":"Temps de main d'œuvre","laborCharge":"Charge de main d'œuvre","travelTime":"Temps de déplacement","travelCharge":"Frais de déplacement","truckCharge":"Frais de camion","partsCharge":"Frais de pièces","handlingFee":"Frais de manutention","dateProcessed":"Date de traitement","originalHardtInvoice":"Facture originale Hardt","freightCharge":"Frais de transport","salesTax":"Taxe de vente","totalCharge":"Total des frais","customerAddress":"Adresse du client","customerCity":"Ville du client","customerProvince":"Province du client","customerCountry":"Pays du client","customerZip":"Code postal du client","serviceCompanyProvince":"Province de la société de service","serviceCompanyZip":"Code postal de la société de service","tripsNumber":"Nombre de voyages","wasModified":"A été modifié","pleaseSelectType":"Veuillez sélectionner le type","parameters":"Paramètres","dateFromAcceptedDate":"Date à partir de (Date d'acceptation)","dateToAcceptedDate":"Date jusqu'à (Date d'acceptation)","sortBy":"Trier par","customerNumber":"Numéro de client","province":"Province","company":"Entreprise","dateOfCompletion":"Date de complétion","sortDescending":"Trier par ordre décroissant","exportToExcel":"Exporter vers Excel","claimCreationDate":"Date de création de la réclamation","dateOfCompletition":"Date de complétion","daysToInvoice":"Jours avant la facturation","customerNo":"Numéro de client","laborHours":"Heures de main d'œuvre","travelTruckMileage":"Déplacement, camion et kilométrage","laborRegularHours":"Heures de main d'œuvre régulières","laborRegularTotal":"Total de main d'œuvre régulière","laborOvertimeHours":"Heures supplémentaires de main d'œuvre","laborOvertimeTotal":"Total des heures supplémentaires de main d'œuvre","noDataFound":"Aucune donnée trouvée avec ces paramètres. Veuillez vérifier les paramètres.","viewMore":"Voir plus","edit":"Modifier","claimsPerModel":"Réclamations en $ par modèle","choosePeriod":"Choisissez la période","chooseModel":"Choisissez le modèle","from":"Depuis","to":"Pour","attn":"À l'attention","rmaStatus":"Statut RMA","countryOfOrigin":"Pays d'origine","authorizationNumber":"Numéro d'autorisation","modelNumber":"Numéro de modèle","pleaseSelectatLeastOneColumn":"Veuillez sélectionner au moins une colonne pour générer le rapport !","raiseOnDate":"Date d'élévation","toRaisedDate":"Jusqu'à la date de Raid","state":"État","serialNumber":"En série","serviceCompanyPhoneNumber":"Numéro de téléphone de la société de services","claimDate":"Date de réclamation"}

/***/ }),

/***/ "kj/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ComplaintCodeSelector__ = __webpack_require__("kDWN");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ComplaintCodeSelector__["a"]; });


/***/ }),

/***/ "kkDv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("ABK5");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'country-selector',
    props: ['value'],
    data: function data() {
        return {
            loading: false,
            countries: []
        };
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getCountries().then(function (countries) {
            _this.loading = false;
            _this.countries = countries;
        });
    }
});

/***/ }),

/***/ "knv9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"clearable":"","filterable":"","placeholder":_vm.$t('masters.pleaseSelectChain'),"loading":_vm.loading},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.chains),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kriW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProductList__ = __webpack_require__("hBPL");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProductList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateProductDialog__ = __webpack_require__("oznG");
/* unused harmony reexport CreateUpdateProductDialog */



/***/ }),

/***/ "kum8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("kriW");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/products',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ProductList */],
  name: 'productList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "kwnR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalApp_vue__ = __webpack_require__("fapr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71349536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalApp_vue__ = __webpack_require__("9Fxv");
function injectStyle (ssrContext) {
  __webpack_require__("MDFF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GlobalApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71349536_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GlobalApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l++A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleSelector_vue__ = __webpack_require__("qlZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439f3e42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleSelector_vue__ = __webpack_require__("p5ts");
function injectStyle (ssrContext) {
  __webpack_require__("ao2v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-439f3e42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoleSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_439f3e42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoleSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l3fA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lNhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailDetailsDialog_vue__ = __webpack_require__("jBpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01883cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailDetailsDialog_vue__ = __webpack_require__("nOjy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailDetailsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01883cb1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailDetailsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "lXaJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "le7S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectShippingMethod'),"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lfPk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lkUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerList_vue__ = __webpack_require__("fkD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9ebc73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerList_vue__ = __webpack_require__("hBnb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9ebc73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lqBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search"},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.customerChains}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('common.name'),"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('masters.validationRules')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.validationRules),function(rule){return _c('el-tag',{key:rule,staticStyle:{"margin-right":"10px"},attrs:{"type":"info"}},[_vm._v(_vm._s(rule))])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('masters.storeNumberRequired')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.storeNumberRequired)?_c('i',{staticClass:"el-icon-check"}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 160 : 116 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editCustomerChain(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(_vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteCustomerChain(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-customer-chain-dialog',{attrs:{"customerChainId":_vm.customerChainToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendCustomerChain}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lqfw":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "4ap1",
	"./fr.json": "irhS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lqfw";

/***/ }),

/***/ "lxc3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__ = __webpack_require__("eNsn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6fc943_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__ = __webpack_require__("vQoq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6fc943_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m4RV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mAoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceCompanyList_vue__ = __webpack_require__("cx5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3140368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceCompanyList_vue__ = __webpack_require__("yacA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceCompanyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3140368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceCompanyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mFvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateUserDialog_vue__ = __webpack_require__("Rhgp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a86b144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateUserDialog_vue__ = __webpack_require__("VA7P");
function injectStyle (ssrContext) {
  __webpack_require__("cOmU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a86b144_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mIN7":
/***/ (function(module, exports) {

module.exports = {"countryProvince":"Country / Province","selectCountryAndProvince":"Select country and province","zip":"Zip","pleaseSelectCode":"Please select code","selectChainAndRule":"Select chain and rule","allowedDistance":"Allowed distance(Mls.)","pleaseSelectServiceCompany":"Please select service company","noCompaniesInCurrentProvince":"No companies in current province","pleaseSelectCountry":"Please select country","pleaseSelectCustomer":"Please select customer","pleaseSelectEquipment":"Please select equipment","pleaseSelectProduct":"Please select product","pleaseSelectCategory":"Please select category","pleaseSelectATTN":"Please select ATTN","pleaseSelectStatus":"Please select status","pleaseSelectRole":"Please select role","pleaseSelectServiceCoverage":"Please select service coverage","pleaseSelectOvertimeApproved":"Please select overtime approved","pleaseSelectShippingMethod":"Please select shipping method","pleaseSelectTicket":"Please select ticket","changePassword":"Change Password","oldPassword":"Old Password","newPassword":"New Password","change":"Change","logout":"Logout","returnToMyAccount":"Return to my account","orderParts":"Order Parts","newClaim":"New Claim","newServiceTicket":"New Service Ticket","registerEquipment":"Register Equipment","selectLanguage":"Select Language","english":"English","french":"French","dashboard":"Dashboard","claimsFAQ":"Claims FAQ","accounting":"Accounting","reports":"Reports","graphs":"Graphs","claimHistory":"Claim History","priceList":"Price list","resolutionCodes":"Resolution Codes","resolutionCodeCategories":"Resolution Code Categories","usedParts":"Used Parts","simsAPReport":"Sims AP Report","masterData":"Master Data","customers":"Customers","customersNotifications":"Customers Notifications","customerChains":"Customer Chains","serviceCompanies":"Service Companies","products":"Products","canadianTaxes":"Canadian Taxes","users":"Users","technicalDocumentation":"Technical Documentation","loggedIn":"Logged in as "}

/***/ }),

/***/ "mX48":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mziX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{attrs:{"id":"app"}},[_c('el-aside',{staticStyle:{"overflow":"unset"},attrs:{"width":"250px"}},[_c('span',{class:'env env-'+_vm.env},[_vm._v(_vm._s(_vm.env))]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"draggable":"false","src":"static/STS-header-logo.png","alt":"HARDT logo"}}),_vm._v(" "),_c('navigation',{on:{"place-order":_vm.showPlaceOrderDialog,"new-claim":_vm.showNewClaimDialog,"new-service-ticket":_vm.showCreateServiceTicketDialog,"register-equipment":_vm.showRegisterEquipmentDialog}})],1),_vm._v(" "),_c('el-container',[_c('el-main',[_c('router-view')],1)],1),_vm._v(" "),_c('create-update-part-order-dialog',{attrs:{"visible":_vm.orderDialogVisible},on:{"dialogClosed":function($event){_vm.orderDialogVisible = false}}}),_vm._v(" "),_c('create-update-claim-dialog',{attrs:{"visible":_vm.claimDialogVisible},on:{"dialogClosed":function($event){_vm.claimDialogVisible = false}}}),_vm._v(" "),_c('equipment-registration-dialog',{attrs:{"equipmentId":_vm.equipmentId,"visible":_vm.registerEquipmentDialogVisible},on:{"dialogClosed":_vm.equipmentDialogClose}}),_vm._v(" "),_c('create-service-ticket-dialog',{attrs:{"visible":_vm.createServiceTicketDialogVisible},on:{"dialogClosed":function($event){_vm.createServiceTicketDialogVisible = false}}}),_vm._v(" "),_c('create-update-customer-dialog',{attrs:{"visible":_vm.customerCreateDialogVisible},on:{"dialogClosed":function($event){_vm.customerCreateDialogVisible = false}}}),_vm._v(" "),_c('create-country-dialog',{attrs:{"visible":_vm.countryCreateDialogVisible},on:{"dialogClosed":function($event){_vm.countryCreateDialogVisible = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n0TB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"id":"rmaStatusSelectorInput","value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectStatus'),"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('input', $event)}}},[_vm._l((_vm.reOpenStatuses),function(item){return (_vm.value == 0 || _vm.value == 2)?_c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}}):_vm._e()}),_vm._v(" "),_vm._l((_vm.statuses),function(item){return (_vm.value == 1)?_c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}}):_vm._e()})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n36o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("p4R0");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var glCodeValidator = {
    validator: function validator(rule, value, callback) {
        if (/^\d{4}-\d{3}-\d{3}$/.test(value)) {
            callback();
        } else {
            callback('Use XXXX-XXX-XXX format.');
        }
    },
    trigger: 'blur'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'create-update-product-dialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        productId: {
            required: false
        }
    },
    data: function data() {
        return {
            form: {
                no: undefined,
                name: undefined,
                altName: undefined,
                model: undefined,
                serialPrefix: undefined,
                laborGLCode: undefined,
                partGLCode: undefined,
                handlingGLCode: undefined,
                freightGLCode: undefined,
                miscGLCode: undefined,
                note: undefined
            },
            rules: {
                no: [{
                    required: true,
                    message: this.$t('common.pleaseEnterProductNumber'),
                    trigger: 'blur'
                }],
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterProductName'),
                    trigger: 'blur'
                }],
                model: [{
                    required: true,
                    message: this.$t('common.pleaseEnterModel'),
                    trigger: 'blur'
                }],
                serialPrefix: [{
                    required: true,
                    message: this.$t('common.pleaseEnterSerialPrefix'),
                    trigger: 'blur'
                }],
                laborGLCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterLaborGLCode'),
                    trigger: 'blur'
                }, glCodeValidator],
                partGLCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPartGLCode'),
                    trigger: 'blur'
                }, glCodeValidator],
                handlingGLCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterHandlingGLCode'),
                    trigger: 'blur'
                }, glCodeValidator],
                freightGLCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterFreightGLCode'),
                    trigger: 'blur'
                }, glCodeValidator],
                miscGLCode: [{
                    required: true,
                    message: this.$t('common.pleaseEnterMiscGLCode'),
                    trigger: 'blur'
                }, glCodeValidator]
            },
            loading: false,
            showDialog: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadProduct: function loadProduct() {
            var _this = this;

            if (this.productId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getProduct(this.productId).then(function (response) {
                    _this.loading = false;
                    _this.form = Object.assign({}, response.data);
                });
            }
        },
        closeDialog: function closeDialog() {
            this.$refs['form'].resetFields();
            this.showDialog = false;
            this.loading = false;
            this.$emit('dialogClosed');
        },
        save: function save() {
            var _this2 = this;

            this.$refs['form'].validate(function (valid) {
                if (valid) {
                    _this2.loading = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].saveProduct(_this2.productId, _this2.form).then(function (response) {
                        _this2.$emit('save', {
                            new: _this2.productId === undefined,
                            id: _this2.productId,
                            data: _this2.form
                        });
                        _this2.closeDialog();
                    }).catch(function (err) {
                        _this2.loading = false;
                        _this2.$message(_this2.$t('common.creationFailed'));
                    });
                } else {
                    return false;
                }
            });
        }
    }
});

/***/ }),

/***/ "n9Dq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("sK4M");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "nANx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nOjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.subject,"visible":_vm.showDialog,"width":"650px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadTicket,"close":_vm.closeDialog}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nRd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nb5a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ndkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "delivery-info",
  data: function data() {
    return {
      form: {
        deliverySignedBy: "",
        deliveryDate: new Date()
      },
      rules: {
        deliverySignedBy: [{
          required: true,
          message: this.$t('common.pleaseEnterPersonName'),
          trigger: "blur"
        }],
        deliveryDate: [{
          required: true,
          message: this.$t('common.pleaseEnterDate'),
          trigger: "change"
        }]
      }
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.$emit("update", _this.form);
        }
      });
    }
  }
});

/***/ }),

/***/ "nlNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{staticClass:"selector",attrs:{"placeholder":_vm.$t('shared.selectChainAndRule'),"value":_vm.value,"options":_vm.chains,"filterable":"","change-on-select":""},on:{"change":function($event){_vm.$emit('input', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nnwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("065F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-update-customer-dialog",
    components: {
        AddressSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["a" /* AddressSelector */],
        ChainSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["d" /* ChainSelector */],
        CompanySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["e" /* CompanySelector */]
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        customerId: {
            required: false
        }
    },
    data: function data() {
        var _this = this;

        return {
            form: {
                primaryServiceCompanyId: undefined,
                chainId: undefined,
                no: undefined,
                name: undefined,
                contactPersonName: undefined,
                classification: undefined,
                selectedCountryState: undefined,
                city: undefined,
                address: undefined,
                regional: undefined,
                region: undefined,
                zip: undefined,
                phone: undefined,
                email: undefined,
                activeStep: "generalInfo",
                notificationMessage: "",
                notificationId: undefined,
                isEditNotification: false,
                registeredEquipment: undefined,
                isRs: false,
                cookingParam: "",
                cookingParamId: undefined,
                isEditCookingParam: false,
                info: undefined,
                empty: ""
            },
            rules: {
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCustomerName'),
                    trigger: "blur"
                }, {
                    validator: function validator(rule, value, callback) {
                        var chainHasRule = _this.form.chainId && _this.form.chainId[1];
                        var chainRule = _this.form.chainId ? _this.form.chainId[1] : undefined;
                        if (chainHasRule) {
                            if (!chainRule) {
                                callback(new Error(_this.$t('common.pleaseSelectChainFirst')));
                                return;
                            }
                            if (chainRule && !value.startsWith(chainRule)) {
                                callback(new Error(_this.$t('common.customerNameShouldStartWith') + (" '" + chainRule + "'")));
                                return;
                            }
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                no: [{
                    required: true,
                    message: this.$t('common.pleaseEnterNumber'),
                    trigger: "blur"
                }],
                classification: [{
                    required: true,
                    message: this.$t('common.pleaseEnterClassification'),
                    trigger: "change"
                }],
                chainId: [{
                    validator: function validator(rule, value, callback) {
                        if (!value || value === "") {
                            callback(new Error(_this.$t('masters.plaseSelectChain')));
                        } else {
                            callback();
                        }
                    },
                    type: "array",
                    required: true,
                    message: this.$t('masters.plaseSelectChain'),
                    trigger: "change"
                }],
                selectedCountryState: [{
                    type: "array",
                    required: true,
                    message: this.$t('common.pleaseEnterProvinceAndCountry'),
                    trigger: "change"
                }],
                city: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCity'),
                    trigger: "blur"
                }],
                address: [{
                    required: true,
                    message: this.$t('common.pleaseEnterAddress'),
                    trigger: "blur"
                }],
                zip: [{
                    required: true,
                    message: this.$t('common.pleaseEnterZip'),
                    trigger: "blur"
                }],
                phone: [{
                    required: true,
                    message: this.$t('common.pleaseEnterPhone'),
                    trigger: "blur"
                }],
                primaryServiceCompanyId: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.isCanadaOrUsa && _this.isEmptyServiceCompany) {
                            callback(new Error(_this.$t('common.pleaseSelectServiceCompany')));
                        } else {
                            callback();
                        }
                    },
                    type: "number",
                    message: this.$t('common.pleaseSelectServiceCompany'),
                    trigger: "change"
                }],
                email: [{
                    type: "email",
                    message: this.$t('common.pleaseInputCorrectEmailAddress'),
                    trigger: "blur"
                }]
            },
            loading: false,
            showDialog: this.visible,
            notifications: undefined,
            activeStep: "generalInfo",
            notificationMessage: "",
            notificationId: undefined,
            isEditNotification: false,
            equipmentDialogVisible: false,
            cookingParams: undefined,
            cookingParam: "",
            cookingParamId: undefined,
            isEditCookingParam: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        "form.chainId": function formChainId(val) {
            if (!this.form.name && val && val[1]) {
                this.form.name = val[1] + " ";
            }
        }
    },
    computed: {
        isDominican: function isDominican() {
            return this.form.selectedCountryState && this.form.selectedCountryState[0] === "29";
        },
        isCanadaOrUsa: function isCanadaOrUsa() {
            return this.form.selectedCountryState && (this.form.selectedCountryState[0] === "1" || this.form.selectedCountryState[0] === "2");
        },
        isEmptyServiceCompany: function isEmptyServiceCompany() {
            // primaryServiceCompanyId === 1 is number of empty service company record
            //return this.form.primaryServiceCompanyId === 1 || !this.form.primaryServiceCompanyId || this.form.primaryServiceCompanyId === "";
        }
    },
    methods: {
        loadCustomer: function loadCustomer() {
            var _this2 = this;

            if (this.customerId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCustomer(this.customerId).then(function (response) {
                    _this2.form = Object.assign({}, response);
                    _this2.form.previousState = {
                        country: "",
                        state: "",
                        city: "",
                        address: "",
                        zip: "",
                        serviceCompany: "",
                        distance: ""
                    };
                    _this2.loadNotifications();
                    _this2.loadCookingParams();
                    _this2.loading = false;
                });
            }
        },
        editEquipment: function editEquipment(equipmentId) {
            __WEBPACK_IMPORTED_MODULE_2__app_event_bus_js__["a" /* EventBus */].$emit("editEquipment", equipmentId);
        },
        deleteEquipment: function deleteEquipment(equipmentId) {
            var _this3 = this;

            this.$confirm(this.$t('common.thisWillDeleteEquipmentContinue'), "Warning", {
                confirmButtonText: "Yes",
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteEquipment(equipmentId).then(function () {
                    _this3.loadCustomer();
                    _this3.$message({
                        type: "success",
                        message: _this3.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        closeDialog: function closeDialog() {
            this.form.primaryServiceCompanyId = undefined;
            this.loading = false;
            this.showDialog = false;
            this.activeStep = "generalInfo";
            this.notifications = null;
            this.notificationMessage = "";
            this.notificationId = null;
            this.isEditNotification = false;
            this.$refs["form"].resetFields();
            if (this.$refs["companySelector"]) {
                this.$refs["companySelector"].cleanFields();
            }

            this.$emit("dialogClosed");
        },
        save: function save() {
            var _this4 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    // Commented because this is only for a specific case and does not solve anything.
                    // The Customer name has to be checked in the Customer Controller!!!!
                    _this4.form.name = /#/.test(_this4.form.name) ? _this4.form.name.split("#")[0] + "#" + _this4.form.name.split("#")[1].trim() : _this4.form.name;
                    _this4.loading = true;
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCustomer(_this4.customerId, _this4.form).then(function (response) {
                        if (response != null && response.data != null) {
                            __WEBPACK_IMPORTED_MODULE_2__app_event_bus_js__["a" /* EventBus */].$emit("saveCustomer", response.data.id);
                        }
                        _this4.closeDialog();
                    }).catch(function (error) {
                        _this4.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        loadNotifications: function loadNotifications() {
            var _this5 = this;

            this.notificationMessage = "";
            this.notificationId = null;
            this.isEditNotification = false;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getNotifications(this.customerId).then(function (response) {
                _this5.notifications = response.data;
            });
        },
        editNotification: function editNotification(notification) {
            this.notificationMessage = notification.message;
            this.notificationId = notification.id;
            this.isEditNotification = true;
        },
        deleteNotification: function deleteNotification(id) {
            var _this6 = this;

            this.$confirm(this.$t('common.thisWillDeleteNotificationContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteNotification(id).then(function () {
                    _this6.loadNotifications();
                    _this6.$message({
                        type: "success",
                        message: _this6.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        saveNotification: function saveNotification() {
            var _this7 = this;

            if (this.isEditNotification) {
                var notification = this.notifications.find(function (x) {
                    return x.id == _this7.notificationId;
                });

                var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " ";
                notification.message = (this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] ? this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] : this.notificationMessage) + " " + date;

                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveNotification(this.customerId, notification).then(function () {
                    _this7.loadNotifications();
                    _this7.$notify({
                        title: _this7.$t('common.success'),
                        message: _this7.$t('common.notifySuccesfullySaved'),
                        type: "success"
                    });
                });
            } else {
                var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " ";
                var notification = {
                    message: (this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] ? this.notificationMessage.split(/\d\/\d\/\d\d\d\d - /)[0] : this.notificationMessage) + " " + date
                };
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveNotification(this.customerId, notification).then(function () {
                    _this7.loadNotifications();
                    _this7.$notify({
                        title: _this7.$t('common.success'),
                        message: _this7.$t('common.notifySuccesfullySaved'),
                        type: "success"
                    });
                });
            }
        },
        cancelNotification: function cancelNotification() {
            this.notificationMessage = null;
            this.notificationId = null;
            this.isEditNotification = false;
        },
        createCountry: function createCountry() {
            __WEBPACK_IMPORTED_MODULE_2__app_event_bus_js__["a" /* EventBus */].$emit("createCountry");
        },
        loadCookingParams: function loadCookingParams() {
            var _this8 = this;

            this.cookingParam = "";
            this.cookingParamId = null;
            this.isEditCookingParam = false;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCookingParams(this.customerId).then(function (response) {
                _this8.cookingParams = response.data;
            });
        },
        editCookingParam: function editCookingParam(cookingParam) {
            this.cookingParam = cookingParam.cookingParam;
            this.cookingParamId = cookingParam.id;
            this.isEditCookingParam = true;
        },
        deleteCookingParam: function deleteCookingParam(id) {
            var _this9 = this;

            this.$confirm(this.$t('common.thisWillDeleteCookingParameterContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteCookingParam(id).then(function () {
                    _this9.loadCookingParams();
                    _this9.$message({
                        type: "success",
                        message: _this9.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        saveCookingParam: function saveCookingParam() {
            var _this10 = this;

            if (this.isEditCookingParam) {
                var cookingParam = this.cookingParams.find(function (x) {
                    return x.id == _this10.cookingParamId;
                });
                cookingParam.cookingParam = this.cookingParam;
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCookingParam(this.customerId, cookingParam).then(function () {
                    _this10.loadCookingParams();
                    _this10.$notify({
                        title: _this10.$t('common.success'),
                        message: _this10.$t('common.cookingParameterSuccesfullySaved'),
                        type: "success"
                    });
                });
            } else {
                var cookingParam = {
                    cookingParam: this.cookingParam
                };
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].saveCookingParam(this.customerId, cookingParam).then(function () {
                    _this10.loadCookingParams();
                    _this10.$notify({
                        title: _this10.$t('common.success'),
                        message: _this10.$t('common.cookingParameterSuccesfullySaved'),
                        type: "success"
                    });
                });
            }
        },
        cancelCookingParam: function cancelCookingParam() {
            this.cookingParam = null;
            this.cookingParamId = null;
            this.isEditCookingParam = false;
        },
        downloadQrCode: function downloadQrCode() {
            var link = document.createElement('a');
            link.href = this.form.qrCodeImg;
            link.download = 'qr-code.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
});

/***/ }),

/***/ "ntHU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_masters_customers_components__ = __webpack_require__("AKRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "sims-ap-report",
    components: {
        ChainSelector: __WEBPACK_IMPORTED_MODULE_1__app_masters_customers_components__["a" /* ChainSelector */],
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        ServiceCoverageSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["o" /* ServiceCoverageSelector */],
        ResolutionCategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["m" /* ResolutionCategorySelector */],
        RepairCodeSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["l" /* RepairCodeSelector */]
    },
    data: function data() {
        return {
            form: {
                fields: [],
                categoryId: null,
                codeId: null
            },
            loading: false
        };
    },

    watch: {
        "form.productId": function formProductId() {
            this.form.categoryId = null;
        },
        "form.categoryId": function formCategoryId() {
            this.form.codeId = null;
        }
    },
    methods: {
        generateReport: function generateReport() {
            var _this = this;

            console.log(this.form);
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].downloadSimsApReport(this.form).then(function (response) {
                _this.loading = false;
                var blob = response.data;
                var fileName = response.headers["content-disposition"].split(";")[1].split("=")[1];
                fileName = fileName.replace(/"/g, '');
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", fileName);

                    // Safari thinks _blank anchor are pop ups. We only want to set _blank
                    // target if the browser does not support the HTML5 download attribute.
                    // This allows you to download files in desktop safari if pop up blocking
                    // is enabled.
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
            });
        },
        clearFields: function clearFields() {
            this.form = {
                fields: [],
                categoryId: null,
                codeId: null
            };
        }
    }
});

/***/ }),

/***/ "nw/e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'service-coverage-selector',
  props: {
    value: {},
    disabled: {},

    forExclude: {
      type: String,
      default: ""
    }
  },
  data: function data(vm) {
    var _this = this;

    var roles = [{
      id: '1',
      name: vm.$t('common.warrantyInvoiceHardt')
    }, {
      id: '2',
      name: vm.$t('common.costcoNonWarrantyInvoiceHardt')
    },
    //{
    //  id: '3',
    //  name: 'Costco Preventative Maintenance, Invoice Hardt'
    //},
    {
      id: '4',
      name: vm.$t('common.walMartNonWarrantyInvoiceHardt')
    }, {
      id: '5',
      name: vm.$t('common.pendingWarrantyInvoiceHardtPendingDecision')
    }, {
      id: '6',
      name: vm.$t('common.warrantyExceptionInvoiceHardt')
    }, {
      id: '7',
      name: vm.$t('common.installationPostInstall')
    }, {
      id: '8',
      name: vm.$t('common.nonWarrantyInvoiceHardt')
    }];
    return {
      loading: false,
      roles: roles.filter(function (x) {
        return !_this.forExclude.split(',').find(function (y) {
          return y == x.id;
        });
      })
    };
  }
});

/***/ }),

/***/ "o64V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SendEmailDialog__ = __webpack_require__("hoZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddPartDialog__ = __webpack_require__("uzhV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("H50Z");
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-ticket-details-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            required: true
        }
    },
    components: {
        SendEmailDialog: __WEBPACK_IMPORTED_MODULE_0__SendEmailDialog__["a" /* default */],
        AddPartDialog: __WEBPACK_IMPORTED_MODULE_1__AddPartDialog__["a" /* default */]
    },
    data: function data() {
        var _this = this,
            _ref;

        return _ref = {
            form: {
                comment: "",
                escalationCommentNextStep: ""
            },
            details: {},
            serviceCompanyId: null,
            productId: null,
            selectedPart: undefined,
            showAddPartsDialog: false,
            partsNumber: null,
            partsForm: [],
            showSubscriptionDialog: false,
            subscriberForm: [],
            newParts: [],
            partsRules: {},
            isNotWarrantyClaim: false,
            rules: {
                comment: [{
                    message: this.$t('common.pleaseEnterCommentText'),
                    trigger: "blur"
                }]
            },
            loading: false,
            showDialog: this.visible,
            statuses: [],
            fileUrlPreview: null,
            showImagePreview: false,
            showRsMessage: false,
            fileExtension: null,
            showResendDialog: false,
            showGenerateAuthDialog: false,
            showPartsNeededDialog: false,
            formChangeEmail: {
                serviceCompany: null,
                phone: null,
                email: null,
                useCustom: false
            }
        }, _defineProperty(_ref, "serviceCompanyId", null), _defineProperty(_ref, "showRejectedReason", false), _defineProperty(_ref, "isPendingPart", false), _defineProperty(_ref, "rejectedReasonForm", {
            rejectedReason: null
        }), _defineProperty(_ref, "partsNeededForm", {
            salesOrderNumber: "",
            trackingNumber: "",
            workflowStage: null,
            smsSubscription: false,
            emailSubscription: false,
            escallationContactName: "",
            escallationContactPhone: "",
            escallationContactEmail: "",
            escalatedBy: "",
            parts: []
        }), _defineProperty(_ref, "partsNeededRules", {}), _defineProperty(_ref, "salesOrderNumber", ""), _defineProperty(_ref, "trackingNumber", ""), _defineProperty(_ref, "rejectedReasonRules", {
            rejectedReason: [{
                message: this.$t('common.pleaseEnterRejectedReason'),
                required: true
            }, {
                validator: function validator(rule, value, callback) {
                    if (_this.showRejectedReason && (!_this.rejectedReasonForm.rejectedReason || _this.rejectedReasonForm.rejectedReason == "")) {
                        callback(new Error(_this.$t('common.invoiceNumberMustBeUnique')));
                    } else {
                        callback();
                    }
                },
                trigger: "blur"
            }]
        }), _defineProperty(_ref, "authForm", {
            partNumber: "",
            qty: 0,
            techName: "",
            id: 0,
            serviceTicketId: 0,
            authNumber: "",
            date: "",
            authNumberString: ""
        }), _ref;
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
            this.loadStatuses();
        },
        salesOrderNumber: function salesOrderNumber(val) {
            if (this.partsNeededForm.trackingNumber == "") {
                if (val != "") this.partsNeededForm.workflowStage = 6;else this.partsNeededForm.workflowStage = null;
            }
            this.partsNeededForm.salesOrderNumber = val;
        },
        trackingNumber: function trackingNumber(val) {
            if (val != "") this.partsNeededForm.workflowStage = 8;else this.partsNeededForm.workflowStage = null;
            this.partsNeededForm.trackingNumber = val;
        }
    },
    methods: (_methods = {
        loadTicket: function loadTicket() {
            var _this2 = this;

            if (this.ticketId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getTicket(this.ticketId).then(function (response) {
                    _this2.loading = false;
                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getIsPendingPart(_this2.ticketId).then(function (responsePendingPart) {
                        _this2.isPendingPart = responsePendingPart.data;
                    });
                    if (response.data.success) {
                        _this2.details = Object.assign({}, response.data.ticket);
                        if (_this2.details.isRs) {
                            _this2.showRsMessage = true;
                        }
                        _this2.serviceCompanyId = response.data.ticket.serviceCompanyId;
                        _this2.formChangeEmail.email = response.data.ticket.customEmailAddress.email;
                        _this2.formChangeEmail.phone = response.data.ticket.customEmailAddress.phone;
                        _this2.formChangeEmail.serviceCompany = response.data.ticket.customEmailAddress.serviceCompany;
                        var authNumber = response.data.ticket.authNumber || {};
                        _this2.authForm = {
                            partNumber: authNumber.partNumber || "",
                            qty: authNumber.qty || 0,
                            techName: authNumber.techName || "",
                            id: authNumber.id || 0,
                            serviceTicketId: authNumber.serviceTicketId || 0,
                            date: authNumber.date || "",
                            authNumberString: authNumber.authNumberString || "",
                            authNumber: authNumber.date && authNumber.serviceTicketId && authNumber.partNumber ? authNumber.authNumberString : ""
                        };
                        _this2.isNotWarrantyClaim = response.data.ticket.coverageNumber == 2 || response.data.ticket.coverageNumber == 3 || response.data.ticket.coverageNumber == 4 || response.data.ticket.coverageNumber == 8;
                        var escalatedParts = response.data.ticket.escalatedNeededPart || {};
                        _this2.partsNeededForm = {
                            salesOrderNumber: escalatedParts.salesOrderNumber || "",
                            trackingNumber: escalatedParts.trackingNumber || "",
                            workflowStage: escalatedParts.workflowStage || null,
                            //smsSubscription: escalatedParts.smsSubscription || false,
                            escallationContactName: escalatedParts.escallationContactName || "",
                            escallationContactPhone: escalatedParts.escallationContactPhone || "",
                            escallationContactEmail: escalatedParts.escallationContactEmail || "",
                            escalatedBy: escalatedParts.escalatedBy || "",
                            parts: escalatedParts.parts || []
                        };
                        _this2.subscriberForm = response.data.subscriberList;
                        if (escalatedParts.parts != null && escalatedParts.parts.length > 0) {
                            var self = _this2;

                            var _loop = function _loop(i) {
                                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPartById(escalatedParts.parts[i].id, _this2.details.serviceCompanyId, _this2.isNotWarrantyClaim).then(function (responsePart) {
                                    var partForm = {
                                        part: {
                                            extendedPrice: responsePart.data.extendedPrice,
                                            name: responsePart.data.name,
                                            price: responsePart.data.price,
                                            partNo: responsePart.data.partNo
                                        },
                                        quantity: escalatedParts.parts[i].quantity
                                    };
                                    self.partsForm.push(partForm);
                                });
                            };

                            for (var i = 0; i < escalatedParts.parts.length; i++) {
                                _loop(i);
                            }
                        }
                    } else {
                        _this2.$notify({
                            title: "Error",
                            message: response.data.message,
                            type: "error"
                        });
                        _this2.$emit("dialogClosed");
                    }
                });
            }
        },
        updateSubscriber: function updateSubscriber() {
            var _this3 = this;

            this.loading = true;
            console.log(this.subscriberForm);
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateSubscriber(this.ticketId, this.subscriberForm).then(function (response) {
                _this3.loading = false;
                _this3.showSubscriptionDialog = false;
            }).catch(function () {
                _this3.loading = false;
            });
        },
        partDialogClosed: function partDialogClosed() {
            this.showAddPartsDialog = false;
        },
        partAdded: function partAdded(payload) {
            this.partsForm.push(payload);
        },
        showAddPart: function showAddPart() {
            this.showAddPartsDialog = true;
        },
        resolveTicket: function resolveTicket() {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].resolveTicket(this.ticketId).then(function (response) {
                _this4.closeDialog();
                _this4.$emit("updated");
            });
        },
        reopenTicket: function reopenTicket() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reopenTicket(this.ticketId).then(function (response) {
                _this5.closeDialog();
                _this5.$emit("updated");
            });
        },
        print: function print() {
            var a = this;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].printTicket(this.ticketId).then(function (response) {
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);

                setTimeout(function () {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                }, 500);
            });
        },
        submitComment: function submitComment() {
            var self = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].submitComment(this.ticketId, this.form).then(function (response) {
                self.loading = false;
                self.form.comment = '';
                if (response.data) {
                    var edited = self.details.comments.filter(function (item) {
                        return item.id === response.data.id;
                    });
                    if (edited.length) {
                        edited[0].message = response.data.message;
                    } else {
                        self.details.comments.push(response.data);
                        self.details.comments = self.details.comments.sort(function (a, b) {
                            return new Date(b.at) - new Date(a.at);
                        });
                    }
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        changeStatus: function changeStatus() {
            var _this6 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].editServiceTicketStatus(this.ticketId, this.details.status).then(function () {
                _this6.$notify({
                    title: "Success",
                    message: "Ticket status updated successfully",
                    type: "success"
                });
                _this6.$emit("statusUpdated", _this6.details.status);
            }).catch(function (error) {
                console.error("Failed to update ticket status", error);
                _this6.$notify({
                    title: "Error",
                    message: "Failed to update ticket status",
                    type: "error"
                });
            }).finally(function () {
                _this6.loading = false;
            });
        },
        submitEscalationCommentNextStep: function submitEscalationCommentNextStep() {
            var self = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].submitEscalationCommentNextStep(this.ticketId, this.form).then(function (response) {
                self.loading = false;
                self.form.escalationCommentNextStep = '';
                if (response.data) {
                    var edited = self.details.escalationCommentNextStep.filter(function (item) {
                        return item.id === response.data.id;
                    });
                    if (edited.length) {
                        edited[0].message = response.data.message;
                    } else {
                        self.details.escalationCommentNextStep.push(response.data);
                        self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.sort(function (a, b) {
                            return new Date(b.at) - new Date(a.at);
                        });
                    }
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        submitEscalationSubscriber: function submitEscalationSubscriber() {
            var _this7 = this;

            var self = this;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].submitEscalationSubscriber(this.ticketId, this.subscriberForm).then(function (response) {
                self.loading = false;
                //self.$refs["subscriberForm"].resetFields();                        
                self.details.escalationSubscriberEmail = _this7.subscriberForm.isSubscribedByEmail;
                self.details.escalationSubscriberSms = _this7.subscriberForm.isSubscribedBySms;
            }).catch(function () {
                self.loading = false;
            });
        },

        //editComment(comment) {
        //  this.form.comment = comment.message;
        //  this.form.commentId = comment.id;
        //},
        deleteComment: function deleteComment(comment) {
            var _this8 = this;

            var self = this;
            this.$confirm(this.$t('common.areYouSureToDeleteTheComment'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteComment(_this8.ticketId, comment).then(function (response) {
                    self.loading = false;
                    self.$refs["form"].resetFields();
                    if (response.data.status === "Success") {
                        if (response.data.id) {
                            self.details.comments = self.details.comments.filter(function (item) {
                                return item.id !== response.data.id;
                            });
                        }
                        self.$message({
                            type: "success",
                            message: _this8.$t('common.deleteCompleted')
                        });
                    } else {
                        self.$message({
                            type: "error",
                            message: _this8.$t('common.youDoNotHaveRightsToDeleteThisComment')

                        });
                    }
                });
            }).catch(function () {
                _this8.loading = false;
            });
        },
        deleteEscalationCommentNextStep: function deleteEscalationCommentNextStep(comment) {
            var _this9 = this;

            var self = this;
            this.$confirm('Are you sure to delete the comment ?', "Warning", {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteEscalationCommentNextStep(_this9.ticketId, comment).then(function (response) {
                    self.loading = false;
                    self.$refs["form"].resetFields();
                    if (response.data.status === "Success") {
                        if (response.data.id) {
                            self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.filter(function (item) {
                                return item.id !== response.data.id;
                            });
                        }
                        self.$message({
                            type: "success",
                            message: 'Delete Completed'
                        });
                    } else {
                        self.$message({
                            type: "error",
                            message: 'You do not have rights to delete this comment'
                        });
                    }
                });
            }).catch(function () {
                _this9.loading = false;
            });
        }
    }, _defineProperty(_methods, "deleteEscalationCommentNextStep", function deleteEscalationCommentNextStep(comment) {
        var _this10 = this;

        var self = this;
        this.$confirm('Are you sure to delete the comment ?', "Warning", {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: "warning"
        }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].deleteEscalationCommentNextStep(_this10.ticketId, comment).then(function (response) {
                self.loading = false;
                self.$refs["form"].resetFields();
                if (response.data.status === "Success") {
                    if (response.data.id) {
                        self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.filter(function (item) {
                            return item.id !== response.data.id;
                        });
                    }
                    self.$message({
                        type: "success",
                        message: 'Delete Completed'
                    });
                } else {
                    self.$message({
                        type: "error",
                        message: 'You do not have rights to delete this comment'
                    });
                }
            });
        }).catch(function () {
            _this10.loading = false;
        });
    }), _defineProperty(_methods, "showCommentFullTime", function showCommentFullTime(comment) {
        console.log(comment);
        var commentTime = new Date(comment.at);
        return commentTime.toLocaleString();
    }), _defineProperty(_methods, "closeDialog", function closeDialog() {
        this.$refs["form"].resetFields();
        this.partsForm = [];
        this.showDialog = false;
        this.$emit("dialogClosed");
    }), _defineProperty(_methods, "loadStatuses", function loadStatuses() {
        var _this11 = this;

        if (this.$isAdmin) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getStatuses().then(function (response) {
                _this11.statuses = response.data;
            });
        }
    }), _defineProperty(_methods, "closePartsNeededDialog", function closePartsNeededDialog() {
        this.$refs["partsNeededForm"].resetFields();
        this.showPartsNeededDialog = false;
    }), _defineProperty(_methods, "addEscalationPartNeeded", function addEscalationPartNeeded() {
        this.details.escalationPart = this.partsNeededForm;
        this.details.escalationPart.parts = this.partsForm;
        this.showPartsNeededDialog = false;
    }), _defineProperty(_methods, "updateTicket", function updateTicket() {
        var _this12 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateTicket(this.details).then(function (response) {
            _this12.$notify({
                title: _this12.$t('common.success'),
                message: _this12.$t('common.serviceTicketSuccesfullyUpdated'),
                type: "success"
            });
            _this12.closeDialog();
            _this12.$emit("updated");
        });
    }), _defineProperty(_methods, "attachmentChanged", function attachmentChanged(file, fileList) {
        this.details.attachments.push(file.raw);
    }), _defineProperty(_methods, "attachmentRemoved", function attachmentRemoved(file, fileList) {
        if (file.id) {
            var index = this.details.attachments.findIndex(function (attachment) {
                return attachment.id === file.id;
            });
            this.details.attachments.splice(index, 1);
        } else {
            var index = this.details.attachments.findIndex(function (attachment) {
                return attachment.uid == file.uid;
            });
            this.details.attachments.splice(index, 1);
        }
    }), _defineProperty(_methods, "handlePreview", function handlePreview(file) {
        var split = file.name.split(".");
        this.fileExtension = split[split.length - 1];
        if (!file.url) {
            return;
        }
        if (this.fileExtension !== "jpg" && this.fileExtension !== "pdf" && this.fileExtension !== "jpeg" && this.fileExtension !== "png") {
            window.open(file.url);
            return;
        }
        this.fileUrlPreview = file.url;
        this.showImagePreview = true;
    }), _defineProperty(_methods, "viewrsprocedures", function viewrsprocedures() {
        window.open("static/RS Procedure Technical Support.pdf", "_blank", "width=600,height=800,toolbar=1");
        this.showRsMessage = false;
    }), _defineProperty(_methods, "sendEmail", function sendEmail(_sendEmail, isEmailFormValied) {
        this.showResendDialog = false;
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].resendEmail(this.details.id, this.formChangeEmail.email);
        this.details.dispatchedTo = this.formChangeEmail.serviceCompany + "<br />" + this.formChangeEmail.phone + "<br />" + this.formChangeEmail.email;
    }), _defineProperty(_methods, "accept", function accept() {
        var _this13 = this;

        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].accept(this.details.id).then(function (response) {
            _this13.$notify({
                title: _this13.$t('common.success'),
                message: _this13.$t('common.serviceTicketAccepted'),
                type: "success"
            });
            window.location.href = "/";
        });
    }), _defineProperty(_methods, "reject", function reject() {
        var _this14 = this;

        this.$refs["rejectedReasonForm"].validate(function (valid) {
            if (valid) {
                _this14.showResendDialog = false;
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].reject(_this14.details.id, _this14.rejectedReasonForm.rejectedReason).then(function (response) {
                    _this14.$notify({
                        title: "Rejected",
                        message: _this14.$t('common.serviceTicketRejected'),
                        type: "success"
                    });
                    window.location.href = "/";
                });
            }
        });
    }), _defineProperty(_methods, "generateAuth", function generateAuth() {
        var _this15 = this;

        this.authForm.serviceTicketId = this.ticketId;
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].generateAuthNumber(this.authForm.id, this.authForm).then(function (response) {
            if (response.data.status == "Success") {
                _this15.$notify({
                    title: _this15.$t('common.success'),
                    message: _this15.$t('common.authNumGenerated'),
                    type: "success"
                });
                _this15.authForm.authNumber = response.data.authNumber;
            } else {
                _this15.$notify({
                    title: "Error",
                    message: _this15.$t('common.authNumWasntGenerated'),
                    type: "error"
                });
            }

            _this15.showGenerateAuthDialog = false;
        });
    }), _defineProperty(_methods, "ShowRecommendedParts", function ShowRecommendedParts(complaint) {
        if (complaint.partSelected.length > 0) {
            var recommendedParts = "";
            complaint.partSelected.forEach(function (element) {
                if (element.isRecommendedPart && element.part != null) {
                    recommendedParts += '' + element.part.no + '\n';
                }
            });
            return recommendedParts;
        } else {
            return "";
        }
    }), _defineProperty(_methods, "ShowDescriptionForRecommendedParts", function ShowDescriptionForRecommendedParts(complaint) {
        if (complaint.partSelected.length > 0) {
            var recommendedPartsDescription = "";
            complaint.partSelected.forEach(function (element) {
                if (element.isRecommendedPart && element.part != null) {
                    recommendedPartsDescription += '' + element.part.description + '\n';
                }
            });
            return recommendedPartsDescription;
        } else {
            return "";
        }
    }), _defineProperty(_methods, "ShowMandatoryParts", function ShowMandatoryParts(complaint) {
        if (complaint.partSelected.length > 0) {
            var mandatoryParts = "";
            complaint.partSelected.forEach(function (element) {
                if (element.isRequiredPart && element.part != null) {
                    mandatoryParts += '' + element.part.no + '\n';
                }
            });
            return mandatoryParts;
        } else {
            return "";
        }
    }), _defineProperty(_methods, "ShowDescriptionForMandatoryParts", function ShowDescriptionForMandatoryParts(complaint) {
        if (complaint.partSelected.length > 0) {
            var mandatoryPartsDescription = "";
            complaint.partSelected.forEach(function (element) {
                if (element.isRequiredPart && element.part != null) {
                    mandatoryPartsDescription += '' + element.part.description + '\n';
                }
            });
            return mandatoryPartsDescription;
        } else {
            return "";
        }
    }), _methods)
});

/***/ }),

/***/ "o8U/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("iaHJ");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/masters/users',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* UserList */],
  name: 'usersList',
  meta: { admin: true }
}]);

/***/ }),

/***/ "oFnY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('service-ticket-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oOrt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateResolutionCodeDialog_vue__ = __webpack_require__("gq8g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f27dea3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateResolutionCodeDialog_vue__ = __webpack_require__("Xrf5");
function injectStyle (ssrContext) {
  __webpack_require__("wGQX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateResolutionCodeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f27dea3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateResolutionCodeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ojtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EquipmentSelector__ = __webpack_require__("07F/");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EquipmentSelector__["a"]; });


/***/ }),

/***/ "ozTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateCustomerChainDialog_vue__ = __webpack_require__("FxqY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92b32e5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateCustomerChainDialog_vue__ = __webpack_require__("66FX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateCustomerChainDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92b32e5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateCustomerChainDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oznG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateProductDialog_vue__ = __webpack_require__("n36o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967ac7da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateProductDialog_vue__ = __webpack_require__("bfth");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateProductDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967ac7da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateProductDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p2L6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p4R0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/products/export', {
            no: filter.text,
            name: filter.text,
            model: filter.text
        });
    },
    getProducts: function getProducts(page, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/products', {
            params: {
                page: page,
                no: text,
                name: text,
                model: text
            }
        });
    },
    getProduct: function getProduct(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/products/' + id);
    },
    saveProduct: function saveProduct(id, product) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/products/' + id, product);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/products', product);
    },
    deleteProduct: function deleteProduct(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/products/' + id);
    }
});

/***/ }),

/***/ "p5ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectRole')},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.roles),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p89l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("03aQ");
/* unused harmony reexport routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GlobalApp__ = __webpack_require__("kwnR");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__GlobalApp__["a"]; });



/***/ }),

/***/ "pIAk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__("4RiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6991468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__("Ysa+");
function injectStyle (ssrContext) {
  __webpack_require__("Xxyi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d6991468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6991468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pJZO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "NAUj",
	"./fr.json": "OkWW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pJZO";

/***/ }),

/***/ "pJr0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getCategories: function getCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/complaintcodes/categories');
    }
});

/***/ }),

/***/ "pK4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("AKRq");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/masters/customers',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["d" /* CustomerList */],
    name: 'customerList',
    meta: { admin: true }
}, {
    path: '/masters/customersnotifications',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["e" /* CustomerNotificationList */],
    name: 'customerNotificationsList',
    meta: { admin: true }
}]);

/***/ }),

/***/ "pX9V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pn1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.$t('serviceTickets.selectCategory') + ' ' + _vm.ticketId + ' ' + _vm.$t('serviceTickets.details'),"visible":_vm.showDialog,"width":"650px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadTicket,"close":_vm.closeDialog}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":9}},[_c('dl',[(_vm.details.confirmation)?_c('dt',[_vm._v(_vm._s(_vm.details.confirmationText))]):_vm._e(),_vm._v(" "),_c('dt',[_vm._v("Opened by")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.openedBy))]),_vm._v(" "),_c('dt',[_vm._v("Opened on")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("date")(_vm.details.raisedOn)))]),_vm._v(" "),_c('dt',[_vm._v("Dispatched to")]),_vm._v(" "),_c('dd',{domProps:{"innerHTML":_vm._s(_vm.details.dispatchedTo)}}),_vm._v(" "),_c('dt',[_vm._v("Urgency")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.urgency))]),_vm._v(" "),_c('dt',[_vm._v("Overtime")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.overtimeApproved ? _vm.$t('common.yes') : _vm.$t('common.no')))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":9}},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.customerName')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.customerName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.address')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.customerAddress))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.phone')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.callBy')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.callBy))]),_vm._v(" "),(_vm.details.callerPhoneNumber)?_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.callerPhone')))]):_vm._e(),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.callerPhoneNumber == null ? '' : _vm.details.callerPhoneNumber))]),_vm._v(" "),(_vm.details.secondCallerPhoneNumber)?_c('dt',[_vm._v("Second Contact")]):_vm._e(),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.secondCallerPhoneNumber == null ? '' : _vm.details.secondCallerPhoneNumber))]),_vm._v(" "),(_vm.details.callerEmail)?_c('dt',[_vm._v("Caller Email")]):_vm._e(),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.callerEmail == null ? '' : _vm.details.callerEmail))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.status')))]),_vm._v(" "),_c('dd',[(_vm.$isAdmin)?[_c('el-select',{attrs:{"placeholder":_vm.$t('serviceTickets.select')},on:{"change":_vm.changeStatus},model:{value:(_vm.details.status),callback:function ($$v) {_vm.$set(_vm.details, "status", $$v)},expression:"details.status"}},_vm._l((_vm.statuses),function(item){return _c('el-option',{key:item.status,attrs:{"label":item.name,"value":item.status}})}))]:_c('span',[_vm._v(_vm._s(_vm.details.statusText))])],2)])]),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('dl',[_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.model')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.model))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.serial')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.serialNumber))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.coverage')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.coverage))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.gasType')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.details.gasType))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.$t('serviceTickets.warrEnd')))]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm._f("date")(_vm.details.warrantyEnd)))])])])],1),_vm._v(" "),(_vm.$isAdmin && _vm.details.statusHistory && _vm.details.statusHistory.length)?_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.statusHistory')))]),_vm._v(" "),_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.details.statusHistory,"size":"mini"}},[_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.changedAt'),"width":"145"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(_vm._f("datetime")(scope.row.changedAt))+"\n                ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"oldStatus","label":_vm.$t('serviceTickets.oldStatus')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"newStatus","label":_vm.$t('serviceTickets.newStatus')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"changedBy","label":_vm.$t('serviceTickets.changedBy')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"source","label":_vm.$t('serviceTickets.source'),"width":"100"}})],1)],1):_vm._e(),_vm._v(" "),_c('el-row',[(_vm.$isAdmin && _vm.details.status == 5)?_c('el-button',{staticStyle:{"font-weight":"bold"},attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.showPartsNeededDialog = true}}},[_vm._v("Parts Needed")]):_vm._e()],1),_vm._v(" "),_c('el-row',{staticClass:"mb-3"},[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.liveSupportAvailability'))+": 1 800-387-6847")]),_vm._v(" "),_c('ul',{staticClass:"support-hours"},[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('serviceTickets.mondayToFriday'))+":")]),_vm._v(_vm._s(_vm.$t('serviceTickets.mondayToFridayHours')))]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('serviceTickets.afterHours'))+":")]),_vm._v(_vm._s(_vm.$t('serviceTickets.afterHoursHours')))]),_vm._v(" "),_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('serviceTickets.afterHoursWeekends'))+":")]),_vm._v(_vm._s(_vm.$t('serviceTickets.afterHoursWeekendsHours')))])]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.hardtEqTechnResources')))]),_vm._v(" "),_c('p',[_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.hardtEqTechnResourcesText1'))),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.hardtEqTechnResourcesText2'))+"\n            "),_c('a',{attrs:{"href":"https://hardtinfotechsupport.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n                https://hardtinfotechsupport.com\n            ")])])]),_vm._v(" "),(_vm.details.note)?_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.communicationRequirements')))]),_vm._v("\n        "+_vm._s(_vm.details.note)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.details.productNote)?_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.productNote')))]),_vm._v("\n        "+_vm._s(_vm.details.productNote)+"\n    ")]):_vm._e(),_vm._v(" "),_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.symptoms')))]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('table',{staticStyle:{"width":"100%"}},_vm._l((_vm.details.complaints),function(complaint){return _c('tbody',{key:complaint.code},[_c('tr',[_c('td',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.symptomCodes')))])]),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.description')))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(complaint.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(complaint.description))])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.ShowMandatoryParts(complaint))?_c('h4',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.mandatoryParts')))]):_vm._e()]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[(_vm.ShowMandatoryParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowMandatoryParts(complaint)))]):_vm._e(),_vm._v(" "),(_vm.ShowMandatoryParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowDescriptionForMandatoryParts(complaint)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[(_vm.ShowRecommendedParts(complaint))?_c('h4',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.$t('serviceTickets.recommendedParts')))]):_vm._e()]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[(_vm.ShowRecommendedParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowRecommendedParts(complaint)))]):_vm._e(),_vm._v(" "),(_vm.ShowRecommendedParts(complaint))?_c('td',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.ShowDescriptionForRecommendedParts(complaint)))]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',[_c('hr')])])])}))])],1),_vm._v(" "),(_vm.$isAdmin || (_vm.details.comments && _vm.details.comments.lenght > 0))?_c('el-row',[_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.comments')))]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.details.comments),function(comment){return _c('li',{key:comment.id},[_c('p',[_vm._v("\n                        "+_vm._s(comment.message)+"\n\n                    ")]),_vm._v(" "),_c('i',{attrs:{"size":"mini"},on:{"click":function($event){_vm.deleteComment(comment)}}},[_c('i',{staticClass:"el-icon-delete"})]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm.showCommentFullTime(comment))+" by "+_vm._s(comment.author))])])}))]),_vm._v(" "),(_vm.$isAdmin)?_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"size":"small"}},[_c('el-form-item',{staticClass:"comment-input",attrs:{"prop":"comment","show-message":false}},[_c('el-input',{attrs:{"type":"textarea","size":"small","rows":4,"placeholder":_vm.$t('serviceTickets.newTicketComment')},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1),_vm._v(" "),_c('el-button',{staticClass:"comment-button",on:{"click":_vm.submitComment}},[_vm._v(_vm._s(_vm.$t('serviceTickets.saveComment')))])],1):_vm._e()],1):_vm._e(),_vm._v(" "),((_vm.$isAdmin || (_vm.details.escalationCommentNextStep && _vm.details.escalationCommentNextStep.lenght > 0)) && _vm.details.status == 5)?_c('el-row',[_c('h4',[_vm._v("Escalation Next Step")]),_vm._v(" "),_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('ul',{staticClass:"comment-box"},_vm._l((_vm.details.escalationCommentNextStep),function(escalationCommentNextStep){return _c('li',{key:escalationCommentNextStep.id},[_c('p',[_vm._v("\n                        "+_vm._s(escalationCommentNextStep.message)+"\n\n                    ")]),_vm._v(" "),_c('i',{attrs:{"size":"mini"},on:{"click":function($event){_vm.deleteEscalationCommentNextStep(escalationCommentNextStep)}}},[_c('i',{staticClass:"el-icon-delete"})]),_vm._v(" "),_c('small',[_vm._v("On "+_vm._s(_vm.showCommentFullTime(escalationCommentNextStep))+" by "+_vm._s(escalationCommentNextStep.author))])])}))]),_vm._v(" "),(_vm.$isAdmin)?_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"size":"small"}},[_c('el-form-item',{staticClass:"comment-input",attrs:{"prop":"escalationCommentNextStep","show-message":false}},[_c('el-input',{attrs:{"type":"textarea","size":"small","rows":4,"placeholder":"Escalation Next Step"},model:{value:(_vm.form.escalationCommentNextStep),callback:function ($$v) {_vm.$set(_vm.form, "escalationCommentNextStep", $$v)},expression:"form.escalationCommentNextStep"}})],1),_vm._v(" "),_c('el-button',{staticClass:"comment-button",on:{"click":_vm.submitEscalationCommentNextStep}},[_vm._v("Save Escalation Next Step")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.details.status == 5)?_c('el-row',[_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px","display":"flex","justify-content":"flex-end"}},[_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":function($event){_vm.showSubscriptionDialog = true}}},[_vm._v("Subscription List")])],1)]):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"20px"}},[(_vm.$isAdmin)?_c('el-upload',{staticStyle:{"text-align":"center"},attrs:{"name":"attachments","drag":"","multiple":"","file-list":_vm.details.attachments,"auto-upload":false,"limit":10,"action":"","on-change":_vm.attachmentChanged,"on-remove":_vm.attachmentRemoved,"on-preview":_vm.handlePreview}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                "+_vm._s(_vm.$t('serviceTickets.dropFile'))+"\n                "),_c('em',[_vm._v(_vm._s(_vm.$t('serviceTickets.clicktoUpload')))])])]):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showImagePreview,"width":"60%","append-to-body":""},on:{"update:visible":function($event){_vm.showImagePreview=$event}}},[(_vm.fileExtension!=='pdf')?_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.fileUrlPreview,"alt":""}}):_vm._e(),_vm._v(" "),(_vm.fileExtension==='pdf')?_c('embed',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.fileUrlPreview,"type":"application/pdf"}}):_vm._e(),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showImagePreview = false}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.close')))])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showRsMessage,"width":"30%","append-to-body":"","title":_vm.$t('serviceTickets.customerRs')},on:{"update:visible":function($event){_vm.showRsMessage=$event}}},[_c('p',[_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.rsMessage1'))),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.rsMessage2'))+"\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showRsMessage = false}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.ok')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.viewrsprocedures}},[_vm._v(_vm._s(_vm.$t('serviceTickets.viewRsProcedures')))])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticStyle:{"margin-bottom":"10px"}},[(_vm.$isAdmin && _vm.authForm.id == 0)?_c('el-button',{staticStyle:{"color":"red","font-weight":"bold"},attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.showGenerateAuthDialog = true}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.generateAuth')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin && _vm.authForm.id)?_c('el-button',{staticStyle:{"color":"red","font-weight":"bold"},attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.showGenerateAuthDialog = true}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.seeAuth')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.showResendDialog = true}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.resend')))]):_vm._e(),_vm._v(" "),(_vm.details.status === 1 && _vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.resolveTicket}},[_vm._v(_vm._s(_vm.$t('serviceTickets.resolveTicket')))]):_vm._e(),_vm._v(" "),(_vm.details.status === 2 && _vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.reopenTicket}},[_vm._v(_vm._s(_vm.$t('serviceTickets.reopen')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.print}},[_vm._v(_vm._s(_vm.$t('serviceTickets.print')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('serviceTickets.close')))]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.accept}},[_vm._v(_vm._s(_vm.$t('serviceTickets.accept')))]):_vm._e(),_vm._v(" "),(_vm.$isUser)?_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":function($event){_vm.showRejectedReason = true}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.reject')))]):_vm._e()],1),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.updateTicket}},[_vm._v(_vm._s(_vm.$t('serviceTickets.update')))]):_vm._e()],1),_vm._v(" "),_c('send-email-dialog',{attrs:{"visible":_vm.showResendDialog,"formChangeEmail":_vm.formChangeEmail},on:{"save":_vm.sendEmail}}),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showRejectedReason,"width":"50%","append-to-body":""},on:{"update:visible":function($event){_vm.showRejectedReason=$event}}},[_c('el-form',{ref:"rejectedReasonForm",attrs:{"model":_vm.rejectedReasonForm,"rules":_vm.rejectedReasonRules}},[_c('el-form-item',{attrs:{"prop":"rejectedReason","label":_vm.$t('serviceTickets.rejectServiceDispatch')}},[_c('el-input',{attrs:{"type":"textarea","size":"small","rows":4},model:{value:(_vm.rejectedReasonForm.rejectedReason),callback:function ($$v) {_vm.$set(_vm.rejectedReasonForm, "rejectedReason", $$v)},expression:"rejectedReasonForm.rejectedReason"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.reject}},[_vm._v(_vm._s(_vm.$t('serviceTickets.ok')))])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Parts Needed","visible":_vm.showPartsNeededDialog,"width":"650px","append-to-body":""},on:{"update:visible":function($event){_vm.showPartsNeededDialog=$event}}},[_c('el-form',{ref:"partsNeededForm",attrs:{"model":_vm.partsNeededForm,"rules":_vm.partsNeededRules}},[_c('el-form-item',{attrs:{"prop":"salesOrderNumber","label":"Sales Order #"}},[_c('el-input',{attrs:{"type":"number"},model:{value:(_vm.salesOrderNumber),callback:function ($$v) {_vm.salesOrderNumber=_vm._n($$v)},expression:"salesOrderNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"trackingNumber","label":"Tracking #"}},[_c('el-input',{model:{value:(_vm.trackingNumber),callback:function ($$v) {_vm.trackingNumber=$$v},expression:"trackingNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"workflowStage","label":"Workflow Stage"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.partsNeededForm.workflowStage),callback:function ($$v) {_vm.$set(_vm.partsNeededForm, "workflowStage", $$v)},expression:"partsNeededForm.workflowStage"}},[_c('el-option',{attrs:{"value":1,"label":"Dispatched"}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"Pending Tech ETA (1)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":"Tech ETA (1)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"Tech onsite (1)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":"Parts needed"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"Pending Parts Order / Parts Ordered"}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":"Sales Order #"}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":"Parts Shipped"}}),_vm._v(" "),_c('el-option',{attrs:{"value":9,"label":"Tracking # (allow for more than one)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":10,"label":"Parts Estimated delivery (ETD)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":11,"label":"Parts Delivered"}}),_vm._v(" "),_c('el-option',{attrs:{"value":12,"label":"Pending Tech ETA (2)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":13,"label":"Tech ETA (2)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":14,"label":"Tech onsite (2)"}}),_vm._v(" "),_c('el-option',{attrs:{"value":15,"label":"Job Completed"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"escalationContactName","label":"SVC Co. Escalation Contact Name"}},[_c('el-input',{model:{value:(_vm.partsNeededForm.escallationContactName),callback:function ($$v) {_vm.$set(_vm.partsNeededForm, "escallationContactName", $$v)},expression:"partsNeededForm.escallationContactName"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"escalationContactPhone","label":"SVC Co. Escalation Contact Phone"}},[_c('el-input',{model:{value:(_vm.partsNeededForm.escallationContactPhone),callback:function ($$v) {_vm.$set(_vm.partsNeededForm, "escallationContactPhone", $$v)},expression:"partsNeededForm.escallationContactPhone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"escalationContactEmail","label":"SVC Co. Escalation Contact E-Mail"}},[_c('el-input',{model:{value:(_vm.partsNeededForm.escallationContactEmail),callback:function ($$v) {_vm.$set(_vm.partsNeededForm, "escallationContactEmail", $$v)},expression:"partsNeededForm.escallationContactEmail"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"escalatedBy","label":"Escalated By"}},[_c('el-input',{model:{value:(_vm.partsNeededForm.escalatedBy),callback:function ($$v) {_vm.$set(_vm.partsNeededForm, "escalatedBy", $$v)},expression:"partsNeededForm.escalatedBy"}})],1),_vm._v(" "),_c('h3',[_vm._v("\n                Parts\n                "),_c('el-button',{attrs:{"size":"mini"},on:{"click":_vm.showAddPart}},[_vm._v("Click Here To Add Parts")])],1),_vm._v(" "),(_vm.partsForm.length > 0)?_c('el-table',{staticClass:"tablewithshading",attrs:{"data":_vm.partsForm,"size":"mini"}},[_c('el-table-column',{attrs:{"label":"Part #"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"effect":"dark","content":scope.row.part.name,"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(scope.row.part.partNo))])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.name","label":"Name","width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Price"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.part.price))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"part.extendedPrice","label":"Ext. Price"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                        "+_vm._s(_vm._f("money")(scope.row.part.extendedPrice * scope.row.quantity))+"\n                    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":"Quantity"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations","align":"center"}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px","display":"flex","justify-content":"flex-end"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addEscalationPartNeeded}},[_vm._v("Add")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closePartsNeededDialog}},[_vm._v("Close")])],1)],1),_vm._v(" "),_c('add-part-dialog',{attrs:{"visible":_vm.showAddPartsDialog,"serviceCompanyId":_vm.details.serviceCompanyId,"productId":_vm.details.productId,"isNotWarrantyClaim":_vm.isNotWarrantyClaim},on:{"update:visible":function($event){_vm.showAddPartsDialog=$event},"part-added":_vm.partAdded,"dialogClosed":_vm.partDialogClosed}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('serviceTickets.generateAuth'),"visible":_vm.showGenerateAuthDialog,"width":"50%","append-to-body":""},on:{"update:visible":function($event){_vm.showGenerateAuthDialog=$event}}},[_c('el-form',{ref:"authForm",attrs:{"model":_vm.authForm}},[(_vm.authForm.authNumber)?_c('el-form-item',{staticStyle:{"font-weight":"700"},attrs:{"prop":"authNumber","label":_vm.$t('serviceTickets.currentAuth')}},[_c('span',{staticStyle:{"font-weight":"normal"}},[_vm._v(_vm._s(_vm.authForm.authNumber))])]):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"partNumber","label":_vm.$t('serviceTickets.partNumber')}},[_c('el-input',{model:{value:(_vm.authForm.partNumber),callback:function ($$v) {_vm.$set(_vm.authForm, "partNumber", $$v)},expression:"authForm.partNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"qty","label":"QTY"}},[_c('el-input',{model:{value:(_vm.authForm.qty),callback:function ($$v) {_vm.$set(_vm.authForm, "qty", $$v)},expression:"authForm.qty"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"techName","label":_vm.$t('serviceTickets.techName')}},[_c('el-input',{model:{value:(_vm.authForm.techName),callback:function ($$v) {_vm.$set(_vm.authForm, "techName", $$v)},expression:"authForm.techName"}})],1),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.generateAuth}},[_vm._v(_vm._s(_vm.$t('serviceTickets.generate')))])],1)],1),_vm._v(" "),_c('el-dialog',{staticStyle:{"margin-left":"-15px"},attrs:{"visible":_vm.showSubscriptionDialog,"width":"650px","append-to-body":""},on:{"update:visible":function($event){_vm.showSubscriptionDialog=$event}}},[_c('el-scrollbar',{staticStyle:{"margin-bottom":"10px"}},[_c('h4',[_vm._v("Subscription List")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.subscriberForm,"size":"mini"}},[_c('el-table-column',{attrs:{"prop":"name","width":"90","label":"Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","width":"90","label":"Email"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sms","width":"90","label":"Phone Number"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"IsSubscribedByEmail","label":"Email Subscription","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100%"}},[_c('el-checkbox',{staticClass:"checkbox",model:{value:(scope.row.isSubscribedByEmail),callback:function ($$v) {_vm.$set(scope.row, "isSubscribedByEmail", $$v)},expression:"scope.row.isSubscribedByEmail"}})],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"IsSubscribedBySms","label":"SMS Subscription","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","height":"100%"}},[_c('el-checkbox',{staticClass:"checkbox",model:{value:(scope.row.isSubscribedBySms),callback:function ($$v) {_vm.$set(scope.row, "isSubscribedBySms", $$v)},expression:"scope.row.isSubscribedBySms"}})],1)]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"10px","margin-top":"10px","display":"flex","justify-content":"flex-end"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.updateSubscriber}},[_vm._v("Update")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q1KM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.showDialog,"width":"400px"},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closePage}},[[_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('masters.pleaseEnterTheNotification')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticStyle:{"width":"355px","max-width":"355px"},attrs:{"notificationMessage":_vm.notificationMessage},domProps:{"value":(_vm.message)},on:{"update:notificationMessage":function($event){_vm.notificationMessage=$event},"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.addNotification}},[_vm._v(_vm._s(_vm.$t('common.ok')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.closePage}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qRCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":8}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.rmaNumber')},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.rmaList},on:{"sort-change":_vm.sortRma}},[_c('el-table-column',{attrs:{"prop":"rmaNumber","label":_vm.$t('common.rmaNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"invoiceNumber","label":_vm.$t('common.invoiceNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"partNumber","label":_vm.$t('common.partNum')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"authorizationNumber","label":_vm.$t('rma.authorNum')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"rmaDate","label":_vm.$t('rma.rmaDate')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompany","label":_vm.$t('common.serviceCompany')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceTicketNumber","label":_vm.$t('common.serviceTicketNum')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('common.status'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.status === "1")?_c('p',[_vm._v(_vm._s(_vm.$t('common.opened')))]):_vm._e(),_vm._v(" "),(scope.row.status === "0")?_c('p',[_vm._v(_vm._s(_vm.$t('common.closed')))]):_vm._e(),_vm._v(" "),(scope.row.status === "2")?_c('p',[_vm._v(_vm._s(_vm.$t('rma.reopen')))]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trackingNumber","label":_vm.$t('common.trackingNumber')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){_vm.trackingNumberToUrl(scope.row.trackingNumber)}}},[_vm._v("\n                    "+_vm._s(scope.row.trackingNumber)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modelNumber","label":_vm.$t('common.modelNum')}}),_vm._v(" "),(_vm.$isFullAdmin)?_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.showPreviewRma(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-view"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.showEditRma(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteRma(scope.row.rmaNumber)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])}):_vm._e()],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-rma-dialog',{attrs:{"rmaId":_vm.rmaToEdit,"visible":_vm.updateRmaVisible},on:{"dialogClosed":_vm.updateRmaFinished,"showRmaConfirm":_vm.showRmaConfirm}}),_vm._v(" "),_c('preview-rma-dialog',{attrs:{"rmaId":_vm.rmaToView,"visible":_vm.previewRmaVisible},on:{"dialogClosed":_vm.previewRmaFinished}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qTlW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "rma",
    components: {},
    props: {},
    data: function data() {
        return {
            form: {
                fields: []
            },
            loading: false
        };
    },

    methods: {
        selectAll: function selectAll() {
            if (this.form.fields.length === 14) {
                this.form.fields = [];
            } else {
                for (var i = 1; i <= 14; i++) {
                    this.form.fields.push(i + "");
                }
            }
        },
        generateReport: function generateReport() {
            var _this = this;

            if (this.form.fields.length == 0) {
                this.$refs["labelInfo"].focus();
                return;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].downloadRmaReport(this.form).then(function (response) {
                _this.loading = false;
                var blob = response.data;
                var fileName = response.headers["content-disposition"].split(";")[1].split("=")[1];
                fileName = fileName.replace(/"/g, '');
                if (typeof window.navigator.msSaveBlob !== "undefined") {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    var blobURL = window.URL.createObjectURL(blob);
                    var tempLink = document.createElement("a");
                    tempLink.style.display = "none";
                    tempLink.href = blobURL;
                    tempLink.setAttribute("download", fileName);

                    // Safari thinks _blank anchor are pop ups. We only want to set _blank
                    // target if the browser does not support the HTML5 download attribute.
                    // This allows you to download files in desktop safari if pop up blocking
                    // is enabled.
                    if (typeof tempLink.download === "undefined") {
                        tempLink.setAttribute("target", "_blank");
                    }

                    document.body.appendChild(tempLink);
                    tempLink.click();
                    document.body.removeChild(tempLink);
                    window.URL.revokeObjectURL(blobURL);
                }
            });
        }
    },
    computed: {},
    watch: {}
});

/***/ }),

/***/ "qd8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateServiceCompanyDialog_vue__ = __webpack_require__("5h5b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fdea0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateServiceCompanyDialog_vue__ = __webpack_require__("2as5");
function injectStyle (ssrContext) {
  __webpack_require__("Ky6T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24fdea0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateServiceCompanyDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24fdea0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateServiceCompanyDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qlZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'role-selector',
  props: ['value'],
  data: function data() {
    return {
      loading: false,
      roles: [{
        id: '1',
        name: 'User'
      }, {
        id: '2',
        name: 'Admin'
      }]
    };
  }
});

/***/ }),

/***/ "qx1m":
/***/ (function(module, exports) {

module.exports = {"countryProvince":"Pays / Province","selectCountryAndProvince":"Sélectionnez le pays et la province","zip":"Zipper","pleaseSelectCode":"Veuillez sélectionner le code","selectChainAndRule":"Sélectionner la chaîne et la règle","allowedDistance":"Distance autorisée (Mls.)","pleaseSelectServiceCompany":"Veuillez sélectionner la société de services","noCompaniesInCurrentProvince":"Aucune entreprise dans la province actuelle","pleaseSelectCountry":"Veuillez sélectionner le pays","pleaseSelectCustomer":"Veuillez sélectionner le client","pleaseSelectEquipment":"Veuillez sélectionner l'équipement","pleaseSelectProduct":"Veuillez sélectionner le produit","pleaseSelectCategory":"Veuillez sélectionner la catégorie","pleaseSelectATTN":"Veuillez sélectionner ATTN","pleaseSelectStatus":"Veuillez sélectionner le statut","pleaseSelectRole":"Veuillez sélectionner un rôle","pleaseSelectServiceCoverage":"Veuillez sélectionner la couverture du service","pleaseSelectOvertimeApproved":"Veuillez d'abord sélectionner heures supplémentaires approuvées","pleaseSelectShippingMethod":"Veuillez sélectionner la méthode d'expédition","pleaseSelectTicket":"Veuillez sélectionner la Numéro de ticket","changePassword":"Changer le mot de passe","oldPassword":"ancien mot de passe","newPassword":"nouveau mot de passe","change":"Changement","logout":"Se déconnecter","returnToMyAccount":"Revenir à mon compte","orderParts":"Commander des pièces","newClaim":"Nouvelle réclamation","newServiceTicket":"Nouveau billet de service","registerEquipment":"Enregistrer l'équipement","selectLanguage":"Choisir la langue","english":"Anglais","french":"Français","dashboard":"Tableau de bord","claimsFAQ":"FAQ sur les réclamations","accounting":"Comptabilité","reports":"Rapports","graphs":"Graphiques","claimHistory":"Historique des réclamations","priceList":"Liste de prix","resolutionCodes":"Codes de résolution","usedParts":"Pièces d'occasion","simsAPReport":"Rapport SIMS comptes payables","masterData":"Données de références","customers":"Clients","customersNotifications":"Avis aux clients","customerChains":"Chaînes de clients","serviceCompanies":"Sociétés de services","products":"Produits","canadianTaxes":"Impôts canadiens","users":"Utilisateurs","technicalDocumentation":"Documentation technique","loggedIn":"Connecté comme "}

/***/ }),

/***/ "rExp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartList__ = __webpack_require__("IJD1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PartList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdatePartDialog__ = __webpack_require__("Z7Se");
/* unused harmony reexport CreateUpdatePartDialog */



/***/ }),

/***/ "rKfw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'chain-selector',
    props: ['value'],
    data: function data() {
        return {
            loading: false,
            chains: []
        };
    },
    created: function created() {
        var _this = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customerchains/lookup').then(function (response) {
            _this.loading = false;
            _this.chains = response.data.map(function (c) {
                return { id: c.value, name: c.label };
            });
        });
    }
});

/***/ }),

/***/ "rYXq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("PWOQ");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/accounting',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* ClaimsList */],
  name: 'accounting',
  meta: { admin: true }
}]);

/***/ }),

/***/ "rb25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateServiceTicketDialog_vue__ = __webpack_require__("E3ii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36829e3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateServiceTicketDialog_vue__ = __webpack_require__("tMv7");
function injectStyle (ssrContext) {
  __webpack_require__("b1/0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36829e3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateServiceTicketDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36829e3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateServiceTicketDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rbm1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("esN2");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "used-parts-list-report",
  data: function data() {
    return {
      loading: false,
      parts: [],
      filter: {
        part: undefined,
        claimNumber: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        serviceCompany: window.currentCompany.id
      },
      currentPage: 1,
      total: 0,
      exporting: false
    };
  },
  created: function created() {
    this.loadParts();
  },

  watch: {
    filter: {
      deep: true,
      handler: function handler(val) {
        this.currentPage = 1;
        this.loadParts();
      }
    }
  },
  methods: {
    loadParts: function loadParts() {
      var _this = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getUsedParts(this.currentPage, this.filter).then(function (response) {
        _this.loading = false;
        _this.parts = response.data.items;
        _this.total = response.data.total;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadParts();
    },
    download: function download() {
      var _this2 = this;

      this.exporting = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadUsedParts(this.filter).then(function () {
        _this2.exporting = false;
      }).catch(function () {
        _this2.exporting = false;
      });
    }
  }
});

/***/ }),

/***/ "rcIU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{attrs:{"size":"mini"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.from'),"prop":"dateFrom"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateFrom),callback:function ($$v) {_vm.$set(_vm.form, "dateFrom", $$v)},expression:"form.dateFrom"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serviceTicketNum'),"prop":"serviceTicketId"}},[_c('el-input',{model:{value:(_vm.form.serviceTicketId),callback:function ($$v) {_vm.$set(_vm.form, "serviceTicketId", $$v)},expression:"form.serviceTicketId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":_vm.$t('reports.to'),"prop":"dateTo"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.form.dateTo),callback:function ($$v) {_vm.$set(_vm.form, "dateTo", $$v)},expression:"form.dateTo"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.invoiceNumber'),"prop":"invoiceNumber"}},[_c('el-input',{model:{value:(_vm.form.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.form, "invoiceNumber", $$v)},expression:"form.invoiceNumber"}})],1)],1)],1),_vm._v(" "),_c('el-checkbox-group',{ref:"group",staticClass:"fields",model:{value:(_vm.form.fields),callback:function ($$v) {_vm.$set(_vm.form, "fields", $$v)},expression:"form.fields"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"1"}},[_vm._v(_vm._s(_vm.$t('common.rmaNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"2"}},[_vm._v(_vm._s(_vm.$t('common.shippingMethod')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"3"}},[_vm._v(_vm._s(_vm.$t('common.serviceCompany')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"4"}},[_vm._v(_vm._s(_vm.$t('common.serviceTicketNum')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"5"}},[_vm._v(_vm._s(_vm.$t('reports.attn')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"6"}},[_vm._v(_vm._s(_vm.$t('reports.rmaStatus')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"7"}},[_vm._v(_vm._s(_vm.$t('common.trackingNumber')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"8"}},[_vm._v(_vm._s(_vm.$t('reports.countryOfOrigin')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"9"}},[_vm._v(_vm._s(_vm.$t('common.claimNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"10"}},[_vm._v(_vm._s(_vm.$t('common.invoiceNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"11"}},[_vm._v(_vm._s(_vm.$t('common.customerName')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"12"}},[_vm._v(_vm._s(_vm.$t('common.rmaCreationDate')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"13"}},[_vm._v(_vm._s(_vm.$t('reports.authorizationNumber')))]),_vm._v(" "),_c('el-checkbox',{staticClass:"checkbox",attrs:{"label":"14"}},[_vm._v(_vm._s(_vm.$t('reports.modelNumber')))])],1)],1)],1),_vm._v(" "),_c('el-button',{on:{"click":_vm.selectAll}},[_vm._v(_vm._s(_vm.$t('common.deSelectAll')))]),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.generateReport}},[_vm._v(_vm._s(_vm.$t('common.generate')))]),_vm._v(" "),(this.form.fields.length == 0)?_c('p',{ref:"labelInfo",staticClass:"labelInfo"},[_vm._v(_vm._s(_vm.$t('reports.pleaseSelectatLeastOneColumn')))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"labelInfo"},[_vm._v(_vm._s(_vm.$t('reports.noDatesChoosenMessage')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rpgD":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "hdl+",
	"./fr.json": "ROTR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rpgD";

/***/ }),

/***/ "rqAC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _getServiceRequests$g;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = (_getServiceRequests$g = {
    getServiceRequests: function getServiceRequests(page, filter, sorting) {
        var params = {
            page: page,
            serialNumber: filter.serialNumber,
            isHistory: !!filter.isHistory,
            sortBy: sorting.sortBy,
            sortOrder: sorting.sortOrder,
            dateFrom: filter.dateFrom,
            dateTo: filter.dateTo

        };

        if (filter.type !== 0) {
            params.status = filter.type;
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/service-requests', {
            params: params
        });
    },
    getServiceRequest: function getServiceRequest(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/service-requests/' + id);
    },
    deleteServiceRequest: function deleteServiceRequest(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/service-requests/' + id);
    },
    saveTicket: function saveTicket(dispatch, ticket, number, changeEmail) {
        var fd = new FormData();
        for (var prop in ticket) {
            if (ticket.hasOwnProperty(prop)) {
                if (prop === 'attachments') {
                    for (var i = 0; i < ticket.attachments.length; i++) {
                        if (ticket.attachments[i] instanceof File) {
                            fd.append('attachments', ticket.attachments[i]);
                        }
                    }
                } else if (prop === 'complaintCodes') {
                    for (var _i = 0; _i < ticket.complaintCodes.length; _i++) {
                        fd.append('complaintCodes', ticket.complaintCodes[_i].id);
                    }
                } else {
                    fd.append(prop, ticket[prop]);
                }
            }
        }
        if (changeEmail && changeEmail.useCustom) {
            fd.append('customEmailAddress[serviceCompany]', changeEmail.serviceCompany);
            fd.append('customEmailAddress[phone]', changeEmail.phone);
            fd.append('customEmailAddress[email]', changeEmail.email);
            fd.append('customEmailAddress[custom]', changeEmail.useCustom);
        }

        fd.append('isCreatedFromServiceRequest', true);

        var url = '/api/service-requests/create-service-ticket?number=' + number;

        if (dispatch) {
            url += '&dispatch=' + dispatch;
        }

        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, fd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    getStatuses: function getStatuses() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/statuses');
    },
    getCategories: function getCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/dashboard/categories/servicetickets');
    },
    getServiceTicketNumber: function getServiceTicketNumber() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/getnumber');
    },
    getComplaintCodeCategories: function getComplaintCodeCategories() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/complaintcodes/categories');
    },
    getPreviousTickets: function getPreviousTickets(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/previoustickets');
    },
    getServiceCompanyCredentials: function getServiceCompanyCredentials(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/getServiceCompanyCredentials');
    },
    customerIsRs: function customerIsRs(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/customerIsRs');
    }
}, _defineProperty(_getServiceRequests$g, 'getPreviousTickets', function getPreviousTickets(id, pageNumber, previousTicketsPageSize) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/servicetickets/' + id + '/previoustickets', {
        params: {
            page: pageNumber,
            perPage: previousTicketsPageSize
        }
    });
}), _defineProperty(_getServiceRequests$g, 'download', function download(filter, sorting) {
    var params = {
        serialNumber: filter.serialNumber,
        isHistory: filter.isHistory == 0 ? false : true,
        dateFrom: filter.dateFrom,
        dateTo: filter.dateTo,
        sortBy: sorting.sortBy,
        sortOrder: sorting.sortOrder
    };
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/service-requests/export', params);
}), _getServiceRequests$g);

/***/ }),

/***/ "ruon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.showDialog,"width":"40%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadEquipment,"close":_vm.closeDialog}},[_c('template',{slot:"title"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('equipments.equipmentRegistration'))+"\n            "),(!_vm.equipmentId)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.createCustomer}},[_vm._v("\n                "+_vm._s(_vm.$t('equipments.createCustomer'))+"\n            ")]):_vm._e()],1)]),_vm._v(" "),_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.customer'),"prop":"customerId"}},[_c('customer-selector',{model:{value:(_vm.form.customerId),callback:function ($$v) {_vm.$set(_vm.form, "customerId", $$v)},expression:"form.customerId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{attrs:{"disabled":this.updateMode},on:{"serialUpdate":_vm.serialUpdated},model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.serialNumber'),"prop":"serialNumber"}},[_c('el-input',{attrs:{"disabled":this.updateMode},model:{value:(_vm.form.serialNumber),callback:function ($$v) {_vm.$set(_vm.form, "serialNumber", $$v)},expression:"form.serialNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('equipments.gasType'),"prop":"gasType"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.gasType),callback:function ($$v) {_vm.$set(_vm.form, "gasType", $$v)},expression:"form.gasType"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('equipments.notApplicable')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('equipments.natural')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('equipments.propane')}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('equipments.shippingDate'),"prop":"shippingDate"}},[_c('el-date-picker',{staticClass:"full-width",attrs:{"type":"date"},model:{value:(_vm.form.shippingDate),callback:function ($$v) {_vm.$set(_vm.form, "shippingDate", $$v)},expression:"form.shippingDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('equipments.installationDate'),"prop":"installationDate"}},[_c('el-date-picker',{staticClass:"full-width",attrs:{"type":"date","picker-options":_vm.installationDatePickerOptions},model:{value:(_vm.form.installationDate),callback:function ($$v) {_vm.$set(_vm.form, "installationDate", $$v)},expression:"form.installationDate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.warrantyStart'),"prop":"warrantyStart"}},[_c('el-date-picker',{staticClass:"full-width",attrs:{"type":"date"},model:{value:(_vm.form.warrantyStart),callback:function ($$v) {_vm.$set(_vm.form, "warrantyStart", $$v)},expression:"form.warrantyStart"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.warrantyEnd'),"prop":"warrantyEnd"}},[_c('el-date-picker',{staticClass:"full-width",attrs:{"type":"date"},model:{value:(_vm.form.warrantyEnd),callback:function ($$v) {_vm.$set(_vm.form, "warrantyEnd", $$v)},expression:"form.warrantyEnd"}})],1)],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(!this.updateMode)?_c('el-button',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"type":"success"},on:{"click":function($event){_vm.save(true)}}},[_vm._v(_vm._s(_vm.$t('equipments.copyAndCreate')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"loading":_vm.loading,"disabled":_vm.loading,"type":"primary"},on:{"click":function($event){_vm.save(false)}}},[(this.updateMode)?_c('span',[_vm._v(_vm._s(_vm.$t('common.update')))]):_c('span',[_vm._v(_vm._s(_vm.$t('common.create')))])]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s3+J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("H50Z");
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-ticket-list-from-email",
    components: {
        ServiceTicketDetailsDialog: __WEBPACK_IMPORTED_MODULE_0__ServiceTicketDetailsDialog__["a" /* default */]
    },
    data: function data() {
        return {
            dialogVisible: false,
            ticketToEdit: this.$route.params.ticketId
        };
    },
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].updateEmailStatus(this.ticketToEdit);
    },
    mounted: function mounted() {
        if (this.ticketToEdit) {
            this.editTicket(parseInt(this.ticketToEdit));
        }
    },

    methods: {
        editTicket: function editTicket(id) {
            this.ticketToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        }
    }
});

/***/ }),

/***/ "sAAO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelector_vue__ = __webpack_require__("kkDv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a70bf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelector_vue__ = __webpack_require__("fRW5");
function injectStyle (ssrContext) {
  __webpack_require__("2urG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a70bf0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountrySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a70bf0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountrySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sEg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":(_vm.partId === null ? _vm.$t('common.create') : _vm.$t('common.update')) + ' ' + _vm.$t('masters.part'),"visible":_vm.showDialog,"width":"620px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadPart,"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"240px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('common.product'),"prop":"productId"}},[_c('product-selector',{model:{value:(_vm.form.productId),callback:function ($$v) {_vm.$set(_vm.form, "productId", $$v)},expression:"form.productId"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.number'),"prop":"no"}},[_c('el-input',{model:{value:(_vm.form.no),callback:function ($$v) {_vm.$set(_vm.form, "no", $$v)},expression:"form.no"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.description'),"prop":"description"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.descriptionFr'),"prop":"descriptionFr"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.descriptionFr),callback:function ($$v) {_vm.$set(_vm.form, "descriptionFr", $$v)},expression:"form.descriptionFr"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.needsReturn')}},[_c('el-switch',{model:{value:(_vm.form.needsReturn),callback:function ($$v) {_vm.$set(_vm.form, "needsReturn", $$v)},expression:"form.needsReturn"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.extDiscountRate'),"prop":"extendedPriceRate"}},[_c('el-radio-group',{model:{value:(_vm.form.extendedPriceRate),callback:function ($$v) {_vm.$set(_vm.form, "extendedPriceRate", $$v)},expression:"form.extendedPriceRate"}},[_c('el-radio',{attrs:{"label":2}},[_vm._v("50%")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v("35%")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.usListPrice'),"prop":"usListPrice"}},[_c('el-input',{model:{value:(_vm.form.usListPrice),callback:function ($$v) {_vm.$set(_vm.form, "usListPrice", _vm._n($$v))},expression:"form.usListPrice"}},[_c('template',{slot:"suffix"},[_vm._v("\n                    Extended: "+_vm._s(_vm._f("money")(_vm.usExtendedPrice))+" Non-Warranty: "+_vm._s(_vm._f("money")(_vm.usNonWarrantyPrice))+"\n                ")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.cdnListPrice'),"prop":"cdnListPrice"}},[_c('el-input',{model:{value:(_vm.form.cdnListPrice),callback:function ($$v) {_vm.$set(_vm.form, "cdnListPrice", _vm._n($$v))},expression:"form.cdnListPrice"}},[_c('template',{slot:"suffix"},[_vm._v("\n                    "+_vm._s(_vm.$t('common.extended'))+": "+_vm._s(_vm._f("money")(_vm.cdnExtendedPrice))+" "+_vm._s(_vm.$t('common.nonWarranty'))+": "+_vm._s(_vm._f("money")(_vm.cdnNonWarrantyPrice))+"\n                ")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.shippingMethod'),"prop":"shippingMethod"}},[_c('shipping-method-selector',{model:{value:(_vm.form.shippingMethod),callback:function ($$v) {_vm.$set(_vm.form, "shippingMethod", $$v)},expression:"form.shippingMethod"}})],1),_vm._v(" "),(_vm.form.shippingMethod === '5')?_c('el-form-item',{attrs:{"label":_vm.$t('common.otherCompany'),"prop":"otherCompany"}},[_c('el-input',{model:{value:(_vm.form.otherCompany),callback:function ($$v) {_vm.$set(_vm.form, "otherCompany", $$v)},expression:"form.otherCompany"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.coo'),"prop":"countryOfOrigin"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.countryOfOrigin),callback:function ($$v) {_vm.$set(_vm.form, "countryOfOrigin", $$v)},expression:"form.countryOfOrigin"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.unavailableForPartsOrders')}},[_c('el-checkbox',{staticClass:"checkbox",on:{"change":_vm.deactivate},model:{value:(_vm.form.unavailableForPartsOrders),callback:function ($$v) {_vm.$set(_vm.form, "unavailableForPartsOrders", $$v)},expression:"form.unavailableForPartsOrders"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.unavailableForClaimsDeactivated')}},[_c('el-checkbox',{staticClass:"checkbox",on:{"change":_vm.deactivate},model:{value:(_vm.form.unavailableForClaims),callback:function ($$v) {_vm.$set(_vm.form, "unavailableForClaims", $$v)},expression:"form.unavailableForClaims"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('masters.authorizationNumRequired')}},[_c('el-checkbox',{staticClass:"checkbox",model:{value:(_vm.form.isAuthRequired),callback:function ($$v) {_vm.$set(_vm.form, "isAuthRequired", $$v)},expression:"form.isAuthRequired"}})],1),_vm._v(" "),(_vm.showDeactivateComment)?_c('el-form-item',{attrs:{"label":_vm.$t('masters.pleaseLeaveCommentBeforeDeactivatePart')}},[_c('el-input',{attrs:{"type":"textarea","size":"small","rows":4,"placeholder":_vm.$t('common.comment')},model:{value:(_vm.form.deactivateComment),callback:function ($$v) {_vm.$set(_vm.form, "deactivateComment", $$v)},expression:"form.deactivateComment"}})],1):_vm._e()],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"disabled":_vm.loading,"type":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.partId === null ? _vm.$t('common.create') : _vm.$t('common.update')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.loading},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('common.cancel')))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sH+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "email-details-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            required: true
        },
        subject: {
            required: true
        },
        body: {
            required: true
        }
    },
    data: function data() {
        return {
            showDialog: this.visible
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    },
    methods: {
        loadTicket: function loadTicket() {
            console.log("Load Ticket");
        },
        closeDialog: function closeDialog() {
            this.showDialog = false;
            this.$emit("dialogClosed");
        }
    }
});

/***/ }),

/***/ "sK4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("hpk7");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/rma',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* RMA */],
    name: 'rma'
}]);

/***/ }),

/***/ "sRA6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"direction":"vertical"}},[_c('el-row',[_c('el-col',{attrs:{"span":2}},[(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1)],1),_vm._v(" "),_vm._l((_vm.taxes),function(tax){return _c('el-row',{key:tax.id,staticClass:"row"},[_c('el-col',{attrs:{"span":1}},[_vm._v(_vm._s(tax.code))]),_vm._v(" "),(tax.hstTax)?_c('tax-input',{attrs:{"taxType":'hst',"tax":tax.hstTax},on:{"update":function($event){_vm.taxUpdated(tax.id, $event)}}}):_vm._e(),_vm._v(" "),(tax.gstTax)?_c('tax-input',{attrs:{"taxType":'gst',"tax":tax.gstTax},on:{"update":function($event){_vm.taxUpdated(tax.id, $event)}}}):_vm._e(),_vm._v(" "),(tax.qstTax)?_c('tax-input',{attrs:{"taxType":'qst',"tax":tax.qstTax},on:{"update":function($event){_vm.taxUpdated(tax.id, $event)}}}):_vm._e()],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sRsp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("MVm2");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "sT8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    getEquipmentList: function getEquipmentList(page, text, sorting) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/equipment/table', {
            params: {
                page: page,
                serialNumber: text,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder
            }
        });
    },
    getEquipment: function getEquipment(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/equipment/' + id);
    },
    saveEquipment: function saveEquipment(id, equipment) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/equipment/' + id, equipment);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/equipment', equipment);
    },
    deleteEquipment: function deleteEquipment(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/equipment/' + id);
    },
    download: function download(serialNumber) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/equipment/export', {
            serialNumber: serialNumber
        });
    }
});

/***/ }),

/***/ "sV98":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketList_vue__ = __webpack_require__("iXAO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40dc569f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketList_vue__ = __webpack_require__("yT6J");
function injectStyle (ssrContext) {
  __webpack_require__("thCH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceTicketList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40dc569f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceTicketList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sXP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/parts/export', {
            no: filter.text,
            productId: filter.productId,
            description: filter.text,
            code: filter.text
        });
    },
    getParts: function getParts(page, productId, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts', {
            params: {
                page: page,
                no: text,
                productId: productId,
                description: text,
                descriptionFr: text,
                code: text
            }
        });
    },
    getPart: function getPart(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/parts/' + id);
    },
    savePart: function savePart(id, part) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/parts/' + id, part);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/parts', part);
    },
    deletePart: function deletePart(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/parts/' + id);
    },
    upload: function upload(file) {
        var formData = new FormData();
        formData.append('file', file);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/parts/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    saveParts: function saveParts(parts) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/parts/saveparts', parts);
    },
    uploadConfirm: function uploadConfirm(file) {
        var formData = new FormData();
        formData.append('file', file);
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/parts/importConfirmation', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    backup: function backup() {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/parts/backup');
    }
});

/***/ }),

/***/ "spEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateUpdateCustomerChainDialog_vue__ = __webpack_require__("ozTw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("SiCf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'customer-chain-list',
    components: {
        CreateUpdateCustomerChainDialog: __WEBPACK_IMPORTED_MODULE_0__CreateUpdateCustomerChainDialog_vue__["a" /* default */]
    },
    data: function data() {
        return {
            customerChains: [],
            loading: true,
            dialogVisible: false,
            customerChainToEdit: null,
            filter: {
                text: undefined
            },
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadCustomerChains();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadCustomerChains();
            }
        }
    },
    methods: {
        download: function download() {
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].download(this.filter);
        },
        loadCustomerChains: function loadCustomerChains() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCustomerChains(this.currentPage, this.filter.text).then(function (response) {
                _this.loading = false;
                _this.customerChains = response.data.items;
                _this.total = response.data.total;
            });
        },
        appendCustomerChain: function appendCustomerChain(event) {
            this.loadCustomerChains();
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadCustomerChains();
        },
        editCustomerChain: function editCustomerChain(id) {
            this.customerChainToEdit = id;
            this.dialogVisible = true;
        },
        editFinished: function editFinished() {
            this.customerChainToEdit = null;
            this.dialogVisible = false;
        },
        deleteCustomerChain: function deleteCustomerChain(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteCustomerChainContinue'), 'Warning', {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteCustomerChain(id).then(function () {
                    _this2.loadCustomerChains();
                    _this2.$message({
                        type: 'success',
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        }
    }
});

/***/ }),

/***/ "t559":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PDFDocument__ = __webpack_require__("dCXX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("15dZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PDFDocument: __WEBPACK_IMPORTED_MODULE_0__PDFDocument__["a" /* default */]
  },
  name: "node",
  props: {
    nodes: Array
  },
  data: function data() {
    return {
      isPreviewPdf: false,
      previewUrl: "",
      scale: 2
    };
  },

  methods: {
    deleteFolder: function deleteFolder(id) {
      var _this = this;

      this.$confirm(this.$t('common.areYouSureAllFilesInThisFolderWillBeDeleted'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteFolder(id).then(function (response) {
          _this.$notify({
            title: _this.$t('common.success'),
            message: _this.$t('common.folderSuccesfullyDeleted'),
            type: "success"
          });
          _this.$emit("folderDeleted");
        });
      }).catch(function (_) {});
    },
    deleteDocument: function deleteDocument(id) {
      var _this2 = this;

      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteDocument(id).then(function (response) {
          _this2.$notify({
            title: _this2.$t('common.success'),
            message: _this2.$t('common.documentsSuccesfullyDeleted'),
            type: "success"
          });
          _this2.$emit("documentDeleted");
        });
      }).catch(function (_) {});
    },
    openFolder: function openFolder(node) {
      node.open = !node.open;
    },
    OpenPreviewWindow: function OpenPreviewWindow(url) {
      this.previewUrl = url;
      this.isPreviewPdf = true;
    },
    ClosePreviewWindow: function ClosePreviewWindow() {
      this.isPreviewPdf = false;
      this.previewUrl = "";
    }
  }
});

/***/ }),

/***/ "t7Q2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("jCQl");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/escalation-tickets',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["a" /* EscalationList */],
    name: 'escalationList'
}]);

/***/ }),

/***/ "t8d6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("cFdp");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "tCss":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("t7Q2");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "tMv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.$t('serviceTickets.createServiceTicket'),"visible":_vm.showDialog,"width":"60%","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"close":_vm.closeDialog}},[_c('el-form',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"form",attrs:{"disabled":_vm.isSavingInProgress,"model":_vm.form,"rules":_vm.rules,"size":"small","label-width":"140px","label-position":"left"}},[_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.ticketNumber')}},[_c('el-input',{attrs:{"disabled":"","type":"number"},model:{value:(_vm.serviceTicketNumber),callback:function ($$v) {_vm.serviceTicketNumber=$$v},expression:"serviceTicketNumber"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"Customer",attrs:{"label":_vm.$t('serviceTickets.customer'),"prop":"customerId"}},[(!_vm.copyticket)?_c('customer-selector',{model:{value:(_vm.form.customerId),callback:function ($$v) {_vm.$set(_vm.form, "customerId", $$v)},expression:"form.customerId"}}):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.product'),"prop":"equipmentId"}},[_c('equipment-selector',{attrs:{"customerId":_vm.form.customerId},on:{"equipmentSelected":_vm.equipmentSelected},model:{value:(_vm.form.equipmentId),callback:function ($$v) {_vm.$set(_vm.form, "equipmentId", $$v)},expression:"form.equipmentId"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{staticStyle:{"float":"right"},attrs:{"label":_vm.$t('serviceTickets.warrantyEnd')}},[_c('el-input',{attrs:{"disabled":"","type":"text"},model:{value:(_vm.equipmentWrtEnd),callback:function ($$v) {_vm.equipmentWrtEnd=$$v},expression:"equipmentWrtEnd"}})],1)],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.callerTitle'),"prop":"callerTitle"}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.callerTitle),callback:function ($$v) {_vm.$set(_vm.form, "callerTitle", $$v)},expression:"form.callerTitle"}},[_c('el-option',{attrs:{"value":15,"label":"Food Court Manager"}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('serviceTickets.deliManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":14,"label":_vm.$t('serviceTickets.deliSupervisor')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('serviceTickets.meatManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('serviceTickets.regionalManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('serviceTickets.hardtManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('serviceTickets.hardtProductManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('serviceTickets.warehouseManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('serviceTickets.warehouseManagerAssistant')}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":_vm.$t('serviceTickets.operator')}}),_vm._v(" "),_c('el-option',{attrs:{"value":9,"label":_vm.$t('serviceTickets.customerCorporateRequest')}}),_vm._v(" "),_c('el-option',{attrs:{"value":10,"label":_vm.$t('serviceTickets.maintance')}}),_vm._v(" "),_c('el-option',{attrs:{"value":11,"label":_vm.$t('serviceTickets.freshManager')}}),_vm._v(" "),_c('el-option',{attrs:{"value":12,"label":_vm.$t('serviceTickets.freshManagerAssistant')}}),_vm._v(" "),_c('el-option',{attrs:{"value":13,"label":_vm.$t('serviceTickets.other')}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.callerName'),"prop":"caller"}},[_c('el-input',{model:{value:(_vm.form.caller),callback:function ($$v) {_vm.$set(_vm.form, "caller", $$v)},expression:"form.caller"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.callerPhone'),"prop":"callerPhoneNumber"}},[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.form.callerPhoneNumber),callback:function ($$v) {_vm.$set(_vm.form, "callerPhoneNumber", $$v)},expression:"form.callerPhoneNumber"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.urgency'),"prop":"urgency"}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.urgency),callback:function ($$v) {_vm.$set(_vm.form, "urgency", $$v)},expression:"form.urgency"}},[_c('el-option',{attrs:{"value":7,"label":_vm.$t('serviceTickets.escalation')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('serviceTickets.priorityDown')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('serviceTickets.priorityOperational')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('serviceTickets.installation')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('serviceTickets.postInstallation')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('serviceTickets.installPostInstallCombo')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('serviceTickets.hold')}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.status'),"prop":"status"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.status),callback:function ($$v) {_vm.$set(_vm.form, "status", $$v)},expression:"form.status"}},[_c('el-option',{attrs:{"value":1,"label":" "}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('common.flagged')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('common.escalation')}}),_vm._v(" "),_c('el-option',{attrs:{"value":8,"label":"Standard"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.serviceCoverage'),"prop":"serviceCoverage"}},[(!_vm.copyticket)?_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.serviceCoverage),callback:function ($$v) {_vm.$set(_vm.form, "serviceCoverage", $$v)},expression:"form.serviceCoverage"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('serviceTickets.warranty')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('serviceTickets.costcoNonWarranty')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('serviceTickets.costcoPreventativeMaintenance')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('serviceTickets.wallMartNonWarranty')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('serviceTickets.pendingWarranty')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('serviceTickets.warrantyException')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('serviceTickets.installationPostInstallation')}})],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.overtimeApproved'),"prop":"overtimeApproved"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.overtimeApproved),callback:function ($$v) {_vm.$set(_vm.form, "overtimeApproved", $$v)},expression:"form.overtimeApproved"}},[_c('el-option',{attrs:{"value":true,"label":"Yes"}}),_vm._v(" "),_c('el-option',{attrs:{"value":false,"label":"No"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.communicationRequirements'),"prop":"notes"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.notes),callback:function ($$v) {_vm.$set(_vm.form, "notes", $$v)},expression:"form.notes"}})],1),_vm._v(" "),(!!_vm.form.equipmentNote)?_c('el-row',[_c('el-col',[_c('el-form-item',{staticStyle:{"background-color":"yellow","padding":"2px"},attrs:{"label":_vm.$t('serviceTickets.productNote')}},[_c('el-input',{attrs:{"type":"textarea","autosize":"","disabled":""},model:{value:(_vm.form.equipmentNote),callback:function ($$v) {_vm.$set(_vm.form, "equipmentNote", $$v)},expression:"form.equipmentNote"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.responseTime'),"prop":"responseTime"}},[_c('el-select',{staticClass:"full-width",model:{value:(_vm.form.responseTime),callback:function ($$v) {_vm.$set(_vm.form, "responseTime", $$v)},expression:"form.responseTime"}},[_c('el-option',{attrs:{"value":-1,"label":" "}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":"2 hrs"}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":"4 hrs"}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":"6 hrs"}})],1)],1),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('serviceTickets.symptoms')))]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","justify-content":"space-around"}},[_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.selectCategory'),"prop":"categoryName"}},[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('serviceTickets.pleaseSelectCategory')},model:{value:(_vm.form.categoryName),callback:function ($$v) {_vm.$set(_vm.form, "categoryName", $$v)},expression:"form.categoryName"}},_vm._l((_vm.form.categories),function(item){return _c('el-option',{attrs:{"label":item.category,"value":item.category}})}))],1),_vm._v(" "),(_vm.form.subCategories && _vm.form.subCategories.length >  0 && _vm.form.equipmentName && _vm.form.equipmentName.includes('I4500'))?_c('el-form-item',{staticStyle:{"margin-left":"30px"},attrs:{"label":_vm.$t('serviceTickets.selectSubcategory'),"prop":"subCategoryName"}},[_c('el-select',{staticClass:"select",attrs:{"clearable":"","filterable":"","placeholder":_vm.$t('serviceTickets.pleaseSelectSubcategory')},model:{value:(_vm.form.subCategoryName),callback:function ($$v) {_vm.$set(_vm.form, "subCategoryName", $$v)},expression:"form.subCategoryName"}},_vm._l((_vm.form.subCategories),function(item){return (_vm.form.categoryName)?_c('el-option',{attrs:{"label":item,"value":item}}):_vm._e()}))],1):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.addSymptom')}},[_c('complaint-code-selector',{attrs:{"equipmentId":_vm.form.equipmentId,"categoryName":_vm.form.categoryName,"subCategoryName":_vm.form.subCategoryName},on:{"code-selected":_vm.appendCode}})],1),_vm._v(" "),_vm._l((_vm.form.complaintCodes),function(complaint){return _c('el-alert',{key:complaint.id,staticStyle:{"margin-bottom":"5px"},attrs:{"title":complaint.name,"type":"info"},on:{"close":function($event){_vm.removeCode(complaint.id)}}})}),_vm._v(" "),(_vm.previousTickets.length > 0)?_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.previousCalls')}},[_c('el-table',{staticClass:"tablewithshading",attrs:{"disabled":_vm.isSavingInProgress,"data":_vm.previousTickets}},[_c('el-table-column',{attrs:{"prop":"raisedOn","label":_vm.$t('serviceTickets.date')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"id","label":_vm.$t('serviceTickets.ticketNumber'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":_vm.$t('serviceTickets.serialNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"note","label":_vm.$t('serviceTickets.description'),"min-width":"300"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":_vm.$t('serviceTickets.status'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.view'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editTicket(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})])]}}])})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-top":"10px"}},[(!_vm.previousTicketsButtonDisabled)?_c('el-button',{on:{"click":function($event){_vm.getMorePreviousTickets()}}},[_vm._v("\n                    Load More\n                ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('serviceTickets.ticketFiles'),"prop":"attachments"}},[_c('el-upload',{attrs:{"name":"attachments","drag":"","multiple":"","file-list":_vm.form.attachments,"auto-upload":false,"limit":10,"action":"","on-change":_vm.attachmentChanged,"on-preview":_vm.handlePreview}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                    "+_vm._s(_vm.$t('serviceTickets.dropFile'))+"\n                    "),_c('em',[_vm._v(_vm._s(_vm.$t('serviceTickets.clicktoUpload')))])])])],1)],2),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"success","disabled":_vm.isSavingInProgress && !_vm.isCopy,"loading":_vm.isSavingInProgress && _vm.isCopy},on:{"click":_vm.copyAndSave}},[_vm._v(_vm._s(_vm.$t('serviceTickets.copyAndSave')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.isSavingInProgress && !_vm.isCopy,"disabled":_vm.isSavingInProgress && _vm.isCopy},on:{"click":_vm.showEmailDialog}},[_vm._v(_vm._s(_vm.$t('serviceTickets.save')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.isSavingInProgress},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('serviceTickets.close')))]),_vm._v(" "),_c('el-button',{attrs:{"disabled":_vm.isSavingInProgress},on:{"click":_vm.closeDialog}},[_vm._v(_vm._s(_vm.$t('serviceTickets.cancel')))])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showImagePreview,"width":"60%","append-to-body":""},on:{"update:visible":function($event){_vm.showImagePreview=$event}}},[_c('embed',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.fileUrlPreview,"type":"application/pdf"}}),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showImagePreview = false}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.close')))])],1),_vm._v(" "),_c('send-email-dialog',{attrs:{"visible":_vm.showSaveDialog,"loadingChangeEmail":_vm.loadingChangeEmail,"formChangeEmail":_vm.formChangeEmail},on:{"save":_vm.save}}),_vm._v(" "),_c('duplicate-ticket-warning',{attrs:{"visible":_vm.showDuplicateTicketWarning,"existingTicketId":_vm.existingTicketId,"existingTicketDate":_vm.existingTicketDate},on:{"close":_vm.handleDialogClose,"cancel":_vm.handleDialogCancel,"continue":_vm.handleDialogContinue}}),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showRsMessage,"width":"30%","append-to-body":"","title":_vm.$t('serviceTickets.customerRs')},on:{"update:visible":function($event){_vm.showRsMessage=$event}}},[_c('p',[_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.rsMessage1'))),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('serviceTickets.rsMessage2'))+"\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){_vm.showRsMessage = false}}},[_vm._v(_vm._s(_vm.$t('serviceTickets.ok')))]),_vm._v(" "),_c('el-button',{on:{"click":_vm.viewrsprocedures}},[_vm._v(_vm._s(_vm.$t('serviceTickets.viewRsProcedures')))])],1),_vm._v(" "),_c('service-ticket-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tPvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRBQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__servicetickets_components_ServiceTicketDetailsDialog__ = __webpack_require__("84W6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__servicetickets_components_SendEmailDialog__ = __webpack_require__("hoZv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("rqAC");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-service-ticket-from-draft-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        ticketId: {
            type: Number
        },
        isHistory: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CustomerSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["h" /* CustomerSelector */],
        EquipmentSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["i" /* EquipmentSelector */],
        ComplaintCodeSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["f" /* ComplaintCodeSelector */],
        CategorySelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["c" /* CategorySelector */],
        ServiceTicketDetailsDialog: __WEBPACK_IMPORTED_MODULE_1__servicetickets_components_ServiceTicketDetailsDialog__["a" /* default */],
        SendEmailDialog: __WEBPACK_IMPORTED_MODULE_2__servicetickets_components_SendEmailDialog__["a" /* default */]
    },

    data: function data() {
        this.loading = true;

        return {
            id: undefined,
            dialogVisible: false,
            isSavingInProgress: false,
            showRsMessage: false,
            serviceCoverageName: undefined,
            callerTitleValue: undefined,
            urgencyValue: undefined,
            copyticket: false,
            isCopy: false,
            form: {
                customerName: undefined,
                customerId: undefined,
                equipmentId: undefined,
                categoryName: undefined,
                equipmentName: undefined,
                subCategoryName: undefined,
                callerTitle: undefined,
                requestorName: "",
                callerPhoneNumber: "",
                requestorEmail: "",
                overtimeApproved: undefined,
                isConfirmationOnly: false,
                urgency: undefined,
                notes: "",
                status: undefined,
                serviceCoverage: undefined,
                complaintCodes: [],
                attachments: [],
                categories: [],
                subCategories: [],
                responseTime: -1,
                mobilePhone: undefined,
                secondMobilePhone: undefined,
                email: undefined
            },
            rules: _defineProperty({
                customerId: [{
                    type: "number",
                    required: true,
                    message: "Please select customer",
                    trigger: "change"
                }],
                equipmentId: [{
                    type: "number",
                    required: true,
                    message: "Please select equipment",
                    trigger: "change"
                }],
                callerTitle: [{
                    type: "number",
                    required: true,
                    message: "Please select title",
                    trigger: "change"
                }],
                requestorName: [{
                    required: true,
                    message: "Please enter caller name",
                    trigger: "blur"
                }],
                urgency: [{
                    type: "number",
                    required: true,
                    message: "Please select urgency",
                    trigger: "change"
                }],
                serviceCoverage: [{
                    type: "number",
                    required: true,
                    message: "Please select service coverage",
                    trigger: "change"
                }],
                overtimeApproved: [{
                    required: true,
                    message: "Please select overtime approved",
                    trigger: "change"
                }]
            }, "overtimeApproved", [{
                required: true,
                message: this.$t('shared.pleaseSelectOvertimeApproved'),
                trigger: "change"
            }]),
            formChangeEmail: {
                serviceCompany: null,
                phone: null,
                email: null,
                useCustom: false
            },
            loading: false,
            showDialog: this.visible,
            fileUrlPreview: null,
            showImagePreview: false,
            serviceTicketNumber: null,
            previousTickets: [],
            showSaveDialog: false,
            loadingChangeEmail: false,
            ticketToEdit: null,
            equipmentWrtEnd: null,
            fileExtension: undefined,
            currentPreviousTicketsPage: 1,
            previousTicketsPageSize: 4,
            previousTicketsTotal: 0,
            previousTicketsButtonDisabled: false
        };
    },

    watch: {
        "form.customerId": function formCustomerId(val, oldVal) {
            var _this = this;

            if (this.form.customerId) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].customerIsRs(this.form.customerId).then(function (response) {
                    if (response && response.data && response.data === true) {
                        _this.showRsMessage = true;
                    }
                });
            }
            this.getServiceCompanyCredentials();
            if (this.form.customerId && oldVal === undefined) {
                return;
            }
            this.form.equipmentId = undefined;
        },
        "form.equipmentId": function formEquipmentId(val, oldVal) {
            var _this2 = this;

            if (val != undefined && val != null && val != "") {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getPreviousTickets(val, this.previousTicketsPage, this.previousTicketsPageSize).then(function (response) {
                    _this2.previousTickets = response.data.items;
                    _this2.previousTicketsTotal = response.data.total;
                    if (response.data.items.length < _this2.previousTicketsPageSize || response.data.items.length === response.data.total) {
                        _this2.previousTicketsButtonDisabled = true;
                    }
                });
            }
        },
        "form.categoryName": function formCategoryName(val) {
            if (val != undefined && val != null && val != "") {
                this.form.subCategories = this.form.categories.filter(function (e) {
                    return e.category == val;
                })[0].subCategories;
                this.form.subCategoryName = undefined;
            } else {
                this.form.subCategories = [];
                this.form.subCategoryName = undefined;
            }
        },
        "form.status": function formStatus(val, oldVal) {
            switch (val) {
                case 1:
                    this.form.notes = "";
                    break;
                case 3:
                    this.form.notes = "FLAGGED CALL - *** Tech MUST call Hardt at 1-800-387-6847 upon arrival to work with tech support and report findings. **** Please provide techs ETA to service@hardt.ca. Thank you.";
                    break;
                case 5:
                    this.form.notes = "ESCALATION - ***Tech MUST call tech support from site at 1-800-387-6847 UPON ARRIVAL to report findings and for further support. *** We need a technician scheduled as soon as possible today or 1st call tomorrow at the latest. Thank you.";
                    break;
                case 8:
                    this.form.notes = "***Please call the Customer at the number provided above to SCHEDULE or PROVIDE TECH\'S ETA upon receiving this ticket.***";
                    break;
            }
        },
        visible: function visible(val) {
            this.showDialog = val;
            if (val) {
                this.loadTicket();
            }
        }
    },
    methods: {
        scrollToElement: function scrollToElement(options) {
            var el = this.$el.getElementsByClassName('Customer')[0];

            if (el) {
                el.scrollIntoView(options);
            }
        },
        loadTicket: function loadTicket() {
            var _this3 = this;

            if (this.ticketId) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceRequest(this.ticketId).then(function (response) {
                    _this3.loading = false;
                    if (response.data.success) {
                        var ticket = response.data.ticket;
                        _this3.form = Object.assign({}, ticket, {
                            requestorEmail: ticket.email,
                            serviceCoverage: undefined,
                            notes: ticket.explanationOfIssue ? ticket.explanationOfIssue : "",
                            callerTitle: Number(ticket.requestorTitleId),
                            complaintCodes: [],
                            categories: [],
                            customerName: ticket.customerName
                        });
                        _this3.serviceCoverageName = undefined;
                        _this3.callerTitleValue = ticket.callerTitleValue;
                        _this3.urgencyValue = ticket.urgencyValue;
                        _this3.equipmentWrtEnd = ticket.warrantyEndFormatted;

                        if (!ticket.customerId) {
                            _this3.form.customerId = undefined;
                            _this3.form.equipmentId = undefined;
                        }

                        if (ticket.complaint && ticket.customerId) {
                            _this3.appendCode({
                                id: ticket.complaint.id,
                                name: ticket.complaint.code + " - " + ticket.complaint.description
                            });
                        }

                        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
                            _this3.form.categories = response.data;
                        });

                        _this3.getServiceCompanyCredentials();
                    } else {
                        _this3.$notify({
                            title: "Error",
                            message: response.data.message,
                            type: "error"
                        });
                        _this3.copyticket = false;
                    }
                });
            }
        },
        appendCode: function appendCode(code) {
            if (this.form.complaintCodes.indexOf(code) === -1) {
                this.form.complaintCodes.push(code);
            }
        },
        removeCode: function removeCode(code) {
            this.form.complaintCodes = this.form.complaintCodes.filter(function (c) {
                return c.id != code;
            });
        },
        closeDialog: function closeDialog() {
            this.formChangeEmail.serviceCompany = null;
            this.formChangeEmail.phone = null;
            this.formChangeEmail.email = null;
            this.formChangeEmail.useCustom = false;
            this.$refs["form"].resetFields();
            this.form.complaintCodes = [];
            this.showDialog = false;
            this.previousTickets = [];
            this.loading = false;
            this.showSaveDialog = false;
            this.isCopy = false;
            this.isSavingInProgress = false;
            this.$emit("dialogClosed");
            this.previousTicketsTotal = 0;
            this.previousTicketsButtonDisabled = false;
            this.currentPreviousTicketsPage = 1;
        },
        save: function save(sendEmail, isEmailFormValied) {
            var _this4 = this;

            this.showSaveDialog = false;
            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this4.$refs["form"].loading = true;
                    _this4.isSavingInProgress = true;
                    _this4.form.status = _this4.form.status || "1"; // service ticket opened value
                    if (_this4.formChangeEmail.useCustom) {
                        if (isEmailFormValied) {
                            __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTicket(sendEmail, _this4.form, _this4.serviceTicketNumber, _this4.formChangeEmail).then(function () {
                                _this4.$notify({
                                    title: "Success",
                                    message: 'Ticket successfully saved.',
                                    type: "success"
                                });
                                _this4.closeDialog();
                            }).catch(function (response) {
                                _this4.$notify({
                                    title: "Error",
                                    message: response.response.data,
                                    type: "error"
                                });
                                _this4.loading = false;
                                _this4.isSavingInProgress = false;
                            });
                        } else {
                            return false;
                        }
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTicket(sendEmail, _this4.form, _this4.serviceTicketNumber).then(function () {
                            if (!_this4.isCopy) {
                                _this4.$notify({
                                    title: "Success",
                                    message: 'Ticket successfully saved.',
                                    type: "success"
                                });
                                _this4.closeDialog();
                            } else {
                                _this4.$notify({
                                    title: "Success",
                                    message: 'Ticket successfully saved.',
                                    type: "success"
                                });
                                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
                                    _this4.form.categories = response.data;
                                });
                                _this4.form.status = undefined;
                                _this4.form.equipmentId = undefined;
                                _this4.form.categoryName = undefined;
                                _this4.form.equipmentName = undefined;
                                _this4.form.subCategoryName = undefined;
                                _this4.form.overtimeApproved = undefined;
                                _this4.form.isConfirmationOnly = false;
                                _this4.form.urgency = undefined;
                                _this4.form.notes = "";
                                _this4.form.status = undefined;
                                _this4.form.serviceCoverage = undefined;
                                _this4.form.complaintCodes = [];
                                _this4.form.attachments = [];
                                _this4.form.subCategories = [];
                                _this4.form.responseTime = -1;
                                _this4.isSavingInProgress = false;
                                _this4.isCopy = false;

                                _this4.scrollToElement({ behavior: 'smooth' });
                            }
                        }).catch(function (response) {
                            _this4.$notify({
                                title: "Error",
                                message: response.response.data,
                                type: "error"
                            });
                            _this4.loading = false;
                            _this4.isSavingInProgress = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        close: function close() {
            var _this5 = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this5.loading = true;
                    _this5.form.status = _this5.form.status || "1"; // service ticket opened value
                    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].saveTicket(null, _this5.form, _this5.serviceTicketNumber).then(function () {
                        _this5.closeDialog();
                    }).catch(function (response) {
                        _this5.$notify({
                            title: "Error",
                            message: response.response.data,
                            type: "error"
                        });
                        _this5.loading = false;
                    });
                } else {
                    return false;
                }
            });
        },
        attachmentChanged: function attachmentChanged(file, fileList) {
            this.form.attachments.push(file.raw);
        },
        handlePreview: function handlePreview(file) {
            var split = file.name.split(".");
            this.fileExtension = split[split.length - 1];
            if (!file.url) {
                return;
            }
            if (this.fileExtension !== "jpg" && this.fileExtension !== "pdf" && this.fileExtension !== "jpeg" && this.fileExtension !== "png") {
                window.open(file.url);
                return;
            }
            this.fileUrlPreview = file.url;
            this.showImagePreview = true;
        },
        getServiceCompanyCredentials: function getServiceCompanyCredentials() {
            var _this6 = this;

            if (this.form && this.form.customerId) {
                this.loadingChangeEmail = true;
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getServiceCompanyCredentials(this.form.customerId).then(function (response) {
                    _this6.formChangeEmail.email = response.data.email;
                    _this6.formChangeEmail.phone = response.data.phone;
                    _this6.formChangeEmail.serviceCompany = response.data.serviceCompany;
                    _this6.loadingChangeEmail = false;
                });
            }
        },
        copyAndSave: function copyAndSave() {
            this.showEmailDialog();
            this.isCopy = true;
        },
        showEmailDialog: function showEmailDialog() {
            var _this7 = this;

            if (this.form.complaintCodes.length === 0) {
                this.$message.error("At least one symptom code should be added");
                return;
            }
            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    _this7.showSaveDialog = true;
                } else {
                    return false;
                }
            });
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.dialogVisible = false;
        },
        editTicket: function editTicket(id) {
            this.ticketToEdit = id;
            this.dialogVisible = true;
        },
        viewrsprocedures: function viewrsprocedures() {
            window.open("static/RS Procedure Technical Support.pdf", "_blank", "width=600,height=800,toolbar=1");
            this.showRsMessage = false;
        },
        equipmentSelected: function equipmentSelected(equipment) {
            this.equipmentWrtEnd = equipment.warrantyEndFormatted;
            this.form.equipmentName = equipment.model;
        },
        getMorePreviousTickets: function getMorePreviousTickets() {
            var _this8 = this;

            if (this.currentPreviousTicketsPage * this.previousTicketsPageSize < this.previousTicketsTotal) {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getPreviousTickets(this.form.equipmentId, this.currentPreviousTicketsPage + 1, this.previousTicketsPageSize).then(function (response) {
                    if (response.data.items.length > 0) {
                        _this8.currentPreviousTicketsPage = _this8.currentPreviousTicketsPage + 1;
                        _this8.previousTickets = [].concat(_toConsumableArray(_this8.previousTickets), _toConsumableArray(response.data.items));
                        _this8.previousTicketsTotal = response.data.total;

                        if (response.data.items.length < _this8.previousTicketsPageSize || _this8.currentPreviousTicketsPage * _this8.previousTicketsPageSize === _this8.previousTicketsTotal) {
                            _this8.previousTicketsButtonDisabled = true;
                        }
                    } else {
                        _this8.previousTicketsButtonDisabled = true;
                    }
                });
            } else {
                this.previousTicketsButtonDisabled = true;
            }
        },
        deleteServiceRequest: function deleteServiceRequest() {
            var _this9 = this;

            this.$confirm('Are you sure you want to delete the service request?', 'Warning', {
                confirmButtonText: 'Ok',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].deleteServiceRequest(_this9.form.id).then(function () {
                    _this9.loading = false;
                    _this9.closeDialog();
                    _this9.$message({
                        type: 'success',
                        message: 'Delete completed'
                    });
                });
            }).catch(function (_) {});
        }
    },
    mounted: function mounted() {
        var _this10 = this;

        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].getComplaintCodeCategories().then(function (response) {
            _this10.loading = false;
            _this10.form.categories = response.data;
        });
    }
});

/***/ }),

/***/ "thCH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "twtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("bM5v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-ticket-selector",
    props: ["value", "customerName"],
    watch: {
        customerName: function customerName(newValue) {
            console.info(newValue);
            if (newValue) {
                this.searchserviceTickets(newValue);
            }
        }
    },
    data: function data() {
        return {
            loading: false,
            serviceTickets: []
        };
    },

    methods: {
        searchserviceTickets: function searchserviceTickets(term) {
            var self = this;
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getServiceTicket(term).then(function (response) {
                self.loading = false;
                self.serviceTickets = response.data;
            });
        },
        selectCustomer: function selectCustomer(event) {

            this.$emit("input", event);
        },
        searchserviceTicketsById: function searchserviceTicketsById(id, callback) {
            var self = this;
            self.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getserviceTicketsById(id).then(function (response) {
                self.loading = false;
                self.serviceTickets = response.data;

                if (callback) {
                    callback();
                }
            });
        },
        getserviceTickets: function getserviceTickets() {
            return this.serviceTickets;
        }
    },
    created: function created() {
        this.searchserviceTickets("");
    }
});

/***/ }),

/***/ "u/aD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceList_vue__ = __webpack_require__("eGIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8e74d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceList_vue__ = __webpack_require__("XKyj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f8e74d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u1Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSelector_vue__ = __webpack_require__("ZPea");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61031ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSelector_vue__ = __webpack_require__("wHnl");
function injectStyle (ssrContext) {
  __webpack_require__("8Vec")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61031ebe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddressSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61031ebe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddressSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u27F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("Et0o");


/* harmony default export */ __webpack_exports__["a"] = ([{
    path: '/costco-service-requests/:status?',
    component: __WEBPACK_IMPORTED_MODULE_0__components__["b" /* CostcoServiceRequestsList */],
    name: 'CostcoServiceRequestsList',
    meta: { admin: true }
}]);

/***/ }),

/***/ "u6Cr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("acN8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb5f1c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("bL4T");
function injectStyle (ssrContext) {
  __webpack_require__("/3FV")
  __webpack_require__("tPvG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4fb5f1c5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fb5f1c5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uHJs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Costco__ = __webpack_require__("4a7p");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Costco__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClaimHistory__ = __webpack_require__("IyOY");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ClaimHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PriceList__ = __webpack_require__("u/aD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__PriceList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResolutionCodeList__ = __webpack_require__("/r6A");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__ResolutionCodeList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UsedPartsList__ = __webpack_require__("K6Tg");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__UsedPartsList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Graphs__ = __webpack_require__("J9fi");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Graphs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceTickets__ = __webpack_require__("g3GU");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__ServiceTickets__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RMA__ = __webpack_require__("3HQz");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__RMA__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ApReport__ = __webpack_require__("7ANf");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__ApReport__["a"]; });










/***/ }),

/***/ "uSZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oidc_client__ = __webpack_require__("k9w+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_oidc_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_oidc_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__ = __webpack_require__("wUZ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app__ = __webpack_require__("iK3N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__("ff6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__globalapp__ = __webpack_require__("p89l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n__ = __webpack_require__("CXBx");















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_the_mask___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('money', function (value) {
    if (!value) return '$0.00';
    value = parseFloat(value).toFixed(2);
    return '$' + value;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('date', function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(value)).format('YYYY/MM/DD');
    }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('datetime', function (value) {
    if (value) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(value)).format('YYYY/MM/DD HH:mm');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_en___default.a });
__webpack_require__("hKoQ").polyfill();
//require('babel-polyfill')
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.download = function (url, params) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, {
        responseType: 'arraybuffer',
        params: params
    }).then(function (response) {
        var blob = new Blob([response.data], { type: response.headers['content-type'] });
        var link = document.createElement('a');
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        var matches = /filename=(.*?)(;|$)/g.exec(response.headers['content-disposition']);
        link.download = matches && matches.length > 1 ? matches[1].replace(/"/g, '') : null;
        link.click();
        document.body.removeChild(link);
    });
};
var unAuthorizedUrls = {
    EscalationTickets: "escalation-tickets"
};

var manager = new __WEBPACK_IMPORTED_MODULE_3_oidc_client___default.a.UserManager({
    userStore: new __WEBPACK_IMPORTED_MODULE_3_oidc_client___default.a.WebStorageStateStore(),
    authority: window.authentication.authority,
    client_id: window.authentication.clientId,
    redirect_uri: window.authentication.redirectUrl,
    response_type: 'id_token token',
    scope: 'openid profile email api',
    post_logout_redirect_uri: window.authentication.authority,
    loadUserInfo: true,
    silent_redirect_uri: window.location.origin + "/static/silent.html",
    automaticSilentRenew: true
});

manager.getUser().then(function (user) {
    var pathSegments = window.location.pathname.split('/');
    // If using a hash URL
    var hashSegment = window.location.hash.split('/').pop();

    if (hashSegment === unAuthorizedUrls.EscalationTickets) {
        new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
            i18n: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */],
            el: '#app',
            router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
            render: function render(h) {
                return h(__WEBPACK_IMPORTED_MODULE_9__globalapp__["a" /* GlobalApp */]);
            }
        });
    } else {
        if (localStorage.getItem("browserClosed")) {
            document.cookie = "browserClosed=" + localStorage.getItem("browserClosed");
        }
        if (user === null) {
            validNavigation = true;
            manager.signinRedirect();
            console.log("Testing");
        } else {
            user.profile.role = user.profile.role.toLowerCase();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$currentUser = user;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isAdmin = user.profile.role === 'admin';
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isReadonlyAdmin = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isAdmin && user.profile.readonly;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isFullAdmin = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isAdmin && !user.profile.readonly;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isSuperAdmin = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isAdmin && user.profile.superAdmin;
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isSubAgentUser = user.profile.role === 'subagentuser';
            console.log(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isSubAgentUser);
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isUser = user.profile.role === 'user';
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isImpersonateUser = localStorage["isImpersonateUser"] === "true";
            console.log(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isUser);
            console.log("Testing");

            /* eslint-disable no-new */
            new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
                i18n: __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */],
                el: '#app',
                router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
                render: function render(h) {
                    return h(__WEBPACK_IMPORTED_MODULE_7__app__["a" /* App */]);
                }
            });
        }
        __WEBPACK_IMPORTED_MODULE_11__i18n__["a" /* default */].locale = 'en';
    }
}).catch(function (err) {
    console.log(err);
});

var validNavigation = false;

window.addEventListener('beforeunload', function (event) {
    if (!validNavigation) {
        //localStorage.clear();
        //document.cookie = "browserClosed=" + new Date().getTime();
        //localStorage.setItem("browserClosed", new Date().getTime());
    }
});
window.signInManager = manager;

/***/ }),

/***/ "ufXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("YZek");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreateUpdateRma__ = __webpack_require__("NMra");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PreviewRmaDialog__ = __webpack_require__("z0Xr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app_event_bus_js__ = __webpack_require__("fEXR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "rma",
    components: {
        CreateUpdateRmaDialog: __WEBPACK_IMPORTED_MODULE_2__CreateUpdateRma__["a" /* default */],
        PreviewRmaDialog: __WEBPACK_IMPORTED_MODULE_3__PreviewRmaDialog__["a" /* default */]
    },
    props: {},
    data: function data() {
        return {
            loading: true,
            filter: {
                text: undefined
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            rmaList: [],
            rmaToView: undefined,
            rmaToEdit: undefined,
            updateRmaVisible: false,
            previewRmaVisible: false,
            isForPartial: false,
            rmaTicketList: []
        };
    },

    methods: {
        loadRma: function loadRma() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getRMAs(this.currentPage, this.sorting, this.filter).then(function (response) {
                _this.loading = false;
                _this.rmaList = response.data.items;
                _this.total = response.data.total;
            });
        },
        sortRma: function sortRma(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadRma();
            } else {
                this.currentPage = 1;
            }
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadRma();
        },
        deleteRma: function deleteRma(id) {
            var _this2 = this;

            this.$confirm(this.$t('common.thisWillDeleteRMAContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].deleteRma(id).then(function () {
                    _this2.loadRma();
                    _this2.$message({
                        type: "success",
                        message: _this2.$t('common.deleteCompleted')
                    });
                });
            }).catch(function (_) {});
        },
        updateRmaFinished: function updateRmaFinished() {
            this.rmaToEdit = undefined;
            this.updateRmaVisible = false;
        },
        showPreviewRma: function showPreviewRma(id) {
            console.log(id);
            this.rmaToView = id;
            this.previewRmaVisible = true;
        },
        showRmaConfirm: function showRmaConfirm(id) {
            this.rmaToView = id;
            this.previewRmaVisible = true;
        },
        previewRmaFinished: function previewRmaFinished() {
            this.rmaToView = undefined;
            this.previewRmaVisible = false;
        },
        showEditRma: function showEditRma(id) {
            this.rmaToEdit = id;
            this.updateRmaVisible = true;
        },

        trackingNumberToUrl: function trackingNumberToUrl(trackingNumber) {
            if (trackingNumber) {
                var tnum = trackingNumber.match(/^\s*(.*?)\s*$/)[1];
                var tnumEscaped = encodeURIComponent(tnum);
                if (/^(?:1Z[A-Z0-9]{16}|\d{9}|T\d{10})$/.test(tnum)) {
                    var url = 'https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=' + tnumEscaped;
                    window.open(url, '_blank');
                } else {
                    return null;
                }
            }
        }
    },
    computed: {},
    created: function created() {
        this.loadRma();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadRma();
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        __WEBPACK_IMPORTED_MODULE_4__app_event_bus_js__["a" /* EventBus */].$on("showRmaConfirm", function (rmaId) {
            _this3.showRmaConfirm(rmaId);
        });
    }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uzhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPartDialog_vue__ = __webpack_require__("/U6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba610034_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPartDialog_vue__ = __webpack_require__("8rwU");
function injectStyle (ssrContext) {
  __webpack_require__("nANx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba610034"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddPartDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba610034_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddPartDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v9zC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanySelector_vue__ = __webpack_require__("Es/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11df963c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanySelector_vue__ = __webpack_require__("8iTD");
function injectStyle (ssrContext) {
  __webpack_require__("S1Cx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11df963c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanySelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11df963c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanySelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vBEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "tax-input",
  props: {
    taxType: {
      type: String,
      required: true
    },
    tax: {
      type: Number,
      required: true
    },
    span: {
      type: Number,
      default: 3
    }
  },
  data: function data() {
    return {
      value: this.tax,
      editing: false
    };
  },

  methods: {
    updateTax: function updateTax() {
      this.value = +(Math.round(this.value + "e+2") + "e-2");
      this.$emit("update", { value: this.value, type: this.taxType });
    }
  },
  watch: {
    value: function value(val) {
      if (this.value > 100) {
        this.value = 100;
      }
      if (this.value < 0) {
        this.value = 0;
      }
    }
  }
});

/***/ }),

/***/ "vMsE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscalationListDetailsDialog_vue__ = __webpack_require__("MNom");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54292eac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscalationListDetailsDialog_vue__ = __webpack_require__("+bCh");
function injectStyle (ssrContext) {
  __webpack_require__("O3Mh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54292eac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EscalationListDetailsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54292eac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EscalationListDetailsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vQoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":16}},[(_vm.$isSuperAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.email'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.email),callback:function ($$v) {_vm.$set(_vm.filter, "email", $$v)},expression:"filter.email"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"placeholder":_vm.$t('masters.userName'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.userName),callback:function ($$v) {_vm.$set(_vm.filter, "userName", $$v)},expression:"filter.userName"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.users},on:{"sort-change":_vm.sortServiceTickets}},[_c('el-table-column',{attrs:{"prop":"userName","label":_vm.$t('masters.userName'),"width":"150","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email","label":_vm.$t('common.email'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"phoneNumber","label":_vm.$t('common.phone')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('masters.isReadOnly')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isReadOnly)?_c('i',{staticClass:"el-icon-check"}):_vm._e()]}}])}),_vm._v(" "),(_vm.$isSuperAdmin)?_c('el-table-column',{attrs:{"label":_vm.$t('masters.isSuperAdmin')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.isSuperAdmin)?_c('i',{staticClass:"el-icon-check"}):_vm._e()]}}])}):_vm._e(),_vm._v(" "),(_vm.$isSuperAdmin)?_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editUser(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteUser(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})])]}}])}):_vm._e()],1),_vm._v(" "),_c('create-update-user-dialog',{attrs:{"userId":_vm.userToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendUser}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vaJH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ClaimPartSelector__ = __webpack_require__("QCCL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("fboY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "add-part-dialog",
    components: {
        ClaimPartSelector: __WEBPACK_IMPORTED_MODULE_1__ClaimPartSelector__["a" /* default */]
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        misc: {
            type: Boolean,
            default: false
        },
        serviceCompanyId: {
            type: Number,
            required: false
        },
        productId: {
            required: true
        },
        isNotWarrantyClaim: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            form: {
                part: undefined,
                quantity: 1,

                name: "",
                price: undefined,
                extendedPrice: undefined
            },
            rules: {
                part: [{
                    required: true,
                    message: this.$t('common.pleaseSelectPart'),
                    trigger: "change"
                }],
                name: [{
                    required: true,
                    message: this.$t('common.pleaseEnterName'),
                    trigger: "blur"
                }],
                price: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseEnterPrice'),
                    trigger: "blur"
                }],
                extendedPrice: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseEnterExtendedPrice'),
                    trigger: "blur"
                }],
                quantity: [{
                    type: "number",
                    required: true,
                    message: this.$t('common.pleaseEnterQuantity'),
                    trigger: "blur"
                }]
            },
            selectedPart: undefined,
            showDialog: this.visible
        };
    },

    methods: {
        closeDialog: function closeDialog() {
            this.selectedPart = undefined;
            this.$refs["form"].resetFields();
            if (this.$refs["part-selector"]) {
                this.$refs["part-selector"].reset();
            }
            this.showDialog = false;
            this.$emit("dialogClosed");
        },
        partSelected: function partSelected(part) {
            if (part) {
                this.form.part = part;
                var self = this;
                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPartById(part.id, this.serviceCompanyId, this.isNotWarrantyClaim).then(function (response) {
                    self.form.part = response.data;
                    self.selectedPart = response.data;
                });
            } else {
                this.form.part = undefined;
                this.form.quantity = 1;
                this.selectedPart = undefined;
            }
        },
        addPart: function addPart() {
            var _this = this;

            this.$refs["form"].validate(function (valid) {
                if (valid) {
                    var part = _this.form.part;
                    if (_this.misc) {
                        part = {
                            name: _this.form.name,
                            price: _this.form.price,
                            extendedPrice: _this.form.extendedPrice
                        };
                    }
                    _this.$emit("part-added", {
                        part: part,
                        quantity: _this.form.quantity
                    });
                    _this.closeDialog();
                } else {
                    return false;
                }
            });
        }
    },
    computed: {
        currentCompanyId: function currentCompanyId() {
            return this.$isAdmin ? this.serviceCompanyId : window.currentCompany.id;
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        }
    }
});

/***/ }),

/***/ "vg3B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__("iqu8");


/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/part-orders/:status?',
  component: __WEBPACK_IMPORTED_MODULE_0__components__["b" /* PartOrderList */],
  name: 'partOrdersList'
}]);

/***/ }),

/***/ "vhVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("vg3B");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "vkL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  getChains: function getChains() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/customerchains/lookup');
  }
});

/***/ }),

/***/ "vtEV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vw1y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("u27F");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "w+3a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'duplicate-ticket-warning',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        existingTicketId: {
            type: String,
            default: ''
        },
        existingTicketDate: {
            type: String,
            default: ''
        }
    },
    computed: {
        dialogVisible: {
            get: function get() {
                return this.visible;
            },
            set: function set(value) {
                this.$emit('update:visible', value);
            }
        }
    },
    methods: {
        handleClose: function handleClose() {
            this.$emit('close');
        },
        handleCancel: function handleCancel() {
            this.$emit('cancel');
        },
        handleContinue: function handleContinue() {
            this.$emit('continue');
        }
    }
});

/***/ }),

/***/ "w1zW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w9Cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClaimList__ = __webpack_require__("UTxS");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClaimList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateUpdateClaimDialog__ = __webpack_require__("Lj1T");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__CreateUpdateClaimDialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreviewClaimDialog__ = __webpack_require__("LoMJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__PreviewClaimDialog__["a"]; });




/***/ }),

/***/ "wGQX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wGf4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerChainList_vue__ = __webpack_require__("spEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5792761c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerChainList_vue__ = __webpack_require__("lqBE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerChainList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5792761c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerChainList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wHnl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("title",[_c('h3',[_vm._v(_vm._s(_vm.$t('common.address')))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.companyName'),"prop":"shipToName"}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"disabled":_vm.disable},model:{value:(_vm.value.shipToName),callback:function ($$v) {_vm.$set(_vm.value, "shipToName", $$v)},expression:"value.shipToName"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.shipToName))]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.address'),"prop":"address"}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"disabled":_vm.disable,"autoComplete":"new-password"},model:{value:(_vm.value.address),callback:function ($$v) {_vm.$set(_vm.value, "address", $$v)},expression:"value.address"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.address))]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('shared.countryProvince'),"prop":"selectedCountryState"}},[(!_vm.showAsPreview)?_c('el-cascader',{staticClass:"selector",attrs:{"disabled":_vm.disable,"placeholder":_vm.$t('shared.selectCountryAndProvince'),"options":_vm.countriesWithStates,"filterable":"","change-on-select":""},model:{value:(_vm.value.selectedCountryState),callback:function ($$v) {_vm.$set(_vm.value, "selectedCountryState", $$v)},expression:"value.selectedCountryState"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.selectedCountryState))]):_vm._e()],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('common.city'),"prop":"city"}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"disabled":_vm.disable,"autoComplete":"new-password"},model:{value:(_vm.value.city),callback:function ($$v) {_vm.$set(_vm.value, "city", $$v)},expression:"value.city"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.city))]):_vm._e()],1),_vm._v(" "),(_vm.showRegional)?_c('el-form-item',{attrs:{"label":_vm.$t('common.regional'),"prop":"regional","disabled":_vm.disable}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.value.regional),callback:function ($$v) {_vm.$set(_vm.value, "regional", $$v)},expression:"value.regional"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.regional))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showRegional)?_c('el-form-item',{attrs:{"label":_vm.$t('common.region'),"prop":"region","disabled":_vm.disable}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"autoComplete":"new-password"},model:{value:(_vm.value.region),callback:function ($$v) {_vm.$set(_vm.value, "region", $$v)},expression:"value.region"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.region))]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('shared.zip'),"prop":"zip"}},[(!_vm.showAsPreview)?_c('el-input',{attrs:{"disabled":_vm.disable,"autoComplete":"new-password"},model:{value:(_vm.value.zip),callback:function ($$v) {_vm.$set(_vm.value, "zip", $$v)},expression:"value.zip"}}):_vm._e(),_vm._v(" "),(_vm.showAsPreview)?_c('span',[_vm._v(_vm._s(_vm.value.zip))]):_vm._e()],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wViC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostcoServiceRequestsList_vue__ = __webpack_require__("yUjF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f51807d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostcoServiceRequestsList_vue__ = __webpack_require__("PRS+");
function injectStyle (ssrContext) {
  __webpack_require__("d098")
  __webpack_require__("aU7l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f51807d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostcoServiceRequestsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f51807d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostcoServiceRequestsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wXjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":2}},[_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.claimNumber')},model:{value:(_vm.filter.claimNumber),callback:function ($$v) {_vm.$set(_vm.filter, "claimNumber", $$v)},expression:"filter.claimNumber"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('common.partNumber')},model:{value:(_vm.filter.part),callback:function ($$v) {_vm.$set(_vm.filter, "part", $$v)},expression:"filter.part"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.$t('common.dateFrom')},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":_vm.$t('common.dateTo')},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"tablewithshading",attrs:{"size":"mini","data":_vm.parts}},[_c('el-table-column',{attrs:{"prop":"claimNumber","label":_vm.$t('common.claimNumber')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('reports.claimDate')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("date")(scope.row.raisedOn))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"no","label":_vm.$t('common.number'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('common.description')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":_vm.$t('common.quantity'),"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.listPrice'),"width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.price))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.extendedPrice'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("money")(scope.row.extendedPrice))+"\n            ")]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wkbZ":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "jDhz",
	"./fr.json": "8zVP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wkbZ";

/***/ }),

/***/ "x0TM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("esN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_claims_components_CreateUpdateClaimDialog__ = __webpack_require__("Lj1T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_claims_components_PreviewClaimDialog__ = __webpack_require__("LoMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "costco-report",
  components: {
    ProductSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["k" /* ProductSelector */],
    CreateUpdateClaimDialog: __WEBPACK_IMPORTED_MODULE_2__app_claims_components_CreateUpdateClaimDialog__["a" /* default */],
    PreviewClaimDialog: __WEBPACK_IMPORTED_MODULE_3__app_claims_components_PreviewClaimDialog__["a" /* default */],
    CustomerSelector: __WEBPACK_IMPORTED_MODULE_1__app_shared_components__["h" /* CustomerSelector */]
  },
  data: function data() {
    return {
      form: {
        isCanadian: true,
        isForCostco: false
      },
      showButton: false,
      claims: [],
      loading: false,
      showNoDataMessage: false,
      isFirst50Items: true,
      chooseActionVisible: false,
      claimId: 0,
      claimStatus: null,
      updateClaimVisible: false,
      previewClaimVisible: false,
      claimToView: undefined,
      claimToEdit: undefined,
      reportType: 0
    };
  },

  watch: {
    form: {
      deep: true,
      handler: function handler(val) {
        this.claims = [];
      }
    }
  },
  computed: {
    canBeEdited: function canBeEdited() {
      return this.claimStatus === 0 || this.claimStatus === 3;
    }
  },
  methods: {
    generateFullReport: function generateFullReport() {
      var _this = this;

      this.loading = true;
      this.isFirst50Items = false;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getClaims(this.form, this.isFirst50Items).then(function (response) {
        _this.loading = false;
        _this.showButton = false;
        _this.claims = _this.claims.concat(response.data);
        _this.isFirst50Items = true;
      });
    },
    generateReport: function generateReport() {
      var _this2 = this;

      this.showNoDataMessage = false;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getClaims(this.form, this.isFirst50Items).then(function (response) {
        _this2.loading = false;
        if (response.data.length === 0) {
          _this2.showNoDataMessage = true;
        }
        _this2.claims = response.data;
        if (response.data[0]) {
          _this2.showButton = response.data[0].totalItems > 50;
        }
        _this2.isFirst50Items = true;
      });
    },
    exportExcel: function exportExcel() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].downloadReport(this.form).then(function (response) {
        _this3.loading = false;
        var blob = response.data;
        var fileName = response.headers["content-disposition"].split(";")[1].split("=")[1];
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          var blobURL = window.URL.createObjectURL(blob);
          var tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", fileName);

          // Safari thinks _blank anchor are pop ups. We only want to set _blank
          // target if the browser does not support the HTML5 download attribute.
          // This allows you to download files in desktop safari if pop up blocking
          // is enabled.
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }

          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(blobURL);
        }
      }).catch(function (error) {
        _this3.loading = false;
      });
    },
    chooseAction: function chooseAction(id, status) {
      this.claimId = id;
      this.claimStatus = status;
      this.chooseActionVisible = true;
    },
    viewClaim: function viewClaim(id) {
      if (this.chooseActionVisible == true) {
        this.chooseActionVisible = false;
      }
      this.claimToView = id;
      this.previewClaimVisible = true;
    },
    editClaim: function editClaim(id) {
      if (this.chooseActionVisible == true) {
        this.chooseActionVisible = false;
      }
      this.claimToEdit = id;
      this.updateClaimVisible = true;
    },
    updateClaimFinished: function updateClaimFinished() {
      this.claimToEdit = undefined;
      this.updateClaimVisible = false;
    },
    previewClaimFinished: function previewClaimFinished() {
      this.claimToView = undefined;
      this.previewClaimVisible = false;
    },
    showClaimPreview: function showClaimPreview(id) {
      this.claimToView = id;
      this.previewClaimVisible = true;
    },
    claimPublished: function claimPublished() {
      this.$notify({
        title: this.$t('common.success'),
        message: this.$t('common.claimSuccesfullySubmitted'),
        type: "success"
      });
      this.loadClaims();
    },
    change: function change(value) {
      switch (value) {
        case 0:
          this.form.isCanadian = true;
          this.form.isForCostco = false;
          break;
        case 1:
          this.form.isCanadian = true;
          this.form.isForCostco = true;
          break;
        case 2:
          this.form.isCanadian = false;
          this.form.isForCostco = false;
          break;
        case 3:
          this.form.isCanadian = false;
          this.form.isForCostco = true;
          break;
      }
    }
  }
});

/***/ }),

/***/ "xMBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateComplaintCodeDialog_vue__ = __webpack_require__("/4Dx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a76638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateComplaintCodeDialog_vue__ = __webpack_require__("dxgD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUpdateComplaintCodeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a76638_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUpdateComplaintCodeDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xONh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PartSelector__ = __webpack_require__("VPW1");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PartSelector__["a"]; });


/***/ }),

/***/ "xQon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__("kum8");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__routes__["a"]; });


/***/ }),

/***/ "xaXQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
    download: function download(filter) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.download('/api/complaintcodes/export', {
            productId: filter.productId,
            description: filter.text,
            code: filter.text
        });
    },
    getCodes: function getCodes(page, productId, text) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/complaintcodes/table', {
            params: {
                page: page,
                productId: productId,
                description: text,
                code: text
            }
        });
    },
    getCode: function getCode(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/complaintcodes/' + id);
    },
    saveCode: function saveCode(id, code) {
        if (id) {
            return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/api/complaintcodes/' + id, code);
        }
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/complaintcodes', code);
    },
    deleteCode: function deleteCode(id) {
        return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/complaintcodes/' + id);
    }
});

/***/ }),

/***/ "xooi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ChainSelector__ = __webpack_require__("T4VY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PromptDialog__ = __webpack_require__("MPtm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("065F");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "customernotification-list",
    components: {
        CountrySelector: __WEBPACK_IMPORTED_MODULE_2__app_shared_components__["g" /* CountrySelector */],
        ChainSelector: __WEBPACK_IMPORTED_MODULE_1__ChainSelector__["a" /* default */],
        promptDialog: __WEBPACK_IMPORTED_MODULE_3__PromptDialog__["a" /* default */]
    },
    data: function data() {
        return {
            customers: [],
            customerNotifications: [],
            loading: true,
            exporting: false,
            dialogVisible: false,
            customerToEdit: undefined,
            notification: '',
            notificationId: null,
            filter: {
                countryId: undefined,
                chainId: undefined,
                text: undefined,
                notification: undefined
            },
            sort: undefined,
            currentPage: 1,
            total: 0
        };
    },
    created: function created() {
        this.loadCustomers();
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler(val) {
                this.loadCustomers();
            }
        }
    },
    methods: {
        sortChanged: function sortChanged(sort) {
            this.sort = sort;
            if (this.currentPage === 1) {
                this.loadCustomers();
            } else {
                this.currentPage = 1;
            }
        },
        expanded: function expanded(row, expandedRows) {
            var _this = this;

            var isExpanded = expandedRows.indexOf(row);
            if (isExpanded !== -1) {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getNotifications(row.id).then(function (response) {
                    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this.customerNotifications, row.id, response.data);
                });
            }
        },
        loadCustomers: function loadCustomers() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getCustomers(this.currentPage, this.filter.countryId, this.filter.chainId, this.filter.text, "", "", "", this.sort, this.filter.notification).then(function (response) {
                _this2.loading = false;
                _this2.customers = response.data.items.map(function (obj) {
                    return _extends({}, obj, { count: obj.notifications.length });
                });
                _this2.total = response.data.total;
            });
        },
        closePromptDialog: function closePromptDialog() {
            this.dialogVisible = false;
        },
        addNote: function addNote(message) {
            var _this3 = this;

            var date = new Date().toLocaleDateString() + " - " + this.$currentUser.profile.name + " ";
            var notification = {
                id: this.notificationId,
                message: (message.split(/\d\/\d\/\d\d\d\d - /)[0] ? message.split(/\d\/\d\/\d\d\d\d - /)[0] : message) + " " + date
            };
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveNotification(this.customerId, notification).then(function () {
                _this3.loadNotifications(_this3.customerId);
                _this3.$notify({
                    title: _this3.$t('common.success'),
                    message: _this3.$t('common.notifySuccesfullySaved'),
                    type: "success"
                });

                if (!_this3.notificationId) {
                    _this3.loadCustomers();
                }
            });
        },
        addNotification: function addNotification(customerId) {
            this.notificationId = null;
            this.customerId = customerId;
            this.dialogVisible = true;
            this.notification = '';
        },
        loadNotifications: function loadNotifications(customerId) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getNotifications(customerId).then(function (response) {
                //this.customerNotifications[customerId] = response.data;
                __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(_this4.customerNotifications, customerId, response.data);
                console.log(response.data);
            });
        },
        editNotification: function editNotification(customerId, notificationUpdated) {
            var notification = this.customerNotifications[customerId].find(function (x) {
                return x.id == notificationUpdated;
            });

            this.notification = notification.message;
            this.notificationId = notification.id;
            this.customerId = customerId;

            this.dialogVisible = true;
        },
        deleteNotification: function deleteNotification(customerId, id) {
            var _this5 = this;

            this.$confirm(this.$t('common.thisWillDeleteNotificationContinue'), "Warning", {
                confirmButtonText: this.$t('common.OK'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
            }).then(function () {
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].deleteNotification(id).then(function () {
                    _this5.loadNotifications(customerId);
                    _this5.$message({
                        type: "success",
                        message: _this5.$t('common.deleteCompleted')
                    });
                    _this5.loadCustomers();
                });
            }).catch(function (_) {});
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadCustomers();
        }
    }
});

/***/ }),

/***/ "xutu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_shared_components__ = __webpack_require__("aA7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AddRepairCodeDialog__ = __webpack_require__("iNqm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AddPartDialog__ = __webpack_require__("KF1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__ = __webpack_require__("fEXR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("fboY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "create-update-claim-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        claimId: {
            required: false
        }
    },
    components: {
        CustomerSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["h" /* CustomerSelector */],
        ProductSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["k" /* ProductSelector */],
        ServiceCoverageSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["o" /* ServiceCoverageSelector */],
        ServiceTicketSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["p" /* ServiceTicketSelector */],
        AddRepairCodeDialog: __WEBPACK_IMPORTED_MODULE_1__AddRepairCodeDialog__["a" /* default */],
        AddPartDialog: __WEBPACK_IMPORTED_MODULE_2__AddPartDialog__["a" /* default */],
        AttnSelector: __WEBPACK_IMPORTED_MODULE_0__app_shared_components__["b" /* AttnSelector */]
    },
    data: function data() {
        var _this = this;

        var that = this;
        return {
            trackForm: {},
            isTrackInfoLoaded: false,
            rmaForm: {
                rmaNumber: null,
                rmaDate: '',
                attns: [],
                attn: "",
                selectedCustomer: {},
                serviceCompany: {},
                serviceTicket: {
                    raisedOn: '',
                    authNumber: '',
                    tsr: ''
                },
                serviceCompanyId: '',
                serviceTicketId: '',
                invoiceNumber: '',
                claimNumber: '',
                serviceTicketNumber: undefined,
                shippingMethod: '',
                countryOfOrigin: '',
                parts: [],
                claimId: '',
                id: '',
                claimStatus: ''
            },
            printing: false,
            localClaimId: null,
            claimNumber: undefined,
            claimStatus: -1,
            fileUrlPreview: null,
            fileExtension: null,
            showImagePreview: false,
            oldInvoiceNumber: "",
            generalForm: {
                serviceWorkOrder: "",
                invoiceNumber: "",
                serviceCoverage: undefined,
                dateOfDispatch: "",
                dateWorkCompleted: "",
                productId: undefined,
                serialNumber: "",
                is90DaysWarranty: false,
                workOrders: [],
                serviceTicketNumber: ""
            },
            generalRules: {
                serviceWorkOrder: [{
                    message: this.$t('common.pleaseEnterServiceWorkOrderNumber'),
                    required: true
                }],
                invoiceNumber: [{
                    message: this.$t('common.pleaseEnterInvoiceNumber'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (_this.claimNumber && value === _this.oldInvoiceNumber) {
                            callback();
                        } else {
                            _this.oldInvoiceNumber = value;
                            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].validateInvoiceNumber(value, _this.localClaimId).then(function (response) {
                                if (response.data) {
                                    callback();
                                } else {
                                    callback(new Error(_this.$t('common.invoiceNumberMustBeUnique')));
                                }
                            });
                        }
                    },
                    trigger: "blur"
                }],
                serviceCoverage: [{
                    message: this.$t('shared.pleaseSelectServiceCoverage'),
                    required: true,
                    trigger: "change"
                }],
                dateOfDispatch: [{
                    type: "date",
                    message: this.$t('common.pleaseEnterDateOfDispatch'),
                    required: true,
                    trigger: "change"
                }, {
                    validator: function validator(rule, value, callback) {
                        if (value >= new Date()) {
                            callback(new Error(_this.$t('common.dateOfDispatchMustBeBeforeToday')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                }],
                dateWorkCompleted: [{
                    type: "date",
                    message: this.$t('common.pleaseEnterDateWorkCompleted'),
                    required: true,
                    trigger: "change"
                }, {
                    validator: function validator(rule, value, callback) {
                        if (value >= new Date()) {
                            callback(new Error(_this.$t('common.dateWorkCompletedMustBeBeforeToday')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                }, {
                    validator: function validator(rule, value, callback) {
                        if (value < new Date(that.generalForm.dateOfDispatch.getFullYear(), that.generalForm.dateOfDispatch.getMonth(), that.generalForm.dateOfDispatch.getDate())) {
                            callback(new Error(_this.$t('common.dateWorkCompletedMustBeAfterOrEqualDateOfDispatch')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "change"
                }],
                productId: [{
                    message: this.$t('common.pleaseSelectModel'),
                    required: true,
                    trigger: "change"
                }],
                serialNumber: [{
                    message: this.$t('common.pleaseEnterSerialNumber'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (_this.generalForm.productId === undefined) {
                            callback(new Error(_this.$t('common.pleaseSelectProductFirst')));
                            return;
                        }
                        if (_this.generalForm.productId === undefined) {
                            callback(new Error(_this.$t('common.pleaseSelectServiceCoverageFirst')));
                            return;
                        }
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].validateSerialNumber(value, _this.generalForm.productId, _this.generalForm.serviceCoverage, _this.generalForm.is90DaysWarranty).then(function (result) {
                            if (result.success) {
                                callback();
                            } else {
                                callback(new Error(result.error));
                            }
                        });
                    },
                    trigger: "change"
                }],
                workOrders: [{
                    type: "array",
                    message: this.$t('common.workOrderIsRequired'),
                    required: true,
                    trigger: "change"
                }],
                serviceTicketNumber: [{
                    message: this.$t('common.pleaseEnterServiceTicketNumber'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].validateServiceTicketNumber(value).then(function (result) {
                            if (result.data) {
                                callback();
                            } else {
                                callback(new Error(_this.$t('common.serviceTicketNumberNotFound')));
                            }
                        });
                    },
                    trigger: "change"
                }]
            },

            siteInfoForm: {
                customerId: undefined,
                serviceCompanyId: undefined,
                subagentId: undefined,
                orderSignedBy: "",
                technicianName: "",
                serviceRequestedBy: "",
                complaint: ""
            },
            siteInfoRules: {
                customerId: [{
                    message: this.$t('common.pleaseEnterCustomerId'),
                    required: true,
                    trigger: "change"
                }],
                orderSignedBy: [{
                    message: this.$t('common.pleaseEnterOrderSignedBy'),
                    required: true
                }],
                technicianName: [{
                    message: this.$t('common.pleaseEnterTechnicianName'),
                    required: true
                }],
                serviceRequestedBy: [{
                    message: this.$t('common.pleaseEnterServiceRequestedBy'),
                    required: true
                }],
                complaint: [{
                    message: this.$t('common.pleaseEnterSymptoms'),
                    required: true
                }]
            },
            laborTravelForm: {
                numberOfTrips: 1,
                regularTravelHours: 0,
                overtimeTravelHours: 0,
                regularMileage: 0,
                overtimeMileage: 0,
                serviceFuel: 0,
                tripsExplanationEnum: undefined,
                tripsExplanation: undefined
            },
            laborTravelRules: {
                numberOfTrips: [{
                    type: "number",
                    message: this.$t('common.pleaseEnterNumberOfTrips'),
                    required: true
                }],
                regularTravelHours: [{
                    message: this.$t('common.pleaseEnterRegularTravelHours'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.regularTravelHoursMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                overtimeTravelHours: [{
                    message: this.$t('common.pleaseEnterOvertimeTravelHours'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.overtimeTravelHoursMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                regularMileage: [{
                    message: this.$t('common.pleaseEnterRegularMileage'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.mileageMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                overtimeMileage: [{
                    message: this.$t('common.pleaseEnterOvertimeMileage'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.overtimeMileageMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                serviceFuel: [{
                    message: this.$t('common.pleaseEnterFuel'),
                    required: true
                }, {
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.serviceFuelChargeMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }]
            },

            totalForm: {
                freight: 0,
                hardtInvoice: undefined,
                tax: 0
            },
            totalRules: {
                hardtInvoice: [{
                    validator: function validator(rule, value, callback) {
                        if (_this.totalForm.freight >= 50 && value === "") {
                            callback(new Error(_this.$t('common.invoiceIsRequired')));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"
                }],
                freight: [{
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.freightMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }],
                tax: [{
                    validator: function validator(rule, value, callback) {
                        if (!/^(\d*\.)?\d+$/.test(value)) {
                            callback(new Error(_this.$t('common.taxMustBeANumber')));
                            return;
                        }
                        callback();
                    },
                    trigger: "blur"
                }]
            },

            commentForm: {
                comment: "",
                status: null,
                attachments: []
            },
            commentRules: {
                comment: [{
                    required: true,
                    message: this.$t('common.pleaseEnterCommentText'),
                    trigger: "blur"
                }]
            },

            loading: false,
            loadingClaim: false,
            showDialog: this.visible,
            showRma: this.rmaVisible,
            isServiceCompany: this.rmaForServiceCompany,
            showRmaButton: this.rmaButtonVisible,
            repairCodeDialogVisible: false,
            partDialogVisible: false,
            isMiscPartDialog: false,
            isMultiCodeAdd: false,
            repairCodeToEdit: undefined,
            activeStep: "claimInfo",
            isNew: true,
            comments: [],
            parts: [],
            miscParts: [],
            repairCodes: [],
            isNotWarrantyClaim: false,
            subcontractors: {},
            subagents: {},
            companyType: "1"
        };
    },

    computed: {
        rates: function rates() {
            if ([2, 3, 4, 8].indexOf(parseInt(this.generalForm.serviceCoverage)) === -1) {
                // if not CostcoNonWarranty and not CostcoMaintenance and not WalMartNonWarranty
                return window.currentCompany.rates.warranty;
            } else {
                return window.currentCompany.rates.nonWarranty;
            }
        },
        mutatedClaimId: function mutatedClaimId() {
            return this.localClaimId;
        },
        nextButton: function nextButton() {
            return this.activeStep === "freightTax" ? this.localClaimId ? this.$isAdmin ? "Save" : "Preview" // : "Submit"
            : "Preview" : "Next";
        },
        currentCompany: function currentCompany() {
            return window.currentCompany.id;
        },

        maxRegularTravel: function maxRegularTravel() {
            return window.currentCompany.rates.maxTravelPerTrip * this.laborTravelForm.numberOfTrips - this.laborTravelForm.overtimeTravelHours;
        },
        maxOvertimeTravel: function maxOvertimeTravel() {
            return window.currentCompany.rates.maxTravelPerTrip * this.laborTravelForm.numberOfTrips - this.laborTravelForm.regularTravelHours;
        },
        maxRegularMileage: function maxRegularMileage() {
            return window.currentCompany.rates.maxMileagePerTrip * this.laborTravelForm.numberOfTrips - this.laborTravelForm.overtimeMileage;
        },
        maxOvertimeMileage: function maxOvertimeMileage() {
            return window.currentCompany.rates.maxMileagePerTrip * this.laborTravelForm.numberOfTrips - this.laborTravelForm.regularMileage;
        },
        laborHours: function laborHours() {
            return this.repairCodes.map(function (c) {
                return c.regularTime;
            }).reduce(function (p, c) {
                return p + c;
            }, 0);
        },
        laborSupplementaryHours: function laborSupplementaryHours() {
            return this.repairCodes.map(function (c) {
                return c.supplementaryRegularTime;
            }).reduce(function (p, c) {
                return p + c;
            }, 0);
        },
        laborOvertimeHours: function laborOvertimeHours() {
            return this.repairCodes.map(function (c) {
                return c.overTime;
            }).reduce(function (p, c) {
                return p + c;
            }, 0);
        },
        laborOvertimeSupplementaryHours: function laborOvertimeSupplementaryHours() {
            return this.repairCodes.map(function (c) {
                return c.supplementaryOverTime;
            }).reduce(function (p, c) {
                return p + c;
            }, 0);
        },
        canEdit: function canEdit() {
            return (this.mutatedClaimId || this.isNew) && [-1, 0, 1, 3, 5, 8].indexOf(this.claimStatus) !== -1;
        },
        partsTotal: function partsTotal() {
            var total = 0;
            this.parts.forEach(function (part) {
                total = total + part.part.extendedPrice * part.quantity;
            });
            this.miscParts.forEach(function (part) {
                total = total + part.part.price * part.quantity;
            });
            return total;
        },
        handling: function handling() {
            var handling = 0;
            var coverage = parseInt(this.generalForm.serviceCoverage);
            var isWarrantyClaim = coverage !== 2 && coverage !== 3 && coverage !== 4 && coverage !== 8;
            if (isWarrantyClaim && this.totalForm.freight <= 0) {
                handling = this.partsTotal * 0.15;
            }
            return handling;
        },
        freightTaxTotal: function freightTaxTotal() {
            return Number(this.laborHours) * Number(this.rates.laborRate) + Number(this.laborSupplementaryHours) * Number(this.rates.laborRate) + Number(this.laborOvertimeHours) * Number(this.rates.laborRateOverTime) + Number(this.laborOvertimeSupplementaryHours) * Number(this.rates.laborRateOverTime) + Number(this.laborTravelForm.regularTravelHours) * Number(this.rates.travelRate) + Number(this.laborTravelForm.overtimeTravelHours) * Number(this.rates.travelRateOverTime) + Number(this.laborTravelForm.regularMileage) * Number(this.rates.mileageRate) + Number(this.laborTravelForm.overtimeMileage) * Number(this.rates.mileageRateOverTime) + Number(this.laborTravelForm.serviceFuel);
        }
    },
    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        rmaVisible: function rmaVisible(val) {
            this.showRma = val;
        },
        rmaForServiceCompany: function rmaForServiceCompany(val) {
            this.isServiceCompany = val;
        },
        rmaButtonVisible: function rmaButtonVisible(val) {
            this.showRmaButton = val;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getRmaNumber().then(function (response) {
            _this2.rmaForm.rmaNumber = response.data.data;
        });

        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$on("confirmed", function () {
            _this2.$notify({
                title: _this2.$t('common.success'),
                message: _this2.$t('common.claimSuccesfullySaved'),
                type: "success"
            });
            _this2.closeDialog();
            __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$emit("claim-created");
        });
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$off("confirmed");
    },

    methods: {
        getTrackInfo: function getTrackInfo() {
            var _this3 = this;

            if (!this.rmaForm.trackingNumber) {
                return;
            }
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getTrackingInfo(this.rmaForm.trackingNumber).then(function (response) {
                _this3.trackForm = response.data;
                _this3.isTrackInfoLoaded = true;
                _this3.loading = false;
            }).catch(function (err) {
                console.log(err);
            });
        },
        printRma: function printRma() {
            var _this4 = this;

            this.printing = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].printRma(this.rmaForm.id).then(function (response) {
                _this4.printing = false;
                var oHiddFrame = document.createElement("iframe");
                oHiddFrame.style.visibility = "hidden";
                oHiddFrame.style.position = "fixed";
                oHiddFrame.style.right = "0";
                oHiddFrame.style.bottom = "0";
                oHiddFrame.src = "javascript:void(0)";
                document.body.appendChild(oHiddFrame);
                var dstDoc = oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                dstDoc.write(response.data);

                dstDoc.close();
                var isFirefox = typeof InstallTrigger !== "undefined";
                if (isFirefox) {
                    oHiddFrame.contentWindow.print();
                    document.body.removeChild(oHiddFrame);
                } else {
                    setTimeout(function () {
                        oHiddFrame.contentWindow.print();
                        document.body.removeChild(oHiddFrame);
                    }, 500);
                }
            }, function () {
                return _this4.printing = false;
            });
        },
        openTrackingWindow: function openTrackingWindow() {
            var url = "http://www.ups.com/WebTracking/track?loc=en_US&WT.svl=PNRO_L1";
            window.open(url);
        },
        saveRma: function saveRma() {
            var _this5 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveRma(this.rmaForm).then(function (response) {
                _this5.loading = false;
                _this5.showRma = false;
                _this5.rmaForm.id = response.data.id;
            }).catch(function (err) {
                console.log(err);
            });
        },
        sendRmaFormLink: function sendRmaFormLink() {
            var _this6 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].sendRmaFormLink(this.rmaForm.claimId).then(function (response) {
                _this6.loading = false;
            });
        },
        loadClaim: function loadClaim() {
            var _this7 = this;

            this.localClaimId = this.claimId;
            if (this.localClaimId) {
                this.isNew = false;
                this.loading = true;
                this.loadingClaim = true;
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getClaim(this.localClaimId).then(function (response) {
                    var that = _this7;
                    _this7.claimNumber = response.data.claimNumber;
                    _this7.claimStatus = response.data.claimStatus;
                    _this7.generalForm = response.data.generalForm;
                    _this7.generalForm.serviceCoverage = _this7.generalForm.serviceCoverage.toString();
                    _this7.generalForm.dateOfDispatch = new Date(_this7.generalForm.dateOfDispatch);
                    _this7.generalForm.dateWorkCompleted = new Date(_this7.generalForm.dateWorkCompleted);
                    _this7.siteInfoForm = response.data.siteInfoForm;

                    _this7.subcontractors = response.data.siteInfoForm.subcontractors;
                    _this7.rmaForm.attns = response.data.rmaForm.attns;
                    _this7.rmaForm.attn = response.data.rmaForm.attnId > 0 ? response.data.rmaForm.attns[response.data.rmaForm.attnId - 1].id : "";
                    _this7.$refs["customerIdSelector"].searchCustomersById(response.data.siteInfoForm.customerId, function () {
                        var customers = that.$refs["customerIdSelector"].getCustomers();
                        that.rmaForm.selectedCustomer = customers[0];
                    });

                    _this7.laborTravelForm = response.data.laborTravelForm;
                    _this7.totalForm = response.data.totalForm;
                    _this7.repairCodes = response.data.repairCodes;
                    _this7.parts = response.data.parts;

                    _this7.miscParts = response.data.miscParts;
                    _this7.comments = response.data.comments;
                    _this7.oldInvoiceNumber = response.data.generalForm.invoiceNumber;
                    _this7.loading = false;
                    _this7.loadingClaim = false;

                    _this7.rmaForm.serviceCompany = response.data.rmaForm.serviceCompany;
                    _this7.rmaForm.serviceTicket = {
                        raisedOn: response.data.rmaForm.serviceTicket.raisedOn,
                        // ? new Date(response.data.rmaForm.serviceTicket.raisedOn).toLocaleString("en-Ca") : new Date(),
                        authNumber: response.data.rmaForm.serviceTicket.authNumber,
                        tsr: response.data.rmaForm.serviceTicket.tsr
                    };
                    _this7.rmaForm.shippingMethod = response.data.rmaForm.shippingMethod;
                    _this7.rmaForm.countryOfOrigin = response.data.rmaForm.countryOfOrigin;

                    _this7.rmaForm.parts = response.data.parts.slice();
                    var totalPrice = 0,
                        totalExtendedPrice = 0;
                    response.data.parts.map(function (e) {
                        totalPrice += e.part.price;totalExtendedPrice += e.part.extendedPrice;
                    });
                    _this7.rmaForm.parts.push({ part: { partNo: 'Total', name: 'N/A', price: totalPrice, extendedPrice: totalExtendedPrice }, quantity: 'N/A' });

                    _this7.rmaForm.serviceCompanyId = response.data.rmaForm.serviceCompanyId;
                    _this7.rmaForm.serviceTicketId = response.data.rmaForm.serviceTicketId;
                    _this7.rmaForm.claimId = response.data.rmaForm.claimId;

                    _this7.rmaForm.claimNumber = response.data.rmaForm.claimNumber;
                    _this7.rmaForm.invoiceNumber = response.data.rmaForm.invoiceNumber;
                    _this7.rmaForm.serviceTicketNumber = response.data.rmaForm.serviceTicketNumber;
                    _this7.rmaForm.id = response.data.rmaForm.id;
                    _this7.showRmaButton = response.data.rmaForm.claimStatus == 7;
                    _this7.rmaForm.claimStatus = response.data.rmaForm.claimStatus;
                    _this7.isServiceCompany = response.data.rmaForm.isServiceCompany;
                    _this7.rmaForm.rmaDate = response.data.rmaForm.rmaDate;

                    self.isNotWarrantyClaim = response.data.generalForm.serviceCoverage == 2 || response.data.generalForm.serviceCoverage == 3 || response.data.generalForm.serviceCoverage == 4 || response.data.generalForm.serviceCoverage == 8;
                });
            }
        },
        workOrderChanged: function workOrderChanged(file, fileList) {
            this.generalForm.workOrders.push(file.raw);
        },
        workOrderRemoved: function workOrderRemoved(file, fileList) {
            if (file.id) {
                var index = this.generalForm.workOrders.findIndex(function (attachment) {
                    return attachment.id === file.id;
                });
                this.generalForm.workOrders.splice(index, 1);
            } else {
                var index = this.generalForm.workOrders.findIndex(function (attachment) {
                    return attachment.uid == file.uid;
                });
                this.generalForm.workOrders.splice(index, 1);
            }
        },
        attachmentsChanged: function attachmentsChanged(file, fileList) {
            this.commentForm.attachments.push(file.raw);
        },
        back: function back() {
            var _this8 = this;

            var self = this;
            if (this.activeStep === "freightTax") {
                this.activeStep = "parts";
                return;
            } else if (this.activeStep === "parts") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "laborTravel";
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveParts(this.mutatedClaimId, this.parts, this.miscParts).then(function (response) {
                    _this8.activeStep = "laborTravel";
                });
            } else if (this.activeStep === "laborTravel") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "siteInfo";
                    return;
                }
                this.$refs["laborTravel"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveLaborTravel(_this8.mutatedClaimId, _this8.laborTravelForm).then(function (response) {
                            _this8.activeStep = "siteInfo";
                        });
                    }
                });
            } else if (this.activeStep === "siteInfo") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "claimInfo";
                    return;
                }
                this.$refs["siteInfo"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveSiteInfo(_this8.mutatedClaimId, _this8.siteInfoForm, _this8.repairCodes).then(function (response) {
                            self.siteInfoForm.serviceCompanyId = response.data.serviceCompanyId;
                            _this8.activeStep = "claimInfo";
                        });
                    }
                });
            }
        },
        next: function next() {
            var _this9 = this;

            var self = this;
            if (this.activeStep === "claimInfo") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "siteInfo";
                    return;
                }

                this.$refs["general"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveGeneral(_this9.mutatedClaimId, _this9.generalForm).then(function (response) {
                            if (response.data === false) {
                                _this9.$notify({
                                    title: "Error",
                                    message: _this9.$t('common.invoiceNumberMustBeUnique'),
                                    type: "error"
                                });
                            } else {
                                if (!_this9.$isAdmin && !_this9.localClaimId) {
                                    _this9.localClaimId = response.data.claim.id;
                                }
                                _this9.claimNumber = response.data.claim.claimNumber;
                                _this9.subcontractors = response.data.subcontractors;
                                _this9.childCompanies = response.data.childCompanies;
                                _this9.companyType = response.data.companyType;
                                _this9.activeStep = "siteInfo";
                                self.isNotWarrantyClaim = response.data.claim.coverage == 2 || response.data.claim.coverage == 3 || response.data.claim.coverage == 4;
                            }
                        });
                    }
                });
            } else if (this.activeStep === "siteInfo") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "laborTravel";
                    return;
                }
                this.$refs["siteInfo"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveSiteInfo(_this9.mutatedClaimId, _this9.siteInfoForm, _this9.repairCodes).then(function (response) {
                            self.siteInfoForm.serviceCompanyId = response.data.serviceCompanyId;
                            _this9.activeStep = "laborTravel";
                        });
                    }
                });
            } else if (this.activeStep === "laborTravel") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "parts";
                    return;
                }
                this.$refs["laborTravel"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveLaborTravel(_this9.mutatedClaimId, _this9.laborTravelForm).then(function (response) {
                            _this9.activeStep = "parts";
                        });
                    }
                });
            } else if (this.activeStep === "parts") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.activeStep = "freightTax";
                    return;
                }
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveParts(this.mutatedClaimId, this.parts, this.miscParts).then(function (response) {
                    _this9.activeStep = "freightTax";
                });
            } else if (this.activeStep === "freightTax") {
                if (!this.canEdit && !this.$isAdmin) {
                    this.closeDialog();
                    return;
                }
                this.$refs["freightTax"].validate(function (valid) {
                    if (valid) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].saveTotal(_this9.mutatedClaimId, _this9.totalForm, _this9.claimId).then(function (response) {
                            if (typeof claimId == "undefined" || claimId == null) {
                                __WEBPACK_IMPORTED_MODULE_3__app_event_bus_js__["a" /* EventBus */].$emit("showClaimConfirm", _this9.mutatedClaimId);
                            } else {
                                _this9.$emit("showClaimConfirm", _this9.mutatedClaimId);
                            }
                            // if (this.claimId && this.claimStatus == 0) {
                            // } else {
                            //   this.$notify({
                            //     title: this.$t('common.success'),
                            //     message: "Claim successfully saved.",
                            //     type: "success"
                            //   });
                            //   this.$emit("showClaimPreview", this.mutatedClaimId);
                            //   this.closeDialog();
                            // }
                        });
                    }
                });
            }
        },
        postComment: function postComment() {
            var _this10 = this;

            this.$refs["commentForm"].validate(function (valid) {
                if (valid) {
                    _this10.loading = true;
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].submitComment(_this10.mutatedClaimId, _this10.commentForm).then(function (response) {
                        _this10.loading = false;
                        _this10.$refs["commentForm"].resetFields();
                        _this10.comments.push(response.data);
                    }).catch(function (err) {
                        console.log(err);
                    });
                }
            });
        },
        openRmaForm: function openRmaForm() {
            this.showRma = true;
        },
        showRepairCodeDialog: function showRepairCodeDialog() {
            this.repairCodeDialogVisible = true;
        },
        showMultiRepairCodeDialog: function showMultiRepairCodeDialog() {
            this.isMultiCodeAdd = true;
            this.repairCodeDialogVisible = true;
        },
        showAddPart: function showAddPart() {
            this.partDialogVisible = true;
        },
        showAddMiscPart: function showAddMiscPart() {
            this.partDialogVisible = true;
            this.isMiscPartDialog = true;
        },
        repairCodeDialogClosed: function repairCodeDialogClosed() {
            this.repairCodeToEdit = undefined;
            this.isMultiCodeAdd = false;
            this.repairCodeDialogVisible = false;
        },
        partDialogClosed: function partDialogClosed() {
            this.isMiscPartDialog = false;
            this.partDialogVisible = false;
        },
        partAdded: function partAdded(payload) {
            if (this.isMiscPartDialog && !this.miscParts.find(function (p) {
                return p.part.name.toLowerCase() === payload.part.name.toLowerCase();
            })) {
                this.miscParts.push(payload);
            } else if (!this.isMiscPartDialog && !this.parts.find(function (p) {
                return p.part.id === payload.part.id;
            })) {
                this.parts.push(payload);
            }
        },
        codesAdded: function codesAdded(payload) {
            var presentIds = this.repairCodes.map(function (c) {
                return c.code.id;
            });
            var newCodes = payload.codesToAdd;
            for (var i = 0; i < newCodes.length; i++) {
                var code = newCodes[i];
                var existingCode = newCodes.find(function (c) {
                    return presentIds.indexOf(c.code.id) === 0;
                });
                if (payload.codeToEdit) {
                    this.repairCodes = this.repairCodes.filter(function (e, i) {
                        return e.code.id != payload.codeToEdit.code.id;
                    });
                }
                if (!existingCode) {
                    this.repairCodes.push(code);
                } else {
                    var index = this.repairCodes.findIndex(function (c) {
                        return c.code.id === existingCode.code.id;
                    });
                    this.$set(this.repairCodes, index, code);
                }
            }
        },
        deletePart: function deletePart(id) {
            this.parts = this.parts.filter(function (p) {
                return p.part.id !== id;
            });
        },
        deleteMiscPart: function deleteMiscPart(name) {
            this.miscParts = this.miscParts.filter(function (p) {
                return p.part.name !== name;
            });
        },
        deleteCode: function deleteCode(id) {
            this.repairCodes = this.repairCodes.filter(function (c) {
                return c.code.id !== id;
            });
        },
        editCode: function editCode(code) {
            this.repairCodeToEdit = code;
            this.showRepairCodeDialog();
        },
        closeRma: function closeRma() {
            this.showRma = false;
        },
        closeDialog: function closeDialog() {
            this.isNew = true;
            this.claimNumber = undefined;
            this.parts = [];
            this.miscParts = [];
            this.repairCodes = [];
            this.comments = [];
            if (this.$refs["general"]) {
                this.$refs["general"].resetFields();
            }
            if (this.$refs["siteInfo"]) {
                this.$refs["siteInfo"].resetFields();
            }
            if (this.$refs["laborTravel"]) {
                this.$refs["laborTravel"].resetFields();
            }
            if (this.$refs["total"]) {
                this.$refs["total"].resetFields();
            }
            if (this.$refs["commentForm"]) {
                this.$refs["commentForm"].resetFields();
            }
            if (this.$refs["freightTax"]) {
                this.$refs["freightTax"].resetFields();
            }
            this.activeStep = "claimInfo";
            this.showDialog = false;
            this.showRma = false;
            this.loading = false;
            this.$emit("dialogClosed");
        },
        previewClaim: function previewClaim(id) {
            this.$emit("previewClaim", id);
            this.closeDialog();
        },
        handlePreview: function handlePreview(file) {
            var split = file.name.split(".");
            this.fileExtension = split[split.length - 1];
            if (this.fileExtension !== "jpg" && this.fileExtension !== "pdf" && this.fileExtension !== "jpeg" && this.fileExtension !== "png") {
                // window.open(file.url);
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download(file.url);
                return;
            }
            this.fileUrlPreview = file.url;
            this.showImagePreview = true;
        },
        handleAttachmentPreview: function handleAttachmentPreview(file) {
            this.fileExtension = file.mimeType.replace(".", "");
            if (this.fileExtension !== "jpg" && this.fileExtension !== "pdf" && this.fileExtension !== "jpeg" && this.fileExtension !== "png") {
                // window.open(file.url);
                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].download(file.url);
                return;
            }
            this.fileUrlPreview = file.url;
            this.showImagePreview = true;
        },
        recalculateRegularTravelHours: function recalculateRegularTravelHours() {
            if (this.laborTravelForm.regularTravelHours > this.maxRegularTravel) {
                this.laborTravelForm.regularTravelHours = this.maxRegularTravel;
            }
        },
        recalculateOvertimeTravelHours: function recalculateOvertimeTravelHours() {
            if (this.laborTravelForm.overtimeTravelHours > this.maxOvertimeTravel) {
                this.laborTravelForm.overtimeTravelHours = this.maxOvertimeTravel;
            }
        },
        recalculateRegularMileage: function recalculateRegularMileage() {
            if (this.laborTravelForm.regularMileage > this.maxRegularMileage) {
                this.laborTravelForm.regularMileage = this.maxRegularMileage;
            }
        },
        recalculateOvertimeMileage: function recalculateOvertimeMileage() {
            if (this.laborTravelForm.overtimeMileage > this.maxOvertimeMileage) {
                this.laborTravelForm.overtimeMileage = this.maxOvertimeMileage;
            }
        }
    }
});

/***/ }),

/***/ "y85y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yCWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("H50Z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: "send-email-dialog",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        loadingChangeEmail: {
            type: Boolean,
            defailt: false
        },
        formChangeEmail: {
            serviceCompany: null,
            phone: null,
            email: null,
            useCustom: false
        }
    },
    data: function data() {
        return {
            buttonkey: 0,
            rulesChangeEmail: {
                serviceCompany: [{
                    required: true,
                    message: this.$t('common.pleaseSelectServiceCompany'),
                    trigger: "blur"
                }],
                phone: [{
                    required: true,
                    message: this.$t('common.pleaseSelectPhone'),
                    trigger: "blur"
                }],
                email: [{
                    type: "email",
                    required: true,
                    message: this.$t('common.pleaseInputCorrectEmailAddress'),
                    trigger: "blur"
                }]
            },
            showDialog: this.visible,
            showChangeEmailDialog: false
        };
    },

    watch: {
        visible: function visible(val) {
            this.showDialog = val;
        },
        loadingChangeEmail: function loadingChangeEmail(val) {
            this.loadingChangeEmail = val;
        },
        formChangeEmail: function formChangeEmail(val) {
            this.formChangeEmail = val;
        }
    },
    methods: {
        save: function save(sendEmail) {
            var _this = this;

            var isValid = true;
            if (this.formChangeEmail.useCustom) {
                this.$refs["formChangeEmail"].validate(function (validChangeEmail) {
                    if (!validChangeEmail) {
                        isValid = false;
                    }
                });
            }
            this.showChangeEmailDialog = false;
            this.$emit("dialogClosed");
            this.$emit('save', sendEmail, isValid);
            setTimeout(function () {
                _this.buttonkey++;
            }, 1000);
        }
    }
});

/***/ }),

/***/ "yT6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-radio-group',{attrs:{"size":"mini"},model:{value:(_vm.filter.type),callback:function ($$v) {_vm.$set(_vm.filter, "type", $$v)},expression:"filter.type"}},[[_c('el-radio-button',{attrs:{"label":null}},[_vm._v(_vm._s(_vm.$t('common.all')))]),_vm._v(" "),_vm._l((_vm.categories),function(category){return _c('el-radio-button',{key:category.status,attrs:{"label":category.status}},[_vm._v(_vm._s(category.total)+" "+_vm._s(_vm.$i18n.locale == 'en' ? category.name : category.nameFr))])})]],2)],1),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"md":8,"lg":6}},[_c('chain-selector',{model:{value:(_vm.filter.chainId),callback:function ($$v) {_vm.$set(_vm.filter, "chainId", $$v)},expression:"filter.chainId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('customer-selector',{model:{value:(_vm.filter.customerId),callback:function ($$v) {_vm.$set(_vm.filter, "customerId", $$v)},expression:"filter.customerId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.ticketNumber'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.ticket),callback:function ($$v) {_vm.$set(_vm.filter, "ticket", $$v)},expression:"filter.ticket"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.city'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.city),callback:function ($$v) {_vm.$set(_vm.filter, "city", $$v)},expression:"filter.city"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":6,"lg":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.state'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.state),callback:function ($$v) {_vm.$set(_vm.filter, "state", $$v)},expression:"filter.state"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.serialNumber'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.serialNumber),callback:function ($$v) {_vm.$set(_vm.filter, "serialNumber", $$v)},expression:"filter.serialNumber"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-input',{attrs:{"placeholder":_vm.$t('serviceTickets.lookUpServiceCompany'),"prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.filter.serviceCompany),callback:function ($$v) {_vm.$set(_vm.filter, "serviceCompany", $$v)},expression:"filter.serviceCompany"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.$t('serviceTickets.fromRaisedOnDate')},model:{value:(_vm.filter.dateFrom),callback:function ($$v) {_vm.$set(_vm.filter, "dateFrom", $$v)},expression:"filter.dateFrom"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":_vm.$t('serviceTickets.toRaisedOnDate')},model:{value:(_vm.filter.dateTo),callback:function ($$v) {_vm.$set(_vm.filter, "dateTo", $$v)},expression:"filter.dateTo"}})],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6}},[_c('el-select',{staticClass:"selector",attrs:{"placeholder":"Source","clearable":""},model:{value:(_vm.filter.source),callback:function ($$v) {_vm.$set(_vm.filter, "source", $$v)},expression:"filter.source"}},_vm._l((_vm.selfServiceOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1),_vm._v(" "),_c('el-col',{attrs:{"md":8,"lg":6,"justify":_vm.end}},[(_vm.$isAdmin)?_c('el-button',{attrs:{"loading":_vm.exporting,"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('serviceTickets.export')))]):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.filter.type == 5)?_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"1",staticClass:"tickets-table",attrs:{"size":"mini","data":_vm.tickets,"row-class-name":_vm.tableRowEscalationTime},on:{"sort-change":_vm.sortServiceTickets}},[_c('el-table-column',{attrs:{"prop":"id","width":"90","label":"Ticket #","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":"Customer #","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"raisedOn","label":"Raised On","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.raisedOn))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":"Serial #","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"workflowStage","label":"Workflow Stage","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.workflowStage === 1)?_c('span',[_vm._v("Dispatched")]):(scope.row.workflowStage === 2)?_c('span',[_vm._v("Pending Tech ETA (1)")]):(scope.row.workflowStage === 3)?_c('span',[_vm._v("Tech ETA (1)")]):(scope.row.workflowStage === 4)?_c('span',[_vm._v("Tech onsite (1)")]):(scope.row.workflowStage === 5)?_c('span',[_vm._v("Parts needed")]):(scope.row.workflowStage === 6)?_c('span',[_vm._v("Pending Parts Order / Parts Ordered")]):(scope.row.workflowStage === 7)?_c('span',[_vm._v("Sales Order #")]):(scope.row.workflowStage === 8)?_c('span',[_vm._v("Parts Shipped")]):(scope.row.workflowStage === 9)?_c('span',[_vm._v("Tracking # (allow for more than one)")]):(scope.row.workflowStage === 10)?_c('span',[_vm._v("Parts Estimated delivery (ETD)")]):(scope.row.workflowStage === 11)?_c('span',[_vm._v("Parts Delivered")]):(scope.row.workflowStage === 12)?_c('span',[_vm._v("Pending Tech ETA (2)")]):(scope.row.workflowStage === 13)?_c('span',[_vm._v("Tech ETA (2)")]):(scope.row.workflowStage === 14)?_c('span',[_vm._v("Tech onsite (2)")]):(scope.row.workflowStage === 15)?_c('span',[_vm._v("Job Completed")]):_c('span')]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"timeInWorkflowStage","label":"Time In Workflow Stage","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm.formattedHour(scope.row.timeInWorkflowStage))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"escalatedOn","label":"Escalated On","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.escalatedOn))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"escalatedBy","label":"Escalated By","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"daysSinceRaised","label":"Days since raised","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"escalationGauge","label":"Escalation Gauge","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"lastUpdatedBy","label":"Last Update by","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"lastUpdatedTime","label":"Last Update date & time","sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.lastUpdatedTime))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"lastComment","label":"Last Comment","sortable":"custom","formatter":_vm.truncateComment}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"escalationContactName","label":"Escalation Contact Name","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"escalationContactNumber","label":"Escalation Contact #","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Operations","fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editTicket(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})])]}}])})],1):_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],key:"2",staticClass:"tickets-table tablewithshading",attrs:{"size":"mini","data":_vm.tickets},on:{"sort-change":_vm.sortServiceTickets}},[_c('el-table-column',{attrs:{"prop":"id","width":"90","label":_vm.$t('serviceTickets.ticketNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"confirmation","width":"120","label":_vm.$t('serviceTickets.confirmation'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"openedBy","label":_vm.$t('serviceTickets.openedBy'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer","label":_vm.$t('serviceTickets.customerNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.raisedOn'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(_vm._f("datetime")(scope.row.raisedOn))+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serialNumber","label":_vm.$t('serviceTickets.serialNumber'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.codeDescription'),"min-width":"175"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.complaints),function(complaint){return _c('el-tooltip',{key:complaint.code,attrs:{"effect":"dark","content":_vm.calculateNameToBeShown(complaint),"placement":"top"}},[_c('el-tag',{staticStyle:{"margin-right":"5px"},attrs:{"type":"info","size":"small","disable-transitions":true}},[_vm._v(_vm._s(_vm.calculateNameToBeShown(complaint)))])],1)})}}])}),_vm._v(" "),(_vm.$i18n.locale == 'en')?_c('el-table-column',{attrs:{"prop":"status","width":"100","label":_vm.$t('serviceTickets.status'),"sortable":"custom"}}):_c('el-table-column',{attrs:{"prop":"statusFr","width":"100","label":_vm.$t('serviceTickets.status'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"serviceCompany","label":_vm.$t('serviceTickets.serviceCompany'),"sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.serviceCompanyPhone'),"sortable":"custom"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'callto:'+scope.row.serviceCompanyPhone}},[_vm._v(_vm._s(scope.row.serviceCompanyPhone))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Source"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                "+_vm._s(scope.row.sourceRequest)+"\n            ")]}}])}),_vm._v(" "),(_vm.filter.type == 99)?_c('el-table-column',{attrs:{"prop":"sendHours","width":"90","label":_vm.$t('serviceTickets.ticketSent'),"sortable":"custom"}}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('serviceTickets.operations'),"fixed":"right","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editTicket(scope.row.id)}}},[_c('i',{staticClass:"el-icon-view"})])]}}])})],1),_vm._v(" "),_c('create-service-ticket-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.createServiceTicketDialogVisible},on:{"dialogClosed":function($event){_vm.createServiceTicketDialogVisible = false}}}),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('service-ticket-details-dialog',{attrs:{"ticketId":_vm.ticketToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"updated":_vm.ticketUpdated}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUjF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateServiceTicketFromDraftDialog__ = __webpack_require__("Mc52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__("rqAC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_js__ = __webpack_require__("Ayk/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "service-ticket-list",
    components: {
        CreateServiceTicketFromDraftDialog: __WEBPACK_IMPORTED_MODULE_0__CreateServiceTicketFromDraftDialog__["a" /* default */]
    },
    data: function data() {
        return {
            tickets: [],
            loading: true,
            dialogVisible: false,
            ticketToEdit: null,
            requestToView: null,
            createServiceTicketDialogVisible: false,
            filter: {
                type: this.$route.params.status || null,
                serialNumber: "",
                isHistory: 0,
                fromDate: "",
                toDate: ""
            },
            sorting: {},
            currentPage: 1,
            total: 0,
            categories: [],
            store: __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* default */],
            exporting: false
        };
    },

    watch: {
        filter: {
            deep: true,
            handler: function handler() {
                if (this.filter.status === null && this.$route.params.status != null) {
                    window.location.href = "/#/service-tickets";
                }
                this.loadServiceRequests();
            }
        }
    },
    created: function created() {
        this.loadServiceRequests();
        this.loadCategories();
    },

    methods: {
        ticketUpdated: function ticketUpdated() {
            this.loadServiceRequests();
        },
        loadServiceRequests: function loadServiceRequests() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getServiceRequests(this.currentPage, this.filter, this.sorting).then(function (response) {
                _this.loading = false;
                _this.tickets = response.data.items;
                _this.total = response.data.total;
                _this.store.setCount(response.data.total);
            });
        },
        handleCurrentChange: function handleCurrentChange(page) {
            this.currentPage = page;
            this.loadServiceRequests();
        },
        editTicket: function editTicket(id) {
            this.ticketToEdit = id;
            this.isHistory = false;
            this.createServiceTicketDialogVisible = true;
        },
        showHistoryInfo: function showHistoryInfo(id) {
            this.ticketToEdit = id;
            this.isHistory = true;
            this.createServiceTicketDialogVisible = true;
        },
        editFinished: function editFinished() {
            this.ticketToEdit = null;
            this.createServiceTicketDialogVisible = false;
            this.loadServiceRequests();
        },
        loadCategories: function loadCategories() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].getCategories().then(function (response) {
                _this2.loading = false;
                _this2.categories = response.data;
            });
        },
        sortServiceTickets: function sortServiceTickets(sort) {
            var sortBy = sort.prop;
            if (!sortBy && sort.column != null) {
                sortBy = sort.column.label;
            }
            var sortOrder = sort.order;
            this.sorting = {
                sortBy: sortBy,
                sortOrder: sortOrder
            };
            if (this.currentPage === 1) {
                this.loadServiceRequests();
            } else {
                this.currentPage = 1;
            }
        },
        tableRowEscalationTime: function tableRowEscalationTime(_ref) {
            var row = _ref.row,
                column = _ref.column;

            if (row.isProcessed) {
                return 'success-row';
            } else if (row.isDeleted) {
                return 'error-row';
            } else {
                return 'warning-row';
            }
        },
        download: function download() {
            var _this3 = this;

            this.exporting = true;
            if (!this.filter.fromDate && !this.filter.dateTo) {
                var dateToday = new Date();
                var day = dateToday.getDate();
                var month = Number(dateToday.getMonth() + 1);
                var year = Number(dateToday.getFullYear());
                this.$confirm(this.$t('common.theExportWillBeGeneratedForAPeriodOfOneYear') + (year - 1) + '/' + month + '/' + day + " - " + year + '/' + month + '/' + day + this.$t('common.sinceTheDateRangeWasNotSelectedPleaseConfirm'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                }).then(function () {
                    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].download(_this3.filter, _this3.sorting).then(function () {
                        _this3.exporting = false;
                        _this3.$message({
                            title: _this3.$t('common.success'),
                            message: _this3.$t('common.exportWasGeneratedSuccesfully'),
                            type: "success"
                        });
                    });
                }).catch(function (_) {
                    _this3.exporting = false;
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].download(this.filter, this.sorting).then(function () {
                    _this3.exporting = false;
                    _this3.$message({
                        title: _this3.$t('common.success'),
                        message: _this3.$t('common.exportWasGeneratedSuccesfully'),
                        type: "success"
                    });
                });
            }
        }
    }
});

/***/ }),

/***/ "yacA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"20px"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":6}},[_vm._v("\n             \n            "),(_vm.$isFullAdmin)?_c('el-button',{attrs:{"type":"primary","icon":"el-icon-plus"},on:{"click":function($event){_vm.dialogVisible = true}}},[_vm._v(_vm._s(_vm.$t('common.create')))]):_vm._e(),_vm._v(" "),(_vm.$isAdmin)?_c('el-button',{attrs:{"icon":"el-icon-download"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.$t('common.export')))]):_vm._e()],1),_vm._v(" "),_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":4}},[_c('el-radio-group',{model:{value:(_vm.filter.isActive),callback:function ($$v) {_vm.$set(_vm.filter, "isActive", $$v)},expression:"filter.isActive"}},[_c('el-radio-button',{attrs:{"label":""}},[_vm._v(_vm._s(_vm.$t('common.all')))]),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"false"}},[_vm._v(_vm._s(_vm.$t('common.pending')))])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('country-selector',{model:{value:(_vm.filter.countryId),callback:function ($$v) {_vm.$set(_vm.filter, "countryId", $$v)},expression:"filter.countryId"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('masters.searchByNameOrCode')},model:{value:(_vm.filter.text),callback:function ($$v) {_vm.$set(_vm.filter, "text", $$v)},expression:"filter.text"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-input',{attrs:{"prefix-icon":"el-icon-search","placeholder":_vm.$t('common.state')},model:{value:(_vm.filter.state),callback:function ($$v) {_vm.$set(_vm.filter, "state", $$v)},expression:"filter.state"}})],1)],1),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"orders-table tablewithshading",attrs:{"size":"mini","data":_vm.serviceCompanies}},[_c('el-table-column',{attrs:{"prop":"code","label":_vm.$t('common.code')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('common.name')}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"country","label":_vm.$t('common.country')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.phone')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'callto:'+scope.row.phone}},[_vm._v(_vm._s(scope.row.phone))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.email')},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{attrs:{"href":'mailto:'+scope.row.email}},[_vm._v(_vm._s(scope.row.email))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('common.operations'),"fixed":"right","width":_vm.$isSuperAdmin ? 230 : 98 + 'px'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.editServiceCompany(scope.row.id)}}},[_c('i',{staticClass:"el-icon-edit"})]),_vm._v(" "),(scope.row.isActive && _vm.$isFullAdmin && _vm.$isSuperAdmin)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t('masters.suspendServiceCompany'),"placement":"top"}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.changeCompanyStatus(scope.row, false)}}},[_c('i',{staticClass:"el-icon-close"})])],1):_vm._e(),_vm._v(" "),(!scope.row.isActive && _vm.$isFullAdmin)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t('masters.activateServiceCompany'),"placement":"top"}},[_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.changeCompanyStatus(scope.row, true)}}},[_c('i',{staticClass:"el-icon-check"})])],1):_vm._e(),_vm._v(" "),(_vm.$isSuperAdmin)?_c('el-button',{attrs:{"size":"mini","type":"danger"},on:{"click":function($event){_vm.deleteServiceCompany(scope.row.id)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e(),_vm._v(" "),(_vm.$isFullAdmin && _vm.$isSuperAdmin)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$t('masters.impersonate'),"placement":"top"}},[(_vm.$isFullAdmin)?_c('el-button',{attrs:{"size":"mini"},on:{"click":function($event){_vm.impersonateServiceCompany(scope.row.id)}}},[_vm._v("I")]):_vm._e()],1):_vm._e()]}}])})],1),_vm._v(" "),(_vm.total !== 0)?_c('el-pagination',{staticClass:"pager",attrs:{"current-page":_vm.currentPage,"page-size":15,"layout":"total, prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.currentPage=$event}}}):_vm._e(),_vm._v(" "),_c('create-update-service-company-dialog',{attrs:{"serviceCompanyId":_vm.serviceCompanyToEdit,"visible":_vm.dialogVisible},on:{"dialogClosed":_vm.editFinished,"save":_vm.appendServiceCompany}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z0Xr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewRmaDialog_vue__ = __webpack_require__("Kc0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6136f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewRmaDialog_vue__ = __webpack_require__("Ggy9");
function injectStyle (ssrContext) {
  __webpack_require__("dkbm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e6136f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreviewRmaDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6136f5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreviewRmaDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z4cC":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": "ZpMc",
	"./fr.json": "kKqp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z4cC";

/***/ }),

/***/ "z60R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairCodeSelector_vue__ = __webpack_require__("VA0b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_509b139c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairCodeSelector_vue__ = __webpack_require__("Kcxu");
function injectStyle (ssrContext) {
  __webpack_require__("Anpv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-509b139c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RepairCodeSelector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_509b139c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RepairCodeSelector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zcLs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["uSZ5"]);


// WEBPACK FOOTER //
// js/app.691702d35dbb97eef1c5.js